/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    isTenantAvailable(input: IsTenantAvailableInput | null | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(<any>response_);
                } catch (e) {
                    return <Observable<IsTenantAvailableOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<IsTenantAvailableOutput>><any>_observableThrow(response_);
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    register(input: RegisterInput | null | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(<any>response_);
                } catch (e) {
                    return <Observable<RegisterOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisterOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisterOutput>(<any>null);
    }
}

@Injectable()
export class AccountTransactionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: GetAllAccountTransactionInput | null | undefined): Observable<PagedResultDtoOfAccountTransactionDto> {
        let url_ = this.baseUrl + "/api/services/app/AccountTransaction/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAccountTransactionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAccountTransactionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAccountTransactionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAccountTransactionDto.fromJS(resultData200) : new PagedResultDtoOfAccountTransactionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAccountTransactionDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAllSearch(input: GetAllAccountTransactionInput | null | undefined): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        let url_ = this.baseUrl + "/api/services/app/AccountTransaction/GetAllSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchAccountTransactionOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchAccountTransactionOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAllSearchRA(input: GetAllAccountTransactionInput | null | undefined): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        let url_ = this.baseUrl + "/api/services/app/AccountTransaction/GetAllSearchRA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearchRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearchRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearchRA(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchAccountTransactionOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchAccountTransactionOutput>(<any>null);
    }

    /**
     * @param registeredAgentID (optional) 
     * @param paymentDateFrom (optional) 
     * @param paymentDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPrepaidAccountHistoryCR(registeredAgentID: string | null | undefined, paymentDateFrom: Date | null | undefined, paymentDateTo: Date | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        let url_ = this.baseUrl + "/api/services/app/AccountTransaction/GetPrepaidAccountHistoryCR?";
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (paymentDateFrom !== undefined)
            url_ += "PaymentDateFrom=" + encodeURIComponent(paymentDateFrom ? "" + paymentDateFrom.toJSON() : "") + "&"; 
        if (paymentDateTo !== undefined)
            url_ += "PaymentDateTo=" + encodeURIComponent(paymentDateTo ? "" + paymentDateTo.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrepaidAccountHistoryCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrepaidAccountHistoryCR(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrepaidAccountHistoryCR(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchAccountTransactionOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchAccountTransactionOutput>(<any>null);
    }

    /**
     * @param registeredAgentID (optional) 
     * @param paymentDateFrom (optional) 
     * @param paymentDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getPrepaidAccountHistoryRA(registeredAgentID: string | null | undefined, paymentDateFrom: Date | null | undefined, paymentDateTo: Date | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        let url_ = this.baseUrl + "/api/services/app/AccountTransaction/GetPrepaidAccountHistoryRA?";
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (paymentDateFrom !== undefined)
            url_ += "PaymentDateFrom=" + encodeURIComponent(paymentDateFrom ? "" + paymentDateFrom.toJSON() : "") + "&"; 
        if (paymentDateTo !== undefined)
            url_ += "PaymentDateTo=" + encodeURIComponent(paymentDateTo ? "" + paymentDateTo.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrepaidAccountHistoryRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrepaidAccountHistoryRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetPrepaidAccountHistoryRA(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchAccountTransactionOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchAccountTransactionOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchAccountTransactionOutput>(<any>null);
    }
}

@Injectable()
export class AnnualRenewalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    calculateRenewalFees(input: CalculateRenewalFeesInput | null | undefined): Observable<AnnualRenewalDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/CalculateRenewalFees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRenewalFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRenewalFees(<any>response_);
                } catch (e) {
                    return <Observable<AnnualRenewalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnualRenewalDto>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateRenewalFees(response: HttpResponseBase): Observable<AnnualRenewalDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnualRenewalDto.fromJS(resultData200) : new AnnualRenewalDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnualRenewalDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateAnnualRenewalInput | null | undefined): Observable<AnnualRenewalDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<AnnualRenewalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnualRenewalDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AnnualRenewalDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnualRenewalDto.fromJS(resultData200) : new AnnualRenewalDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnualRenewalDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<AnnualRenewalDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<AnnualRenewalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnualRenewalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AnnualRenewalDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnualRenewalDto.fromJS(resultData200) : new AnnualRenewalDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnualRenewalDto>(<any>null);
    }

    /**
     * @param creationTimeFrom (optional) 
     * @param creationTimeTo (optional) 
     * @param entityName (optional) 
     * @param registeredAgentId (optional) 
     * @param requestInternalStatusKeys (optional) 
     * @param requestExternalStatusKeys (optional) 
     * @param requestNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(creationTimeFrom: Date | null | undefined, creationTimeTo: Date | null | undefined, entityName: string | null | undefined, registeredAgentId: string | null | undefined, requestInternalStatusKeys: string[] | null | undefined, requestExternalStatusKeys: string[] | null | undefined, requestNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfAnnualRenewalDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/GetAll?";
        if (creationTimeFrom !== undefined)
            url_ += "CreationTimeFrom=" + encodeURIComponent(creationTimeFrom ? "" + creationTimeFrom.toJSON() : "") + "&"; 
        if (creationTimeTo !== undefined)
            url_ += "CreationTimeTo=" + encodeURIComponent(creationTimeTo ? "" + creationTimeTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestInternalStatusKeys !== undefined)
            requestInternalStatusKeys && requestInternalStatusKeys.forEach(item => { url_ += "RequestInternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestExternalStatusKeys !== undefined)
            requestExternalStatusKeys && requestExternalStatusKeys.forEach(item => { url_ += "RequestExternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfAnnualRenewalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfAnnualRenewalDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfAnnualRenewalDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfAnnualRenewalDto.fromJS(resultData200) : new PagedResultDtoOfAnnualRenewalDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfAnnualRenewalDto>(<any>null);
    }

    /**
     * @param creationTimeFrom (optional) 
     * @param creationTimeTo (optional) 
     * @param entityName (optional) 
     * @param registeredAgentId (optional) 
     * @param requestInternalStatusKeys (optional) 
     * @param requestExternalStatusKeys (optional) 
     * @param requestNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearch(creationTimeFrom: Date | null | undefined, creationTimeTo: Date | null | undefined, entityName: string | null | undefined, registeredAgentId: string | null | undefined, requestInternalStatusKeys: string[] | null | undefined, requestExternalStatusKeys: string[] | null | undefined, requestNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllSearchAnnualRenewalOutput> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/GetAllSearch?";
        if (creationTimeFrom !== undefined)
            url_ += "CreationTimeFrom=" + encodeURIComponent(creationTimeFrom ? "" + creationTimeFrom.toJSON() : "") + "&"; 
        if (creationTimeTo !== undefined)
            url_ += "CreationTimeTo=" + encodeURIComponent(creationTimeTo ? "" + creationTimeTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestInternalStatusKeys !== undefined)
            requestInternalStatusKeys && requestInternalStatusKeys.forEach(item => { url_ += "RequestInternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestExternalStatusKeys !== undefined)
            requestExternalStatusKeys && requestExternalStatusKeys.forEach(item => { url_ += "RequestExternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchAnnualRenewalOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchAnnualRenewalOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchAnnualRenewalOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchAnnualRenewalOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchAnnualRenewalOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchAnnualRenewalOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateAnnualRenewalInput | null | undefined): Observable<AnnualRenewalDto> {
        let url_ = this.baseUrl + "/api/services/app/AnnualRenewal/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<AnnualRenewalDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnnualRenewalDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AnnualRenewalDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AnnualRenewalDto.fromJS(resultData200) : new AnnualRenewalDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnnualRenewalDto>(<any>null);
    }
}

@Injectable()
export class BatchServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateBatchInput | null | undefined): Observable<BatchDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BatchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BatchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BatchDto.fromJS(resultData200) : new BatchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Batch/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<BatchDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BatchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BatchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BatchDto.fromJS(resultData200) : new BatchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchDto>(<any>null);
    }

    /**
     * @param batchNumber (optional) 
     * @param batchStatusKeys (optional) 
     * @param companyName (optional) 
     * @param registeredAgentId (optional) 
     * @param requestCreationDateFrom (optional) 
     * @param requestCreationDateTo (optional) 
     * @param requestNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(batchNumber: string | null | undefined, batchStatusKeys: string[] | null | undefined, companyName: string | null | undefined, registeredAgentId: string | null | undefined, requestCreationDateFrom: Date | null | undefined, requestCreationDateTo: Date | null | undefined, requestNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfBatchDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetAll?";
        if (batchNumber !== undefined)
            url_ += "BatchNumber=" + encodeURIComponent("" + batchNumber) + "&"; 
        if (batchStatusKeys !== undefined)
            batchStatusKeys && batchStatusKeys.forEach(item => { url_ += "BatchStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestCreationDateFrom !== undefined)
            url_ += "RequestCreationDateFrom=" + encodeURIComponent(requestCreationDateFrom ? "" + requestCreationDateFrom.toJSON() : "") + "&"; 
        if (requestCreationDateTo !== undefined)
            url_ += "RequestCreationDateTo=" + encodeURIComponent(requestCreationDateTo ? "" + requestCreationDateTo.toJSON() : "") + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBatchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBatchDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBatchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBatchDto.fromJS(resultData200) : new PagedResultDtoOfBatchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBatchDto>(<any>null);
    }

    /**
     * @param batchNumber (optional) 
     * @param batchStatusKeys (optional) 
     * @param companyName (optional) 
     * @param registeredAgentId (optional) 
     * @param requestCreationDateFrom (optional) 
     * @param requestCreationDateTo (optional) 
     * @param requestNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearch(batchNumber: string | null | undefined, batchStatusKeys: string[] | null | undefined, companyName: string | null | undefined, registeredAgentId: string | null | undefined, requestCreationDateFrom: Date | null | undefined, requestCreationDateTo: Date | null | undefined, requestNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllBatchOutput> {
        let url_ = this.baseUrl + "/api/services/app/Batch/GetAllSearch?";
        if (batchNumber !== undefined)
            url_ += "BatchNumber=" + encodeURIComponent("" + batchNumber) + "&"; 
        if (batchStatusKeys !== undefined)
            batchStatusKeys && batchStatusKeys.forEach(item => { url_ += "BatchStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestCreationDateFrom !== undefined)
            url_ += "RequestCreationDateFrom=" + encodeURIComponent(requestCreationDateFrom ? "" + requestCreationDateFrom.toJSON() : "") + "&"; 
        if (requestCreationDateTo !== undefined)
            url_ += "RequestCreationDateTo=" + encodeURIComponent(requestCreationDateTo ? "" + requestCreationDateTo.toJSON() : "") + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllBatchOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllBatchOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllBatchOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllBatchOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllBatchOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllBatchOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateBatchInput | null | undefined): Observable<BatchDto> {
        let url_ = this.baseUrl + "/api/services/app/Batch/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BatchDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BatchDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BatchDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BatchDto.fromJS(resultData200) : new BatchDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BatchDto>(<any>null);
    }
}

@Injectable()
export class BusinessActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: BusinessActivityDto | null | undefined): Observable<BusinessActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessActivity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<BusinessActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BusinessActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BusinessActivityDto.fromJS(resultData200) : new BusinessActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessActivityDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<BusinessActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessActivity/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<BusinessActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BusinessActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BusinessActivityDto.fromJS(resultData200) : new BusinessActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessActivityDto>(<any>null);
    }

    /**
     * @param beps (optional) 
     * @param childBusinessActivityName (optional) 
     * @param companyTypeKey (optional) 
     * @param isActive (optional) 
     * @param name (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(beps: boolean | null | undefined, childBusinessActivityName: string | null | undefined, companyTypeKey: string | null | undefined, isActive: boolean | null | undefined, name: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfBusinessActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessActivity/GetAll?";
        if (beps !== undefined)
            url_ += "Beps=" + encodeURIComponent("" + beps) + "&"; 
        if (childBusinessActivityName !== undefined)
            url_ += "ChildBusinessActivityName=" + encodeURIComponent("" + childBusinessActivityName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfBusinessActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfBusinessActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBusinessActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfBusinessActivityDto.fromJS(resultData200) : new PagedResultDtoOfBusinessActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfBusinessActivityDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: BusinessActivityDto | null | undefined): Observable<BusinessActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/BusinessActivity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<BusinessActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<BusinessActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BusinessActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? BusinessActivityDto.fromJS(resultData200) : new BusinessActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BusinessActivityDto>(<any>null);
    }
}

@Injectable()
export class CertificateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CertificateDto | null | undefined): Observable<CertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CertificateDto.fromJS(resultData200) : new CertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<CertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CertificateDto.fromJS(resultData200) : new CertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateDto>(<any>null);
    }

    /**
     * @param key (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(key: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/GetAll?";
        if (key !== undefined)
            url_ += "Key=" + encodeURIComponent("" + key) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCertificateDto.fromJS(resultData200) : new PagedResultDtoOfCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCertificateDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CertificateDto | null | undefined): Observable<CertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/Certificate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CertificateDto.fromJS(resultData200) : new CertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateDto>(<any>null);
    }
}

@Injectable()
export class CommentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCommentInput | null | undefined): Observable<CommentDto> {
        let url_ = this.baseUrl + "/api/services/app/Comment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CommentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CommentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CommentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CommentDto.fromJS(resultData200) : new CommentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommentDto>(<any>null);
    }

    /**
     * @param commentThreadId (optional) 
     * @param excludedTags (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(commentThreadId: string | null | undefined, excludedTags: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCommentDto> {
        let url_ = this.baseUrl + "/api/services/app/Comment/GetAll?";
        if (commentThreadId !== undefined)
            url_ += "CommentThreadId=" + encodeURIComponent("" + commentThreadId) + "&"; 
        if (excludedTags !== undefined)
            excludedTags && excludedTags.forEach(item => { url_ += "ExcludedTags=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCommentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCommentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCommentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCommentDto.fromJS(resultData200) : new PagedResultDtoOfCommentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCommentDto>(<any>null);
    }
}

@Injectable()
export class CompanyRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateCompanyRegistrationInput | null | undefined): Observable<CompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<CompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyRegistrationDto.fromJS(resultData200) : new CompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyRegistrationDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    dummy(): Observable<AjaxResponseOfCompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Dummy";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfCompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfCompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processDummy(response: HttpResponseBase): Observable<AjaxResponseOfCompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AjaxResponseOfCompanyRegistrationDto.fromJS(resultData200) : new AjaxResponseOfCompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfCompanyRegistrationDto>(<any>null);
    }

    /**
     * @return Success
     */
    dummy2(): Observable<AjaxResponseOfRequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Dummy2";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDummy2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDummy2(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponseOfRequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponseOfRequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processDummy2(response: HttpResponseBase): Observable<AjaxResponseOfRequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AjaxResponseOfRequestV2Dto.fromJS(resultData200) : new AjaxResponseOfRequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponseOfRequestV2Dto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<CompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyRegistrationDto.fromJS(resultData200) : new CompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyRegistrationDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKeys (optional) 
     * @param entitiesPassedAnnualRenewalDate (optional) 
     * @param entitiesWithCertificatesNotIssuedWithRequestCompletion (optional) 
     * @param entitiesWithExpiredManagerId (optional) 
     * @param entitiesWithoutRegisteredAgent (optional) 
     * @param entityActivityKey (optional) 
     * @param entityStatusKeys (optional) 
     * @param ibcInsuranceClasses (optional) 
     * @param ids (optional) 
     * @param includeChildren (optional) 
     * @param incorporationDateFrom (optional) 
     * @param incorporationDateTo (optional) 
     * @param incorporationNumber (optional) 
     * @param lastRenewedYear (optional) 
     * @param nameReservationReferenceNumber (optional) 
     * @param nextAnnualRenewalDateFrom (optional) 
     * @param nextAnnualRenewalDateTo (optional) 
     * @param registeredAgentIds (optional) 
     * @param requestCreationDateFrom (optional) 
     * @param requestCreationDateTo (optional) 
     * @param requestExternalStatusKeys (optional) 
     * @param requestInternalStatusKeys (optional) 
     * @param requestOrBatchNumber (optional) 
     * @param typesOfSharesAllowedKey (optional) 
     * @param entityStatusDateFrom (optional) 
     * @param entityStatusDateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(companyName: string | null | undefined, companyTypeKeys: string[] | null | undefined, entitiesPassedAnnualRenewalDate: boolean | null | undefined, entitiesWithCertificatesNotIssuedWithRequestCompletion: boolean | null | undefined, entitiesWithExpiredManagerId: boolean | null | undefined, entitiesWithoutRegisteredAgent: EntitiesWithoutRegisteredAgent[] | null | undefined, entityActivityKey: string | null | undefined, entityStatusKeys: string[] | null | undefined, ibcInsuranceClasses: string[] | null | undefined, ids: string[] | null | undefined, includeChildren: boolean | null | undefined, incorporationDateFrom: Date | null | undefined, incorporationDateTo: Date | null | undefined, incorporationNumber: string | null | undefined, lastRenewedYear: LastRenewedYear | null | undefined, nameReservationReferenceNumber: string | null | undefined, nextAnnualRenewalDateFrom: Date | null | undefined, nextAnnualRenewalDateTo: Date | null | undefined, registeredAgentIds: string[] | null | undefined, requestCreationDateFrom: Date | null | undefined, requestCreationDateTo: Date | null | undefined, requestExternalStatusKeys: string[] | null | undefined, requestInternalStatusKeys: string[] | null | undefined, requestOrBatchNumber: string | null | undefined, typesOfSharesAllowedKey: string | null | undefined, entityStatusDateFrom: Date | null | undefined, entityStatusDateTo: Date | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfCompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/GetAll?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKeys !== undefined)
            companyTypeKeys && companyTypeKeys.forEach(item => { url_ += "CompanyTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (entitiesPassedAnnualRenewalDate !== undefined)
            url_ += "EntitiesPassedAnnualRenewalDate=" + encodeURIComponent("" + entitiesPassedAnnualRenewalDate) + "&"; 
        if (entitiesWithCertificatesNotIssuedWithRequestCompletion !== undefined)
            url_ += "EntitiesWithCertificatesNotIssuedWithRequestCompletion=" + encodeURIComponent("" + entitiesWithCertificatesNotIssuedWithRequestCompletion) + "&"; 
        if (entitiesWithExpiredManagerId !== undefined)
            url_ += "EntitiesWithExpiredManagerId=" + encodeURIComponent("" + entitiesWithExpiredManagerId) + "&"; 
        if (entitiesWithoutRegisteredAgent !== undefined)
            entitiesWithoutRegisteredAgent && entitiesWithoutRegisteredAgent.forEach(item => { url_ += "EntitiesWithoutRegisteredAgent=" + encodeURIComponent("" + item) + "&"; });
        if (entityActivityKey !== undefined)
            url_ += "EntityActivityKey=" + encodeURIComponent("" + entityActivityKey) + "&"; 
        if (entityStatusKeys !== undefined)
            entityStatusKeys && entityStatusKeys.forEach(item => { url_ += "EntityStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (ibcInsuranceClasses !== undefined)
            ibcInsuranceClasses && ibcInsuranceClasses.forEach(item => { url_ += "IbcInsuranceClasses=" + encodeURIComponent("" + item) + "&"; });
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeChildren !== undefined)
            url_ += "IncludeChildren=" + encodeURIComponent("" + includeChildren) + "&"; 
        if (incorporationDateFrom !== undefined)
            url_ += "IncorporationDateFrom=" + encodeURIComponent(incorporationDateFrom ? "" + incorporationDateFrom.toJSON() : "") + "&"; 
        if (incorporationDateTo !== undefined)
            url_ += "IncorporationDateTo=" + encodeURIComponent(incorporationDateTo ? "" + incorporationDateTo.toJSON() : "") + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (lastRenewedYear !== undefined)
            url_ += "LastRenewedYear=" + encodeURIComponent("" + lastRenewedYear) + "&"; 
        if (nameReservationReferenceNumber !== undefined)
            url_ += "NameReservationReferenceNumber=" + encodeURIComponent("" + nameReservationReferenceNumber) + "&"; 
        if (nextAnnualRenewalDateFrom !== undefined)
            url_ += "NextAnnualRenewalDateFrom=" + encodeURIComponent(nextAnnualRenewalDateFrom ? "" + nextAnnualRenewalDateFrom.toJSON() : "") + "&"; 
        if (nextAnnualRenewalDateTo !== undefined)
            url_ += "NextAnnualRenewalDateTo=" + encodeURIComponent(nextAnnualRenewalDateTo ? "" + nextAnnualRenewalDateTo.toJSON() : "") + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestCreationDateFrom !== undefined)
            url_ += "RequestCreationDateFrom=" + encodeURIComponent(requestCreationDateFrom ? "" + requestCreationDateFrom.toJSON() : "") + "&"; 
        if (requestCreationDateTo !== undefined)
            url_ += "RequestCreationDateTo=" + encodeURIComponent(requestCreationDateTo ? "" + requestCreationDateTo.toJSON() : "") + "&"; 
        if (requestExternalStatusKeys !== undefined)
            requestExternalStatusKeys && requestExternalStatusKeys.forEach(item => { url_ += "RequestExternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestInternalStatusKeys !== undefined)
            requestInternalStatusKeys && requestInternalStatusKeys.forEach(item => { url_ += "RequestInternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestOrBatchNumber !== undefined)
            url_ += "RequestOrBatchNumber=" + encodeURIComponent("" + requestOrBatchNumber) + "&"; 
        if (typesOfSharesAllowedKey !== undefined)
            url_ += "TypesOfSharesAllowedKey=" + encodeURIComponent("" + typesOfSharesAllowedKey) + "&"; 
        if (entityStatusDateFrom !== undefined)
            url_ += "EntityStatusDateFrom=" + encodeURIComponent(entityStatusDateFrom ? "" + entityStatusDateFrom.toJSON() : "") + "&"; 
        if (entityStatusDateTo !== undefined)
            url_ += "EntityStatusDateTo=" + encodeURIComponent(entityStatusDateTo ? "" + entityStatusDateTo.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCompanyRegistrationDto.fromJS(resultData200) : new PagedResultDtoOfCompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCompanyRegistrationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAllSearch(input: GetAllCompanyRegistrationInput | null | undefined): Observable<PagedResultDtoOfGetAllSearchCompanyRegistrationOutput> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/GetAllSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchCompanyRegistrationOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchCompanyRegistrationOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchCompanyRegistrationOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchCompanyRegistrationOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchCompanyRegistrationOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchCompanyRegistrationOutput>(<any>null);
    }

    /**
     * @param incorporationNumber (optional) 
     * @return Success
     */
    getByIncorporationNumber(incorporationNumber: string | null | undefined): Observable<CompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/GetByIncorporationNumber?";
        if (incorporationNumber !== undefined)
            url_ += "incorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByIncorporationNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByIncorporationNumber(<any>response_);
                } catch (e) {
                    return <Observable<CompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByIncorporationNumber(response: HttpResponseBase): Observable<CompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyRegistrationDto.fromJS(resultData200) : new CompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyRegistrationDto>(<any>null);
    }

    /**
     * @return Success
     */
    getIbcInsuranceClasses(): Observable<IbcInsuranceClassDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/GetIbcInsuranceClasses";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIbcInsuranceClasses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIbcInsuranceClasses(<any>response_);
                } catch (e) {
                    return <Observable<IbcInsuranceClassDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<IbcInsuranceClassDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetIbcInsuranceClasses(response: HttpResponseBase): Observable<IbcInsuranceClassDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(IbcInsuranceClassDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IbcInsuranceClassDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLabel(id: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/GetLabel?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLabel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLabel(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetLabel(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateCompanyRegistrationInput | null | undefined): Observable<CompanyRegistrationDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<CompanyRegistrationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CompanyRegistrationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CompanyRegistrationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CompanyRegistrationDto.fromJS(resultData200) : new CompanyRegistrationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CompanyRegistrationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateRequestFees(input: UpdateRequestFeesInput | null | undefined): Observable<RequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyRegistration/UpdateRequestFees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestFees(<any>response_);
                } catch (e) {
                    return <Observable<RequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRequestFees(response: HttpResponseBase): Observable<RequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestV2Dto.fromJS(resultData200) : new RequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestV2Dto>(<any>null);
    }
}

@Injectable()
export class CompanyTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param includeOther (optional) 
     * @param ids (optional) 
     * @param includeLookupDataType (optional) 
     * @param isActive (optional) 
     * @param keys (optional) 
     * @param lookupDataTypeKey (optional) 
     * @param parentKeys (optional) 
     * @param parentLevelsToInclude (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(includeOther: boolean | null | undefined, ids: string[] | null | undefined, includeLookupDataType: boolean | null | undefined, isActive: boolean | null | undefined, keys: string[] | null | undefined, lookupDataTypeKey: string | null | undefined, parentKeys: string[] | null | undefined, parentLevelsToInclude: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/GetAll?";
        if (includeOther !== undefined)
            url_ += "IncludeOther=" + encodeURIComponent("" + includeOther) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeLookupDataType !== undefined)
            url_ += "IncludeLookupDataType=" + encodeURIComponent("" + includeLookupDataType) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "Keys=" + encodeURIComponent("" + item) + "&"; });
        if (lookupDataTypeKey !== undefined)
            url_ += "LookupDataTypeKey=" + encodeURIComponent("" + lookupDataTypeKey) + "&"; 
        if (parentKeys !== undefined)
            parentKeys && parentKeys.forEach(item => { url_ += "ParentKeys=" + encodeURIComponent("" + item) + "&"; });
        if (parentLevelsToInclude !== undefined)
            url_ += "ParentLevelsToInclude=" + encodeURIComponent("" + parentLevelsToInclude) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }

    /**
     * @param serviceKey (optional) 
     * @return Success
     */
    getCompanyTypesByServiceKey(serviceKey: string | null | undefined): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/GetCompanyTypesByServiceKey?";
        if (serviceKey !== undefined)
            url_ += "serviceKey=" + encodeURIComponent("" + serviceKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyTypesByServiceKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyTypesByServiceKey(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCompanyTypesByServiceKey(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getSuffixesByCompanyType(id: string | null | undefined): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/CompanyType/GetSuffixesByCompanyType?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuffixesByCompanyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuffixesByCompanyType(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSuffixesByCompanyType(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeSecurityConfigurations(input: ChangeSecurityConfigurationsInput | null | undefined): Observable<ChangeSecurityConfigurationsInput> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeSecurityConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeSecurityConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSecurityConfigurations(<any>response_);
                } catch (e) {
                    return <Observable<ChangeSecurityConfigurationsInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangeSecurityConfigurationsInput>><any>_observableThrow(response_);
        }));
    }

    protected processChangeSecurityConfigurations(response: HttpResponseBase): Observable<ChangeSecurityConfigurationsInput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangeSecurityConfigurationsInput.fromJS(resultData200) : new ChangeSecurityConfigurationsInput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeSecurityConfigurationsInput>(<any>null);
    }

    /**
     * @param name (optional) 
     * @param value (optional) 
     * @return Success
     */
    changeSettingForUser(name: string | null | undefined, value: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeSettingForUser?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&"; 
        if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeSettingForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeSettingForUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeSettingForUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeUiTheme(input: ChangeUiThemeInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getSecurityConfigurations(): Observable<ChangeSecurityConfigurationsInput> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/GetSecurityConfigurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityConfigurations(<any>response_);
                } catch (e) {
                    return <Observable<ChangeSecurityConfigurationsInput>><any>_observableThrow(e);
                }
            } else
                return <Observable<ChangeSecurityConfigurationsInput>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecurityConfigurations(response: HttpResponseBase): Observable<ChangeSecurityConfigurationsInput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ChangeSecurityConfigurationsInput.fromJS(resultData200) : new ChangeSecurityConfigurationsInput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ChangeSecurityConfigurationsInput>(<any>null);
    }
}

@Injectable()
export class CountryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<CountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<CountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CountryDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CountryDto.fromJS(resultData200) : new CountryDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CountryDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAll(ids: string[] | null | undefined, maxResultCount: number | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfCountryDto> {
        let url_ = this.baseUrl + "/api/services/app/Country/GetAll?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfCountryDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfCountryDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfCountryDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfCountryDto.fromJS(resultData200) : new PagedResultDtoOfCountryDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfCountryDto>(<any>null);
    }
}

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getArchivalIntervalInDays(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetArchivalIntervalInDays";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArchivalIntervalInDays(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArchivalIntervalInDays(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetArchivalIntervalInDays(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param fromCRPortal (optional) 
     * @param registeredAgentID (optional) 
     * @param to (optional) 
     * @param top (optional) 
     * @return Success
     */
    getAveregeLifeTimeByServiceTypeCR(from: Date | null | undefined, fromCRPortal: boolean | null | undefined, registeredAgentID: string | null | undefined, to: Date | null | undefined, top: number | null | undefined): Observable<AnalysisResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetAveregeLifeTimeByServiceTypeCR?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (fromCRPortal !== undefined)
            url_ += "FromCRPortal=" + encodeURIComponent("" + fromCRPortal) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (top !== undefined)
            url_ += "Top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAveregeLifeTimeByServiceTypeCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAveregeLifeTimeByServiceTypeCR(<any>response_);
                } catch (e) {
                    return <Observable<AnalysisResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnalysisResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAveregeLifeTimeByServiceTypeCR(response: HttpResponseBase): Observable<AnalysisResultDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AnalysisResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisResultDto[]>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param fromCRPortal (optional) 
     * @param registeredAgentID (optional) 
     * @param to (optional) 
     * @param top (optional) 
     * @return Success
     */
    getNumberOfRequestsByServiceTypeCR(from: Date | null | undefined, fromCRPortal: boolean | null | undefined, registeredAgentID: string | null | undefined, to: Date | null | undefined, top: number | null | undefined): Observable<AnalysisResultByStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetNumberOfRequestsByServiceTypeCR?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (fromCRPortal !== undefined)
            url_ += "FromCRPortal=" + encodeURIComponent("" + fromCRPortal) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (top !== undefined)
            url_ += "Top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfRequestsByServiceTypeCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfRequestsByServiceTypeCR(<any>response_);
                } catch (e) {
                    return <Observable<AnalysisResultByStatusDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnalysisResultByStatusDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfRequestsByServiceTypeCR(response: HttpResponseBase): Observable<AnalysisResultByStatusDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AnalysisResultByStatusDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisResultByStatusDto[]>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param fromCRPortal (optional) 
     * @param registeredAgentID (optional) 
     * @param to (optional) 
     * @param top (optional) 
     * @return Success
     */
    getNumberOfRequestsByServiceTypeRA(from: Date | null | undefined, fromCRPortal: boolean | null | undefined, registeredAgentID: string | null | undefined, to: Date | null | undefined, top: number | null | undefined): Observable<AnalysisResultByStatusDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetNumberOfRequestsByServiceTypeRA?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (fromCRPortal !== undefined)
            url_ += "FromCRPortal=" + encodeURIComponent("" + fromCRPortal) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (top !== undefined)
            url_ += "Top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNumberOfRequestsByServiceTypeRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNumberOfRequestsByServiceTypeRA(<any>response_);
                } catch (e) {
                    return <Observable<AnalysisResultByStatusDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnalysisResultByStatusDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNumberOfRequestsByServiceTypeRA(response: HttpResponseBase): Observable<AnalysisResultByStatusDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AnalysisResultByStatusDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisResultByStatusDto[]>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param fromCRPortal (optional) 
     * @param registeredAgentID (optional) 
     * @param to (optional) 
     * @param top (optional) 
     * @return Success
     */
    getRequestCountByUserGroupCR(from: Date | null | undefined, fromCRPortal: boolean | null | undefined, registeredAgentID: string | null | undefined, to: Date | null | undefined, top: number | null | undefined): Observable<AnalysisResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetRequestCountByUserGroupCR?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (fromCRPortal !== undefined)
            url_ += "FromCRPortal=" + encodeURIComponent("" + fromCRPortal) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (top !== undefined)
            url_ += "Top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestCountByUserGroupCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestCountByUserGroupCR(<any>response_);
                } catch (e) {
                    return <Observable<AnalysisResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnalysisResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestCountByUserGroupCR(response: HttpResponseBase): Observable<AnalysisResultDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AnalysisResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisResultDto[]>(<any>null);
    }

    /**
     * @param from (optional) 
     * @param fromCRPortal (optional) 
     * @param registeredAgentID (optional) 
     * @param to (optional) 
     * @param top (optional) 
     * @return Success
     */
    getRequestsByStatusRA(from: Date | null | undefined, fromCRPortal: boolean | null | undefined, registeredAgentID: string | null | undefined, to: Date | null | undefined, top: number | null | undefined): Observable<AnalysisResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetRequestsByStatusRA?";
        if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toJSON() : "") + "&"; 
        if (fromCRPortal !== undefined)
            url_ += "FromCRPortal=" + encodeURIComponent("" + fromCRPortal) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toJSON() : "") + "&"; 
        if (top !== undefined)
            url_ += "Top=" + encodeURIComponent("" + top) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsByStatusRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsByStatusRA(<any>response_);
                } catch (e) {
                    return <Observable<AnalysisResultDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<AnalysisResultDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestsByStatusRA(response: HttpResponseBase): Observable<AnalysisResultDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(AnalysisResultDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AnalysisResultDto[]>(<any>null);
    }

    /**
     * @param assignedToGroupName (optional) 
     * @param batchID (optional) 
     * @param batchNumber (optional) 
     * @param companyID (optional) 
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param completionDateFrom (optional) 
     * @param completionDateTo (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param ids (optional) 
     * @param lastModificationDateFrom (optional) 
     * @param lastModificationDateTo (optional) 
     * @param loadServiceFees (optional) 
     * @param registeredAgentID (optional) 
     * @param requestNumber (optional) 
     * @param serviceCategoryKey (optional) 
     * @param serviceID (optional) 
     * @param serviceTypeKey (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRequestsCR(assignedToGroupName: string | null | undefined, batchID: string | null | undefined, batchNumber: string | null | undefined, companyID: string | null | undefined, companyName: string | null | undefined, companyTypeKey: string | null | undefined, completionDateFrom: Date | null | undefined, completionDateTo: Date | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, ids: string[] | null | undefined, lastModificationDateFrom: Date | null | undefined, lastModificationDateTo: Date | null | undefined, loadServiceFees: boolean | null | undefined, registeredAgentID: string | null | undefined, requestNumber: string | null | undefined, serviceCategoryKey: string | null | undefined, serviceID: string | null | undefined, serviceTypeKey: string | null | undefined, status: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetRequestsCR?";
        if (assignedToGroupName !== undefined)
            url_ += "AssignedToGroupName=" + encodeURIComponent("" + assignedToGroupName) + "&"; 
        if (batchID !== undefined)
            url_ += "BatchID=" + encodeURIComponent("" + batchID) + "&"; 
        if (batchNumber !== undefined)
            url_ += "BatchNumber=" + encodeURIComponent("" + batchNumber) + "&"; 
        if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&"; 
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (completionDateFrom !== undefined)
            url_ += "CompletionDateFrom=" + encodeURIComponent(completionDateFrom ? "" + completionDateFrom.toJSON() : "") + "&"; 
        if (completionDateTo !== undefined)
            url_ += "CompletionDateTo=" + encodeURIComponent(completionDateTo ? "" + completionDateTo.toJSON() : "") + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (lastModificationDateFrom !== undefined)
            url_ += "LastModificationDateFrom=" + encodeURIComponent(lastModificationDateFrom ? "" + lastModificationDateFrom.toJSON() : "") + "&"; 
        if (lastModificationDateTo !== undefined)
            url_ += "LastModificationDateTo=" + encodeURIComponent(lastModificationDateTo ? "" + lastModificationDateTo.toJSON() : "") + "&"; 
        if (loadServiceFees !== undefined)
            url_ += "LoadServiceFees=" + encodeURIComponent("" + loadServiceFees) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (serviceCategoryKey !== undefined)
            url_ += "ServiceCategoryKey=" + encodeURIComponent("" + serviceCategoryKey) + "&"; 
        if (serviceID !== undefined)
            url_ += "ServiceID=" + encodeURIComponent("" + serviceID) + "&"; 
        if (serviceTypeKey !== undefined)
            url_ += "ServiceTypeKey=" + encodeURIComponent("" + serviceTypeKey) + "&"; 
        if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsCR(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestsCR(response: HttpResponseBase): Observable<PagedResultDtoOfRequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRequestV2Dto.fromJS(resultData200) : new PagedResultDtoOfRequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestV2Dto>(<any>null);
    }

    /**
     * @param assignedToGroupName (optional) 
     * @param batchID (optional) 
     * @param batchNumber (optional) 
     * @param companyID (optional) 
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param completionDateFrom (optional) 
     * @param completionDateTo (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param ids (optional) 
     * @param lastModificationDateFrom (optional) 
     * @param lastModificationDateTo (optional) 
     * @param loadServiceFees (optional) 
     * @param registeredAgentID (optional) 
     * @param requestNumber (optional) 
     * @param serviceCategoryKey (optional) 
     * @param serviceID (optional) 
     * @param serviceTypeKey (optional) 
     * @param status (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRequestsRA(assignedToGroupName: string | null | undefined, batchID: string | null | undefined, batchNumber: string | null | undefined, companyID: string | null | undefined, companyName: string | null | undefined, companyTypeKey: string | null | undefined, completionDateFrom: Date | null | undefined, completionDateTo: Date | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, ids: string[] | null | undefined, lastModificationDateFrom: Date | null | undefined, lastModificationDateTo: Date | null | undefined, loadServiceFees: boolean | null | undefined, registeredAgentID: string | null | undefined, requestNumber: string | null | undefined, serviceCategoryKey: string | null | undefined, serviceID: string | null | undefined, serviceTypeKey: string | null | undefined, status: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/Dashboard/GetRequestsRA?";
        if (assignedToGroupName !== undefined)
            url_ += "AssignedToGroupName=" + encodeURIComponent("" + assignedToGroupName) + "&"; 
        if (batchID !== undefined)
            url_ += "BatchID=" + encodeURIComponent("" + batchID) + "&"; 
        if (batchNumber !== undefined)
            url_ += "BatchNumber=" + encodeURIComponent("" + batchNumber) + "&"; 
        if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&"; 
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (completionDateFrom !== undefined)
            url_ += "CompletionDateFrom=" + encodeURIComponent(completionDateFrom ? "" + completionDateFrom.toJSON() : "") + "&"; 
        if (completionDateTo !== undefined)
            url_ += "CompletionDateTo=" + encodeURIComponent(completionDateTo ? "" + completionDateTo.toJSON() : "") + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (lastModificationDateFrom !== undefined)
            url_ += "LastModificationDateFrom=" + encodeURIComponent(lastModificationDateFrom ? "" + lastModificationDateFrom.toJSON() : "") + "&"; 
        if (lastModificationDateTo !== undefined)
            url_ += "LastModificationDateTo=" + encodeURIComponent(lastModificationDateTo ? "" + lastModificationDateTo.toJSON() : "") + "&"; 
        if (loadServiceFees !== undefined)
            url_ += "LoadServiceFees=" + encodeURIComponent("" + loadServiceFees) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (serviceCategoryKey !== undefined)
            url_ += "ServiceCategoryKey=" + encodeURIComponent("" + serviceCategoryKey) + "&"; 
        if (serviceID !== undefined)
            url_ += "ServiceID=" + encodeURIComponent("" + serviceID) + "&"; 
        if (serviceTypeKey !== undefined)
            url_ += "ServiceTypeKey=" + encodeURIComponent("" + serviceTypeKey) + "&"; 
        if (status !== undefined)
            status && status.forEach(item => { url_ += "Status=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestsRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestsRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRequestsRA(response: HttpResponseBase): Observable<PagedResultDtoOfRequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRequestV2Dto.fromJS(resultData200) : new PagedResultDtoOfRequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestV2Dto>(<any>null);
    }
}

@Injectable()
export class DataMigrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param tableName (optional) 
     * @return Success
     */
    exportData(tableName: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DataMigration/ExportData?";
        if (tableName !== undefined)
            url_ += "tableName=" + encodeURIComponent("" + tableName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportData(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExportData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param whfile (optional) 
     * @return Success
     */
    getColumnDefinitions(whfile: string | null | undefined): Observable<GetColumnDefinitionsOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DataMigration/GetColumnDefinitions?";
        if (whfile !== undefined)
            url_ += "whfile=" + encodeURIComponent("" + whfile) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetColumnDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetColumnDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<GetColumnDefinitionsOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetColumnDefinitionsOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetColumnDefinitions(response: HttpResponseBase): Observable<GetColumnDefinitionsOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetColumnDefinitionsOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetColumnDefinitionsOutput[]>(<any>null);
    }

    /**
     * @param tableName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getData(tableName: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/DataMigration/GetData?";
        if (tableName !== undefined)
            url_ += "TableName=" + encodeURIComponent("" + tableName) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetData(<any>response_);
                } catch (e) {
                    return <Observable<GetDataOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDataOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetData(response: HttpResponseBase): Observable<GetDataOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDataOutput.fromJS(resultData200) : new GetDataOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDataOutput>(<any>null);
    }

    /**
     * @return Success
     */
    getTableDefinitions(): Observable<GetTableDefinitionsOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DataMigration/GetTableDefinitions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTableDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTableDefinitions(<any>response_);
                } catch (e) {
                    return <Observable<GetTableDefinitionsOutput[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetTableDefinitionsOutput[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTableDefinitions(response: HttpResponseBase): Observable<GetTableDefinitionsOutput[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(GetTableDefinitionsOutput.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTableDefinitionsOutput[]>(<any>null);
    }
}

@Injectable()
export class DocumentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateDocumentInput | null | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentDto.fromJS(resultData200) : new DocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Document/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentDto.fromJS(resultData200) : new DocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param confidentialityKey (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param entityName (optional) 
     * @param fileName (optional) 
     * @param fileNumber (optional) 
     * @param incorporationNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param showOnlyFiledDocuments (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(confidentialityKey: string | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, entityName: string | null | undefined, fileName: string | null | undefined, fileNumber: string | null | undefined, incorporationNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, showOnlyFiledDocuments: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAll?";
        if (confidentialityKey !== undefined)
            url_ += "ConfidentialityKey=" + encodeURIComponent("" + confidentialityKey) + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (fileNumber !== undefined)
            url_ += "FileNumber=" + encodeURIComponent("" + fileNumber) + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (showOnlyFiledDocuments !== undefined)
            url_ += "ShowOnlyFiledDocuments=" + encodeURIComponent("" + showOnlyFiledDocuments) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfDocumentDto.fromJS(resultData200) : new PagedResultDtoOfDocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDocumentDto>(<any>null);
    }

    /**
     * @param confidentialityKey (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param entityName (optional) 
     * @param fileName (optional) 
     * @param fileNumber (optional) 
     * @param incorporationNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param showOnlyFiledDocuments (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearch(confidentialityKey: string | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, entityName: string | null | undefined, fileName: string | null | undefined, fileNumber: string | null | undefined, incorporationNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, showOnlyFiledDocuments: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAllSearch?";
        if (confidentialityKey !== undefined)
            url_ += "ConfidentialityKey=" + encodeURIComponent("" + confidentialityKey) + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (fileNumber !== undefined)
            url_ += "FileNumber=" + encodeURIComponent("" + fileNumber) + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (showOnlyFiledDocuments !== undefined)
            url_ += "ShowOnlyFiledDocuments=" + encodeURIComponent("" + showOnlyFiledDocuments) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfDocumentDto.fromJS(resultData200) : new PagedResultDtoOfDocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDocumentDto>(<any>null);
    }

    /**
     * @param confidentialityKey (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param entityName (optional) 
     * @param fileName (optional) 
     * @param fileNumber (optional) 
     * @param incorporationNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param showOnlyFiledDocuments (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllFiledDocumentSearch(confidentialityKey: string | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, entityName: string | null | undefined, fileName: string | null | undefined, fileNumber: string | null | undefined, incorporationNumber: string | null |undefined, reqNo: string | null| undefined, registeredAgentIds: string[] | null | undefined, showOnlyFiledDocuments: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfDocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/GetAllFiledDocumentSearch?";
        if (confidentialityKey !== undefined)
            url_ += "ConfidentialityKey=" + encodeURIComponent("" + confidentialityKey) + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&"; 
        if (fileNumber !== undefined)
            url_ += "FileNumber=" + encodeURIComponent("" + fileNumber) + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (reqNo !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + reqNo) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (showOnlyFiledDocuments !== undefined)
            url_ += "ShowOnlyFiledDocuments=" + encodeURIComponent("" + showOnlyFiledDocuments) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFiledDocumentSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFiledDocumentSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfDocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFiledDocumentSearch(response: HttpResponseBase): Observable<PagedResultDtoOfDocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfDocumentDto.fromJS(resultData200) : new PagedResultDtoOfDocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfDocumentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateDocumentInput | null | undefined): Observable<DocumentDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<DocumentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<DocumentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DocumentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? DocumentDto.fromJS(resultData200) : new DocumentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DocumentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    verifyCertificate(input: VerifyCertificateInput | null | undefined): Observable<CertificateAuthenticityDto> {
        let url_ = this.baseUrl + "/api/services/app/Document/VerifyCertificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyCertificate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyCertificate(<any>response_);
                } catch (e) {
                    return <Observable<CertificateAuthenticityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<CertificateAuthenticityDto>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyCertificate(response: HttpResponseBase): Observable<CertificateAuthenticityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CertificateAuthenticityDto.fromJS(resultData200) : new CertificateAuthenticityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificateAuthenticityDto>(<any>null);
    }
}

@Injectable()
export class EmailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param mailMessage (optional) 
     * @return Success
     */
    test(mailMessage: MailMessageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Email/Test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailMessage);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class EntityActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: EntityActivityCreateDto | null | undefined): Observable<EntityActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EntityActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EntityActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityActivityDto.fromJS(resultData200) : new EntityActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityActivityDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createMultiple(input: EntityActivityCreateDto[] | null | undefined): Observable<EntityActivityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/CreateMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultiple(<any>response_);
                } catch (e) {
                    return <Observable<EntityActivityDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityActivityDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processCreateMultiple(response: HttpResponseBase): Observable<EntityActivityDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(EntityActivityDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityActivityDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<EntityActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EntityActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EntityActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityActivityDto.fromJS(resultData200) : new EntityActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityActivityDto>(<any>null);
    }

    /**
     * @param entityID (optional) 
     * @param activityDateFrom (optional) 
     * @param activityDateTo (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(entityID: string | null | undefined, activityDateFrom: Date | null | undefined, activityDateTo: Date | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfEntityActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/GetAll?";
        if (entityID !== undefined)
            url_ += "EntityID=" + encodeURIComponent("" + entityID) + "&"; 
        if (activityDateFrom !== undefined)
            url_ += "ActivityDateFrom=" + encodeURIComponent(activityDateFrom ? "" + activityDateFrom.toJSON() : "") + "&"; 
        if (activityDateTo !== undefined)
            url_ += "ActivityDateTo=" + encodeURIComponent(activityDateTo ? "" + activityDateTo.toJSON() : "") + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfEntityActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEntityActivityDto.fromJS(resultData200) : new PagedResultDtoOfEntityActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityActivityDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: EntityActivityUpdateDto | null | undefined): Observable<EntityActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityActivity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EntityActivityDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityActivityDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EntityActivityDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityActivityDto.fromJS(resultData200) : new EntityActivityDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityActivityDto>(<any>null);
    }
}

@Injectable()
export class EntityPropertyChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAllSearch(input: GetAllEntityPropertyChangeInput | null | undefined): Observable<PagedResultDtoOfGetAllEntityPropertyChangeOutput> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/GetAllSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllEntityPropertyChangeOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllEntityPropertyChangeOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllEntityPropertyChangeOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllEntityPropertyChangeOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllEntityPropertyChangeOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllEntityPropertyChangeOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<EntityPropertyChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EntityPropertyChangeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityPropertyChangeDto.fromJS(resultData200) : new EntityPropertyChangeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto>(<any>null);
    }

    /**
     * @param changeTimeFrom (optional) 
     * @param changeTimeTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(changeTimeFrom: Date | null | undefined, changeTimeTo: Date | null | undefined, entityId: string[], sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfEntityPropertyChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/GetAll?";
        if (changeTimeFrom !== undefined)
            url_ += "ChangeTimeFrom=" + encodeURIComponent(changeTimeFrom ? "" + changeTimeFrom.toJSON() : "") + "&"; 
        if (changeTimeTo !== undefined)
            url_ += "ChangeTimeTo=" + encodeURIComponent(changeTimeTo ? "" + changeTimeTo.toJSON() : "") + "&"; 
        if (entityId === undefined || entityId === null)
            throw new Error("The parameter 'entityId' must be defined and cannot be null.");
        else
            entityId && entityId.forEach(item => { url_ += "EntityId=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfEntityPropertyChangeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfEntityPropertyChangeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfEntityPropertyChangeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfEntityPropertyChangeDto.fromJS(resultData200) : new PagedResultDtoOfEntityPropertyChangeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfEntityPropertyChangeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: EntityPropertyChangeDto | null | undefined): Observable<EntityPropertyChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EntityPropertyChangeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityPropertyChangeDto.fromJS(resultData200) : new EntityPropertyChangeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: EntityPropertyChangeDto | null | undefined): Observable<EntityPropertyChangeDto> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<EntityPropertyChangeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<EntityPropertyChangeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EntityPropertyChangeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? EntityPropertyChangeDto.fromJS(resultData200) : new EntityPropertyChangeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EntityPropertyChangeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EntityPropertyChange/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FeeGatewayCreateDto | null | undefined): Observable<FeeGatewayDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FeeGatewayDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeGatewayDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FeeGatewayDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FeeGatewayDto.fromJS(resultData200) : new FeeGatewayDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeGatewayDto>(<any>null);
    }

    /**
     * @param tagLevelsToInclude (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(tagLevelsToInclude: number | null | undefined, id: string | null | undefined): Observable<FeeGatewayDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/Get?";
        if (tagLevelsToInclude !== undefined)
            url_ += "TagLevelsToInclude=" + encodeURIComponent("" + tagLevelsToInclude) + "&"; 
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FeeGatewayDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeGatewayDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FeeGatewayDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FeeGatewayDto.fromJS(resultData200) : new FeeGatewayDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeGatewayDto>(<any>null);
    }

    /**
     * @param activityName (optional) 
     * @param companyTypeKey (optional) 
     * @param feeCode (optional) 
     * @param feeDescription (optional) 
     * @param financialAccountId (optional) 
     * @param financialAccountIds (optional) 
     * @param ids (optional) 
     * @param isActive (optional) 
     * @param recordCompanyActivity (optional) 
     * @param serviceTypeKeys (optional) 
     * @param serviceTypeNames (optional) 
     * @param tags (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(activityName: string | null | undefined, companyTypeKey: string | null | undefined, feeCode: number | null | undefined, feeDescription: string | null | undefined, financialAccountId: string | null | undefined, financialAccountIds: string[] | null | undefined, ids: string[] | null | undefined, isActive: boolean | null | undefined, recordCompanyActivity: boolean | null | undefined, serviceTypeKeys: string[] | null | undefined, serviceTypeNames: string[] | null | undefined, tags: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfFeeGatewayDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/GetAll?";
        if (activityName !== undefined)
            url_ += "ActivityName=" + encodeURIComponent("" + activityName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (feeCode !== undefined)
            url_ += "FeeCode=" + encodeURIComponent("" + feeCode) + "&"; 
        if (feeDescription !== undefined)
            url_ += "FeeDescription=" + encodeURIComponent("" + feeDescription) + "&"; 
        if (financialAccountId !== undefined)
            url_ += "FinancialAccountId=" + encodeURIComponent("" + financialAccountId) + "&"; 
        if (financialAccountIds !== undefined)
            financialAccountIds && financialAccountIds.forEach(item => { url_ += "FinancialAccountIds=" + encodeURIComponent("" + item) + "&"; });
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (recordCompanyActivity !== undefined)
            url_ += "RecordCompanyActivity=" + encodeURIComponent("" + recordCompanyActivity) + "&"; 
        if (serviceTypeKeys !== undefined)
            serviceTypeKeys && serviceTypeKeys.forEach(item => { url_ += "ServiceTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (serviceTypeNames !== undefined)
            serviceTypeNames && serviceTypeNames.forEach(item => { url_ += "ServiceTypeNames=" + encodeURIComponent("" + item) + "&"; });
        if (tags !== undefined)
            tags && tags.forEach(item => { url_ += "Tags=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFeeGatewayDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFeeGatewayDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFeeGatewayDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFeeGatewayDto.fromJS(resultData200) : new PagedResultDtoOfFeeGatewayDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFeeGatewayDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: FeeGatewayUpdateDto | null | undefined): Observable<FeeGatewayDto> {
        let url_ = this.baseUrl + "/api/services/app/Fee/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FeeGatewayDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeGatewayDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FeeGatewayDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FeeGatewayDto.fromJS(resultData200) : new FeeGatewayDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeGatewayDto>(<any>null);
    }
}

@Injectable()
export class FileRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    copy(input: EntityDtoOfGuid | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateFileRecordInput | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    download(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Download?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownload(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDownload(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(ids: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfFileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/GetAll?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFileRecordDto.fromJS(resultData200) : new PagedResultDtoOfFileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFileRecordDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param newFileName (optional) 
     * @return Success
     */
    rename(id: string | null | undefined, newFileName: string | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Rename?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        if (newFileName !== undefined)
            url_ += "newFileName=" + encodeURIComponent("" + newFileName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRename(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processRename(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param file (optional) 
     * @return Success
     */
    replace(id: string | null | undefined, file: FileParameter | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Replace?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplace(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processReplace(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateFileRecordInput | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    upload(file: FileParameter | null | undefined): Observable<FileRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/FileRecord/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(<any>response_);
                } catch (e) {
                    return <Observable<FileRecordDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileRecordDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<FileRecordDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FileRecordDto.fromJS(resultData200) : new FileRecordDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileRecordDto>(<any>null);
    }
}

@Injectable()
export class FinancialAccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    addFunds(input: AddFundsInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/AddFunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFunds(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }
    /**
     * @param input (optional) 
     * @return Success
     */
    reduceFunds(input: AddFundsInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/ReduceFunds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
        return this.processAddFunds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                return this.processAddFunds(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }
    protected processAddFunds(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FinancialAccountDto | null | undefined): Observable<FinancialAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FinancialAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinancialAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FinancialAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FinancialAccountDto.fromJS(resultData200) : new FinancialAccountDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialAccountDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<FinancialAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FinancialAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinancialAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FinancialAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FinancialAccountDto.fromJS(resultData200) : new FinancialAccountDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialAccountDto>(<any>null);
    }

    /**
     * @param excludedFinancialAccountTypeKeys (optional) 
     * @return Success
     */
    getAccountTypes(excludedFinancialAccountTypeKeys: string[] | null | undefined): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/GetAccountTypes?";
        if (excludedFinancialAccountTypeKeys !== undefined)
            excludedFinancialAccountTypeKeys && excludedFinancialAccountTypeKeys.forEach(item => { url_ += "ExcludedFinancialAccountTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountTypes(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccountTypes(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param accountNumber (optional) 
     * @param accountNumberOrDescription (optional) 
     * @param description (optional) 
     * @param financialAccountTypeKeys (optional) 
     * @param ids (optional) 
     * @param isActive (optional) 
     * @param includeSystemAccounts (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(accountNumber: string | null | undefined, accountNumberOrDescription: string | null | undefined, description: string | null | undefined, financialAccountTypeKeys: string[] | null | undefined, ids: string[] | null | undefined, isActive: boolean | null | undefined, includeSystemAccounts: boolean | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfFinancialAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/GetAll?";
        if (accountNumber !== undefined)
            url_ += "AccountNumber=" + encodeURIComponent("" + accountNumber) + "&"; 
        if (accountNumberOrDescription !== undefined)
            url_ += "AccountNumberOrDescription=" + encodeURIComponent("" + accountNumberOrDescription) + "&"; 
        if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&"; 
        if (financialAccountTypeKeys !== undefined)
            financialAccountTypeKeys && financialAccountTypeKeys.forEach(item => { url_ += "FinancialAccountTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (includeSystemAccounts !== undefined)
            url_ += "IncludeSystemAccounts=" + encodeURIComponent("" + includeSystemAccounts) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFinancialAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFinancialAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFinancialAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFinancialAccountDto.fromJS(resultData200) : new PagedResultDtoOfFinancialAccountDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFinancialAccountDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRegisteredAgentPrepaidAccountAlarmSettings(id: string | null | undefined): Observable<RegisteredAgentAlarmDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/GetRegisteredAgentPrepaidAccountAlarmSettings?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisteredAgentPrepaidAccountAlarmSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisteredAgentPrepaidAccountAlarmSettings(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredAgentAlarmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredAgentAlarmDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegisteredAgentPrepaidAccountAlarmSettings(response: HttpResponseBase): Observable<RegisteredAgentAlarmDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisteredAgentAlarmDto.fromJS(resultData200) : new RegisteredAgentAlarmDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredAgentAlarmDto>(<any>null);
    }

    /**
     * @param registeredAgentID (optional) 
     * @param registeredAgentAccountNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRegisteredAgentPrepaidAccountBalanceCR(registeredAgentID: string | null | undefined, registeredAgentAccountNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllRAAccountBalanceDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/GetRegisteredAgentPrepaidAccountBalanceCR?";
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (registeredAgentAccountNumber !== undefined)
            url_ += "RegisteredAgentAccountNumber=" + encodeURIComponent("" + registeredAgentAccountNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisteredAgentPrepaidAccountBalanceCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisteredAgentPrepaidAccountBalanceCR(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllRAAccountBalanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllRAAccountBalanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegisteredAgentPrepaidAccountBalanceCR(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllRAAccountBalanceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllRAAccountBalanceDto.fromJS(resultData200) : new PagedResultDtoOfGetAllRAAccountBalanceDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllRAAccountBalanceDto>(<any>null);
    }

    /**
     * @param registeredAgentID (optional) 
     * @param registeredAgentAccountNumber (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRegisteredAgentPrepaidAccountBalanceRA(registeredAgentID: string | null | undefined, registeredAgentAccountNumber: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<GetAllRAAccountBalanceDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/GetRegisteredAgentPrepaidAccountBalanceRA?";
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (registeredAgentAccountNumber !== undefined)
            url_ += "RegisteredAgentAccountNumber=" + encodeURIComponent("" + registeredAgentAccountNumber) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegisteredAgentPrepaidAccountBalanceRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegisteredAgentPrepaidAccountBalanceRA(<any>response_);
                } catch (e) {
                    return <Observable<GetAllRAAccountBalanceDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllRAAccountBalanceDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegisteredAgentPrepaidAccountBalanceRA(response: HttpResponseBase): Observable<GetAllRAAccountBalanceDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetAllRAAccountBalanceDto.fromJS(resultData200) : new GetAllRAAccountBalanceDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllRAAccountBalanceDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    setRegisteredAgentPrepaidAccountAlarmSettings(input: RegisteredAgentAlarmInput | null | undefined): Observable<RegisteredAgentAlarmDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/SetRegisteredAgentPrepaidAccountAlarmSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRegisteredAgentPrepaidAccountAlarmSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRegisteredAgentPrepaidAccountAlarmSettings(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredAgentAlarmDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredAgentAlarmDto>><any>_observableThrow(response_);
        }));
    }

    protected processSetRegisteredAgentPrepaidAccountAlarmSettings(response: HttpResponseBase): Observable<RegisteredAgentAlarmDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisteredAgentAlarmDto.fromJS(resultData200) : new RegisteredAgentAlarmDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredAgentAlarmDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateFinancialAccountInput | null | undefined): Observable<FinancialAccountDto> {
        let url_ = this.baseUrl + "/api/services/app/FinancialAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FinancialAccountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FinancialAccountDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FinancialAccountDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FinancialAccountDto.fromJS(resultData200) : new FinancialAccountDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FinancialAccountDto>(<any>null);
    }
}

@Injectable()
export class LookupDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateLookupDataInputWrapper | null | undefined): Observable<LookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LookupDataDto.fromJS(resultData200) : new LookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<LookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LookupDataDto.fromJS(resultData200) : new LookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param ids (optional) 
     * @param includeLookupDataType (optional) 
     * @param isActive (optional) 
     * @param keys (optional) 
     * @param lookupDataTypeKey (optional) 
     * @param parentKeys (optional) 
     * @param parentLevelsToInclude (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined, ids: string[] | null | undefined, includeLookupDataType: boolean | null | undefined, isActive: boolean | null | undefined, keys: string[] | null | undefined, lookupDataTypeKey: string | null | undefined, parentKeys: string[] | null | undefined, parentLevelsToInclude: number | null | undefined): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeLookupDataType !== undefined)
            url_ += "IncludeLookupDataType=" + encodeURIComponent("" + includeLookupDataType) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "Keys=" + encodeURIComponent("" + item) + "&"; });
        if (lookupDataTypeKey !== undefined)
            url_ += "LookupDataTypeKey=" + encodeURIComponent("" + lookupDataTypeKey) + "&"; 
        if (parentKeys !== undefined)
            parentKeys && parentKeys.forEach(item => { url_ += "ParentKeys=" + encodeURIComponent("" + item) + "&"; });
        if (parentLevelsToInclude !== undefined)
            url_ += "ParentLevelsToInclude=" + encodeURIComponent("" + parentLevelsToInclude) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }

    /**
     * @param companyTypeKey (optional) 
     * @return Success
     */
    getAllSignaturesByCompanyTypeKey(companyTypeKey: string | null | undefined): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/GetAllSignaturesByCompanyTypeKey?";
        if (companyTypeKey !== undefined)
            url_ += "companyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSignaturesByCompanyTypeKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSignaturesByCompanyTypeKey(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSignaturesByCompanyTypeKey(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CreateLookupDataInputWrapper | null | undefined): Observable<LookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/LookupData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? LookupDataDto.fromJS(resultData200) : new LookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto>(<any>null);
    }
}

@Injectable()
export class NameReservationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    checkName(input: CheckNameDtoInput | null | undefined): Observable<CheckNameDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/CheckName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckName(<any>response_);
                } catch (e) {
                    return <Observable<CheckNameDtoOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<CheckNameDtoOutput>><any>_observableThrow(response_);
        }));
    }

    protected processCheckName(response: HttpResponseBase): Observable<CheckNameDtoOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? CheckNameDtoOutput.fromJS(resultData200) : new CheckNameDtoOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckNameDtoOutput>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    complete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Complete?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processComplete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processComplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: NameReservationCreateDto | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createCR(input: NameReservationCreateDto | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/CreateCR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCR(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCR(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRA(input: NameReservationCreateDto | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/CreateRA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRA(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRA(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }

    /**
     * @return Success
     */
    expire(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Expire";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpire(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpire(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processExpire(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param isUnique (optional) 
     * @param isUsedForCompanyRegistration (optional) 
     * @param referenceNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param requestedFromCR (optional) 
     * @param requestNumber (optional) 
     * @param requestNumberOrBatchNumber (optional) 
     * @param requestStatusKeys (optional) 
     * @param reservationStatusKeys (optional) 
     * @param workflowStatusId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     * @deprecated
     */
    getAll(companyName: string | null | undefined, companyTypeKey: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, isUnique: boolean | null | undefined, isUsedForCompanyRegistration: boolean | null | undefined, referenceNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, requestedFromCR: boolean | null | undefined, requestNumber: string | null | undefined, requestNumberOrBatchNumber: string | null | undefined, requestStatusKeys: string[] | null | undefined, reservationStatusKeys: string[] | null | undefined, workflowStatusId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetAll?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (isUnique !== undefined)
            url_ += "IsUnique=" + encodeURIComponent("" + isUnique) + "&"; 
        if (isUsedForCompanyRegistration !== undefined)
            url_ += "IsUsedForCompanyRegistration=" + encodeURIComponent("" + isUsedForCompanyRegistration) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestedFromCR !== undefined)
            url_ += "RequestedFromCR=" + encodeURIComponent("" + requestedFromCR) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (requestNumberOrBatchNumber !== undefined)
            url_ += "RequestNumberOrBatchNumber=" + encodeURIComponent("" + requestNumberOrBatchNumber) + "&"; 
        if (requestStatusKeys !== undefined)
            requestStatusKeys && requestStatusKeys.forEach(item => { url_ += "RequestStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (reservationStatusKeys !== undefined)
            reservationStatusKeys && reservationStatusKeys.forEach(item => { url_ += "ReservationStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatusId !== undefined)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfNameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameReservationDto.fromJS(resultData200) : new PagedResultDtoOfNameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameReservationDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param isUnique (optional) 
     * @param isUsedForCompanyRegistration (optional) 
     * @param referenceNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param requestedFromCR (optional) 
     * @param requestNumber (optional) 
     * @param requestNumberOrBatchNumber (optional) 
     * @param requestStatusKeys (optional) 
     * @param reservationStatusKeys (optional) 
     * @param workflowStatusId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCR(companyName: string | null | undefined, companyTypeKey: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, isUnique: boolean | null | undefined, isUsedForCompanyRegistration: boolean | null | undefined, referenceNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, requestedFromCR: boolean | null | undefined, requestNumber: string | null | undefined, requestNumberOrBatchNumber: string | null | undefined, requestStatusKeys: string[] | null | undefined, reservationStatusKeys: string[] | null | undefined, workflowStatusId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetAllCR?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (isUnique !== undefined)
            url_ += "IsUnique=" + encodeURIComponent("" + isUnique) + "&"; 
        if (isUsedForCompanyRegistration !== undefined)
            url_ += "IsUsedForCompanyRegistration=" + encodeURIComponent("" + isUsedForCompanyRegistration) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestedFromCR !== undefined)
            url_ += "RequestedFromCR=" + encodeURIComponent("" + requestedFromCR) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (requestNumberOrBatchNumber !== undefined)
            url_ += "RequestNumberOrBatchNumber=" + encodeURIComponent("" + requestNumberOrBatchNumber) + "&"; 
        if (requestStatusKeys !== undefined)
            requestStatusKeys && requestStatusKeys.forEach(item => { url_ += "RequestStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (reservationStatusKeys !== undefined)
            reservationStatusKeys && reservationStatusKeys.forEach(item => { url_ += "ReservationStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatusId !== undefined)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCR(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCR(response: HttpResponseBase): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameReservationGetAllDto.fromJS(resultData200) : new PagedResultDtoOfNameReservationGetAllDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameReservationGetAllDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param isUnique (optional) 
     * @param isUsedForCompanyRegistration (optional) 
     * @param referenceNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param requestedFromCR (optional) 
     * @param requestNumber (optional) 
     * @param requestNumberOrBatchNumber (optional) 
     * @param requestStatusKeys (optional) 
     * @param reservationStatusKeys (optional) 
     * @param workflowStatusId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllCustom(companyName: string | null | undefined, companyTypeKey: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, isUnique: boolean | null | undefined, isUsedForCompanyRegistration: boolean | null | undefined, referenceNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, requestedFromCR: boolean | null | undefined, requestNumber: string | null | undefined, requestNumberOrBatchNumber: string | null | undefined, requestStatusKeys: string[] | null | undefined, reservationStatusKeys: string[] | null | undefined, workflowStatusId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetAllCustom?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (isUnique !== undefined)
            url_ += "IsUnique=" + encodeURIComponent("" + isUnique) + "&"; 
        if (isUsedForCompanyRegistration !== undefined)
            url_ += "IsUsedForCompanyRegistration=" + encodeURIComponent("" + isUsedForCompanyRegistration) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestedFromCR !== undefined)
            url_ += "RequestedFromCR=" + encodeURIComponent("" + requestedFromCR) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (requestNumberOrBatchNumber !== undefined)
            url_ += "RequestNumberOrBatchNumber=" + encodeURIComponent("" + requestNumberOrBatchNumber) + "&"; 
        if (requestStatusKeys !== undefined)
            requestStatusKeys && requestStatusKeys.forEach(item => { url_ += "RequestStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (reservationStatusKeys !== undefined)
            reservationStatusKeys && reservationStatusKeys.forEach(item => { url_ += "ReservationStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatusId !== undefined)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCustom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCustom(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllCustom(response: HttpResponseBase): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameReservationGetAllDto.fromJS(resultData200) : new PagedResultDtoOfNameReservationGetAllDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameReservationGetAllDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param isUnique (optional) 
     * @param isUsedForCompanyRegistration (optional) 
     * @param referenceNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param requestedFromCR (optional) 
     * @param requestNumber (optional) 
     * @param requestNumberOrBatchNumber (optional) 
     * @param requestStatusKeys (optional) 
     * @param reservationStatusKeys (optional) 
     * @param workflowStatusId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRA(companyName: string | null | undefined, companyTypeKey: string | null | undefined, dateFrom: Date | null | undefined, dateTo: Date | null | undefined, isUnique: boolean | null | undefined, isUsedForCompanyRegistration: boolean | null | undefined, referenceNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, requestedFromCR: boolean | null | undefined, requestNumber: string | null | undefined, requestNumberOrBatchNumber: string | null | undefined, requestStatusKeys: string[] | null | undefined, reservationStatusKeys: string[] | null | undefined, workflowStatusId: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetAllRA?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&"; 
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&"; 
        if (isUnique !== undefined)
            url_ += "IsUnique=" + encodeURIComponent("" + isUnique) + "&"; 
        if (isUsedForCompanyRegistration !== undefined)
            url_ += "IsUsedForCompanyRegistration=" + encodeURIComponent("" + isUsedForCompanyRegistration) + "&"; 
        if (referenceNumber !== undefined)
            url_ += "ReferenceNumber=" + encodeURIComponent("" + referenceNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestedFromCR !== undefined)
            url_ += "RequestedFromCR=" + encodeURIComponent("" + requestedFromCR) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (requestNumberOrBatchNumber !== undefined)
            url_ += "RequestNumberOrBatchNumber=" + encodeURIComponent("" + requestNumberOrBatchNumber) + "&"; 
        if (requestStatusKeys !== undefined)
            requestStatusKeys && requestStatusKeys.forEach(item => { url_ += "RequestStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (reservationStatusKeys !== undefined)
            reservationStatusKeys && reservationStatusKeys.forEach(item => { url_ += "ReservationStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (workflowStatusId !== undefined)
            url_ += "WorkflowStatusId=" + encodeURIComponent("" + workflowStatusId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfNameReservationGetAllDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRA(response: HttpResponseBase): Observable<PagedResultDtoOfNameReservationGetAllDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfNameReservationGetAllDto.fromJS(resultData200) : new PagedResultDtoOfNameReservationGetAllDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfNameReservationGetAllDto>(<any>null);
    }

    /**
     * @return Success
     */
    getNameReservationDurations(): Observable<NameReservationDurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetNameReservationDurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameReservationDurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameReservationDurations(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDurationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDurationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNameReservationDurations(response: HttpResponseBase): Observable<NameReservationDurationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NameReservationDurationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDurationDto[]>(<any>null);
    }

    /**
     * @param companyTypeKey (optional) 
     * @param durationKey (optional) 
     * @return Success
     */
    getNameReservationDurationServiceFees(companyTypeKey: string | null | undefined, durationKey: string | null | undefined): Observable<FeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetNameReservationDurationServiceFees?";
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (durationKey !== undefined)
            url_ += "DurationKey=" + encodeURIComponent("" + durationKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameReservationDurationServiceFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameReservationDurationServiceFees(<any>response_);
                } catch (e) {
                    return <Observable<FeeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FeeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNameReservationDurationServiceFees(response: HttpResponseBase): Observable<FeeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FeeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FeeDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNameReservationRenewalDurations(): Observable<NameReservationDurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetNameReservationRenewalDurations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNameReservationRenewalDurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNameReservationRenewalDurations(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDurationDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDurationDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetNameReservationRenewalDurations(response: HttpResponseBase): Observable<NameReservationDurationDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(NameReservationDurationDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDurationDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getReservationStatusList(): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/GetReservationStatusList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReservationStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReservationStatusList(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetReservationStatusList(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    renew(input: RenewNameReservationInput | null | undefined): Observable<RenewOutput> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenew(<any>response_);
                } catch (e) {
                    return <Observable<RenewOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<RenewOutput>><any>_observableThrow(response_);
        }));
    }

    protected processRenew(response: HttpResponseBase): Observable<RenewOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RenewOutput.fromJS(resultData200) : new RenewOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RenewOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: NameReservationUpdateDto | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateCR(input: NameReservationUpdateDto | null | undefined): Observable<NameReservationDto> {
        let url_ = this.baseUrl + "/api/services/app/NameReservation/UpdateCR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCR(<any>response_);
                } catch (e) {
                    return <Observable<NameReservationDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NameReservationDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCR(response: HttpResponseBase): Observable<NameReservationDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? NameReservationDto.fromJS(resultData200) : new NameReservationDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NameReservationDto>(<any>null);
    }
}

@Injectable()
export class PersonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreatePersonInput | null | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<PersonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PersonDto.fromJS(resultData200) : new PersonDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Person/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @param throwExceptionNotFound (optional) 
     * @return Success
     */
    get(id: string | null | undefined, throwExceptionNotFound: boolean | null | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        if (throwExceptionNotFound !== undefined)
            url_ += "throwExceptionNotFound=" + encodeURIComponent("" + throwExceptionNotFound) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<PersonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PersonDto.fromJS(resultData200) : new PersonDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonDto>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @param includes (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(ids: string[] | null | undefined, includes: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfPersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/GetAll?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includes !== undefined)
            includes && includes.forEach(item => { url_ += "Includes=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfPersonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfPersonDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPersonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfPersonDto.fromJS(resultData200) : new PagedResultDtoOfPersonDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfPersonDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CreatePersonInput | null | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<PersonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PersonDto.fromJS(resultData200) : new PersonDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    upsert(input: CreatePersonInput | null | undefined): Observable<PersonDto> {
        let url_ = this.baseUrl + "/api/services/app/Person/Upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(<any>response_);
                } catch (e) {
                    return <Observable<PersonDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PersonDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<PersonDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PersonDto.fromJS(resultData200) : new PersonDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PersonDto>(<any>null);
    }
}

@Injectable()
export class ReceiptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ReceiptDto | null | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptDto.fromJS(resultData200) : new ReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptDto.fromJS(resultData200) : new ReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(<any>null);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfReceiptDto.fromJS(resultData200) : new PagedResultDtoOfReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfReceiptDto>(<any>null);
    }

    /**
     * @param receiptNumber (optional) 
     * @return Success
     */
    getByReceiptNumberCR(receiptNumber: string | null | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/GetByReceiptNumberCR?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByReceiptNumberCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByReceiptNumberCR(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByReceiptNumberCR(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptDto.fromJS(resultData200) : new ReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(<any>null);
    }

    /**
     * @param receiptNumber (optional) 
     * @param registeredAgentId (optional) 
     * @return Success
     */
    getByReceiptNumberRA(receiptNumber: string | null | undefined, registeredAgentId: string | null | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/GetByReceiptNumberRA?";
        if (receiptNumber !== undefined)
            url_ += "receiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "registeredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByReceiptNumberRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByReceiptNumberRA(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByReceiptNumberRA(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptDto.fromJS(resultData200) : new ReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ReceiptDto | null | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ReceiptDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ReceiptDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ReceiptDto.fromJS(resultData200) : new ReceiptDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(<any>null);
    }
}

@Injectable()
export class RefundRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRefundRequestCR(input: RefundRequestCreateCRDto | null | undefined): Observable<GetRefundRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundRequest/CreateRefundRequestCR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRefundRequestCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRefundRequestCR(<any>response_);
                } catch (e) {
                    return <Observable<GetRefundRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRefundRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRefundRequestCR(response: HttpResponseBase): Observable<GetRefundRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRefundRequestDto.fromJS(resultData200) : new GetRefundRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundRequestDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRefundRequestRA(input: RefundRequestCreateDto | null | undefined): Observable<GetRefundRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundRequest/CreateRefundRequestRA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRefundRequestRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRefundRequestRA(<any>response_);
                } catch (e) {
                    return <Observable<GetRefundRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRefundRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRefundRequestRA(response: HttpResponseBase): Observable<GetRefundRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRefundRequestDto.fromJS(resultData200) : new GetRefundRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundRequestDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRefundRequest(id: string | null | undefined): Observable<GetRefundRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundRequest/GetRefundRequest?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRefundRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRefundRequest(<any>response_);
                } catch (e) {
                    return <Observable<GetRefundRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRefundRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRefundRequest(response: HttpResponseBase): Observable<GetRefundRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRefundRequestDto.fromJS(resultData200) : new GetRefundRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundRequestDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateRefundRequest(input: RefundRequestUpdateDto | null | undefined): Observable<GetRefundRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/RefundRequest/UpdateRefundRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRefundRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRefundRequest(<any>response_);
                } catch (e) {
                    return <Observable<GetRefundRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRefundRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRefundRequest(response: HttpResponseBase): Observable<GetRefundRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRefundRequestDto.fromJS(resultData200) : new GetRefundRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRefundRequestDto>(<any>null);
    }
}

@Injectable()
export class RegisteredAgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRegisteredAgentInput | null | undefined): Observable<RegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisteredAgent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisteredAgentDto.fromJS(resultData200) : new RegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredAgentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<RegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisteredAgent/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisteredAgentDto.fromJS(resultData200) : new RegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredAgentDto>(<any>null);
    }

    /**
     * @param accountNumber (optional) 
     * @param creationEndDate (optional) 
     * @param creationStartDate (optional) 
     * @param ids (optional) 
     * @param includeContactInformation (optional) 
     * @param isActive (optional) 
     * @param maxResultCount (optional) 
     * @param name (optional) 
     * @param resignedAtFrom (optional) 
     * @param resignedAtTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAll(accountNumber: string | null | undefined, creationEndDate: Date | null | undefined, creationStartDate: Date | null | undefined, ids: string[] | null | undefined, includeContactInformation: boolean | null | undefined, isActive: boolean | null | undefined, maxResultCount: number | null | undefined, name: string | null | undefined, resignedAtFrom: Date | null | undefined, resignedAtTo: Date | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfRegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisteredAgent/GetAll?";
        if (accountNumber !== undefined)
            url_ += "AccountNumber=" + encodeURIComponent("" + accountNumber) + "&"; 
        if (creationEndDate !== undefined)
            url_ += "CreationEndDate=" + encodeURIComponent(creationEndDate ? "" + creationEndDate.toJSON() : "") + "&"; 
        if (creationStartDate !== undefined)
            url_ += "CreationStartDate=" + encodeURIComponent(creationStartDate ? "" + creationStartDate.toJSON() : "") + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeContactInformation !== undefined)
            url_ += "IncludeContactInformation=" + encodeURIComponent("" + includeContactInformation) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (resignedAtFrom !== undefined)
            url_ += "ResignedAtFrom=" + encodeURIComponent(resignedAtFrom ? "" + resignedAtFrom.toJSON() : "") + "&"; 
        if (resignedAtTo !== undefined)
            url_ += "ResignedAtTo=" + encodeURIComponent(resignedAtTo ? "" + resignedAtTo.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRegisteredAgentDto.fromJS(resultData200) : new PagedResultDtoOfRegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRegisteredAgentDto>(<any>null);
    }

    /**
     * @param accountNumber (optional) 
     * @param creationEndDate (optional) 
     * @param creationStartDate (optional) 
     * @param ids (optional) 
     * @param includeContactInformation (optional) 
     * @param isActive (optional) 
     * @param maxResultCount (optional) 
     * @param name (optional) 
     * @param resignedAtFrom (optional) 
     * @param resignedAtTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllSearch(accountNumber: string | null | undefined, creationEndDate: Date | null | undefined, creationStartDate: Date | null | undefined, ids: string[] | null | undefined, includeContactInformation: boolean | null | undefined, isActive: boolean | null | undefined, maxResultCount: number | null | undefined, name: string | null | undefined, resignedAtFrom: Date | null | undefined, resignedAtTo: Date | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined): Observable<PagedResultDtoOfGetAllRegisteredAgentOutput> {
        let url_ = this.baseUrl + "/api/services/app/RegisteredAgent/GetAllSearch?";
        if (accountNumber !== undefined)
            url_ += "AccountNumber=" + encodeURIComponent("" + accountNumber) + "&"; 
        if (creationEndDate !== undefined)
            url_ += "CreationEndDate=" + encodeURIComponent(creationEndDate ? "" + creationEndDate.toJSON() : "") + "&"; 
        if (creationStartDate !== undefined)
            url_ += "CreationStartDate=" + encodeURIComponent(creationStartDate ? "" + creationStartDate.toJSON() : "") + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (includeContactInformation !== undefined)
            url_ += "IncludeContactInformation=" + encodeURIComponent("" + includeContactInformation) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (resignedAtFrom !== undefined)
            url_ += "ResignedAtFrom=" + encodeURIComponent(resignedAtFrom ? "" + resignedAtFrom.toJSON() : "") + "&"; 
        if (resignedAtTo !== undefined)
            url_ += "ResignedAtTo=" + encodeURIComponent(resignedAtTo ? "" + resignedAtTo.toJSON() : "") + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllRegisteredAgentOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllRegisteredAgentOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllRegisteredAgentOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllRegisteredAgentOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllRegisteredAgentOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllRegisteredAgentOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateRegisteredAgentInput | null | undefined): Observable<RegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/RegisteredAgent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RegisteredAgentDto.fromJS(resultData200) : new RegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegisteredAgentDto>(<any>null);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param incorporationDateFrom (optional) 
     * @param incorporationDateTo (optional) 
     * @param registeredAgentIds (optional) 
     * @return Success
     */
    getEntityStatusReport(incorporationDateFrom: Date | null | undefined, incorporationDateTo: Date | null | undefined, registeredAgentIds: string[] | null | undefined): Observable<GetEntityStatusReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetEntityStatusReport?";
        if (incorporationDateFrom !== undefined)
            url_ += "IncorporationDateFrom=" + encodeURIComponent(incorporationDateFrom ? "" + incorporationDateFrom.toJSON() : "") + "&"; 
        if (incorporationDateTo !== undefined)
            url_ += "IncorporationDateTo=" + encodeURIComponent(incorporationDateTo ? "" + incorporationDateTo.toJSON() : "") + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityStatusReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityStatusReport(<any>response_);
                } catch (e) {
                    return <Observable<GetEntityStatusReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetEntityStatusReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetEntityStatusReport(response: HttpResponseBase): Observable<GetEntityStatusReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEntityStatusReportOutput.fromJS(resultData200) : new GetEntityStatusReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEntityStatusReportOutput>(<any>null);
    }

    /**
     * @param incorporationDateFrom (optional) 
     * @param incorporationDateTo (optional) 
     * @param registeredAgentIds (optional) 
     * @return Success
     */
    getIncorporationStatisticsReport(incorporationDateFrom: Date | null | undefined, incorporationDateTo: Date | null | undefined, registeredAgentIds: string[] | null | undefined): Observable<GetIncorporationStatisticsReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetIncorporationStatisticsReport?";
        if (incorporationDateFrom !== undefined)
            url_ += "IncorporationDateFrom=" + encodeURIComponent(incorporationDateFrom ? "" + incorporationDateFrom.toJSON() : "") + "&"; 
        if (incorporationDateTo !== undefined)
            url_ += "IncorporationDateTo=" + encodeURIComponent(incorporationDateTo ? "" + incorporationDateTo.toJSON() : "") + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncorporationStatisticsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncorporationStatisticsReport(<any>response_);
                } catch (e) {
                    return <Observable<GetIncorporationStatisticsReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetIncorporationStatisticsReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetIncorporationStatisticsReport(response: HttpResponseBase): Observable<GetIncorporationStatisticsReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetIncorporationStatisticsReportOutput.fromJS(resultData200) : new GetIncorporationStatisticsReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetIncorporationStatisticsReportOutput>(<any>null);
    }

    /**
     * @param transactionDateFrom (optional) 
     * @param transactionDateTo (optional) 
     * @param registeredAgentIds (optional) 
     * @return Success
     */
    getRegistryStatisticsReport(transactionDateFrom: Date | null | undefined, transactionDateTo: Date | null | undefined, registeredAgentIds: string[] | null | undefined): Observable<GetRegistryStatisticsReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetRegistryStatisticsReport?";
        if (transactionDateFrom !== undefined)
            url_ += "TransactionDateFrom=" + encodeURIComponent(transactionDateFrom ? "" + transactionDateFrom.toJSON() : "") + "&"; 
        if (transactionDateTo !== undefined)
            url_ += "TransactionDateTo=" + encodeURIComponent(transactionDateTo ? "" + transactionDateTo.toJSON() : "") + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegistryStatisticsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegistryStatisticsReport(<any>response_);
                } catch (e) {
                    return <Observable<GetRegistryStatisticsReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRegistryStatisticsReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRegistryStatisticsReport(response: HttpResponseBase): Observable<GetRegistryStatisticsReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRegistryStatisticsReportOutput.fromJS(resultData200) : new GetRegistryStatisticsReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRegistryStatisticsReportOutput>(<any>null);
    }

    /**
     * @param isExport (optional) 
     * @param entityType (optional) 
     * @param entityName (optional) 
     * @param incorporationNo (optional) 
     * @param incorporationDateFrom (optional) 
     * @param incorporationDateTo (optional) 
     * @param status (optional) 
     * @param rAName (optional) 
     * @param businessActivityKeyword (optional) 
     * @param registeredAgentIds (optional) 
     * @return Success
     */
    getBusinessActivitiesReport(isExport: boolean | null | undefined, entityType: string | null | undefined, entityName: string | null | undefined, incorporationNo: string | null | undefined, incorporationDateFrom: Date | null | undefined, incorporationDateTo: Date | null | undefined, status: string | null | undefined, rAName: string | null | undefined, businessActivityKeyword: string | null | undefined, registeredAgentIds: string[] | null | undefined): Observable<GetBusinessActivitiesReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetBusinessActivitiesReport?";
        if (isExport !== undefined)
            url_ += "IsExport=" + encodeURIComponent("" + isExport) + "&"; 
        if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (incorporationNo !== undefined)
            url_ += "IncorporationNo=" + encodeURIComponent("" + incorporationNo) + "&"; 
        if (incorporationDateFrom !== undefined)
            url_ += "IncorporationDateFrom=" + encodeURIComponent(incorporationDateFrom ? "" + incorporationDateFrom.toJSON() : "") + "&"; 
        if (incorporationDateTo !== undefined)
            url_ += "IncorporationDateTo=" + encodeURIComponent(incorporationDateTo ? "" + incorporationDateTo.toJSON() : "") + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (rAName !== undefined)
            url_ += "RAName=" + encodeURIComponent("" + rAName) + "&"; 
        if (businessActivityKeyword !== undefined)
            url_ += "BusinessActivityKeyword=" + encodeURIComponent("" + businessActivityKeyword) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBusinessActivitiesReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBusinessActivitiesReport(<any>response_);
                } catch (e) {
                    return <Observable<GetBusinessActivitiesReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetBusinessActivitiesReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetBusinessActivitiesReport(response: HttpResponseBase): Observable<GetBusinessActivitiesReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetBusinessActivitiesReportOutput.fromJS(resultData200) : new GetBusinessActivitiesReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetBusinessActivitiesReportOutput>(<any>null);
    }

    /**
     * @param registeredAgentIds (optional) 
     * @param transactionDateFrom (optional) 
     * @param transactionDateTo (optional) 
     * @return Success
     */
    getRevenueReport(registeredAgentIds: string[] | null | undefined, transactionDateFrom: Date | null | undefined, transactionDateTo: Date | null | undefined): Observable<GetRevenueReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetRevenueReport?";
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (transactionDateFrom !== undefined)
            url_ += "TransactionDateFrom=" + encodeURIComponent(transactionDateFrom ? "" + transactionDateFrom.toJSON() : "") + "&"; 
        if (transactionDateTo !== undefined)
            url_ += "TransactionDateTo=" + encodeURIComponent(transactionDateTo ? "" + transactionDateTo.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRevenueReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRevenueReport(<any>response_);
                } catch (e) {
                    return <Observable<GetRevenueReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRevenueReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRevenueReport(response: HttpResponseBase): Observable<GetRevenueReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRevenueReportOutput.fromJS(resultData200) : new GetRevenueReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRevenueReportOutput>(<any>null);
    }

    /**
     * @param registeredAgentIds (optional) 
     * @param transactionDateFrom (optional) 
     * @param transactionDateTo (optional) 
     * @return Success
     */
    getDepositReport(registeredAgentIds: string[] | null | undefined, transactionDateFrom: Date | null | undefined, transactionDateTo: Date | null | undefined): Observable<GetDepositReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetDepositReport?";
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (transactionDateFrom !== undefined)
            url_ += "TransactionDateFrom=" + encodeURIComponent(transactionDateFrom ? "" + transactionDateFrom.toJSON() : "") + "&"; 
        if (transactionDateTo !== undefined)
            url_ += "TransactionDateTo=" + encodeURIComponent(transactionDateTo ? "" + transactionDateTo.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepositReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepositReport(<any>response_);
                } catch (e) {
                    return <Observable<GetDepositReportOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetDepositReportOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetDepositReport(response: HttpResponseBase): Observable<GetDepositReportOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetDepositReportOutput.fromJS(resultData200) : new GetDepositReportOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetDepositReportOutput>(<any>null);
    }
}

@Injectable()
export class RequestFeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    checkIsRefunded(ids: string[] | null | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestFee/CheckIsRefunded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIsRefunded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIsRefunded(<any>response_);
                } catch (e) {
                    return <Observable<string[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<string[]>><any>_observableThrow(response_);
        }));
    }

    protected processCheckIsRefunded(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(item);
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(<any>null);
    }

    /**
     * @param companyTypeKey (optional) 
     * @param ibcInsuranceClassKeys (optional) 
     * @return Success
     */
    getAllByCompanyTypeAndServiceTypes(companyTypeKey: string | null | undefined, ibcInsuranceClassKeys: string[] | null | undefined, serviceTypeKeys: string[]): Observable<RequestFeeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestFee/GetAllByCompanyTypeAndServiceTypes?";
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (ibcInsuranceClassKeys !== undefined)
            ibcInsuranceClassKeys && ibcInsuranceClassKeys.forEach(item => { url_ += "IbcInsuranceClassKeys=" + encodeURIComponent("" + item) + "&"; });
        if (serviceTypeKeys === undefined || serviceTypeKeys === null)
            throw new Error("The parameter 'serviceTypeKeys' must be defined and cannot be null.");
        else
            serviceTypeKeys && serviceTypeKeys.forEach(item => { url_ += "ServiceTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByCompanyTypeAndServiceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByCompanyTypeAndServiceTypes(<any>response_);
                } catch (e) {
                    return <Observable<RequestFeeDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestFeeDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByCompanyTypeAndServiceTypes(response: HttpResponseBase): Observable<RequestFeeDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RequestFeeDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFeeDto[]>(<any>null);
    }
}

@Injectable()
export class RequestFeeCertificateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: UpdateRequestFeeCertificateInput | null | undefined): Observable<RequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestFeeCertificateDto.fromJS(resultData200) : new RequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFeeCertificateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<RequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestFeeCertificateDto.fromJS(resultData200) : new RequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFeeCertificateDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getByFileRecordId(input: string | null | undefined): Observable<RequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/GetByFileRecordIdAsync?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFileRecordId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFileRecordId(<any>response_);
                } catch (e) {
                    return <Observable<RequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByFileRecordId(response: HttpResponseBase): Observable<RequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestFeeCertificateDto.fromJS(resultData200) : new RequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFeeCertificateDto>(<any>null);
    }

    /**
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param entityName (optional) 
     * @param incorporationNumber (optional) 
     * @param transactionNumber (optional) 
     * @param receiptNumber (optional) 
     * @param requestNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearch(creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, entityName: string | null | undefined, incorporationNumber: string | null | undefined, transactionNumber: string | null | undefined, receiptNumber: string | null | undefined, requestNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/GetAllSearch?";
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (transactionNumber !== undefined)
            url_ += "TransactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        if (receiptNumber !== undefined)
            url_ += "ReceiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfRequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRequestFeeCertificateDto.fromJS(resultData200) : new PagedResultDtoOfRequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestFeeCertificateDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateRequestFeeCertificateInput | null | undefined): Observable<RequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestFeeCertificateDto.fromJS(resultData200) : new RequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestFeeCertificateDto>(<any>null);
    }

    /**
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param entityName (optional) 
     * @param incorporationNumber (optional) 
     * @param transactionNumber (optional) 
     * @param receiptNumber (optional) 
     * @param requestNumber (optional) 
     * @param registeredAgentIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, entityName: string | null | undefined, incorporationNumber: string | null | undefined, transactionNumber: string | null | undefined, receiptNumber: string | null | undefined, requestNumber: string | null | undefined, registeredAgentIds: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRequestFeeCertificateDto> {
        let url_ = this.baseUrl + "/api/services/app/RequestFeeCertificate/GetAll?";
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (incorporationNumber !== undefined)
            url_ += "IncorporationNumber=" + encodeURIComponent("" + incorporationNumber) + "&"; 
        if (transactionNumber !== undefined)
            url_ += "TransactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        if (receiptNumber !== undefined)
            url_ += "ReceiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (registeredAgentIds !== undefined)
            registeredAgentIds && registeredAgentIds.forEach(item => { url_ += "RegisteredAgentIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRequestFeeCertificateDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRequestFeeCertificateDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRequestFeeCertificateDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRequestFeeCertificateDto.fromJS(resultData200) : new PagedResultDtoOfRequestFeeCertificateDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestFeeCertificateDto>(<any>null);
    }
}

@Injectable()
export class RequestV2ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRequestInput | null | undefined): Observable<RequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestV2Dto.fromJS(resultData200) : new RequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestV2Dto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<RequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestV2Dto.fromJS(resultData200) : new RequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestV2Dto>(<any>null);
    }

    /**
     * @param amountFrom (optional) 
     * @param assignedToGroupName (optional) 
     * @param companyID (optional) 
     * @param companyName (optional) 
     * @param companyTypeKey (optional) 
     * @param completionDateFrom (optional) 
     * @param completionDateTo (optional) 
     * @param creationDateFrom (optional) 
     * @param creationDateTo (optional) 
     * @param excludeCompletedTerminatedRequestInterval (optional) 
     * @param externalStatus (optional) 
     * @param hasRegisteredAgent (optional) 
     * @param ids (optional) 
     * @param internalStatus (optional) 
     * @param isNotInBatch (optional) 
     * @param lastModificationDateFrom (optional) 
     * @param lastModificationDateTo (optional) 
     * @param receivedFromName (optional) 
     * @param registeredAgentID (optional) 
     * @param requestFeeIds (optional) 
     * @param requestNumber (optional) 
     * @param serviceCategoryKey (optional) 
     * @param serviceTypeKey (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(amountFrom: number | null | undefined, assignedToGroupName: string | null | undefined, companyID: string | null | undefined, companyName: string | null | undefined, companyTypeKey: string | null | undefined, completionDateFrom: Date | null | undefined, completionDateTo: Date | null | undefined, creationDateFrom: Date | null | undefined, creationDateTo: Date | null | undefined, excludeCompletedTerminatedRequestInterval: number | null | undefined, externalStatus: string[] | null | undefined, hasRegisteredAgent: boolean | null | undefined, ids: string[] | null | undefined, internalStatus: string[] | null | undefined, isNotInBatch: boolean | null | undefined, lastModificationDateFrom: Date | null | undefined, lastModificationDateTo: Date | null | undefined, receivedFromName: string | null | undefined, registeredAgentID: string | null | undefined, requestFeeIds: string[] | null | undefined, requestNumber: string | null | undefined, serviceCategoryKey: string | null | undefined, serviceTypeKey: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/GetAll?";
        if (amountFrom !== undefined)
            url_ += "AmountFrom=" + encodeURIComponent("" + amountFrom) + "&"; 
        if (assignedToGroupName !== undefined)
            url_ += "AssignedToGroupName=" + encodeURIComponent("" + assignedToGroupName) + "&"; 
        if (companyID !== undefined)
            url_ += "CompanyID=" + encodeURIComponent("" + companyID) + "&"; 
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (completionDateFrom !== undefined)
            url_ += "CompletionDateFrom=" + encodeURIComponent(completionDateFrom ? "" + completionDateFrom.toJSON() : "") + "&"; 
        if (completionDateTo !== undefined)
            url_ += "CompletionDateTo=" + encodeURIComponent(completionDateTo ? "" + completionDateTo.toJSON() : "") + "&"; 
        if (creationDateFrom !== undefined)
            url_ += "CreationDateFrom=" + encodeURIComponent(creationDateFrom ? "" + creationDateFrom.toJSON() : "") + "&"; 
        if (creationDateTo !== undefined)
            url_ += "CreationDateTo=" + encodeURIComponent(creationDateTo ? "" + creationDateTo.toJSON() : "") + "&"; 
        if (excludeCompletedTerminatedRequestInterval !== undefined)
            url_ += "ExcludeCompletedTerminatedRequestInterval=" + encodeURIComponent("" + excludeCompletedTerminatedRequestInterval) + "&"; 
        if (externalStatus !== undefined)
            externalStatus && externalStatus.forEach(item => { url_ += "ExternalStatus=" + encodeURIComponent("" + item) + "&"; });
        if (hasRegisteredAgent !== undefined)
            url_ += "HasRegisteredAgent=" + encodeURIComponent("" + hasRegisteredAgent) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (internalStatus !== undefined)
            internalStatus && internalStatus.forEach(item => { url_ += "InternalStatus=" + encodeURIComponent("" + item) + "&"; });
        if (isNotInBatch !== undefined)
            url_ += "IsNotInBatch=" + encodeURIComponent("" + isNotInBatch) + "&"; 
        if (lastModificationDateFrom !== undefined)
            url_ += "LastModificationDateFrom=" + encodeURIComponent(lastModificationDateFrom ? "" + lastModificationDateFrom.toJSON() : "") + "&"; 
        if (lastModificationDateTo !== undefined)
            url_ += "LastModificationDateTo=" + encodeURIComponent(lastModificationDateTo ? "" + lastModificationDateTo.toJSON() : "") + "&"; 
        if (receivedFromName !== undefined)
            url_ += "ReceivedFromName=" + encodeURIComponent("" + receivedFromName) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestFeeIds !== undefined)
            requestFeeIds && requestFeeIds.forEach(item => { url_ += "RequestFeeIds=" + encodeURIComponent("" + item) + "&"; });
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (serviceCategoryKey !== undefined)
            url_ += "ServiceCategoryKey=" + encodeURIComponent("" + serviceCategoryKey) + "&"; 
        if (serviceTypeKey !== undefined)
            url_ += "ServiceTypeKey=" + encodeURIComponent("" + serviceTypeKey) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRequestV2Dto.fromJS(resultData200) : new PagedResultDtoOfRequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRequestV2Dto>(<any>null);
    }

    /**
     * @param currentStatusKey (optional) 
     * @param parentKeys (optional) 
     * @param workflowKey (optional) 
     * @return Success
     */
    getStatusList(currentStatusKey: string | null | undefined, parentKeys: string[] | null | undefined, workflowKey: string | null | undefined): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/GetStatusList?";
        if (currentStatusKey !== undefined)
            url_ += "CurrentStatusKey=" + encodeURIComponent("" + currentStatusKey) + "&"; 
        if (parentKeys !== undefined)
            parentKeys && parentKeys.forEach(item => { url_ += "ParentKeys=" + encodeURIComponent("" + item) + "&"; });
        if (workflowKey !== undefined)
            url_ += "WorkflowKey=" + encodeURIComponent("" + workflowKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStatusList(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetStatusList(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    markRequestAsPaid(input: MarkRequestAsPaidInput | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/MarkRequestAsPaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkRequestAsPaid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkRequestAsPaid(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processMarkRequestAsPaid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateRequestInput | null | undefined): Observable<RequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestV2Dto.fromJS(resultData200) : new RequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestV2Dto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateRequestFees(input: UpdateRequestFeesInput | null | undefined): Observable<RequestV2Dto> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/UpdateRequestFees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRequestFees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRequestFees(<any>response_);
                } catch (e) {
                    return <Observable<RequestV2Dto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RequestV2Dto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRequestFees(response: HttpResponseBase): Observable<RequestV2Dto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RequestV2Dto.fromJS(resultData200) : new RequestV2Dto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestV2Dto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    validateRequestForPayment(input: ValidateRequestForPaymentInput | null | undefined): Observable<AjaxResponse> {
        let url_ = this.baseUrl + "/api/services/app/RequestV2/ValidateRequestForPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRequestForPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRequestForPayment(<any>response_);
                } catch (e) {
                    return <Observable<AjaxResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AjaxResponse>><any>_observableThrow(response_);
        }));
    }

    protected processValidateRequestForPayment(response: HttpResponseBase): Observable<AjaxResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AjaxResponse.fromJS(resultData200) : new AjaxResponse();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AjaxResponse>(<any>null);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateRoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfPermissionDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfPermissionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfPermissionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfPermissionDto.fromJS(resultData200) : new ListResultDtoOfPermissionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfPermissionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | null | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(<any>response_);
                } catch (e) {
                    return <Observable<GetRoleForEditOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetRoleForEditOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | null | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRolesAsync?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleListDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleListDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: RoleDto | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<RoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param permissions (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, permissions: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfRoleDto.fromJS(resultData200) : new PagedResultDtoOfRoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfRoleDto>(<any>null);
    }
}

@Injectable()
export class SecurityQuestionsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateOrUpdate | null | undefined): Observable<SecurityQuestionDto> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SecurityQuestionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SecurityQuestionDto.fromJS(resultData200) : new SecurityQuestionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param userNameOrEmailAddress (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userNameOrEmailAddress: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfSecurityQuestionDto> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/GetAll?";
        if (userNameOrEmailAddress !== undefined)
            url_ += "UserNameOrEmailAddress=" + encodeURIComponent("" + userNameOrEmailAddress) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfSecurityQuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfSecurityQuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfSecurityQuestionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfSecurityQuestionDto.fromJS(resultData200) : new PagedResultDtoOfSecurityQuestionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfSecurityQuestionDto>(<any>null);
    }

    /**
     * @return Success
     */
    getAllSecurityQuestions(): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/GetAllSecurityQuestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSecurityQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSecurityQuestions(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSecurityQuestions(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }

    /**
     * @return Success
     */
    getSecurityQuestionsForUser(userId: number): Observable<ValidateAnswerForSecurityQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/GetSecurityQuestionsForUser?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecurityQuestionsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecurityQuestionsForUser(<any>response_);
                } catch (e) {
                    return <Observable<ValidateAnswerForSecurityQuestionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ValidateAnswerForSecurityQuestionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetSecurityQuestionsForUser(response: HttpResponseBase): Observable<ValidateAnswerForSecurityQuestionDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ValidateAnswerForSecurityQuestionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateAnswerForSecurityQuestionDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    insertOrUpdate(input: CreateOrUpdate[] | null | undefined): Observable<SecurityQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/InsertOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertOrUpdate(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestionDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestionDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processInsertOrUpdate(response: HttpResponseBase): Observable<SecurityQuestionDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(SecurityQuestionDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestionDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: CreateOrUpdate | null | undefined): Observable<SecurityQuestionDto> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SecurityQuestionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SecurityQuestionDto.fromJS(resultData200) : new SecurityQuestionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestionDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<SecurityQuestionDto> {
        let url_ = this.baseUrl + "/api/services/app/SecurityQuestions/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<SecurityQuestionDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SecurityQuestionDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SecurityQuestionDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SecurityQuestionDto.fromJS(resultData200) : new SecurityQuestionDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SecurityQuestionDto>(<any>null);
    }
}

@Injectable()
export class ServiceFeeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: ServiceFeeDto | null | undefined): Observable<ServiceFeeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFee/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ServiceFeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceFeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceFeeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceFeeDto.fromJS(resultData200) : new ServiceFeeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceFeeDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFee/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<ServiceFeeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFee/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ServiceFeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceFeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceFeeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceFeeDto.fromJS(resultData200) : new ServiceFeeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceFeeDto>(<any>null);
    }

    /**
     * @param companyTypeKey (optional) 
     * @param serviceTypeKey (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(companyTypeKey: string | null | undefined, serviceTypeKey: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfServiceFeeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFee/GetAll?";
        if (companyTypeKey !== undefined)
            url_ += "CompanyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        if (serviceTypeKey !== undefined)
            url_ += "ServiceTypeKey=" + encodeURIComponent("" + serviceTypeKey) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceFeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceFeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfServiceFeeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfServiceFeeDto.fromJS(resultData200) : new PagedResultDtoOfServiceFeeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceFeeDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: ServiceFeeDto | null | undefined): Observable<ServiceFeeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFee/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ServiceFeeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceFeeDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceFeeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceFeeDto.fromJS(resultData200) : new ServiceFeeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceFeeDto>(<any>null);
    }
}

@Injectable()
export class ServiceRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateServiceRequestInput | null | undefined): Observable<ServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<ServiceRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceRequestDto.fromJS(resultData200) : new ServiceRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceRequestDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<ServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ServiceRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceRequestDto.fromJS(resultData200) : new ServiceRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceRequestDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKeys (optional) 
     * @param isWalkInService (optional) 
     * @param registeredAgentId (optional) 
     * @param requestCreationDateFrom (optional) 
     * @param requestCreationDateTo (optional) 
     * @param requestedByName (optional) 
     * @param requestExternalStatusKeys (optional) 
     * @param requestInternalStatusKeys (optional) 
     * @param requestNumber (optional) 
     * @param serviceTypeKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(companyName: string | null | undefined, companyTypeKeys: string[] | null | undefined, isWalkInService: boolean | null | undefined, registeredAgentId: string | null | undefined, requestCreationDateFrom: Date | null | undefined, requestCreationDateTo: Date | null | undefined, requestedByName: string | null | undefined, requestExternalStatusKeys: string[] | null | undefined, requestInternalStatusKeys: string[] | null | undefined, requestNumber: string | null | undefined, serviceTypeKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/GetAll?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKeys !== undefined)
            companyTypeKeys && companyTypeKeys.forEach(item => { url_ += "CompanyTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (isWalkInService !== undefined)
            url_ += "IsWalkInService=" + encodeURIComponent("" + isWalkInService) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestCreationDateFrom !== undefined)
            url_ += "RequestCreationDateFrom=" + encodeURIComponent(requestCreationDateFrom ? "" + requestCreationDateFrom.toJSON() : "") + "&"; 
        if (requestCreationDateTo !== undefined)
            url_ += "RequestCreationDateTo=" + encodeURIComponent(requestCreationDateTo ? "" + requestCreationDateTo.toJSON() : "") + "&"; 
        if (requestedByName !== undefined)
            url_ += "RequestedByName=" + encodeURIComponent("" + requestedByName) + "&"; 
        if (requestExternalStatusKeys !== undefined)
            requestExternalStatusKeys && requestExternalStatusKeys.forEach(item => { url_ += "RequestExternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestInternalStatusKeys !== undefined)
            requestInternalStatusKeys && requestInternalStatusKeys.forEach(item => { url_ += "RequestInternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (serviceTypeKeys !== undefined)
            serviceTypeKeys && serviceTypeKeys.forEach(item => { url_ += "ServiceTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfServiceRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfServiceRequestDto.fromJS(resultData200) : new PagedResultDtoOfServiceRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceRequestDto>(<any>null);
    }

    /**
     * @param companyName (optional) 
     * @param companyTypeKeys (optional) 
     * @param isWalkInService (optional) 
     * @param registeredAgentId (optional) 
     * @param requestCreationDateFrom (optional) 
     * @param requestCreationDateTo (optional) 
     * @param requestedByName (optional) 
     * @param requestExternalStatusKeys (optional) 
     * @param requestInternalStatusKeys (optional) 
     * @param requestNumber (optional) 
     * @param serviceTypeKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearch(companyName: string | null | undefined, companyTypeKeys: string[] | null | undefined, isWalkInService: boolean | null | undefined, registeredAgentId: string | null | undefined, requestCreationDateFrom: Date | null | undefined, requestCreationDateTo: Date | null | undefined, requestedByName: string | null | undefined, requestExternalStatusKeys: string[] | null | undefined, requestInternalStatusKeys: string[] | null | undefined, requestNumber: string | null | undefined, serviceTypeKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllServiceRequestOutput> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/GetAllSearch?";
        if (companyName !== undefined)
            url_ += "CompanyName=" + encodeURIComponent("" + companyName) + "&"; 
        if (companyTypeKeys !== undefined)
            companyTypeKeys && companyTypeKeys.forEach(item => { url_ += "CompanyTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (isWalkInService !== undefined)
            url_ += "IsWalkInService=" + encodeURIComponent("" + isWalkInService) + "&"; 
        if (registeredAgentId !== undefined)
            url_ += "RegisteredAgentId=" + encodeURIComponent("" + registeredAgentId) + "&"; 
        if (requestCreationDateFrom !== undefined)
            url_ += "RequestCreationDateFrom=" + encodeURIComponent(requestCreationDateFrom ? "" + requestCreationDateFrom.toJSON() : "") + "&"; 
        if (requestCreationDateTo !== undefined)
            url_ += "RequestCreationDateTo=" + encodeURIComponent(requestCreationDateTo ? "" + requestCreationDateTo.toJSON() : "") + "&"; 
        if (requestedByName !== undefined)
            url_ += "RequestedByName=" + encodeURIComponent("" + requestedByName) + "&"; 
        if (requestExternalStatusKeys !== undefined)
            requestExternalStatusKeys && requestExternalStatusKeys.forEach(item => { url_ += "RequestExternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestInternalStatusKeys !== undefined)
            requestInternalStatusKeys && requestInternalStatusKeys.forEach(item => { url_ += "RequestInternalStatusKeys=" + encodeURIComponent("" + item) + "&"; });
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (serviceTypeKeys !== undefined)
            serviceTypeKeys && serviceTypeKeys.forEach(item => { url_ += "ServiceTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllServiceRequestOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllServiceRequestOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllServiceRequestOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllServiceRequestOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllServiceRequestOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllServiceRequestOutput>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateServiceRequestInput | null | undefined): Observable<ServiceRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceRequest/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<ServiceRequestDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceRequestDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceRequestDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceRequestDto.fromJS(resultData200) : new ServiceRequestDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceRequestDto>(<any>null);
    }
}

@Injectable()
export class ServiceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<ServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceType/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<ServiceTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceTypeDto.fromJS(resultData200) : new ServiceTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTypeDto>(<any>null);
    }

    /**
     * @param parentKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(parentKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceType/GetAll?";
        if (parentKeys !== undefined)
            parentKeys && parentKeys.forEach(item => { url_ += "ParentKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfServiceTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfServiceTypeDto.fromJS(resultData200) : new PagedResultDtoOfServiceTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceTypeDto>(<any>null);
    }

    /**
     * @param key (optional) 
     * @return Success
     */
    getByKey(key: string | null | undefined): Observable<ServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceType/GetByKey?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByKey(<any>response_);
                } catch (e) {
                    return <Observable<ServiceTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ServiceTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByKey(response: HttpResponseBase): Observable<ServiceTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ServiceTypeDto.fromJS(resultData200) : new ServiceTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceTypeDto>(<any>null);
    }

    /**
     * @param companyTypeKey (optional) 
     * @return Success
     */
    getServiceTypesByCompanyType(companyTypeKey: string | null | undefined): Observable<PagedResultDtoOfServiceTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceType/GetServiceTypesByCompanyType?";
        if (companyTypeKey !== undefined)
            url_ += "companyTypeKey=" + encodeURIComponent("" + companyTypeKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceTypesByCompanyType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceTypesByCompanyType(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfServiceTypeDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfServiceTypeDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetServiceTypesByCompanyType(response: HttpResponseBase): Observable<PagedResultDtoOfServiceTypeDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfServiceTypeDto.fromJS(resultData200) : new PagedResultDtoOfServiceTypeDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfServiceTypeDto>(<any>null);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(<any>response_);
                } catch (e) {
                    return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetCurrentLoginInformationsOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(<any>null);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: CreateTenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | null | undefined, isActive: boolean | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTenantDto.fromJS(resultData200) : new PagedResultDtoOfTenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTenantDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: TenantDto | null | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TenantDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TenantDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(<any>null);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticate(model: AuthenticateModel | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    authenticateUsingSecurityQuestion(model: ValidateAnswerForSecurityQuestionDto[] | null | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/AuthenticateUsingSecurityQuestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticateUsingSecurityQuestion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticateUsingSecurityQuestion(<any>response_);
                } catch (e) {
                    return <Observable<AuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processAuthenticateUsingSecurityQuestion(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(<any>null);
    }

    /**
     * @param model (optional) 
     * @return Success
     */
    externalAuthenticate(model: ExternalAuthenticateModel | null | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(<any>response_);
                } catch (e) {
                    return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalAuthenticateResultModel>><any>_observableThrow(response_);
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(<any>null);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(<any>response_);
                } catch (e) {
                    return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<ExternalLoginProviderInfoModel[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param data (optional) 
     * @param publicKey (optional) 
     * @param signature (optional) 
     * @return Success
     */
    verifyData(data: string | null | undefined, publicKey: string | null | undefined, signature: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/TokenAuth/VerifyData?";
        if (data !== undefined)
            url_ += "Data=" + encodeURIComponent("" + data) + "&"; 
        if (publicKey !== undefined)
            url_ += "PublicKey=" + encodeURIComponent("" + publicKey) + "&"; 
        if (signature !== undefined)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifyData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifyData(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

@Injectable()
export class TransactionHeaderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createCR(input: CreateTransactionHeaderInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/CreateCR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCR(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCR(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRA(input: CreateTransactionHeaderInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/CreateRA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRA(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRA(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param batchOrRequestNumber (optional) 
     * @param entityName (optional) 
     * @param ids (optional) 
     * @param isWalkInService (optional) 
     * @param paymentDateFrom (optional) 
     * @param paymentDateTo (optional) 
     * @param paymentTypeKeys (optional) 
     * @param receiptNumber (optional) 
     * @param receivedFromName (optional) 
     * @param registeredAgentID (optional) 
     * @param requestNumber (optional) 
     * @param status (optional) 
     * @param transactionNumber (optional) 
     * @param transactionTypeKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(batchOrRequestNumber: string | null | undefined, entityName: string | null | undefined, ids: string[] | null | undefined, isWalkInService: boolean | null | undefined, paymentDateFrom: Date | null | undefined, paymentDateTo: Date | null | undefined, paymentTypeKeys: string[] | null | undefined, receiptNumber: string | null | undefined, receivedFromName: string | null | undefined, registeredAgentID: string | null | undefined, requestNumber: string | null | undefined, status: string | null | undefined, transactionNumber: string | null | undefined, transactionTypeKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfTransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetAll?";
        if (batchOrRequestNumber !== undefined)
            url_ += "BatchOrRequestNumber=" + encodeURIComponent("" + batchOrRequestNumber) + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (isWalkInService !== undefined)
            url_ += "IsWalkInService=" + encodeURIComponent("" + isWalkInService) + "&"; 
        if (paymentDateFrom !== undefined)
            url_ += "PaymentDateFrom=" + encodeURIComponent(paymentDateFrom ? "" + paymentDateFrom.toJSON() : "") + "&"; 
        if (paymentDateTo !== undefined)
            url_ += "PaymentDateTo=" + encodeURIComponent(paymentDateTo ? "" + paymentDateTo.toJSON() : "") + "&"; 
        if (paymentTypeKeys !== undefined)
            paymentTypeKeys && paymentTypeKeys.forEach(item => { url_ += "PaymentTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (receiptNumber !== undefined)
            url_ += "ReceiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (receivedFromName !== undefined)
            url_ += "ReceivedFromName=" + encodeURIComponent("" + receivedFromName) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (transactionNumber !== undefined)
            url_ += "TransactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        if (transactionTypeKeys !== undefined)
            transactionTypeKeys && transactionTypeKeys.forEach(item => { url_ += "TransactionTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfTransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfTransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfTransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfTransactionHeaderDto.fromJS(resultData200) : new PagedResultDtoOfTransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfTransactionHeaderDto>(<any>null);
    }

    /**
     * @param batchOrRequestNumber (optional) 
     * @param entityName (optional) 
     * @param ids (optional) 
     * @param isWalkInService (optional) 
     * @param paymentDateFrom (optional) 
     * @param paymentDateTo (optional) 
     * @param paymentTypeKeys (optional) 
     * @param receiptNumber (optional) 
     * @param receivedFromName (optional) 
     * @param registeredAgentID (optional) 
     * @param requestNumber (optional) 
     * @param status (optional) 
     * @param transactionNumber (optional) 
     * @param transactionTypeKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearchCR(batchOrRequestNumber: string | null | undefined, entityName: string | null | undefined, ids: string[] | null | undefined, isWalkInService: boolean | null | undefined, paymentDateFrom: Date | null | undefined, paymentDateTo: Date | null | undefined, paymentTypeKeys: string[] | null | undefined, receiptNumber: string | null | undefined, receivedFromName: string | null | undefined, registeredAgentID: string | null | undefined, requestNumber: string | null | undefined, status: string | null | undefined, transactionNumber: string | null | undefined, transactionTypeKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetAllSearchCR?";
        if (batchOrRequestNumber !== undefined)
            url_ += "BatchOrRequestNumber=" + encodeURIComponent("" + batchOrRequestNumber) + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (isWalkInService !== undefined)
            url_ += "IsWalkInService=" + encodeURIComponent("" + isWalkInService) + "&"; 
        if (paymentDateFrom !== undefined)
            url_ += "PaymentDateFrom=" + encodeURIComponent(paymentDateFrom ? "" + paymentDateFrom.toJSON() : "") + "&"; 
        if (paymentDateTo !== undefined)
            url_ += "PaymentDateTo=" + encodeURIComponent(paymentDateTo ? "" + paymentDateTo.toJSON() : "") + "&"; 
        if (paymentTypeKeys !== undefined)
            paymentTypeKeys && paymentTypeKeys.forEach(item => { url_ += "PaymentTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (receiptNumber !== undefined)
            url_ += "ReceiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (receivedFromName !== undefined)
            url_ += "ReceivedFromName=" + encodeURIComponent("" + receivedFromName) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (transactionNumber !== undefined)
            url_ += "TransactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        if (transactionTypeKeys !== undefined)
            transactionTypeKeys && transactionTypeKeys.forEach(item => { url_ += "TransactionTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearchCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearchCR(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearchCR(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchOutput>(<any>null);
    }

    /**
     * @param batchOrRequestNumber (optional) 
     * @param entityName (optional) 
     * @param ids (optional) 
     * @param isWalkInService (optional) 
     * @param paymentDateFrom (optional) 
     * @param paymentDateTo (optional) 
     * @param paymentTypeKeys (optional) 
     * @param receiptNumber (optional) 
     * @param receivedFromName (optional) 
     * @param registeredAgentID (optional) 
     * @param requestNumber (optional) 
     * @param status (optional) 
     * @param transactionNumber (optional) 
     * @param transactionTypeKeys (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSearchRA(batchOrRequestNumber: string | null | undefined, entityName: string | null | undefined, ids: string[] | null | undefined, isWalkInService: boolean | null | undefined, paymentDateFrom: Date | null | undefined, paymentDateTo: Date | null | undefined, paymentTypeKeys: string[] | null | undefined, receiptNumber: string | null | undefined, receivedFromName: string | null | undefined, registeredAgentID: string | null | undefined, requestNumber: string | null | undefined, status: string | null | undefined, transactionNumber: string | null | undefined, transactionTypeKeys: string[] | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfGetAllSearchOutput> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetAllSearchRA?";
        if (batchOrRequestNumber !== undefined)
            url_ += "BatchOrRequestNumber=" + encodeURIComponent("" + batchOrRequestNumber) + "&"; 
        if (entityName !== undefined)
            url_ += "EntityName=" + encodeURIComponent("" + entityName) + "&"; 
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
        if (isWalkInService !== undefined)
            url_ += "IsWalkInService=" + encodeURIComponent("" + isWalkInService) + "&"; 
        if (paymentDateFrom !== undefined)
            url_ += "PaymentDateFrom=" + encodeURIComponent(paymentDateFrom ? "" + paymentDateFrom.toJSON() : "") + "&"; 
        if (paymentDateTo !== undefined)
            url_ += "PaymentDateTo=" + encodeURIComponent(paymentDateTo ? "" + paymentDateTo.toJSON() : "") + "&"; 
        if (paymentTypeKeys !== undefined)
            paymentTypeKeys && paymentTypeKeys.forEach(item => { url_ += "PaymentTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (receiptNumber !== undefined)
            url_ += "ReceiptNumber=" + encodeURIComponent("" + receiptNumber) + "&"; 
        if (receivedFromName !== undefined)
            url_ += "ReceivedFromName=" + encodeURIComponent("" + receivedFromName) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (requestNumber !== undefined)
            url_ += "RequestNumber=" + encodeURIComponent("" + requestNumber) + "&"; 
        if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&"; 
        if (transactionNumber !== undefined)
            url_ += "TransactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        if (transactionTypeKeys !== undefined)
            transactionTypeKeys && transactionTypeKeys.forEach(item => { url_ += "TransactionTypeKeys=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSearchRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSearchRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfGetAllSearchOutput>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfGetAllSearchOutput>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllSearchRA(response: HttpResponseBase): Observable<PagedResultDtoOfGetAllSearchOutput> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfGetAllSearchOutput.fromJS(resultData200) : new PagedResultDtoOfGetAllSearchOutput();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfGetAllSearchOutput>(<any>null);
    }

    /**
     * @param transactionNumber (optional) 
     * @return Success
     */
    getByTransactionNumber(transactionNumber: string | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetByTransactionNumber?";
        if (transactionNumber !== undefined)
            url_ += "transactionNumber=" + encodeURIComponent("" + transactionNumber) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByTransactionNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByTransactionNumber(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetByTransactionNumber(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCR(id: string | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetCR?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCR(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetCR(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @return Success
     */
    getCurrencies(): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetCurrencies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencies(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetCurrencies(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getNextAvailableTransactionNumber(): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetNextAvailableTransactionNumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextAvailableTransactionNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextAvailableTransactionNumber(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetNextAvailableTransactionNumber(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }

    /**
     * @param includePrepaidAccounts (optional) 
     * @param portalKey (optional) 
     * @return Success
     */
    getPaymentTypes(includePrepaidAccounts: boolean | null | undefined, portalKey: string | null | undefined): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetPaymentTypes?";
        if (includePrepaidAccounts !== undefined)
            url_ += "IncludePrepaidAccounts=" + encodeURIComponent("" + includePrepaidAccounts) + "&"; 
        if (portalKey !== undefined)
            url_ += "PortalKey=" + encodeURIComponent("" + portalKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTypes(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetPaymentTypes(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRA(id: string | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetRA?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRA(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRA(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param excludedKeys (optional) 
     * @return Success
     */
    getTransactionStatusList(excludedKeys: string[] | null | undefined): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetTransactionStatusList?";
        if (excludedKeys !== undefined)
            excludedKeys && excludedKeys.forEach(item => { url_ += "ExcludedKeys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionStatusList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionStatusList(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionStatusList(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getTransactionTypes(): Observable<LookupDataDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/GetTransactionTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactionTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactionTypes(<any>response_);
                } catch (e) {
                    return <Observable<LookupDataDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<LookupDataDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetTransactionTypes(response: HttpResponseBase): Observable<LookupDataDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(LookupDataDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupDataDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    makeRefund(input: MakeRefundInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/MakeRefund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMakeRefund(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMakeRefund(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processMakeRefund(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UpdateTransactionHeaderInput | null | undefined): Observable<TransactionHeaderDto> {
        let url_ = this.baseUrl + "/api/services/app/TransactionHeader/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<TransactionHeaderDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<TransactionHeaderDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TransactionHeaderDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? TransactionHeaderDto.fromJS(resultData200) : new TransactionHeaderDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TransactionHeaderDto>(<any>null);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changeLanguage(input: ChangeUserLanguageDto | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePassword(input: ChangePasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    changePasswordWithoutCurrent(input: ChangePasswordWithoutCurrentInput | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePasswordWithoutCurrent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePasswordWithoutCurrent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePasswordWithoutCurrent(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processChangePasswordWithoutCurrent(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createCRUser(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateCRUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCRUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCRUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateCRUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    createRAUser(input: CreateUserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateRAUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRAUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRAUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreateRAUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param cRUsers (optional) 
     * @param emailAddress (optional) 
     * @param isActive (optional) 
     * @param isLocked (optional) 
     * @param keyword (optional) 
     * @param name (optional) 
     * @param registeredAgentID (optional) 
     * @param surname (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(cRUsers: boolean | null | undefined, emailAddress: string | null | undefined, isActive: boolean | null | undefined, isLocked: boolean | null | undefined, keyword: string | null | undefined, name: string | null | undefined, registeredAgentID: string | null | undefined, surname: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (cRUsers !== undefined)
            url_ += "CRUsers=" + encodeURIComponent("" + cRUsers) + "&"; 
        if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (isLocked !== undefined)
            url_ += "IsLocked=" + encodeURIComponent("" + isLocked) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (surname !== undefined)
            url_ += "Surname=" + encodeURIComponent("" + surname) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserDto.fromJS(resultData200) : new PagedResultDtoOfUserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(<any>null);
    }

    /**
     * @param cRUsers (optional) 
     * @param emailAddress (optional) 
     * @param isActive (optional) 
     * @param isLocked (optional) 
     * @param keyword (optional) 
     * @param name (optional) 
     * @param registeredAgentID (optional) 
     * @param surname (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRA(cRUsers: boolean | null | undefined, emailAddress: string | null | undefined, isActive: boolean | null | undefined, isLocked: boolean | null | undefined, keyword: string | null | undefined, name: string | null | undefined, registeredAgentID: string | null | undefined, surname: string | null | undefined, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllRA?";
        if (cRUsers !== undefined)
            url_ += "CRUsers=" + encodeURIComponent("" + cRUsers) + "&"; 
        if (emailAddress !== undefined)
            url_ += "EmailAddress=" + encodeURIComponent("" + emailAddress) + "&"; 
        if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&"; 
        if (isLocked !== undefined)
            url_ += "IsLocked=" + encodeURIComponent("" + isLocked) + "&"; 
        if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&"; 
        if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&"; 
        if (registeredAgentID !== undefined)
            url_ += "RegisteredAgentID=" + encodeURIComponent("" + registeredAgentID) + "&"; 
        if (surname !== undefined)
            url_ += "Surname=" + encodeURIComponent("" + surname) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRA(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllRA(response: HttpResponseBase): Observable<PagedResultDtoOfUserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserDto.fromJS(resultData200) : new PagedResultDtoOfUserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserDto>(<any>null);
    }

    /**
     * @param getRAGroupsOnly (optional) 
     * @return Success
     */
    getAllUserGroups(getRAGroupsOnly: boolean | null | undefined): Observable<PagedResultDtoOfLookupDataDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllUserGroups?";
        if (getRAGroupsOnly !== undefined)
            url_ += "getRAGroupsOnly=" + encodeURIComponent("" + getRAGroupsOnly) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserGroups(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfLookupDataDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllUserGroups(response: HttpResponseBase): Observable<PagedResultDtoOfLookupDataDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfLookupDataDto.fromJS(resultData200) : new PagedResultDtoOfLookupDataDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfLookupDataDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRAUser(id: number | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRAUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRAUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRAUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRAUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<ListResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleDto.fromJS(resultData200) : new ListResultDtoOfRoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRolesByPermission(permission: string | null | undefined): Observable<ListResultDtoOfRoleDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRolesByPermission?";
        if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolesByPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolesByPermission(<any>response_);
                } catch (e) {
                    return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ListResultDtoOfRoleDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetRolesByPermission(response: HttpResponseBase): Observable<ListResultDtoOfRoleDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ListResultDtoOfRoleDto.fromJS(resultData200) : new ListResultDtoOfRoleDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListResultDtoOfRoleDto>(<any>null);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getUsersByPermission(permission: string | null | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersByPermission?";
        if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByPermission(<any>response_);
                } catch (e) {
                    return <Observable<UserDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetUsersByPermission(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    resetPassword(input: ResetPasswordDto | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateCRUser(input: UpdateUserInput | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateCRUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCRUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCRUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateCRUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateMyProfileCR(input: UpdateMyProfileInput | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateMyProfileCR";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyProfileCR(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyProfileCR(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMyProfileCR(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateMyProfileRA(input: UpdateMyProfileInput | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateMyProfileRA";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyProfileRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyProfileRA(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateMyProfileRA(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    updateRAUser(input: UserDto | null | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateRAUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRAUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRAUser(<any>response_);
                } catch (e) {
                    return <Observable<UserDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateRAUser(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(<any>null);
    }

    /**
     * @return Success
     */
    restoreAccessForAllRAUsers(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RestoreAccessForAllRAUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestoreAccessForAllRAUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestoreAccessForAllRAUsers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestoreAccessForAllRAUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    restrictAccessForAllRAUsers(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/RestrictAccessForAllRAUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestrictAccessForAllRAUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestrictAccessForAllRAUsers(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processRestrictAccessForAllRAUsers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class UserRegisteredAgentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param onlyDefault (optional) 
     * @param includeInactive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(onlyDefault: boolean | null | undefined, includeInactive: boolean | null | undefined, userId: number, sorting: string | null | undefined, skipCount: number | null | undefined, maxResultCount: number | null | undefined): Observable<PagedResultDtoOfUserRegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/GetAll?";
        if (onlyDefault !== undefined)
            url_ += "OnlyDefault=" + encodeURIComponent("" + onlyDefault) + "&"; 
        if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&"; 
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&"; 
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&"; 
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&"; 
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfUserRegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfUserRegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfUserRegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfUserRegisteredAgentDto.fromJS(resultData200) : new PagedResultDtoOfUserRegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfUserRegisteredAgentDto>(<any>null);
    }

    /**
     * @return Success
     */
    getRAUserRegisteredAgents(): Observable<UserRegisteredAgentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/GetRAUserRegisteredAgents";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRAUserRegisteredAgents(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRAUserRegisteredAgents(<any>response_);
                } catch (e) {
                    return <Observable<UserRegisteredAgentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRegisteredAgentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRAUserRegisteredAgents(response: HttpResponseBase): Observable<UserRegisteredAgentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(UserRegisteredAgentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegisteredAgentDto[]>(<any>null);
    }

    /**
     * @param registredAgentID (optional) 
     * @param errorRAIDNotPopulated (optional) 
     * @return Success
     */
    validateRegistredAgentBelongsToCurrentUser(registredAgentID: string | null | undefined, errorRAIDNotPopulated: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/ValidateRegistredAgentBelongsToCurrentUser?";
        if (registredAgentID !== undefined)
            url_ += "registredAgentID=" + encodeURIComponent("" + registredAgentID) + "&"; 
        if (errorRAIDNotPopulated !== undefined)
            url_ += "errorRAIDNotPopulated=" + encodeURIComponent("" + errorRAIDNotPopulated) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRegistredAgentBelongsToCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRegistredAgentBelongsToCurrentUser(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processValidateRegistredAgentBelongsToCurrentUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | null | undefined): Observable<UserRegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<UserRegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserRegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserRegisteredAgentDto.fromJS(resultData200) : new UserRegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegisteredAgentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: UserRegisteredAgentDto | null | undefined): Observable<UserRegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<UserRegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserRegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserRegisteredAgentDto.fromJS(resultData200) : new UserRegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegisteredAgentDto>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: UserRegisteredAgentDto | null | undefined): Observable<UserRegisteredAgentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<UserRegisteredAgentDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserRegisteredAgentDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserRegisteredAgentDto> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? UserRegisteredAgentDto.fromJS(resultData200) : new UserRegisteredAgentDto();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserRegisteredAgentDto>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserRegisteredAgent/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data; 
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data; 
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: IsTenantAvailableOutputState | undefined;
    tenantId: number | undefined;
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data; 
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean | undefined;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data; 
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean | undefined;
}

export class GetAllAccountTransactionInput implements IGetAllAccountTransactionInput {
    creationTimeFrom: Date | undefined;
    creationTimeTo: Date | undefined;
    entityName: string | undefined;
    feeIds: string[] | undefined;
    financialAccountIds: string[] | undefined;
    financialAccountTypeKeys: string[] | undefined;
    isWalkInService: boolean | undefined;
    paymentTypeKeys: string[] | undefined;
    receivedFromName: string | undefined;
    registeredAgentId: string | undefined;
    status: string | undefined;
    transactionNumber: string | undefined;
    transactionTypeKeys: string[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IGetAllAccountTransactionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTimeFrom = data["creationTimeFrom"] ? new Date(data["creationTimeFrom"].toString()) : <any>undefined;
            this.creationTimeTo = data["creationTimeTo"] ? new Date(data["creationTimeTo"].toString()) : <any>undefined;
            this.entityName = data["entityName"];
            if (data["feeIds"] && data["feeIds"].constructor === Array) {
                this.feeIds = [] as any;
                for (let item of data["feeIds"])
                    this.feeIds.push(item);
            }
            if (data["financialAccountIds"] && data["financialAccountIds"].constructor === Array) {
                this.financialAccountIds = [] as any;
                for (let item of data["financialAccountIds"])
                    this.financialAccountIds.push(item);
            }
            if (data["financialAccountTypeKeys"] && data["financialAccountTypeKeys"].constructor === Array) {
                this.financialAccountTypeKeys = [] as any;
                for (let item of data["financialAccountTypeKeys"])
                    this.financialAccountTypeKeys.push(item);
            }
            this.isWalkInService = data["isWalkInService"];
            if (data["paymentTypeKeys"] && data["paymentTypeKeys"].constructor === Array) {
                this.paymentTypeKeys = [] as any;
                for (let item of data["paymentTypeKeys"])
                    this.paymentTypeKeys.push(item);
            }
            this.receivedFromName = data["receivedFromName"];
            this.registeredAgentId = data["registeredAgentId"];
            this.status = data["status"];
            this.transactionNumber = data["transactionNumber"];
            if (data["transactionTypeKeys"] && data["transactionTypeKeys"].constructor === Array) {
                this.transactionTypeKeys = [] as any;
                for (let item of data["transactionTypeKeys"])
                    this.transactionTypeKeys.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllAccountTransactionInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllAccountTransactionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTimeFrom"] = this.creationTimeFrom ? this.creationTimeFrom.toISOString() : <any>undefined;
        data["creationTimeTo"] = this.creationTimeTo ? this.creationTimeTo.toISOString() : <any>undefined;
        data["entityName"] = this.entityName;
        if (this.feeIds && this.feeIds.constructor === Array) {
            data["feeIds"] = [];
            for (let item of this.feeIds)
                data["feeIds"].push(item);
        }
        if (this.financialAccountIds && this.financialAccountIds.constructor === Array) {
            data["financialAccountIds"] = [];
            for (let item of this.financialAccountIds)
                data["financialAccountIds"].push(item);
        }
        if (this.financialAccountTypeKeys && this.financialAccountTypeKeys.constructor === Array) {
            data["financialAccountTypeKeys"] = [];
            for (let item of this.financialAccountTypeKeys)
                data["financialAccountTypeKeys"].push(item);
        }
        data["isWalkInService"] = this.isWalkInService;
        if (this.paymentTypeKeys && this.paymentTypeKeys.constructor === Array) {
            data["paymentTypeKeys"] = [];
            for (let item of this.paymentTypeKeys)
                data["paymentTypeKeys"].push(item);
        }
        data["receivedFromName"] = this.receivedFromName;
        data["registeredAgentId"] = this.registeredAgentId;
        data["status"] = this.status;
        data["transactionNumber"] = this.transactionNumber;
        if (this.transactionTypeKeys && this.transactionTypeKeys.constructor === Array) {
            data["transactionTypeKeys"] = [];
            for (let item of this.transactionTypeKeys)
                data["transactionTypeKeys"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetAllAccountTransactionInput {
        const json = this.toJSON();
        let result = new GetAllAccountTransactionInput();
        result.init(json);
        return result;
    }
}

export interface IGetAllAccountTransactionInput {
    creationTimeFrom: Date | undefined;
    creationTimeTo: Date | undefined;
    entityName: string | undefined;
    feeIds: string[] | undefined;
    financialAccountIds: string[] | undefined;
    financialAccountTypeKeys: string[] | undefined;
    isWalkInService: boolean | undefined;
    paymentTypeKeys: string[] | undefined;
    receivedFromName: string | undefined;
    registeredAgentId: string | undefined;
    status: string | undefined;
    transactionNumber: string | undefined;
    transactionTypeKeys: string[] | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfAccountTransactionDto implements IPagedResultDtoOfAccountTransactionDto {
    totalCount: number | undefined;
    items: AccountTransactionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAccountTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(AccountTransactionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAccountTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAccountTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfAccountTransactionDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAccountTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAccountTransactionDto {
    totalCount: number | undefined;
    items: AccountTransactionDto[] | undefined;
}

export class AccountTransactionDto implements IAccountTransactionDto {
    accountName: string | undefined;
    accountNumber: string | undefined;
    readonly accountNumberAndName: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    balance: number | undefined;
    companyName: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeAlternativeAmount: number | undefined;
    feeAmount: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccount: FinancialAccountDto | undefined;
    financialAccountId: string | undefined;
    linkedAccountTransaction: AccountTransactionDto | undefined;
    linkedAccountTransactionId: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    previousAccountTransaction: AccountTransactionDto | undefined;
    previousAccountTransactionId: string | undefined;
    quantity: number | undefined;
    receivedFromName: string | undefined;
    refundTransactionHeader: TransactionHeaderDto | undefined;
    refundTransactionHeaderId: string | undefined;
    readonly requestFeeId: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    status: string | undefined;
    transactionHeader: TransactionHeaderDto | undefined;
    transactionHeaderId: string | undefined;
    transactionId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;

    constructor(data?: IAccountTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountName = data["accountName"];
            this.accountNumber = data["accountNumber"];
            (<any>this).accountNumberAndName = data["accountNumberAndName"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.balance = data["balance"];
            this.companyName = data["companyName"];
            this.description = data["description"];
            this.extensionData = data["extensionData"];
            this.fee = data["fee"] ? FeeDto.fromJS(data["fee"]) : <any>undefined;
            this.feeAlternativeAmount = data["feeAlternativeAmount"];
            this.feeAmount = data["feeAmount"];
            this.feeDescription = data["feeDescription"];
            this.feeId = data["feeId"];
            this.financialAccount = data["financialAccount"] ? FinancialAccountDto.fromJS(data["financialAccount"]) : <any>undefined;
            this.financialAccountId = data["financialAccountId"];
            this.linkedAccountTransaction = data["linkedAccountTransaction"] ? AccountTransactionDto.fromJS(data["linkedAccountTransaction"]) : <any>undefined;
            this.linkedAccountTransactionId = data["linkedAccountTransactionId"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeName = data["paymentTypeName"];
            this.previousAccountTransaction = data["previousAccountTransaction"] ? AccountTransactionDto.fromJS(data["previousAccountTransaction"]) : <any>undefined;
            this.previousAccountTransactionId = data["previousAccountTransactionId"];
            this.quantity = data["quantity"];
            this.receivedFromName = data["receivedFromName"];
            this.refundTransactionHeader = data["refundTransactionHeader"] ? TransactionHeaderDto.fromJS(data["refundTransactionHeader"]) : <any>undefined;
            this.refundTransactionHeaderId = data["refundTransactionHeaderId"];
            (<any>this).requestFeeId = data["requestFeeId"];
            this.requestNumber = data["requestNumber"];
            this.serviceTypeName = data["serviceTypeName"];
            this.status = data["status"];
            this.transactionHeader = data["transactionHeader"] ? TransactionHeaderDto.fromJS(data["transactionHeader"]) : <any>undefined;
            this.transactionHeaderId = data["transactionHeaderId"];
            this.transactionId = data["transactionId"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionRequestEntityNames = data["transactionRequestEntityNames"];
            this.transactionRequestServiceTypeNames = data["transactionRequestServiceTypeNames"];
            this.transactionTypeName = data["transactionTypeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AccountTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["accountNumberAndName"] = this.accountNumberAndName;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["companyName"] = this.companyName;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["feeAlternativeAmount"] = this.feeAlternativeAmount;
        data["feeAmount"] = this.feeAmount;
        data["feeDescription"] = this.feeDescription;
        data["feeId"] = this.feeId;
        data["financialAccount"] = this.financialAccount ? this.financialAccount.toJSON() : <any>undefined;
        data["financialAccountId"] = this.financialAccountId;
        data["linkedAccountTransaction"] = this.linkedAccountTransaction ? this.linkedAccountTransaction.toJSON() : <any>undefined;
        data["linkedAccountTransactionId"] = this.linkedAccountTransactionId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeName"] = this.paymentTypeName;
        data["previousAccountTransaction"] = this.previousAccountTransaction ? this.previousAccountTransaction.toJSON() : <any>undefined;
        data["previousAccountTransactionId"] = this.previousAccountTransactionId;
        data["quantity"] = this.quantity;
        data["receivedFromName"] = this.receivedFromName;
        data["refundTransactionHeader"] = this.refundTransactionHeader ? this.refundTransactionHeader.toJSON() : <any>undefined;
        data["refundTransactionHeaderId"] = this.refundTransactionHeaderId;
        data["requestFeeId"] = this.requestFeeId;
        data["requestNumber"] = this.requestNumber;
        data["serviceTypeName"] = this.serviceTypeName;
        data["status"] = this.status;
        data["transactionHeader"] = this.transactionHeader ? this.transactionHeader.toJSON() : <any>undefined;
        data["transactionHeaderId"] = this.transactionHeaderId;
        data["transactionId"] = this.transactionId;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionRequestEntityNames"] = this.transactionRequestEntityNames;
        data["transactionRequestServiceTypeNames"] = this.transactionRequestServiceTypeNames;
        data["transactionTypeName"] = this.transactionTypeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): AccountTransactionDto {
        const json = this.toJSON();
        let result = new AccountTransactionDto();
        result.init(json);
        return result;
    }
}

export interface IAccountTransactionDto {
    accountName: string | undefined;
    accountNumber: string | undefined;
    accountNumberAndName: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    balance: number | undefined;
    companyName: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeAlternativeAmount: number | undefined;
    feeAmount: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccount: FinancialAccountDto | undefined;
    financialAccountId: string | undefined;
    linkedAccountTransaction: AccountTransactionDto | undefined;
    linkedAccountTransactionId: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    previousAccountTransaction: AccountTransactionDto | undefined;
    previousAccountTransactionId: string | undefined;
    quantity: number | undefined;
    receivedFromName: string | undefined;
    refundTransactionHeader: TransactionHeaderDto | undefined;
    refundTransactionHeaderId: string | undefined;
    requestFeeId: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    status: string | undefined;
    transactionHeader: TransactionHeaderDto | undefined;
    transactionHeaderId: string | undefined;
    transactionId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;
}

export class FeeDto implements IFeeDto {
    allowMultiple: boolean | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    extensionData: string | undefined;
    feeCode: number;
    feeDescription: string;
    feeExtensionData: FeeExtensionData | undefined;
    financialAccount: string | undefined;
    financialAccountId: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    key: string | undefined;
    tags: TagDto[] | undefined;
    id: string | undefined;

    constructor(data?: IFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.allowMultiple = data["allowMultiple"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.extensionData = data["extensionData"];
            this.feeCode = data["feeCode"];
            this.feeDescription = data["feeDescription"];
            this.feeExtensionData = data["feeExtensionData"] ? FeeExtensionData.fromJS(data["feeExtensionData"]) : <any>undefined;
            this.financialAccount = data["financialAccount"];
            this.financialAccountId = data["financialAccountId"];
            this.isActive = data["isActive"];
            this.isOptional = data["isOptional"];
            this.key = data["key"];
            if (data["tags"] && data["tags"].constructor === Array) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags.push(TagDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowMultiple"] = this.allowMultiple;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["extensionData"] = this.extensionData;
        data["feeCode"] = this.feeCode;
        data["feeDescription"] = this.feeDescription;
        data["feeExtensionData"] = this.feeExtensionData ? this.feeExtensionData.toJSON() : <any>undefined;
        data["financialAccount"] = this.financialAccount;
        data["financialAccountId"] = this.financialAccountId;
        data["isActive"] = this.isActive;
        data["isOptional"] = this.isOptional;
        data["key"] = this.key;
        if (this.tags && this.tags.constructor === Array) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): FeeDto {
        const json = this.toJSON();
        let result = new FeeDto();
        result.init(json);
        return result;
    }
}

export interface IFeeDto {
    allowMultiple: boolean | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    extensionData: string | undefined;
    feeCode: number;
    feeDescription: string;
    feeExtensionData: FeeExtensionData | undefined;
    financialAccount: string | undefined;
    financialAccountId: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    key: string | undefined;
    tags: TagDto[] | undefined;
    id: string | undefined;
}

export class FinancialAccountDto implements IFinancialAccountDto {
    accountNumber: string;
    description: string | undefined;
    extensionData: string | undefined;
    financialAccountTypeKey: string;
    financialAccountTypeName: string | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    id: string | undefined;

    constructor(data?: IFinancialAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.description = data["description"];
            this.extensionData = data["extensionData"];
            this.financialAccountTypeKey = data["financialAccountTypeKey"];
            this.financialAccountTypeName = data["financialAccountTypeName"];
            this.isActive = data["isActive"];
            this.isEditable = data["isEditable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FinancialAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["financialAccountTypeKey"] = this.financialAccountTypeKey;
        data["financialAccountTypeName"] = this.financialAccountTypeName;
        data["isActive"] = this.isActive;
        data["isEditable"] = this.isEditable;
        data["id"] = this.id;
        return data; 
    }

    clone(): FinancialAccountDto {
        const json = this.toJSON();
        let result = new FinancialAccountDto();
        result.init(json);
        return result;
    }
}

export interface IFinancialAccountDto {
    accountNumber: string;
    description: string | undefined;
    extensionData: string | undefined;
    financialAccountTypeKey: string;
    financialAccountTypeName: string | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    id: string | undefined;
}

export class TransactionHeaderDto implements ITransactionHeaderDto {
    accountTransactions: TransactionHeaderAccountTransactionDto[] | undefined;
    associatedReceiptNumber: string | undefined;
    associatedTransactionID: string | undefined;
    associatedTransactionNumber: string | undefined;
    bank: string | undefined;
    batchID: string | undefined;
    batchNumber: string | undefined;
    chequeNumber: string | undefined;
    companyName: string | undefined;
    exchangeRateAtTimeOfTransaction: number | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    paymentTypeName: string | undefined;
    portalKey: string | undefined;
    postedAt: Date | undefined;
    receiptNumber: string | undefined;
    receivedFromAddress: string | undefined;
    receivedFromName: string | undefined;
    receivedFromPhoneNumber: string | undefined;
    refundCreditedFinancialAccounts: FinancialAccountDto[] | undefined;
    readonly refundRequestId: string | undefined;
    refundTransactionHeaderId: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    status: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountUSD: number | undefined;
    transactionCurrencyKey: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeKey: string | undefined;
    transactionTypeName: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: ITransactionHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["accountTransactions"] && data["accountTransactions"].constructor === Array) {
                this.accountTransactions = [] as any;
                for (let item of data["accountTransactions"])
                    this.accountTransactions.push(TransactionHeaderAccountTransactionDto.fromJS(item));
            }
            this.associatedReceiptNumber = data["associatedReceiptNumber"];
            this.associatedTransactionID = data["associatedTransactionID"];
            this.associatedTransactionNumber = data["associatedTransactionNumber"];
            this.bank = data["bank"];
            this.batchID = data["batchID"];
            this.batchNumber = data["batchNumber"];
            this.chequeNumber = data["chequeNumber"];
            this.companyName = data["companyName"];
            this.exchangeRateAtTimeOfTransaction = data["exchangeRateAtTimeOfTransaction"];
            this.extensionData = data["extensionData"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeKey = data["paymentTypeKey"];
            this.paymentTypeName = data["paymentTypeName"];
            this.portalKey = data["portalKey"];
            this.postedAt = data["postedAt"] ? new Date(data["postedAt"].toString()) : <any>undefined;
            this.receiptNumber = data["receiptNumber"];
            this.receivedFromAddress = data["receivedFromAddress"];
            this.receivedFromName = data["receivedFromName"];
            this.receivedFromPhoneNumber = data["receivedFromPhoneNumber"];
            if (data["refundCreditedFinancialAccounts"] && data["refundCreditedFinancialAccounts"].constructor === Array) {
                this.refundCreditedFinancialAccounts = [] as any;
                for (let item of data["refundCreditedFinancialAccounts"])
                    this.refundCreditedFinancialAccounts.push(FinancialAccountDto.fromJS(item));
            }
            (<any>this).refundRequestId = data["refundRequestId"];
            this.refundTransactionHeaderId = data["refundTransactionHeaderId"];
            this.registeredAgentAccountNumber = data["registeredAgentAccountNumber"];
            this.registeredAgentId = data["registeredAgentId"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestNumber = data["requestNumber"];
            this.status = data["status"];
            this.transactionAmountEC = data["transactionAmountEC"];
            this.transactionAmountUSD = data["transactionAmountUSD"];
            this.transactionCurrencyKey = data["transactionCurrencyKey"];
            this.transactionCurrencyName = data["transactionCurrencyName"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionRequestEntityNames = data["transactionRequestEntityNames"];
            this.transactionRequestServiceTypeNames = data["transactionRequestServiceTypeNames"];
            this.transactionTypeKey = data["transactionTypeKey"];
            this.transactionTypeName = data["transactionTypeName"];
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.accountTransactions && this.accountTransactions.constructor === Array) {
            data["accountTransactions"] = [];
            for (let item of this.accountTransactions)
                data["accountTransactions"].push(item.toJSON());
        }
        data["associatedReceiptNumber"] = this.associatedReceiptNumber;
        data["associatedTransactionID"] = this.associatedTransactionID;
        data["associatedTransactionNumber"] = this.associatedTransactionNumber;
        data["bank"] = this.bank;
        data["batchID"] = this.batchID;
        data["batchNumber"] = this.batchNumber;
        data["chequeNumber"] = this.chequeNumber;
        data["companyName"] = this.companyName;
        data["exchangeRateAtTimeOfTransaction"] = this.exchangeRateAtTimeOfTransaction;
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeKey"] = this.paymentTypeKey;
        data["paymentTypeName"] = this.paymentTypeName;
        data["portalKey"] = this.portalKey;
        data["postedAt"] = this.postedAt ? this.postedAt.toISOString() : <any>undefined;
        data["receiptNumber"] = this.receiptNumber;
        data["receivedFromAddress"] = this.receivedFromAddress;
        data["receivedFromName"] = this.receivedFromName;
        data["receivedFromPhoneNumber"] = this.receivedFromPhoneNumber;
        if (this.refundCreditedFinancialAccounts && this.refundCreditedFinancialAccounts.constructor === Array) {
            data["refundCreditedFinancialAccounts"] = [];
            for (let item of this.refundCreditedFinancialAccounts)
                data["refundCreditedFinancialAccounts"].push(item.toJSON());
        }
        data["refundRequestId"] = this.refundRequestId;
        data["refundTransactionHeaderId"] = this.refundTransactionHeaderId;
        data["registeredAgentAccountNumber"] = this.registeredAgentAccountNumber;
        data["registeredAgentId"] = this.registeredAgentId;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestNumber"] = this.requestNumber;
        data["status"] = this.status;
        data["transactionAmountEC"] = this.transactionAmountEC;
        data["transactionAmountUSD"] = this.transactionAmountUSD;
        data["transactionCurrencyKey"] = this.transactionCurrencyKey;
        data["transactionCurrencyName"] = this.transactionCurrencyName;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionRequestEntityNames"] = this.transactionRequestEntityNames;
        data["transactionRequestServiceTypeNames"] = this.transactionRequestServiceTypeNames;
        data["transactionTypeKey"] = this.transactionTypeKey;
        data["transactionTypeName"] = this.transactionTypeName;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransactionHeaderDto {
        const json = this.toJSON();
        let result = new TransactionHeaderDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionHeaderDto {
    accountTransactions: TransactionHeaderAccountTransactionDto[] | undefined;
    associatedReceiptNumber: string | undefined;
    associatedTransactionID: string | undefined;
    associatedTransactionNumber: string | undefined;
    bank: string | undefined;
    batchID: string | undefined;
    batchNumber: string | undefined;
    chequeNumber: string | undefined;
    companyName: string | undefined;
    exchangeRateAtTimeOfTransaction: number | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    paymentTypeName: string | undefined;
    portalKey: string | undefined;
    postedAt: Date | undefined;
    receiptNumber: string | undefined;
    receivedFromAddress: string | undefined;
    receivedFromName: string | undefined;
    receivedFromPhoneNumber: string | undefined;
    refundCreditedFinancialAccounts: FinancialAccountDto[] | undefined;
    refundRequestId: string | undefined;
    refundTransactionHeaderId: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    status: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountUSD: number | undefined;
    transactionCurrencyKey: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeKey: string | undefined;
    transactionTypeName: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class FeeExtensionData implements IFeeExtensionData {
    activityCodeKey: string | undefined;
    activityName: string | undefined;
    entityTypeKey: string | undefined;
    entityTypeName: string | undefined;
    readonly recordEntityActivity: boolean | undefined;
    serviceTypeKeys: string[] | undefined;
    serviceTypeNames: string | undefined;

    constructor(data?: IFeeExtensionData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityCodeKey = data["activityCodeKey"];
            this.activityName = data["activityName"];
            this.entityTypeKey = data["entityTypeKey"];
            this.entityTypeName = data["entityTypeName"];
            (<any>this).recordEntityActivity = data["recordEntityActivity"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
            this.serviceTypeNames = data["serviceTypeNames"];
        }
    }

    static fromJS(data: any): FeeExtensionData {
        data = typeof data === 'object' ? data : {};
        let result = new FeeExtensionData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityCodeKey"] = this.activityCodeKey;
        data["activityName"] = this.activityName;
        data["entityTypeKey"] = this.entityTypeKey;
        data["entityTypeName"] = this.entityTypeName;
        data["recordEntityActivity"] = this.recordEntityActivity;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        data["serviceTypeNames"] = this.serviceTypeNames;
        return data; 
    }

    clone(): FeeExtensionData {
        const json = this.toJSON();
        let result = new FeeExtensionData();
        result.init(json);
        return result;
    }
}

export interface IFeeExtensionData {
    activityCodeKey: string | undefined;
    activityName: string | undefined;
    entityTypeKey: string | undefined;
    entityTypeName: string | undefined;
    recordEntityActivity: boolean | undefined;
    serviceTypeKeys: string[] | undefined;
    serviceTypeNames: string | undefined;
}

export class TagDto implements ITagDto {
    childTags: TagDto[] | undefined;
    id: string | undefined;
    key: string | undefined;
    parentTags: TagDto[] | undefined;
    value: string | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["childTags"] && data["childTags"].constructor === Array) {
                this.childTags = [] as any;
                for (let item of data["childTags"])
                    this.childTags.push(TagDto.fromJS(item));
            }
            this.id = data["id"];
            this.key = data["key"];
            if (data["parentTags"] && data["parentTags"].constructor === Array) {
                this.parentTags = [] as any;
                for (let item of data["parentTags"])
                    this.parentTags.push(TagDto.fromJS(item));
            }
            this.value = data["value"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.childTags && this.childTags.constructor === Array) {
            data["childTags"] = [];
            for (let item of this.childTags)
                data["childTags"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["key"] = this.key;
        if (this.parentTags && this.parentTags.constructor === Array) {
            data["parentTags"] = [];
            for (let item of this.parentTags)
                data["parentTags"].push(item.toJSON());
        }
        data["value"] = this.value;
        return data; 
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    childTags: TagDto[] | undefined;
    id: string | undefined;
    key: string | undefined;
    parentTags: TagDto[] | undefined;
    value: string | undefined;
}

export class TransactionHeaderAccountTransactionDto implements ITransactionHeaderAccountTransactionDto {
    isRefundable: boolean | undefined;
    isRefunded: boolean | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    readonly accountNumberAndName: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    balance: number | undefined;
    companyName: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeAlternativeAmount: number | undefined;
    feeAmount: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccount: FinancialAccountDto | undefined;
    financialAccountId: string | undefined;
    linkedAccountTransactionId: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    previousAccountTransactionId: string | undefined;
    quantity: number | undefined;
    receivedFromName: string | undefined;
    refundTransactionHeader: TransactionHeaderDto | undefined;
    refundTransactionHeaderId: string | undefined;
    readonly requestFeeId: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    status: string | undefined;
    transactionHeaderId: string | undefined;
    transactionId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;

    constructor(data?: ITransactionHeaderAccountTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isRefundable = data["isRefundable"];
            this.isRefunded = data["isRefunded"];
            this.accountName = data["accountName"];
            this.accountNumber = data["accountNumber"];
            (<any>this).accountNumberAndName = data["accountNumberAndName"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.balance = data["balance"];
            this.companyName = data["companyName"];
            this.description = data["description"];
            this.extensionData = data["extensionData"];
            this.fee = data["fee"] ? FeeDto.fromJS(data["fee"]) : <any>undefined;
            this.feeAlternativeAmount = data["feeAlternativeAmount"];
            this.feeAmount = data["feeAmount"];
            this.feeDescription = data["feeDescription"];
            this.feeId = data["feeId"];
            this.financialAccount = data["financialAccount"] ? FinancialAccountDto.fromJS(data["financialAccount"]) : <any>undefined;
            this.financialAccountId = data["financialAccountId"];
            this.linkedAccountTransactionId = data["linkedAccountTransactionId"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeName = data["paymentTypeName"];
            this.previousAccountTransactionId = data["previousAccountTransactionId"];
            this.quantity = data["quantity"];
            this.receivedFromName = data["receivedFromName"];
            this.refundTransactionHeader = data["refundTransactionHeader"] ? TransactionHeaderDto.fromJS(data["refundTransactionHeader"]) : <any>undefined;
            this.refundTransactionHeaderId = data["refundTransactionHeaderId"];
            (<any>this).requestFeeId = data["requestFeeId"];
            this.requestNumber = data["requestNumber"];
            this.serviceTypeName = data["serviceTypeName"];
            this.status = data["status"];
            this.transactionHeaderId = data["transactionHeaderId"];
            this.transactionId = data["transactionId"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionRequestEntityNames = data["transactionRequestEntityNames"];
            this.transactionRequestServiceTypeNames = data["transactionRequestServiceTypeNames"];
            this.transactionTypeName = data["transactionTypeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionHeaderAccountTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHeaderAccountTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isRefundable"] = this.isRefundable;
        data["isRefunded"] = this.isRefunded;
        data["accountName"] = this.accountName;
        data["accountNumber"] = this.accountNumber;
        data["accountNumberAndName"] = this.accountNumberAndName;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["companyName"] = this.companyName;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["feeAlternativeAmount"] = this.feeAlternativeAmount;
        data["feeAmount"] = this.feeAmount;
        data["feeDescription"] = this.feeDescription;
        data["feeId"] = this.feeId;
        data["financialAccount"] = this.financialAccount ? this.financialAccount.toJSON() : <any>undefined;
        data["financialAccountId"] = this.financialAccountId;
        data["linkedAccountTransactionId"] = this.linkedAccountTransactionId;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeName"] = this.paymentTypeName;
        data["previousAccountTransactionId"] = this.previousAccountTransactionId;
        data["quantity"] = this.quantity;
        data["receivedFromName"] = this.receivedFromName;
        data["refundTransactionHeader"] = this.refundTransactionHeader ? this.refundTransactionHeader.toJSON() : <any>undefined;
        data["refundTransactionHeaderId"] = this.refundTransactionHeaderId;
        data["requestFeeId"] = this.requestFeeId;
        data["requestNumber"] = this.requestNumber;
        data["serviceTypeName"] = this.serviceTypeName;
        data["status"] = this.status;
        data["transactionHeaderId"] = this.transactionHeaderId;
        data["transactionId"] = this.transactionId;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionRequestEntityNames"] = this.transactionRequestEntityNames;
        data["transactionRequestServiceTypeNames"] = this.transactionRequestServiceTypeNames;
        data["transactionTypeName"] = this.transactionTypeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransactionHeaderAccountTransactionDto {
        const json = this.toJSON();
        let result = new TransactionHeaderAccountTransactionDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionHeaderAccountTransactionDto {
    isRefundable: boolean | undefined;
    isRefunded: boolean | undefined;
    accountName: string | undefined;
    accountNumber: string | undefined;
    accountNumberAndName: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    balance: number | undefined;
    companyName: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeAlternativeAmount: number | undefined;
    feeAmount: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccount: FinancialAccountDto | undefined;
    financialAccountId: string | undefined;
    linkedAccountTransactionId: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    previousAccountTransactionId: string | undefined;
    quantity: number | undefined;
    receivedFromName: string | undefined;
    refundTransactionHeader: TransactionHeaderDto | undefined;
    refundTransactionHeaderId: string | undefined;
    requestFeeId: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    status: string | undefined;
    transactionHeaderId: string | undefined;
    transactionId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfGetAllSearchAccountTransactionOutput implements IPagedResultDtoOfGetAllSearchAccountTransactionOutput {
    totalCount: number | undefined;
    items: GetAllSearchAccountTransactionOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSearchAccountTransactionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllSearchAccountTransactionOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSearchAccountTransactionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllSearchAccountTransactionOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllSearchAccountTransactionOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllSearchAccountTransactionOutput {
    totalCount: number | undefined;
    items: GetAllSearchAccountTransactionOutput[] | undefined;
}

export class GetAllSearchAccountTransactionOutput implements IGetAllSearchAccountTransactionOutput {
    accountNumberAndName: string | undefined;
    amountEC: number | undefined;
    balance: number | undefined;
    feeDescription: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    receivedFromName: string | undefined;
    status: string | undefined;
    transactionHeaderId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    refundTransactionHeaderId: string | undefined;

    constructor(data?: IGetAllSearchAccountTransactionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumberAndName = data["accountNumberAndName"];
            this.amountEC = data["amountEC"];
            this.balance = data["balance"];
            this.feeDescription = data["feeDescription"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeName = data["paymentTypeName"];
            this.receivedFromName = data["receivedFromName"];
            this.status = data["status"];
            this.transactionHeaderId = data["transactionHeaderId"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionRequestEntityNames = data["transactionRequestEntityNames"];
            this.transactionRequestServiceTypeNames = data["transactionRequestServiceTypeNames"];
            this.transactionTypeName = data["transactionTypeName"];
            this.refundTransactionHeaderId = data["refundTransactionHeaderId"];
        }
    }

    static fromJS(data: any): GetAllSearchAccountTransactionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSearchAccountTransactionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumberAndName"] = this.accountNumberAndName;
        data["amountEC"] = this.amountEC;
        data["balance"] = this.balance;
        data["feeDescription"] = this.feeDescription;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeName"] = this.paymentTypeName;
        data["receivedFromName"] = this.receivedFromName;
        data["status"] = this.status;
        data["transactionHeaderId"] = this.transactionHeaderId;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionRequestEntityNames"] = this.transactionRequestEntityNames;
        data["transactionRequestServiceTypeNames"] = this.transactionRequestServiceTypeNames;
        data["transactionTypeName"] = this.transactionTypeName;
        data["refundTransactionHeaderId"] = this.refundTransactionHeaderId;
        return data; 
    }

    clone(): GetAllSearchAccountTransactionOutput {
        const json = this.toJSON();
        let result = new GetAllSearchAccountTransactionOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllSearchAccountTransactionOutput {
    accountNumberAndName: string | undefined;
    amountEC: number | undefined;
    balance: number | undefined;
    feeDescription: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    receivedFromName: string | undefined;
    status: string | undefined;
    transactionHeaderId: string | undefined;
    transactionNumber: string | undefined;
    transactionRequestEntityNames: string | undefined;
    transactionRequestServiceTypeNames: string | undefined;
    transactionTypeName: string | undefined;
    refundTransactionHeaderId: string | undefined;
}

export class CalculateRenewalFeesInput implements ICalculateRenewalFeesInput {
    items: AnnualRenewalRequestFeeInput[] | undefined;

    constructor(data?: ICalculateRenewalFeesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(AnnualRenewalRequestFeeInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculateRenewalFeesInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRenewalFeesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CalculateRenewalFeesInput {
        const json = this.toJSON();
        let result = new CalculateRenewalFeesInput();
        result.init(json);
        return result;
    }
}

export interface ICalculateRenewalFeesInput {
    items: AnnualRenewalRequestFeeInput[] | undefined;
}

export class AnnualRenewalRequestFeeInput implements IAnnualRenewalRequestFeeInput {
    companyRegistrationId: string | undefined;
    numberOfYearsToRenew: number | undefined;
    renewalCertificate: boolean | undefined;
    id: string | undefined;

    constructor(data?: IAnnualRenewalRequestFeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyRegistrationId = data["companyRegistrationId"];
            this.numberOfYearsToRenew = data["numberOfYearsToRenew"];
            this.renewalCertificate = data["renewalCertificate"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnualRenewalRequestFeeInput {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualRenewalRequestFeeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegistrationId"] = this.companyRegistrationId;
        data["numberOfYearsToRenew"] = this.numberOfYearsToRenew;
        data["renewalCertificate"] = this.renewalCertificate;
        data["id"] = this.id;
        return data; 
    }

    clone(): AnnualRenewalRequestFeeInput {
        const json = this.toJSON();
        let result = new AnnualRenewalRequestFeeInput();
        result.init(json);
        return result;
    }
}

export interface IAnnualRenewalRequestFeeInput {
    companyRegistrationId: string | undefined;
    numberOfYearsToRenew: number | undefined;
    renewalCertificate: boolean | undefined;
    id: string | undefined;
}

export class AnnualRenewalDto implements IAnnualRenewalDto {
    companyRegistrationRequestFees: AnnualRenewalRequestFeeDto[] | undefined;
    entitiesPassedAnnualRenewalDate: number | undefined;
    entityTypes: { [key: string] : number; } | undefined;
    numberOfEntities: number | undefined;
    request: AnnualRenewalRequestDto | undefined;
    requestedFromCR: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IAnnualRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["companyRegistrationRequestFees"] && data["companyRegistrationRequestFees"].constructor === Array) {
                this.companyRegistrationRequestFees = [] as any;
                for (let item of data["companyRegistrationRequestFees"])
                    this.companyRegistrationRequestFees.push(AnnualRenewalRequestFeeDto.fromJS(item));
            }
            this.entitiesPassedAnnualRenewalDate = data["entitiesPassedAnnualRenewalDate"];
            if (data["entityTypes"]) {
                this.entityTypes = {} as any;
                for (let key in data["entityTypes"]) {
                    if (data["entityTypes"].hasOwnProperty(key))
                        this.entityTypes[key] = data["entityTypes"][key];
                }
            }
            this.numberOfEntities = data["numberOfEntities"];
            this.request = data["request"] ? AnnualRenewalRequestDto.fromJS(data["request"]) : <any>undefined;
            this.requestedFromCR = data["requestedFromCR"];
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnualRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.companyRegistrationRequestFees && this.companyRegistrationRequestFees.constructor === Array) {
            data["companyRegistrationRequestFees"] = [];
            for (let item of this.companyRegistrationRequestFees)
                data["companyRegistrationRequestFees"].push(item.toJSON());
        }
        data["entitiesPassedAnnualRenewalDate"] = this.entitiesPassedAnnualRenewalDate;
        if (this.entityTypes) {
            data["entityTypes"] = {};
            for (let key in this.entityTypes) {
                if (this.entityTypes.hasOwnProperty(key))
                    data["entityTypes"][key] = this.entityTypes[key];
            }
        }
        data["numberOfEntities"] = this.numberOfEntities;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["requestedFromCR"] = this.requestedFromCR;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): AnnualRenewalDto {
        const json = this.toJSON();
        let result = new AnnualRenewalDto();
        result.init(json);
        return result;
    }
}

export interface IAnnualRenewalDto {
    companyRegistrationRequestFees: AnnualRenewalRequestFeeDto[] | undefined;
    entitiesPassedAnnualRenewalDate: number | undefined;
    entityTypes: { [key: string] : number; } | undefined;
    numberOfEntities: number | undefined;
    request: AnnualRenewalRequestDto | undefined;
    requestedFromCR: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class AnnualRenewalRequestFeeDto implements IAnnualRenewalRequestFeeDto {
    companyRegistrationId: string | undefined;
    entityName: string | undefined;
    entityType: string | undefined;
    incorporationNumber: string | undefined;
    incorporationDate: Date | undefined;
    isSelected: boolean | undefined;
    lastAnnualRenewalDate: Date | undefined;
    numberOfYearsToRenew: number | undefined;
    nextAnnualRenewalDate: Date | undefined;
    numberOfLatePenaltyDays: number | undefined;
    penaltyFees: number | undefined;
    renewalFees: number | undefined;
    requestFeeCertificates: RequestFeeCertificateDto[] | undefined;
    total: number | undefined;
    id: string | undefined;

    constructor(data?: IAnnualRenewalRequestFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyRegistrationId = data["companyRegistrationId"];
            this.entityName = data["entityName"];
            this.entityType = data["entityType"];
            this.incorporationNumber = data["incorporationNumber"];
            this.incorporationDate = data["incorporationDate"] ? new Date(data["incorporationDate"].toString()) : <any>undefined;
            this.isSelected = data["isSelected"];
            this.lastAnnualRenewalDate = data["lastAnnualRenewalDate"] ? new Date(data["lastAnnualRenewalDate"].toString()) : <any>undefined;
            this.numberOfYearsToRenew = data["numberOfYearsToRenew"];
            this.nextAnnualRenewalDate = data["nextAnnualRenewalDate"] ? new Date(data["nextAnnualRenewalDate"].toString()) : <any>undefined;
            this.numberOfLatePenaltyDays = data["numberOfLatePenaltyDays"];
            this.penaltyFees = data["penaltyFees"];
            this.renewalFees = data["renewalFees"];
            if (data["requestFeeCertificates"] && data["requestFeeCertificates"].constructor === Array) {
                this.requestFeeCertificates = [] as any;
                for (let item of data["requestFeeCertificates"])
                    this.requestFeeCertificates.push(RequestFeeCertificateDto.fromJS(item));
            }
            this.total = data["total"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnualRenewalRequestFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualRenewalRequestFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegistrationId"] = this.companyRegistrationId;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["incorporationNumber"] = this.incorporationNumber;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["isSelected"] = this.isSelected;
        data["lastAnnualRenewalDate"] = this.lastAnnualRenewalDate ? this.lastAnnualRenewalDate.toISOString() : <any>undefined;
        data["numberOfYearsToRenew"] = this.numberOfYearsToRenew;
        data["nextAnnualRenewalDate"] = this.nextAnnualRenewalDate ? this.nextAnnualRenewalDate.toISOString() : <any>undefined;
        data["numberOfLatePenaltyDays"] = this.numberOfLatePenaltyDays;
        data["penaltyFees"] = this.penaltyFees;
        data["renewalFees"] = this.renewalFees;
        if (this.requestFeeCertificates && this.requestFeeCertificates.constructor === Array) {
            data["requestFeeCertificates"] = [];
            for (let item of this.requestFeeCertificates)
                data["requestFeeCertificates"].push(item.toJSON());
        }
        data["total"] = this.total;
        data["id"] = this.id;
        return data; 
    }

    clone(): AnnualRenewalRequestFeeDto {
        const json = this.toJSON();
        let result = new AnnualRenewalRequestFeeDto();
        result.init(json);
        return result;
    }
}

export interface IAnnualRenewalRequestFeeDto {
    companyRegistrationId: string | undefined;
    entityName: string | undefined;
    entityType: string | undefined;
    incorporationNumber: string | undefined;
    incorporationDate: Date | undefined;
    isSelected: boolean | undefined;
    lastAnnualRenewalDate: Date | undefined;
    numberOfYearsToRenew: number | undefined;
    nextAnnualRenewalDate: Date | undefined;
    numberOfLatePenaltyDays: number | undefined;
    penaltyFees: number | undefined;
    renewalFees: number | undefined;
    requestFeeCertificates: RequestFeeCertificateDto[] | undefined;
    total: number | undefined;
    id: string | undefined;
}

export class AnnualRenewalRequestDto implements IAnnualRenewalRequestDto {
    companyName: string | undefined;
    companyTypeName: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeName: string | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyTypeKey: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    readonly registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceTypeKey: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IAnnualRenewalRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.companyTypeName = data["companyTypeName"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeName = data["serviceTypeName"];
            this.totalAmount = data["totalAmount"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedByUserName = data["assignedByUserName"];
            this.assignedTo = data["assignedTo"];
            this.companyTypeKey = data["companyTypeKey"];
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            this.extensionData = data["extensionData"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
            this.registeredAgentName = data["registeredAgentName"];
            (<any>this).registeredAgentNumber = data["registeredAgentNumber"];
            this.requestedBy = data["requestedBy"] ? PersonDto.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestedByName = data["requestedByName"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.serviceCategoryKey = data["serviceCategoryKey"];
            this.serviceTypeKey = data["serviceTypeKey"];
            this.terminatedAt = data["terminatedAt"] ? new Date(data["terminatedAt"].toString()) : <any>undefined;
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AnnualRenewalRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnnualRenewalRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyTypeName"] = this.companyTypeName;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeName"] = this.serviceTypeName;
        data["totalAmount"] = this.totalAmount;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedByUserName"] = this.assignedByUserName;
        data["assignedTo"] = this.assignedTo;
        data["companyTypeKey"] = this.companyTypeKey;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        data["registeredAgentName"] = this.registeredAgentName;
        data["registeredAgentNumber"] = this.registeredAgentNumber;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestedByName"] = this.requestedByName;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["serviceCategoryKey"] = this.serviceCategoryKey;
        data["serviceTypeKey"] = this.serviceTypeKey;
        data["terminatedAt"] = this.terminatedAt ? this.terminatedAt.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): AnnualRenewalRequestDto {
        const json = this.toJSON();
        let result = new AnnualRenewalRequestDto();
        result.init(json);
        return result;
    }
}

export interface IAnnualRenewalRequestDto {
    companyName: string | undefined;
    companyTypeName: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeName: string | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyTypeKey: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceTypeKey: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class RequestFeeCertificateDto implements IRequestFeeCertificateDto {
    certificate: CertificateDto | undefined;
    certificateFieldValues: CertificateFieldValueDto[] | undefined;
    creationTime: Date | undefined;
    fileRecordId: string | undefined;
    sealKey: string | undefined;
    signatoryKey: string | undefined;
    signatureKey: string | undefined;
    statusKey: string | undefined;
    isDeleted: boolean | undefined;
    lastModificationTime: Date | undefined;
    requestFee: RequestFeeDto | undefined;
    entityName: string | undefined;
    entityTypeName: string | undefined;
    incorporationNumber: string | undefined;
    registeredAgentName: string | undefined;
    fileName: string | undefined;
    id: string | undefined;

    constructor(data?: IRequestFeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificate = data["certificate"] ? CertificateDto.fromJS(data["certificate"]) : <any>undefined;
            if (data["certificateFieldValues"] && data["certificateFieldValues"].constructor === Array) {
                this.certificateFieldValues = [] as any;
                for (let item of data["certificateFieldValues"])
                    this.certificateFieldValues.push(CertificateFieldValueDto.fromJS(item));
            }
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.fileRecordId = data["fileRecordId"];
            this.sealKey = data["sealKey"];
            this.signatoryKey = data["signatoryKey"];
            this.signatureKey = data["signatureKey"];
            this.statusKey = data["statusKey"];
            this.isDeleted = data["isDeleted"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.requestFee = data["requestFee"] ? RequestFeeDto.fromJS(data["requestFee"]) : <any>undefined;
            this.entityName = data["entityName"];
            this.entityTypeName = data["entityTypeName"];
            this.incorporationNumber = data["incorporationNumber"];
            this.registeredAgentName = data["registeredAgentName"];
            this.fileName = data["fileName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RequestFeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificate"] = this.certificate ? this.certificate.toJSON() : <any>undefined;
        if (this.certificateFieldValues && this.certificateFieldValues.constructor === Array) {
            data["certificateFieldValues"] = [];
            for (let item of this.certificateFieldValues)
                data["certificateFieldValues"].push(item.toJSON());
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["fileRecordId"] = this.fileRecordId;
        data["sealKey"] = this.sealKey;
        data["signatoryKey"] = this.signatoryKey;
        data["signatureKey"] = this.signatureKey;
        data["statusKey"] = this.statusKey;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["requestFee"] = this.requestFee ? this.requestFee.toJSON() : <any>undefined;
        data["entityName"] = this.entityName;
        data["entityTypeName"] = this.entityTypeName;
        data["incorporationNumber"] = this.incorporationNumber;
        data["registeredAgentName"] = this.registeredAgentName;
        data["fileName"] = this.fileName;
        data["id"] = this.id;
        return data; 
    }

    clone(): RequestFeeCertificateDto {
        const json = this.toJSON();
        let result = new RequestFeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IRequestFeeCertificateDto {
    certificate: CertificateDto | undefined;
    certificateFieldValues: CertificateFieldValueDto[] | undefined;
    creationTime: Date | undefined;
    fileRecordId: string | undefined;
    sealKey: string | undefined;
    signatoryKey: string | undefined;
    signatureKey: string | undefined;
    statusKey: string | undefined;
    isDeleted: boolean | undefined;
    lastModificationTime: Date | undefined;
    requestFee: RequestFeeDto | undefined;
    entityName: string | undefined;
    entityTypeName: string | undefined;
    incorporationNumber: string | undefined;
    registeredAgentName: string | undefined;
    fileName: string | undefined;
    id: string | undefined;
}

export class RequestFeeDto implements IRequestFeeDto {
    alternativeAmount: number | undefined;
    amount: number | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeCode: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccountId: string | undefined;
    id: string | undefined;
    isDeleted: boolean | undefined;
    isOptional: boolean | undefined;
    isPaid: boolean | undefined;
    isPendingRefund: boolean | undefined;
    isRefunded: boolean | undefined;
    paymentDate: Date | undefined;
    quantity: number | undefined;
    receiptNumber: string | undefined;
    request: RequestV2WithNoRequestFeeDto | undefined;
    requestFeeCertificates: RequestFeeCertificateDto[] | undefined;
    requestId: string | undefined;
    tags: string[] | undefined;
    transactionHeaderId: string | undefined;

    constructor(data?: IRequestFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.extensionData = data["extensionData"];
            this.fee = data["fee"] ? FeeDto.fromJS(data["fee"]) : <any>undefined;
            this.feeCode = data["feeCode"];
            this.feeDescription = data["feeDescription"];
            this.feeId = data["feeId"];
            this.financialAccountId = data["financialAccountId"];
            this.id = data["id"];
            this.isDeleted = data["isDeleted"];
            this.isOptional = data["isOptional"];
            this.isPaid = data["isPaid"];
            this.isPendingRefund = data["isPendingRefund"];
            this.isRefunded = data["isRefunded"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.quantity = data["quantity"];
            this.receiptNumber = data["receiptNumber"];
            this.request = data["request"] ? RequestV2WithNoRequestFeeDto.fromJS(data["request"]) : <any>undefined;
            if (data["requestFeeCertificates"] && data["requestFeeCertificates"].constructor === Array) {
                this.requestFeeCertificates = [] as any;
                for (let item of data["requestFeeCertificates"])
                    this.requestFeeCertificates.push(RequestFeeCertificateDto.fromJS(item));
            }
            this.requestId = data["requestId"];
            if (data["tags"] && data["tags"].constructor === Array) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags.push(item);
            }
            this.transactionHeaderId = data["transactionHeaderId"];
        }
    }

    static fromJS(data: any): RequestFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["extensionData"] = this.extensionData;
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["feeCode"] = this.feeCode;
        data["feeDescription"] = this.feeDescription;
        data["feeId"] = this.feeId;
        data["financialAccountId"] = this.financialAccountId;
        data["id"] = this.id;
        data["isDeleted"] = this.isDeleted;
        data["isOptional"] = this.isOptional;
        data["isPaid"] = this.isPaid;
        data["isPendingRefund"] = this.isPendingRefund;
        data["isRefunded"] = this.isRefunded;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["quantity"] = this.quantity;
        data["receiptNumber"] = this.receiptNumber;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        if (this.requestFeeCertificates && this.requestFeeCertificates.constructor === Array) {
            data["requestFeeCertificates"] = [];
            for (let item of this.requestFeeCertificates)
                data["requestFeeCertificates"].push(item.toJSON());
        }
        data["requestId"] = this.requestId;
        if (this.tags && this.tags.constructor === Array) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["transactionHeaderId"] = this.transactionHeaderId;
        return data; 
    }

    clone(): RequestFeeDto {
        const json = this.toJSON();
        let result = new RequestFeeDto();
        result.init(json);
        return result;
    }
}

export interface IRequestFeeDto {
    alternativeAmount: number | undefined;
    amount: number | undefined;
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    feeCode: number | undefined;
    feeDescription: string | undefined;
    feeId: string | undefined;
    financialAccountId: string | undefined;
    id: string | undefined;
    isDeleted: boolean | undefined;
    isOptional: boolean | undefined;
    isPaid: boolean | undefined;
    isPendingRefund: boolean | undefined;
    isRefunded: boolean | undefined;
    paymentDate: Date | undefined;
    quantity: number | undefined;
    receiptNumber: string | undefined;
    request: RequestV2WithNoRequestFeeDto | undefined;
    requestFeeCertificates: RequestFeeCertificateDto[] | undefined;
    requestId: string | undefined;
    tags: string[] | undefined;
    transactionHeaderId: string | undefined;
}

export class DocumentDto implements IDocumentDto {
    companyRegistrationId: string | undefined;
    confidentialityKey: string | undefined;
    confidentialityName: string | undefined;
    contentType: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    entityName: string | undefined;
    entityTypeName: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    filingDate: Date | undefined;
    incorporationNumber: string | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    registeredAgentName: string | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    stampName: string | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    isDeleted: boolean | undefined;
    requestFeeCertificate: RequestFeeCertificateDto | undefined;
    id: string | undefined;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyRegistrationId = data["companyRegistrationId"];
            this.confidentialityKey = data["confidentialityKey"];
            this.confidentialityName = data["confidentialityName"];
            this.contentType = data["contentType"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creatorUserName = data["creatorUserName"];
            this.entityName = data["entityName"];
            this.entityTypeName = data["entityTypeName"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.filingDate = data["filingDate"] ? new Date(data["filingDate"].toString()) : <any>undefined;
            this.incorporationNumber = data["incorporationNumber"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestId = data["requestId"];
            this.stampKey = data["stampKey"];
            this.stampName = data["stampName"];
            this.statusKey = data["statusKey"];
            this.statusName = data["statusName"];
            this.isDeleted = data["isDeleted"];
            this.requestFeeCertificate = data["requestFeeCertificate"] ? RequestFeeCertificateDto.fromJS(data["requestFeeCertificate"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegistrationId"] = this.companyRegistrationId;
        data["confidentialityKey"] = this.confidentialityKey;
        data["confidentialityName"] = this.confidentialityName;
        data["contentType"] = this.contentType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["entityName"] = this.entityName;
        data["entityTypeName"] = this.entityTypeName;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["filingDate"] = this.filingDate ? this.filingDate.toISOString() : <any>undefined;
        data["incorporationNumber"] = this.incorporationNumber;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestId"] = this.requestId;
        data["stampKey"] = this.stampKey;
        data["stampName"] = this.stampName;
        data["statusKey"] = this.statusKey;
        data["statusName"] = this.statusName;
        data["isDeleted"] = this.isDeleted;
        data["requestFeeCertificate"] = this.requestFeeCertificate ? this.requestFeeCertificate.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): DocumentDto {
        const json = this.toJSON();
        let result = new DocumentDto();
        result.init(json);
        return result;
    }
}

export interface IDocumentDto {
    companyRegistrationId: string | undefined;
    confidentialityKey: string | undefined;
    confidentialityName: string | undefined;
    contentType: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    entityName: string | undefined;
    entityTypeName: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    filingDate: Date | undefined;
    incorporationNumber: string | undefined;
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    registeredAgentName: string | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    stampName: string | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    isDeleted: boolean | undefined;
    requestFeeCertificate: RequestFeeCertificateDto | undefined;
    id: string | undefined;
}

export class RegisteredAgentDto implements IRegisteredAgentDto {
    accountNumber: string | undefined;
    addresses: AddressDto[] | undefined;
    addressStreetLine1: string | undefined;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    companyName: string | undefined;
    contactType: RegisteredAgentDtoContactType | undefined;
    readonly countryName: string | undefined;
    creationTime: Date | undefined;
    email: EmailAddressDto | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    faxNumber: PhoneNumberDto | undefined;
    financialAccountIds: string[] | undefined;
    isDeleted: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    resignedAt: Date | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    people: CompanyPersonDto[] | undefined;
    isActive: boolean | undefined;
    id: string | undefined;

    constructor(data?: IRegisteredAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(AddressDto.fromJS(item));
            }
            this.addressStreetLine1 = data["addressStreetLine1"];
            this.addressStreetLine2 = data["addressStreetLine2"];
            this.businessPhoneNumber = data["businessPhoneNumber"] ? PhoneNumberDto.fromJS(data["businessPhoneNumber"]) : <any>undefined;
            this.cellNumber = data["cellNumber"] ? PhoneNumberDto.fromJS(data["cellNumber"]) : <any>undefined;
            this.companyName = data["companyName"];
            this.contactType = data["contactType"];
            (<any>this).countryName = data["countryName"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.email = data["email"] ? EmailAddressDto.fromJS(data["email"]) : <any>undefined;
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            this.faxNumber = data["faxNumber"] ? PhoneNumberDto.fromJS(data["faxNumber"]) : <any>undefined;
            if (data["financialAccountIds"] && data["financialAccountIds"].constructor === Array) {
                this.financialAccountIds = [] as any;
                for (let item of data["financialAccountIds"])
                    this.financialAccountIds.push(item);
            }
            this.isDeleted = data["isDeleted"];
            if (data["licensesNewRenewalDates"]) {
                this.licensesNewRenewalDates = {} as any;
                for (let key in data["licensesNewRenewalDates"]) {
                    if (data["licensesNewRenewalDates"].hasOwnProperty(key))
                        this.licensesNewRenewalDates[key] = data["licensesNewRenewalDates"][key] ? new Date(data["licensesNewRenewalDates"][key].toString()) : <any>undefined;
                }
            }
            this.name = data["name"];
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            this.resignedAt = data["resignedAt"] ? new Date(data["resignedAt"].toString()) : <any>undefined;
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["people"] && data["people"].constructor === Array) {
                this.people = [] as any;
                for (let item of data["people"])
                    this.people.push(CompanyPersonDto.fromJS(item));
            }
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegisteredAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["addressStreetLine1"] = this.addressStreetLine1;
        data["addressStreetLine2"] = this.addressStreetLine2;
        data["businessPhoneNumber"] = this.businessPhoneNumber ? this.businessPhoneNumber.toJSON() : <any>undefined;
        data["cellNumber"] = this.cellNumber ? this.cellNumber.toJSON() : <any>undefined;
        data["companyName"] = this.companyName;
        data["contactType"] = this.contactType;
        data["countryName"] = this.countryName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        data["faxNumber"] = this.faxNumber ? this.faxNumber.toJSON() : <any>undefined;
        if (this.financialAccountIds && this.financialAccountIds.constructor === Array) {
            data["financialAccountIds"] = [];
            for (let item of this.financialAccountIds)
                data["financialAccountIds"].push(item);
        }
        data["isDeleted"] = this.isDeleted;
        if (this.licensesNewRenewalDates) {
            data["licensesNewRenewalDates"] = {};
            for (let key in this.licensesNewRenewalDates) {
                if (this.licensesNewRenewalDates.hasOwnProperty(key))
                    data["licensesNewRenewalDates"][key] = this.licensesNewRenewalDates[key] ? this.licensesNewRenewalDates[key].toISOString() : <any>undefined;
            }
        }
        data["name"] = this.name;
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["resignedAt"] = this.resignedAt ? this.resignedAt.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.people && this.people.constructor === Array) {
            data["people"] = [];
            for (let item of this.people)
                data["people"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegisteredAgentDto {
        const json = this.toJSON();
        let result = new RegisteredAgentDto();
        result.init(json);
        return result;
    }
}

export interface IRegisteredAgentDto {
    accountNumber: string | undefined;
    addresses: AddressDto[] | undefined;
    addressStreetLine1: string | undefined;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    companyName: string | undefined;
    contactType: RegisteredAgentDtoContactType | undefined;
    countryName: string | undefined;
    creationTime: Date | undefined;
    email: EmailAddressDto | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    faxNumber: PhoneNumberDto | undefined;
    financialAccountIds: string[] | undefined;
    isDeleted: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    resignedAt: Date | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    people: CompanyPersonDto[] | undefined;
    isActive: boolean | undefined;
    id: string | undefined;
}

export class PersonDto implements IPersonDto {
    contactType: PersonDtoContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: AddressDto[] | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;

    constructor(data?: IPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contactType = data["contactType"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(AddressDto.fromJS(item));
            }
            this.companyName = data["companyName"];
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactType"] = this.contactType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["companyName"] = this.companyName;
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): PersonDto {
        const json = this.toJSON();
        let result = new PersonDto();
        result.init(json);
        return result;
    }
}

export interface IPersonDto {
    contactType: PersonDtoContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: AddressDto[] | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;
}

export class CertificateDto implements ICertificateDto {
    description: string | undefined;
    key: string | undefined;
    id: string | undefined;

    constructor(data?: ICertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.key = data["key"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["key"] = this.key;
        data["id"] = this.id;
        return data; 
    }

    clone(): CertificateDto {
        const json = this.toJSON();
        let result = new CertificateDto();
        result.init(json);
        return result;
    }
}

export interface ICertificateDto {
    description: string | undefined;
    key: string | undefined;
    id: string | undefined;
}

export class CertificateFieldValueDto implements ICertificateFieldValueDto {
    certificateField: CertificateFieldDto | undefined;
    dateValue: Date | undefined;
    boolValue: boolean | false;
    value: string | undefined;
    id: string | undefined;

    constructor(data?: ICertificateFieldValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificateField = data["certificateField"] ? CertificateFieldDto.fromJS(data["certificateField"]) : <any>undefined;
            this.dateValue = data["dateValue"] ? new Date(data["dateValue"].toString()) : <any>undefined;
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateFieldValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateFieldValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateField"] = this.certificateField ? this.certificateField.toJSON() : <any>undefined;
        data["dateValue"] = this.dateValue ? this.dateValue.toISOString() : <any>undefined;
        data["boolValue"] = this.boolValue;
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }

    clone(): CertificateFieldValueDto {
        const json = this.toJSON();
        let result = new CertificateFieldValueDto();
        result.init(json);
        return result;
    }
}

export interface ICertificateFieldValueDto {
    certificateField: CertificateFieldDto | undefined;
    dateValue: Date | undefined;
    value: string | undefined;
    id: string | undefined;
    boolValue: boolean | false;
}

export class RequestV2WithNoRequestFeeDto implements IRequestV2WithNoRequestFeeDto {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    readonly registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IRequestV2WithNoRequestFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedByUserName = data["assignedByUserName"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            this.extensionData = data["extensionData"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
            this.registeredAgentName = data["registeredAgentName"];
            (<any>this).registeredAgentNumber = data["registeredAgentNumber"];
            this.requestedBy = data["requestedBy"] ? PersonDto.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestedByName = data["requestedByName"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.serviceCategoryKey = data["serviceCategoryKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            this.serviceTypeName = data["serviceTypeName"];
            this.terminatedAt = data["terminatedAt"] ? new Date(data["terminatedAt"].toString()) : <any>undefined;
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RequestV2WithNoRequestFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestV2WithNoRequestFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedByUserName"] = this.assignedByUserName;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        data["registeredAgentName"] = this.registeredAgentName;
        data["registeredAgentNumber"] = this.registeredAgentNumber;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestedByName"] = this.requestedByName;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["serviceCategoryKey"] = this.serviceCategoryKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        data["serviceTypeName"] = this.serviceTypeName;
        data["terminatedAt"] = this.terminatedAt ? this.terminatedAt.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): RequestV2WithNoRequestFeeDto {
        const json = this.toJSON();
        let result = new RequestV2WithNoRequestFeeDto();
        result.init(json);
        return result;
    }
}

export interface IRequestV2WithNoRequestFeeDto {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class AddressDto implements IAddressDto {
    addressTypeKey: string | undefined;
    city: string | undefined;
    country: CountryDto | undefined;
    state: StateDto | undefined;
    stateName: string | undefined;
    street: string | undefined;
    street2: string | undefined;
    zip: string | undefined;
    id: string | undefined;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.addressTypeKey = data["addressTypeKey"];
            this.city = data["city"];
            this.country = data["country"] ? CountryDto.fromJS(data["country"]) : <any>undefined;
            this.state = data["state"] ? StateDto.fromJS(data["state"]) : <any>undefined;
            this.stateName = data["stateName"];
            this.street = data["street"];
            this.street2 = data["street2"];
            this.zip = data["zip"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressTypeKey"] = this.addressTypeKey;
        data["city"] = this.city;
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["state"] = this.state ? this.state.toJSON() : <any>undefined;
        data["stateName"] = this.stateName;
        data["street"] = this.street;
        data["street2"] = this.street2;
        data["zip"] = this.zip;
        data["id"] = this.id;
        return data; 
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    addressTypeKey: string | undefined;
    city: string | undefined;
    country: CountryDto | undefined;
    state: StateDto | undefined;
    stateName: string | undefined;
    street: string | undefined;
    street2: string | undefined;
    zip: string | undefined;
    id: string | undefined;
}

export class PhoneNumberDto implements IPhoneNumberDto {
    number: string | undefined;
    phoneNumberTypeKey: string | undefined;
    id: string | undefined;

    constructor(data?: IPhoneNumberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.number = data["number"];
            this.phoneNumberTypeKey = data["phoneNumberTypeKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PhoneNumberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhoneNumberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["phoneNumberTypeKey"] = this.phoneNumberTypeKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): PhoneNumberDto {
        const json = this.toJSON();
        let result = new PhoneNumberDto();
        result.init(json);
        return result;
    }
}

export interface IPhoneNumberDto {
    number: string | undefined;
    phoneNumberTypeKey: string | undefined;
    id: string | undefined;
}

export class EmailAddressDto implements IEmailAddressDto {
    email: string | undefined;
    emailAddressTypeKey: string | undefined;
    id: string | undefined;

    constructor(data?: IEmailAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"];
            this.emailAddressTypeKey = data["emailAddressTypeKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EmailAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["emailAddressTypeKey"] = this.emailAddressTypeKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): EmailAddressDto {
        const json = this.toJSON();
        let result = new EmailAddressDto();
        result.init(json);
        return result;
    }
}

export interface IEmailAddressDto {
    email: string | undefined;
    emailAddressTypeKey: string | undefined;
    id: string | undefined;
}

export class CompanyPersonDto implements ICompanyPersonDto {
    title: string | undefined;
    contactType: CompanyPersonDtoContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: AddressDto[] | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;

    constructor(data?: ICompanyPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.title = data["title"];
            this.contactType = data["contactType"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(AddressDto.fromJS(item));
            }
            this.companyName = data["companyName"];
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contactType"] = this.contactType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["companyName"] = this.companyName;
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CompanyPersonDto {
        const json = this.toJSON();
        let result = new CompanyPersonDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyPersonDto {
    title: string | undefined;
    contactType: CompanyPersonDtoContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: AddressDto[] | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;
}

export class CertificateFieldDto implements ICertificateFieldDto {
    defaultValue: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    inputType: string | undefined;
    isReadOnly: boolean | undefined;
    key: string | undefined;
    id: string | undefined;

    constructor(data?: ICertificateFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.defaultValue = data["defaultValue"];
            this.description = data["description"];
            this.extensionData = data["extensionData"];
            this.inputType = data["inputType"];
            this.isReadOnly = data["isReadOnly"];
            this.key = data["key"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CertificateFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultValue"] = this.defaultValue;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["inputType"] = this.inputType;
        data["isReadOnly"] = this.isReadOnly;
        data["key"] = this.key;
        data["id"] = this.id;
        return data; 
    }

    clone(): CertificateFieldDto {
        const json = this.toJSON();
        let result = new CertificateFieldDto();
        result.init(json);
        return result;
    }
}

export interface ICertificateFieldDto {
    defaultValue: string | undefined;
    description: string | undefined;
    extensionData: string | undefined;
    inputType: string | undefined;
    isReadOnly: boolean | undefined;
    key: string | undefined;
    id: string | undefined;
}

export class CountryDto implements ICountryDto {
    iso31661Alpha3: string | undefined;
    name: string | undefined;
    numericCode: number | undefined;
    id: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.iso31661Alpha3 = data["iso31661Alpha3"];
            this.name = data["name"];
            this.numericCode = data["numericCode"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iso31661Alpha3"] = this.iso31661Alpha3;
        data["name"] = this.name;
        data["numericCode"] = this.numericCode;
        data["id"] = this.id;
        return data; 
    }

    clone(): CountryDto {
        const json = this.toJSON();
        let result = new CountryDto();
        result.init(json);
        return result;
    }
}

export interface ICountryDto {
    iso31661Alpha3: string | undefined;
    name: string | undefined;
    numericCode: number | undefined;
    id: string | undefined;
}

export class StateDto implements IStateDto {
    country: CountryDto | undefined;
    name: string | undefined;
    id: string | undefined;

    constructor(data?: IStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.country = data["country"] ? CountryDto.fromJS(data["country"]) : <any>undefined;
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): StateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country ? this.country.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): StateDto {
        const json = this.toJSON();
        let result = new StateDto();
        result.init(json);
        return result;
    }
}

export interface IStateDto {
    country: CountryDto | undefined;
    name: string | undefined;
    id: string | undefined;
}

export class CreateAnnualRenewalInput implements ICreateAnnualRenewalInput {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: AnnualRenewalRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;

    constructor(data?: ICreateAnnualRenewalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.notes = data["notes"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(AnnualRenewalRequestFeeInput.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateAnnualRenewalInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAnnualRenewalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["notes"] = this.notes;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateAnnualRenewalInput {
        const json = this.toJSON();
        let result = new CreateAnnualRenewalInput();
        result.init(json);
        return result;
    }
}

export interface ICreateAnnualRenewalInput {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: AnnualRenewalRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfAnnualRenewalDto implements IPagedResultDtoOfAnnualRenewalDto {
    totalCount: number | undefined;
    items: AnnualRenewalDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAnnualRenewalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(AnnualRenewalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAnnualRenewalDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAnnualRenewalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfAnnualRenewalDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfAnnualRenewalDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfAnnualRenewalDto {
    totalCount: number | undefined;
    items: AnnualRenewalDto[] | undefined;
}

export class PagedResultDtoOfGetAllSearchAnnualRenewalOutput implements IPagedResultDtoOfGetAllSearchAnnualRenewalOutput {
    totalCount: number | undefined;
    items: GetAllSearchAnnualRenewalOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSearchAnnualRenewalOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllSearchAnnualRenewalOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSearchAnnualRenewalOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSearchAnnualRenewalOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllSearchAnnualRenewalOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllSearchAnnualRenewalOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllSearchAnnualRenewalOutput {
    totalCount: number | undefined;
    items: GetAllSearchAnnualRenewalOutput[] | undefined;
}

export class GetAllSearchAnnualRenewalOutput implements IGetAllSearchAnnualRenewalOutput {
    creationTime: Date | undefined;
    lastModificationTime: Date | undefined;
    numberOfEntities: number | undefined;
    registeredAgentName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestNumber: string | undefined;
    id: string | undefined;

    constructor(data?: IGetAllSearchAnnualRenewalOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.numberOfEntities = data["numberOfEntities"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllSearchAnnualRenewalOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSearchAnnualRenewalOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["numberOfEntities"] = this.numberOfEntities;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllSearchAnnualRenewalOutput {
        const json = this.toJSON();
        let result = new GetAllSearchAnnualRenewalOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllSearchAnnualRenewalOutput {
    creationTime: Date | undefined;
    lastModificationTime: Date | undefined;
    numberOfEntities: number | undefined;
    registeredAgentName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestNumber: string | undefined;
    id: string | undefined;
}

export class UpdateAnnualRenewalInput implements IUpdateAnnualRenewalInput {
    isAfterAddEntity: boolean | undefined;
    isBeforeMakePayment: boolean | undefined;
    rowVersion: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: AnnualRenewalRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;

    constructor(data?: IUpdateAnnualRenewalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isAfterAddEntity = data["isAfterAddEntity"];
            this.isBeforeMakePayment = data["isBeforeMakePayment"];
            this.rowVersion = data["rowVersion"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.notes = data["notes"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(AnnualRenewalRequestFeeInput.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateAnnualRenewalInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAnnualRenewalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAfterAddEntity"] = this.isAfterAddEntity;
        data["isBeforeMakePayment"] = this.isBeforeMakePayment;
        data["rowVersion"] = this.rowVersion;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["notes"] = this.notes;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateAnnualRenewalInput {
        const json = this.toJSON();
        let result = new UpdateAnnualRenewalInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateAnnualRenewalInput {
    isAfterAddEntity: boolean | undefined;
    isBeforeMakePayment: boolean | undefined;
    rowVersion: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: AnnualRenewalRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;
}

export class CreateBatchInput implements ICreateBatchInput {
    rowVersion: string | undefined;
    portalKey: string;
    requestIds: string[] | undefined;
    id: string | undefined;

    constructor(data?: ICreateBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.rowVersion = data["rowVersion"];
            this.portalKey = data["portalKey"];
            if (data["requestIds"] && data["requestIds"].constructor === Array) {
                this.requestIds = [] as any;
                for (let item of data["requestIds"])
                    this.requestIds.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowVersion"] = this.rowVersion;
        data["portalKey"] = this.portalKey;
        if (this.requestIds && this.requestIds.constructor === Array) {
            data["requestIds"] = [];
            for (let item of this.requestIds)
                data["requestIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateBatchInput {
        const json = this.toJSON();
        let result = new CreateBatchInput();
        result.init(json);
        return result;
    }
}

export interface ICreateBatchInput {
    rowVersion: string | undefined;
    portalKey: string;
    requestIds: string[] | undefined;
    id: string | undefined;
}

export class BatchDto implements IBatchDto {
    batchNumber: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    requests: RequestV2Dto[] | undefined;
    serviceTypes: { [key: string] : number; } | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    totalAmount: number | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchNumber = data["batchNumber"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
            if (data["requests"] && data["requests"].constructor === Array) {
                this.requests = [] as any;
                for (let item of data["requests"])
                    this.requests.push(RequestV2Dto.fromJS(item));
            }
            if (data["serviceTypes"]) {
                this.serviceTypes = {} as any;
                for (let key in data["serviceTypes"]) {
                    if (data["serviceTypes"].hasOwnProperty(key))
                        this.serviceTypes[key] = data["serviceTypes"][key];
                }
            }
            this.statusKey = data["statusKey"];
            this.statusName = data["statusName"];
            this.totalAmount = data["totalAmount"];
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        if (this.requests && this.requests.constructor === Array) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        if (this.serviceTypes) {
            data["serviceTypes"] = {};
            for (let key in this.serviceTypes) {
                if (this.serviceTypes.hasOwnProperty(key))
                    data["serviceTypes"][key] = this.serviceTypes[key];
            }
        }
        data["statusKey"] = this.statusKey;
        data["statusName"] = this.statusName;
        data["totalAmount"] = this.totalAmount;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): BatchDto {
        const json = this.toJSON();
        let result = new BatchDto();
        result.init(json);
        return result;
    }
}

export interface IBatchDto {
    batchNumber: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    requests: RequestV2Dto[] | undefined;
    serviceTypes: { [key: string] : number; } | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    totalAmount: number | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class RequestV2Dto implements IRequestV2Dto {
    requestFees: RequestFeeDto[] | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    readonly registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IRequestV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.totalAmount = data["totalAmount"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedByUserName = data["assignedByUserName"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            this.extensionData = data["extensionData"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
            this.registeredAgentName = data["registeredAgentName"];
            (<any>this).registeredAgentNumber = data["registeredAgentNumber"];
            this.requestedBy = data["requestedBy"] ? PersonDto.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestedByName = data["requestedByName"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.serviceCategoryKey = data["serviceCategoryKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            this.serviceTypeName = data["serviceTypeName"];
            this.terminatedAt = data["terminatedAt"] ? new Date(data["terminatedAt"].toString()) : <any>undefined;
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RequestV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["totalAmount"] = this.totalAmount;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedByUserName"] = this.assignedByUserName;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        data["registeredAgentName"] = this.registeredAgentName;
        data["registeredAgentNumber"] = this.registeredAgentNumber;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestedByName"] = this.requestedByName;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["serviceCategoryKey"] = this.serviceCategoryKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        data["serviceTypeName"] = this.serviceTypeName;
        data["terminatedAt"] = this.terminatedAt ? this.terminatedAt.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): RequestV2Dto {
        const json = this.toJSON();
        let result = new RequestV2Dto();
        result.init(json);
        return result;
    }
}

export interface IRequestV2Dto {
    requestFees: RequestFeeDto[] | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgentNumber: string | undefined;
    requestedBy: PersonDto | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfBatchDto implements IPagedResultDtoOfBatchDto {
    totalCount: number | undefined;
    items: BatchDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBatchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BatchDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBatchDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBatchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfBatchDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBatchDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBatchDto {
    totalCount: number | undefined;
    items: BatchDto[] | undefined;
}

export class PagedResultDtoOfGetAllBatchOutput implements IPagedResultDtoOfGetAllBatchOutput {
    totalCount: number | undefined;
    items: GetAllBatchOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllBatchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllBatchOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllBatchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllBatchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllBatchOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllBatchOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllBatchOutput {
    totalCount: number | undefined;
    items: GetAllBatchOutput[] | undefined;
}

export class GetAllBatchOutput implements IGetAllBatchOutput {
    batchNumber: string | undefined;
    creationTime: Date | undefined;
    registeredAgentName: string | undefined;
    readonly requestCount: number | undefined;
    requests: RequestV2Dto[] | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    totalAmount: number | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: IGetAllBatchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchNumber = data["batchNumber"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.registeredAgentName = data["registeredAgentName"];
            (<any>this).requestCount = data["requestCount"];
            if (data["requests"] && data["requests"].constructor === Array) {
                this.requests = [] as any;
                for (let item of data["requests"])
                    this.requests.push(RequestV2Dto.fromJS(item));
            }
            this.statusKey = data["statusKey"];
            this.statusName = data["statusName"];
            this.totalAmount = data["totalAmount"];
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllBatchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllBatchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestCount"] = this.requestCount;
        if (this.requests && this.requests.constructor === Array) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item.toJSON());
        }
        data["statusKey"] = this.statusKey;
        data["statusName"] = this.statusName;
        data["totalAmount"] = this.totalAmount;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllBatchOutput {
        const json = this.toJSON();
        let result = new GetAllBatchOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllBatchOutput {
    batchNumber: string | undefined;
    creationTime: Date | undefined;
    registeredAgentName: string | undefined;
    requestCount: number | undefined;
    requests: RequestV2Dto[] | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    totalAmount: number | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class UpdateBatchInput implements IUpdateBatchInput {
    statusKey: string | undefined;
    updateAllRequests: boolean | undefined;
    rowVersion: string | undefined;
    portalKey: string;
    requestIds: string[] | undefined;
    id: string | undefined;

    constructor(data?: IUpdateBatchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.statusKey = data["statusKey"];
            this.updateAllRequests = data["updateAllRequests"];
            this.rowVersion = data["rowVersion"];
            this.portalKey = data["portalKey"];
            if (data["requestIds"] && data["requestIds"].constructor === Array) {
                this.requestIds = [] as any;
                for (let item of data["requestIds"])
                    this.requestIds.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateBatchInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBatchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusKey"] = this.statusKey;
        data["updateAllRequests"] = this.updateAllRequests;
        data["rowVersion"] = this.rowVersion;
        data["portalKey"] = this.portalKey;
        if (this.requestIds && this.requestIds.constructor === Array) {
            data["requestIds"] = [];
            for (let item of this.requestIds)
                data["requestIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateBatchInput {
        const json = this.toJSON();
        let result = new UpdateBatchInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateBatchInput {
    statusKey: string | undefined;
    updateAllRequests: boolean | undefined;
    rowVersion: string | undefined;
    portalKey: string;
    requestIds: string[] | undefined;
    id: string | undefined;
}

export class BusinessActivityDto implements IBusinessActivityDto {
    beps: boolean | undefined;
    childBusinessActivities: ChildBusinessActivityDto[] | undefined;
    companyTypeKey: string;
    companyTypeName: string | undefined;
    extensionData: string | undefined;
    isActive: boolean | undefined;
    name: string;
    id: string | undefined;

    constructor(data?: IBusinessActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.beps = data["beps"];
            if (data["childBusinessActivities"] && data["childBusinessActivities"].constructor === Array) {
                this.childBusinessActivities = [] as any;
                for (let item of data["childBusinessActivities"])
                    this.childBusinessActivities.push(ChildBusinessActivityDto.fromJS(item));
            }
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.extensionData = data["extensionData"];
            this.isActive = data["isActive"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BusinessActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["beps"] = this.beps;
        if (this.childBusinessActivities && this.childBusinessActivities.constructor === Array) {
            data["childBusinessActivities"] = [];
            for (let item of this.childBusinessActivities)
                data["childBusinessActivities"].push(item.toJSON());
        }
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["extensionData"] = this.extensionData;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): BusinessActivityDto {
        const json = this.toJSON();
        let result = new BusinessActivityDto();
        result.init(json);
        return result;
    }
}

export interface IBusinessActivityDto {
    beps: boolean | undefined;
    childBusinessActivities: ChildBusinessActivityDto[] | undefined;
    companyTypeKey: string;
    companyTypeName: string | undefined;
    extensionData: string | undefined;
    isActive: boolean | undefined;
    name: string;
    id: string | undefined;
}

export class ChildBusinessActivityDto implements IChildBusinessActivityDto {
    companyTypeKey: string | undefined;
    isDeleted: boolean | undefined;
    masterBusinessActivityId: string | undefined;
    name: string;
    id: string | undefined;

    constructor(data?: IChildBusinessActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyTypeKey = data["companyTypeKey"];
            this.isDeleted = data["isDeleted"];
            this.masterBusinessActivityId = data["masterBusinessActivityId"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ChildBusinessActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChildBusinessActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyTypeKey"] = this.companyTypeKey;
        data["isDeleted"] = this.isDeleted;
        data["masterBusinessActivityId"] = this.masterBusinessActivityId;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ChildBusinessActivityDto {
        const json = this.toJSON();
        let result = new ChildBusinessActivityDto();
        result.init(json);
        return result;
    }
}

export interface IChildBusinessActivityDto {
    companyTypeKey: string | undefined;
    isDeleted: boolean | undefined;
    masterBusinessActivityId: string | undefined;
    name: string;
    id: string | undefined;
}

export class PagedResultDtoOfBusinessActivityDto implements IPagedResultDtoOfBusinessActivityDto {
    totalCount: number | undefined;
    items: BusinessActivityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBusinessActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(BusinessActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBusinessActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBusinessActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfBusinessActivityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfBusinessActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfBusinessActivityDto {
    totalCount: number | undefined;
    items: BusinessActivityDto[] | undefined;
}

export class PagedResultDtoOfCertificateDto implements IPagedResultDtoOfCertificateDto {
    totalCount: number | undefined;
    items: CertificateDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CertificateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCertificateDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCertificateDto {
    totalCount: number | undefined;
    items: CertificateDto[] | undefined;
}

export class CreateCommentInput implements ICreateCommentInput {
    commentThreadId: string | undefined;
    extensionData: string | undefined;
    tags: string[] | undefined;
    text: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateCommentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commentThreadId = data["commentThreadId"];
            this.extensionData = data["extensionData"];
            if (data["tags"] && data["tags"].constructor === Array) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags.push(item);
            }
            this.text = data["text"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateCommentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentThreadId"] = this.commentThreadId;
        data["extensionData"] = this.extensionData;
        if (this.tags && this.tags.constructor === Array) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["text"] = this.text;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateCommentInput {
        const json = this.toJSON();
        let result = new CreateCommentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCommentInput {
    commentThreadId: string | undefined;
    extensionData: string | undefined;
    tags: string[] | undefined;
    text: string | undefined;
    id: string | undefined;
}

export class CommentDto implements ICommentDto {
    commentThread: CommentThreadDto | undefined;
    commentThreadId: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    extensionData: string | undefined;
    text: string | undefined;
    id: string | undefined;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.commentThread = data["commentThread"] ? CommentThreadDto.fromJS(data["commentThread"]) : <any>undefined;
            this.commentThreadId = data["commentThreadId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creatorUserName = data["creatorUserName"];
            this.extensionData = data["extensionData"];
            this.text = data["text"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentThread"] = this.commentThread ? this.commentThread.toJSON() : <any>undefined;
        data["commentThreadId"] = this.commentThreadId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["extensionData"] = this.extensionData;
        data["text"] = this.text;
        data["id"] = this.id;
        return data; 
    }

    clone(): CommentDto {
        const json = this.toJSON();
        let result = new CommentDto();
        result.init(json);
        return result;
    }
}

export interface ICommentDto {
    commentThread: CommentThreadDto | undefined;
    commentThreadId: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    extensionData: string | undefined;
    text: string | undefined;
    id: string | undefined;
}

export class CommentThreadDto implements ICommentThreadDto {
    comments: CommentDto[] | undefined;
    id: string | undefined;

    constructor(data?: ICommentThreadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["comments"] && data["comments"].constructor === Array) {
                this.comments = [] as any;
                for (let item of data["comments"])
                    this.comments.push(CommentDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CommentThreadDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentThreadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.comments && this.comments.constructor === Array) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CommentThreadDto {
        const json = this.toJSON();
        let result = new CommentThreadDto();
        result.init(json);
        return result;
    }
}

export interface ICommentThreadDto {
    comments: CommentDto[] | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfCommentDto implements IPagedResultDtoOfCommentDto {
    totalCount: number | undefined;
    items: CommentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CommentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCommentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCommentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCommentDto {
    totalCount: number | undefined;
    items: CommentDto[] | undefined;
}

export class CreateCompanyRegistrationInput implements ICreateCompanyRegistrationInput {
    businessActivities: BaseCompanyRegistrationBusinessActivityInput[] | undefined;
    capitalAndShareTransfer: BaseCapitalAndShareTransferInput | undefined;
    entityDetail: CreateEntityDetailInput;
    extensionData: string | undefined;
    ibcInsuranceClasses: CreateIbcInsuranceClassCollectionInput | undefined;
    managementAndOfficers: BaseManagementAndOfficerInput[] | undefined;
    particularAndNote: BaseParticularAndNoteInput | undefined;
    registerOfEntityActivities: BaseRegisterOfEntityActivityInput[] | undefined;
    registrationOfCharges: BaseRegistrationOfChargeInput[] | undefined;
    request: CreateCompanyRegistrationRequestInput;
    id: string | undefined;

    constructor(data?: ICreateCompanyRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entityDetail = new CreateEntityDetailInput();
            this.request = new CreateCompanyRegistrationRequestInput();
        }
    }

    init(data?: any) {
        if (data) {
            if (data["businessActivities"] && data["businessActivities"].constructor === Array) {
                this.businessActivities = [] as any;
                for (let item of data["businessActivities"])
                    this.businessActivities.push(BaseCompanyRegistrationBusinessActivityInput.fromJS(item));
            }
            this.capitalAndShareTransfer = data["capitalAndShareTransfer"] ? BaseCapitalAndShareTransferInput.fromJS(data["capitalAndShareTransfer"]) : <any>undefined;
            this.entityDetail = data["entityDetail"] ? CreateEntityDetailInput.fromJS(data["entityDetail"]) : new CreateEntityDetailInput();
            this.extensionData = data["extensionData"];
            this.ibcInsuranceClasses = data["ibcInsuranceClasses"] ? CreateIbcInsuranceClassCollectionInput.fromJS(data["ibcInsuranceClasses"]) : <any>undefined;
            if (data["managementAndOfficers"] && data["managementAndOfficers"].constructor === Array) {
                this.managementAndOfficers = [] as any;
                for (let item of data["managementAndOfficers"])
                    this.managementAndOfficers.push(BaseManagementAndOfficerInput.fromJS(item));
            }
            this.particularAndNote = data["particularAndNote"] ? BaseParticularAndNoteInput.fromJS(data["particularAndNote"]) : <any>undefined;
            if (data["registerOfEntityActivities"] && data["registerOfEntityActivities"].constructor === Array) {
                this.registerOfEntityActivities = [] as any;
                for (let item of data["registerOfEntityActivities"])
                    this.registerOfEntityActivities.push(BaseRegisterOfEntityActivityInput.fromJS(item));
            }
            if (data["registrationOfCharges"] && data["registrationOfCharges"].constructor === Array) {
                this.registrationOfCharges = [] as any;
                for (let item of data["registrationOfCharges"])
                    this.registrationOfCharges.push(BaseRegistrationOfChargeInput.fromJS(item));
            }
            this.request = data["request"] ? CreateCompanyRegistrationRequestInput.fromJS(data["request"]) : new CreateCompanyRegistrationRequestInput();
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateCompanyRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.businessActivities && this.businessActivities.constructor === Array) {
            data["businessActivities"] = [];
            for (let item of this.businessActivities)
                data["businessActivities"].push(item.toJSON());
        }
        data["capitalAndShareTransfer"] = this.capitalAndShareTransfer ? this.capitalAndShareTransfer.toJSON() : <any>undefined;
        data["entityDetail"] = this.entityDetail ? this.entityDetail.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData;
        data["ibcInsuranceClasses"] = this.ibcInsuranceClasses ? this.ibcInsuranceClasses.toJSON() : <any>undefined;
        if (this.managementAndOfficers && this.managementAndOfficers.constructor === Array) {
            data["managementAndOfficers"] = [];
            for (let item of this.managementAndOfficers)
                data["managementAndOfficers"].push(item.toJSON());
        }
        data["particularAndNote"] = this.particularAndNote ? this.particularAndNote.toJSON() : <any>undefined;
        if (this.registerOfEntityActivities && this.registerOfEntityActivities.constructor === Array) {
            data["registerOfEntityActivities"] = [];
            for (let item of this.registerOfEntityActivities)
                data["registerOfEntityActivities"].push(item.toJSON());
        }
        if (this.registrationOfCharges && this.registrationOfCharges.constructor === Array) {
            data["registrationOfCharges"] = [];
            for (let item of this.registrationOfCharges)
                data["registrationOfCharges"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateCompanyRegistrationInput {
        const json = this.toJSON();
        let result = new CreateCompanyRegistrationInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanyRegistrationInput {
    businessActivities: BaseCompanyRegistrationBusinessActivityInput[] | undefined;
    capitalAndShareTransfer: BaseCapitalAndShareTransferInput | undefined;
    entityDetail: CreateEntityDetailInput;
    extensionData: string | undefined;
    ibcInsuranceClasses: CreateIbcInsuranceClassCollectionInput | undefined;
    managementAndOfficers: BaseManagementAndOfficerInput[] | undefined;
    particularAndNote: BaseParticularAndNoteInput | undefined;
    registerOfEntityActivities: BaseRegisterOfEntityActivityInput[] | undefined;
    registrationOfCharges: BaseRegistrationOfChargeInput[] | undefined;
    request: CreateCompanyRegistrationRequestInput;
    id: string | undefined;
}

export class BaseCompanyRegistrationBusinessActivityInput implements IBaseCompanyRegistrationBusinessActivityInput {
    businessActivityId: string | undefined;
    notes: string | undefined;
    specificActivity: string | undefined;
    subBusinessActivityIds: string[] | undefined;
    id: string | undefined;

    constructor(data?: IBaseCompanyRegistrationBusinessActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessActivityId = data["businessActivityId"];
            this.notes = data["notes"];
            this.specificActivity = data["specificActivity"];
            if (data["subBusinessActivityIds"] && data["subBusinessActivityIds"].constructor === Array) {
                this.subBusinessActivityIds = [] as any;
                for (let item of data["subBusinessActivityIds"])
                    this.subBusinessActivityIds.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseCompanyRegistrationBusinessActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCompanyRegistrationBusinessActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessActivityId"] = this.businessActivityId;
        data["notes"] = this.notes;
        data["specificActivity"] = this.specificActivity;
        if (this.subBusinessActivityIds && this.subBusinessActivityIds.constructor === Array) {
            data["subBusinessActivityIds"] = [];
            for (let item of this.subBusinessActivityIds)
                data["subBusinessActivityIds"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseCompanyRegistrationBusinessActivityInput {
        const json = this.toJSON();
        let result = new BaseCompanyRegistrationBusinessActivityInput();
        result.init(json);
        return result;
    }
}

export interface IBaseCompanyRegistrationBusinessActivityInput {
    businessActivityId: string | undefined;
    notes: string | undefined;
    specificActivity: string | undefined;
    subBusinessActivityIds: string[] | undefined;
    id: string | undefined;
}

export class BaseCapitalAndShareTransferInput implements IBaseCapitalAndShareTransferInput {
    authorizedCapital: number | undefined;
    currencyKey: string | undefined;
    noParValueShares: string | undefined;
    parValue: number | undefined;
    request: IRequestInput | undefined;
    totalNumberOfShares: number | undefined;
    typesOfSharesAllowedKey: string | undefined;
    id: string | undefined;

    constructor(data?: IBaseCapitalAndShareTransferInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authorizedCapital = data["authorizedCapital"];
            this.currencyKey = data["currencyKey"];
            this.noParValueShares = data["noParValueShares"];
            this.parValue = data["parValue"];
            this.request = data["request"] ? IRequestInput.fromJS(data["request"]) : <any>undefined;
            this.totalNumberOfShares = data["totalNumberOfShares"];
            this.typesOfSharesAllowedKey = data["typesOfSharesAllowedKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseCapitalAndShareTransferInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseCapitalAndShareTransferInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizedCapital"] = this.authorizedCapital;
        data["currencyKey"] = this.currencyKey;
        data["noParValueShares"] = this.noParValueShares;
        data["parValue"] = this.parValue;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["totalNumberOfShares"] = this.totalNumberOfShares;
        data["typesOfSharesAllowedKey"] = this.typesOfSharesAllowedKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseCapitalAndShareTransferInput {
        const json = this.toJSON();
        let result = new BaseCapitalAndShareTransferInput();
        result.init(json);
        return result;
    }
}

export interface IBaseCapitalAndShareTransferInput {
    authorizedCapital: number | undefined;
    currencyKey: string | undefined;
    noParValueShares: string | undefined;
    parValue: number | undefined;
    request: IRequestInput | undefined;
    totalNumberOfShares: number | undefined;
    typesOfSharesAllowedKey: string | undefined;
    id: string | undefined;
}

export class CreateEntityDetailInput implements ICreateEntityDetailInput {
    entityName: CreateEntityNameInput;
    incorporationDetail: CreateIncorporationDetailInput | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;

    constructor(data?: ICreateEntityDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entityName = new CreateEntityNameInput();
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] ? CreateEntityNameInput.fromJS(data["entityName"]) : new CreateEntityNameInput();
            this.incorporationDetail = data["incorporationDetail"] ? CreateIncorporationDetailInput.fromJS(data["incorporationDetail"]) : <any>undefined;
            this.insuranceManager = data["insuranceManager"];
            this.notes = data["notes"];
            this.registeredAgentResignedAt = data["registeredAgentResignedAt"] ? new Date(data["registeredAgentResignedAt"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateEntityDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName ? this.entityName.toJSON() : <any>undefined;
        data["incorporationDetail"] = this.incorporationDetail ? this.incorporationDetail.toJSON() : <any>undefined;
        data["insuranceManager"] = this.insuranceManager;
        data["notes"] = this.notes;
        data["registeredAgentResignedAt"] = this.registeredAgentResignedAt ? this.registeredAgentResignedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateEntityDetailInput {
        const json = this.toJSON();
        let result = new CreateEntityDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateEntityDetailInput {
    entityName: CreateEntityNameInput;
    incorporationDetail: CreateIncorporationDetailInput | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;
}

export class CreateIbcInsuranceClassCollectionInput implements ICreateIbcInsuranceClassCollectionInput {
    ibcInsuranceClasses: CreateIbcInsuranceClassInput[] | undefined;
    notes: string | undefined;

    constructor(data?: ICreateIbcInsuranceClassCollectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ibcInsuranceClasses"] && data["ibcInsuranceClasses"].constructor === Array) {
                this.ibcInsuranceClasses = [] as any;
                for (let item of data["ibcInsuranceClasses"])
                    this.ibcInsuranceClasses.push(CreateIbcInsuranceClassInput.fromJS(item));
            }
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): CreateIbcInsuranceClassCollectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIbcInsuranceClassCollectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ibcInsuranceClasses && this.ibcInsuranceClasses.constructor === Array) {
            data["ibcInsuranceClasses"] = [];
            for (let item of this.ibcInsuranceClasses)
                data["ibcInsuranceClasses"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        return data; 
    }

    clone(): CreateIbcInsuranceClassCollectionInput {
        const json = this.toJSON();
        let result = new CreateIbcInsuranceClassCollectionInput();
        result.init(json);
        return result;
    }
}

export interface ICreateIbcInsuranceClassCollectionInput {
    ibcInsuranceClasses: CreateIbcInsuranceClassInput[] | undefined;
    notes: string | undefined;
}

export class BaseManagementAndOfficerInput implements IBaseManagementAndOfficerInput {
    dateAppointed: Date | undefined;
    dateOfResignation: Date | undefined;
    id: string | undefined;
    identification: BaseIdentificationInput;
    managerTypeKey: string;
    nationalityCountryId: string;
    notes: string | undefined;
    originCountryId: string | undefined;
    otherOccupation: string | undefined;
    person: CreatePersonInput;
    priorName: string | undefined;
    registrationDate: Date | undefined;
    titles: string;

    constructor(data?: IBaseManagementAndOfficerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.identification = new BaseIdentificationInput();
            this.person = new CreatePersonInput();
        }
    }

    init(data?: any) {
        if (data) {
            this.dateAppointed = data["dateAppointed"] ? new Date(data["dateAppointed"].toString()) : <any>undefined;
            this.dateOfResignation = data["dateOfResignation"] ? new Date(data["dateOfResignation"].toString()) : <any>undefined;
            this.id = data["id"];
            this.identification = data["identification"] ? BaseIdentificationInput.fromJS(data["identification"]) : new BaseIdentificationInput();
            this.managerTypeKey = data["managerTypeKey"];
            this.nationalityCountryId = data["nationalityCountryId"];
            this.notes = data["notes"];
            this.originCountryId = data["originCountryId"];
            this.otherOccupation = data["otherOccupation"];
            this.person = data["person"] ? CreatePersonInput.fromJS(data["person"]) : new CreatePersonInput();
            this.priorName = data["priorName"];
            this.registrationDate = data["registrationDate"] ? new Date(data["registrationDate"].toString()) : <any>undefined;
            this.titles = data["titles"];
        }
    }

    static fromJS(data: any): BaseManagementAndOfficerInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseManagementAndOfficerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateAppointed"] = this.dateAppointed ? this.dateAppointed.toISOString() : <any>undefined;
        data["dateOfResignation"] = this.dateOfResignation ? this.dateOfResignation.toISOString() : <any>undefined;
        data["id"] = this.id;
        data["identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["managerTypeKey"] = this.managerTypeKey;
        data["nationalityCountryId"] = this.nationalityCountryId;
        data["notes"] = this.notes;
        data["originCountryId"] = this.originCountryId;
        data["otherOccupation"] = this.otherOccupation;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["priorName"] = this.priorName;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["titles"] = this.titles;
        return data; 
    }

    clone(): BaseManagementAndOfficerInput {
        const json = this.toJSON();
        let result = new BaseManagementAndOfficerInput();
        result.init(json);
        return result;
    }
}

export interface IBaseManagementAndOfficerInput {
    dateAppointed: Date | undefined;
    dateOfResignation: Date | undefined;
    id: string | undefined;
    identification: BaseIdentificationInput;
    managerTypeKey: string;
    nationalityCountryId: string;
    notes: string | undefined;
    originCountryId: string | undefined;
    otherOccupation: string | undefined;
    person: CreatePersonInput;
    priorName: string | undefined;
    registrationDate: Date | undefined;
    titles: string;
}

export class BaseParticularAndNoteInput implements IBaseParticularAndNoteInput {
    note: string | undefined;
    id: string | undefined;

    constructor(data?: IBaseParticularAndNoteInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseParticularAndNoteInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseParticularAndNoteInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseParticularAndNoteInput {
        const json = this.toJSON();
        let result = new BaseParticularAndNoteInput();
        result.init(json);
        return result;
    }
}

export interface IBaseParticularAndNoteInput {
    note: string | undefined;
    id: string | undefined;
}

export class BaseRegisterOfEntityActivityInput implements IBaseRegisterOfEntityActivityInput {
    activityDate: Date | undefined;
    activityKey: string | undefined;
    feeAmount: number | undefined;
    licenseYear: number | undefined;
    notes: string | undefined;
    id: string | undefined;

    constructor(data?: IBaseRegisterOfEntityActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityDate = data["activityDate"] ? new Date(data["activityDate"].toString()) : <any>undefined;
            this.activityKey = data["activityKey"];
            this.feeAmount = data["feeAmount"];
            this.licenseYear = data["licenseYear"];
            this.notes = data["notes"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseRegisterOfEntityActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRegisterOfEntityActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["activityKey"] = this.activityKey;
        data["feeAmount"] = this.feeAmount;
        data["licenseYear"] = this.licenseYear;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseRegisterOfEntityActivityInput {
        const json = this.toJSON();
        let result = new BaseRegisterOfEntityActivityInput();
        result.init(json);
        return result;
    }
}

export interface IBaseRegisterOfEntityActivityInput {
    activityDate: Date | undefined;
    activityKey: string | undefined;
    feeAmount: number | undefined;
    licenseYear: number | undefined;
    notes: string | undefined;
    id: string | undefined;
}

export class BaseRegistrationOfChargeInput implements IBaseRegistrationOfChargeInput {
    chargee: BaseContactInput | undefined;
    charger: BaseContactInput | undefined;
    dateOfCreationOfCharge: Date | undefined;
    descriptionOfCharge: string | undefined;
    governingLawOfTheCharge: string | undefined;
    id: string | undefined;
    mortgageAndDebenture: BaseMortgageAndDebentureInput | undefined;
    registrationDate: Date | undefined;
    statusOfTheChargeKey: string | undefined;

    constructor(data?: IBaseRegistrationOfChargeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chargee = data["chargee"] ? BaseContactInput.fromJS(data["chargee"]) : <any>undefined;
            this.charger = data["charger"] ? BaseContactInput.fromJS(data["charger"]) : <any>undefined;
            this.dateOfCreationOfCharge = data["dateOfCreationOfCharge"] ? new Date(data["dateOfCreationOfCharge"].toString()) : <any>undefined;
            this.descriptionOfCharge = data["descriptionOfCharge"];
            this.governingLawOfTheCharge = data["governingLawOfTheCharge"];
            this.id = data["id"];
            this.mortgageAndDebenture = data["mortgageAndDebenture"] ? BaseMortgageAndDebentureInput.fromJS(data["mortgageAndDebenture"]) : <any>undefined;
            this.registrationDate = data["registrationDate"] ? new Date(data["registrationDate"].toString()) : <any>undefined;
            this.statusOfTheChargeKey = data["statusOfTheChargeKey"];
        }
    }

    static fromJS(data: any): BaseRegistrationOfChargeInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRegistrationOfChargeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargee"] = this.chargee ? this.chargee.toJSON() : <any>undefined;
        data["charger"] = this.charger ? this.charger.toJSON() : <any>undefined;
        data["dateOfCreationOfCharge"] = this.dateOfCreationOfCharge ? this.dateOfCreationOfCharge.toISOString() : <any>undefined;
        data["descriptionOfCharge"] = this.descriptionOfCharge;
        data["governingLawOfTheCharge"] = this.governingLawOfTheCharge;
        data["id"] = this.id;
        data["mortgageAndDebenture"] = this.mortgageAndDebenture ? this.mortgageAndDebenture.toJSON() : <any>undefined;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["statusOfTheChargeKey"] = this.statusOfTheChargeKey;
        return data; 
    }

    clone(): BaseRegistrationOfChargeInput {
        const json = this.toJSON();
        let result = new BaseRegistrationOfChargeInput();
        result.init(json);
        return result;
    }
}

export interface IBaseRegistrationOfChargeInput {
    chargee: BaseContactInput | undefined;
    charger: BaseContactInput | undefined;
    dateOfCreationOfCharge: Date | undefined;
    descriptionOfCharge: string | undefined;
    governingLawOfTheCharge: string | undefined;
    id: string | undefined;
    mortgageAndDebenture: BaseMortgageAndDebentureInput | undefined;
    registrationDate: Date | undefined;
    statusOfTheChargeKey: string | undefined;
}

export class CreateCompanyRegistrationRequestInput implements ICreateCompanyRegistrationRequestInput {
    registeredAgentId: string;
    portalKey: string;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: ICreateCompanyRegistrationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registeredAgentId = data["registeredAgentId"];
            this.portalKey = data["portalKey"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.id = data["id"];
            this.notes = data["notes"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(BaseRequestFeeInput.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCompanyRegistrationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCompanyRegistrationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredAgentId"] = this.registeredAgentId;
        data["portalKey"] = this.portalKey;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): CreateCompanyRegistrationRequestInput {
        const json = this.toJSON();
        let result = new CreateCompanyRegistrationRequestInput();
        result.init(json);
        return result;
    }
}

export interface ICreateCompanyRegistrationRequestInput {
    registeredAgentId: string;
    portalKey: string;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class IRequestInput implements IIRequestInput {
    registeredAgentId: string | undefined;
    readonly portalKey: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    readonly requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IIRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registeredAgentId = data["registeredAgentId"];
            (<any>this).portalKey = data["portalKey"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            (<any>this).requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): IRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new IRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredAgentId"] = this.registeredAgentId;
        data["portalKey"] = this.portalKey;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): IRequestInput {
        const json = this.toJSON();
        let result = new IRequestInput();
        result.init(json);
        return result;
    }
}

export interface IIRequestInput {
    registeredAgentId: string | undefined;
    portalKey: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestInternalStatusKey: string | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class CreateEntityNameInput implements ICreateEntityNameInput {
    alternativeCompanyName: string | undefined;
    companyTypeKey: string;
    nameReservationId: string;
    oldName: string | undefined;
    suffixKey: string;
    id: string | undefined;

    constructor(data?: ICreateEntityNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.nameReservationId = data["nameReservationId"];
            this.oldName = data["oldName"];
            this.suffixKey = data["suffixKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateEntityNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEntityNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["nameReservationId"] = this.nameReservationId;
        data["oldName"] = this.oldName;
        data["suffixKey"] = this.suffixKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateEntityNameInput {
        const json = this.toJSON();
        let result = new CreateEntityNameInput();
        result.init(json);
        return result;
    }
}

export interface ICreateEntityNameInput {
    alternativeCompanyName: string | undefined;
    companyTypeKey: string;
    nameReservationId: string;
    oldName: string | undefined;
    suffixKey: string;
    id: string | undefined;
}

export class CreateIncorporationDetailInput implements ICreateIncorporationDetailInput {
    address: CreateAddressInput | undefined;
    addressId: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;

    constructor(data?: ICreateIncorporationDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? CreateAddressInput.fromJS(data["address"]) : <any>undefined;
            this.addressId = data["addressId"];
            this.statusDate = data["statusDate"] ? new Date(data["statusDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateIncorporationDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncorporationDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateIncorporationDetailInput {
        const json = this.toJSON();
        let result = new CreateIncorporationDetailInput();
        result.init(json);
        return result;
    }
}

export interface ICreateIncorporationDetailInput {
    address: CreateAddressInput | undefined;
    addressId: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;
}

export class CreateIbcInsuranceClassInput implements ICreateIbcInsuranceClassInput {
    ibcInsuranceClassKey: string | undefined;
    id: string | undefined;
    isSelected: boolean | undefined;
    statusKey: string | undefined;

    constructor(data?: ICreateIbcInsuranceClassInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ibcInsuranceClassKey = data["ibcInsuranceClassKey"];
            this.id = data["id"];
            this.isSelected = data["isSelected"];
            this.statusKey = data["statusKey"];
        }
    }

    static fromJS(data: any): CreateIbcInsuranceClassInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIbcInsuranceClassInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ibcInsuranceClassKey"] = this.ibcInsuranceClassKey;
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        data["statusKey"] = this.statusKey;
        return data; 
    }

    clone(): CreateIbcInsuranceClassInput {
        const json = this.toJSON();
        let result = new CreateIbcInsuranceClassInput();
        result.init(json);
        return result;
    }
}

export interface ICreateIbcInsuranceClassInput {
    ibcInsuranceClassKey: string | undefined;
    id: string | undefined;
    isSelected: boolean | undefined;
    statusKey: string | undefined;
}

export class BaseIdentificationInput implements IBaseIdentificationInput {
    expirationDate: Date;
    identificationTypeKey: string;
    issuanceDate: Date;
    issuingCountryId: string;
    number: string;
    id: string | undefined;

    constructor(data?: IBaseIdentificationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : <any>undefined;
            this.identificationTypeKey = data["identificationTypeKey"];
            this.issuanceDate = data["issuanceDate"] ? new Date(data["issuanceDate"].toString()) : <any>undefined;
            this.issuingCountryId = data["issuingCountryId"];
            this.number = data["number"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseIdentificationInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseIdentificationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["identificationTypeKey"] = this.identificationTypeKey;
        data["issuanceDate"] = this.issuanceDate ? this.issuanceDate.toISOString() : <any>undefined;
        data["issuingCountryId"] = this.issuingCountryId;
        data["number"] = this.number;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseIdentificationInput {
        const json = this.toJSON();
        let result = new BaseIdentificationInput();
        result.init(json);
        return result;
    }
}

export interface IBaseIdentificationInput {
    expirationDate: Date;
    identificationTypeKey: string;
    issuanceDate: Date;
    issuingCountryId: string;
    number: string;
    id: string | undefined;
}

export class CreatePersonInput implements ICreatePersonInput {
    companyName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: CreateAddressInput[] | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;

    constructor(data?: ICreatePersonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(CreateAddressInput.fromJS(item));
            }
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreatePersonInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): CreatePersonInput {
        const json = this.toJSON();
        let result = new CreatePersonInput();
        result.init(json);
        return result;
    }
}

export interface ICreatePersonInput {
    companyName: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: CreateAddressInput[] | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
}

export class BaseContactInput implements IBaseContactInput {
    companyName: string | undefined;
    contactType: BaseContactInputContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: CreateAddressInput[] | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;

    constructor(data?: IBaseContactInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.contactType = data["contactType"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(CreateAddressInput.fromJS(item));
            }
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BaseContactInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseContactInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["contactType"] = this.contactType;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        return data; 
    }

    clone(): BaseContactInput {
        const json = this.toJSON();
        let result = new BaseContactInput();
        result.init(json);
        return result;
    }
}

export interface IBaseContactInput {
    companyName: string | undefined;
    contactType: BaseContactInputContactType | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    addresses: CreateAddressInput[] | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
}

export class BaseMortgageAndDebentureInput implements IBaseMortgageAndDebentureInput {
    amountSecuredByCharge: string | undefined;
    currencyKey: string | undefined;
    dateOfRegistration: Date | undefined;
    dateOfSatisfaction: Date | undefined;
    dateOfVariation: Date | undefined;
    natureOfRestrictions: string | undefined;
    natureOfTheCharge: string;
    particularsNotesOfVariation: string | undefined;
    serialNumberOfDocumentOnFile: string | undefined;
    shortParticularsOfThePropertyCharged: string;
    id: string | undefined;

    constructor(data?: IBaseMortgageAndDebentureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amountSecuredByCharge = data["amountSecuredByCharge"];
            this.currencyKey = data["currencyKey"];
            this.dateOfRegistration = data["dateOfRegistration"] ? new Date(data["dateOfRegistration"].toString()) : <any>undefined;
            this.dateOfSatisfaction = data["dateOfSatisfaction"] ? new Date(data["dateOfSatisfaction"].toString()) : <any>undefined;
            this.dateOfVariation = data["dateOfVariation"] ? new Date(data["dateOfVariation"].toString()) : <any>undefined;
            this.natureOfRestrictions = data["natureOfRestrictions"];
            this.natureOfTheCharge = data["natureOfTheCharge"];
            this.particularsNotesOfVariation = data["particularsNotesOfVariation"];
            this.serialNumberOfDocumentOnFile = data["serialNumberOfDocumentOnFile"];
            this.shortParticularsOfThePropertyCharged = data["shortParticularsOfThePropertyCharged"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseMortgageAndDebentureInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseMortgageAndDebentureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountSecuredByCharge"] = this.amountSecuredByCharge;
        data["currencyKey"] = this.currencyKey;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toISOString() : <any>undefined;
        data["dateOfSatisfaction"] = this.dateOfSatisfaction ? this.dateOfSatisfaction.toISOString() : <any>undefined;
        data["dateOfVariation"] = this.dateOfVariation ? this.dateOfVariation.toISOString() : <any>undefined;
        data["natureOfRestrictions"] = this.natureOfRestrictions;
        data["natureOfTheCharge"] = this.natureOfTheCharge;
        data["particularsNotesOfVariation"] = this.particularsNotesOfVariation;
        data["serialNumberOfDocumentOnFile"] = this.serialNumberOfDocumentOnFile;
        data["shortParticularsOfThePropertyCharged"] = this.shortParticularsOfThePropertyCharged;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseMortgageAndDebentureInput {
        const json = this.toJSON();
        let result = new BaseMortgageAndDebentureInput();
        result.init(json);
        return result;
    }
}

export interface IBaseMortgageAndDebentureInput {
    amountSecuredByCharge: string | undefined;
    currencyKey: string | undefined;
    dateOfRegistration: Date | undefined;
    dateOfSatisfaction: Date | undefined;
    dateOfVariation: Date | undefined;
    natureOfRestrictions: string | undefined;
    natureOfTheCharge: string;
    particularsNotesOfVariation: string | undefined;
    serialNumberOfDocumentOnFile: string | undefined;
    shortParticularsOfThePropertyCharged: string;
    id: string | undefined;
}

export class BaseRequestFeeInput implements IBaseRequestFeeInput {
    feeId: string | undefined;
    quantity: number | undefined;
    id: string | undefined;

    constructor(data?: IBaseRequestFeeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.feeId = data["feeId"];
            this.quantity = data["quantity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): BaseRequestFeeInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestFeeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feeId"] = this.feeId;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): BaseRequestFeeInput {
        const json = this.toJSON();
        let result = new BaseRequestFeeInput();
        result.init(json);
        return result;
    }
}

export interface IBaseRequestFeeInput {
    feeId: string | undefined;
    quantity: number | undefined;
    id: string | undefined;
}

export class CreateAddressInput implements ICreateAddressInput {
    city: string | undefined;
    country: string | undefined;
    id: string | undefined;
    state: string | undefined;
    street: string | undefined;
    street2: string | undefined;
    zip: string | undefined;

    constructor(data?: ICreateAddressInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.city = data["city"];
            this.country = data["country"];
            this.id = data["id"];
            this.state = data["state"];
            this.street = data["street"];
            this.street2 = data["street2"];
            this.zip = data["zip"];
        }
    }

    static fromJS(data: any): CreateAddressInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["city"] = this.city;
        data["country"] = this.country;
        data["id"] = this.id;
        data["state"] = this.state;
        data["street"] = this.street;
        data["street2"] = this.street2;
        data["zip"] = this.zip;
        return data; 
    }

    clone(): CreateAddressInput {
        const json = this.toJSON();
        let result = new CreateAddressInput();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressInput {
    city: string | undefined;
    country: string | undefined;
    id: string | undefined;
    state: string | undefined;
    street: string | undefined;
    street2: string | undefined;
    zip: string | undefined;
}

export class CompanyRegistrationDto implements ICompanyRegistrationDto {
    businessActivities: CompanyRegistrationBusinessActivityDto[] | undefined;
    capitalAndShareTransfer: CapitalAndShareTransferDto | undefined;
    daysPastRenewDate: number | undefined;
    daysWithoutRegisteredAgent: number | undefined;
    entityDetail: EntityDetailDto | undefined;
    extensionData: string | undefined;
    ibcInsuranceClasses: IbcInsuranceClassCollectionDto | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    managementAndOfficers: ManagementAndOfficerDto[] | undefined;
    particularAndNote: ParticularAndNoteDto | undefined;
    registerOfEntityActivities: RegisterOfEntityActivityDto[] | undefined;
    registrationFeeAndPayment: any | undefined;
    registrationOfCharges: RegistrationOfChargeDto[] | undefined;
    request: CompanyRegistrationRequestDto | undefined;
    id: string | undefined;

    constructor(data?: ICompanyRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["businessActivities"] && data["businessActivities"].constructor === Array) {
                this.businessActivities = [] as any;
                for (let item of data["businessActivities"])
                    this.businessActivities.push(CompanyRegistrationBusinessActivityDto.fromJS(item));
            }
            this.capitalAndShareTransfer = data["capitalAndShareTransfer"] ? CapitalAndShareTransferDto.fromJS(data["capitalAndShareTransfer"]) : <any>undefined;
            this.daysPastRenewDate = data["daysPastRenewDate"];
            this.daysWithoutRegisteredAgent = data["daysWithoutRegisteredAgent"];
            this.entityDetail = data["entityDetail"] ? EntityDetailDto.fromJS(data["entityDetail"]) : <any>undefined;
            this.extensionData = data["extensionData"];
            this.ibcInsuranceClasses = data["ibcInsuranceClasses"] ? IbcInsuranceClassCollectionDto.fromJS(data["ibcInsuranceClasses"]) : <any>undefined;
            this.isActive = data["isActive"];
            this.isEditable = data["isEditable"];
            if (data["managementAndOfficers"] && data["managementAndOfficers"].constructor === Array) {
                this.managementAndOfficers = [] as any;
                for (let item of data["managementAndOfficers"])
                    this.managementAndOfficers.push(ManagementAndOfficerDto.fromJS(item));
            }
            this.particularAndNote = data["particularAndNote"] ? ParticularAndNoteDto.fromJS(data["particularAndNote"]) : <any>undefined;
            if (data["registerOfEntityActivities"] && data["registerOfEntityActivities"].constructor === Array) {
                this.registerOfEntityActivities = [] as any;
                for (let item of data["registerOfEntityActivities"])
                    this.registerOfEntityActivities.push(RegisterOfEntityActivityDto.fromJS(item));
            }
            this.registrationFeeAndPayment = data["registrationFeeAndPayment"];
            if (data["registrationOfCharges"] && data["registrationOfCharges"].constructor === Array) {
                this.registrationOfCharges = [] as any;
                for (let item of data["registrationOfCharges"])
                    this.registrationOfCharges.push(RegistrationOfChargeDto.fromJS(item));
            }
            this.request = data["request"] ? CompanyRegistrationRequestDto.fromJS(data["request"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.businessActivities && this.businessActivities.constructor === Array) {
            data["businessActivities"] = [];
            for (let item of this.businessActivities)
                data["businessActivities"].push(item.toJSON());
        }
        data["capitalAndShareTransfer"] = this.capitalAndShareTransfer ? this.capitalAndShareTransfer.toJSON() : <any>undefined;
        data["daysPastRenewDate"] = this.daysPastRenewDate;
        data["daysWithoutRegisteredAgent"] = this.daysWithoutRegisteredAgent;
        data["entityDetail"] = this.entityDetail ? this.entityDetail.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData;
        data["ibcInsuranceClasses"] = this.ibcInsuranceClasses ? this.ibcInsuranceClasses.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        data["isEditable"] = this.isEditable;
        if (this.managementAndOfficers && this.managementAndOfficers.constructor === Array) {
            data["managementAndOfficers"] = [];
            for (let item of this.managementAndOfficers)
                data["managementAndOfficers"].push(item.toJSON());
        }
        data["particularAndNote"] = this.particularAndNote ? this.particularAndNote.toJSON() : <any>undefined;
        if (this.registerOfEntityActivities && this.registerOfEntityActivities.constructor === Array) {
            data["registerOfEntityActivities"] = [];
            for (let item of this.registerOfEntityActivities)
                data["registerOfEntityActivities"].push(item.toJSON());
        }
        data["registrationFeeAndPayment"] = this.registrationFeeAndPayment;
        if (this.registrationOfCharges && this.registrationOfCharges.constructor === Array) {
            data["registrationOfCharges"] = [];
            for (let item of this.registrationOfCharges)
                data["registrationOfCharges"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CompanyRegistrationDto {
        const json = this.toJSON();
        let result = new CompanyRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRegistrationDto {
    businessActivities: CompanyRegistrationBusinessActivityDto[] | undefined;
    capitalAndShareTransfer: CapitalAndShareTransferDto | undefined;
    daysPastRenewDate: number | undefined;
    daysWithoutRegisteredAgent: number | undefined;
    entityDetail: EntityDetailDto | undefined;
    extensionData: string | undefined;
    ibcInsuranceClasses: IbcInsuranceClassCollectionDto | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    managementAndOfficers: ManagementAndOfficerDto[] | undefined;
    particularAndNote: ParticularAndNoteDto | undefined;
    registerOfEntityActivities: RegisterOfEntityActivityDto[] | undefined;
    registrationFeeAndPayment: any | undefined;
    registrationOfCharges: RegistrationOfChargeDto[] | undefined;
    request: CompanyRegistrationRequestDto | undefined;
    id: string | undefined;
}

export class CompanyRegistrationBusinessActivityDto implements ICompanyRegistrationBusinessActivityDto {
    businessActivity: BusinessActivityDto | undefined;
    creationTime: Date | undefined;
    notes: string | undefined;
    specificActivity: string | undefined;
    subBusinessActivities: CompanyRegistrationBusinessActivitySubBusinessActivityDto[] | undefined;
    id: string | undefined;

    constructor(data?: ICompanyRegistrationBusinessActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessActivity = data["businessActivity"] ? BusinessActivityDto.fromJS(data["businessActivity"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.specificActivity = data["specificActivity"];
            if (data["subBusinessActivities"] && data["subBusinessActivities"].constructor === Array) {
                this.subBusinessActivities = [] as any;
                for (let item of data["subBusinessActivities"])
                    this.subBusinessActivities.push(CompanyRegistrationBusinessActivitySubBusinessActivityDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyRegistrationBusinessActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRegistrationBusinessActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessActivity"] = this.businessActivity ? this.businessActivity.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["specificActivity"] = this.specificActivity;
        if (this.subBusinessActivities && this.subBusinessActivities.constructor === Array) {
            data["subBusinessActivities"] = [];
            for (let item of this.subBusinessActivities)
                data["subBusinessActivities"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): CompanyRegistrationBusinessActivityDto {
        const json = this.toJSON();
        let result = new CompanyRegistrationBusinessActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRegistrationBusinessActivityDto {
    businessActivity: BusinessActivityDto | undefined;
    creationTime: Date | undefined;
    notes: string | undefined;
    specificActivity: string | undefined;
    subBusinessActivities: CompanyRegistrationBusinessActivitySubBusinessActivityDto[] | undefined;
    id: string | undefined;
}

export class CapitalAndShareTransferDto implements ICapitalAndShareTransferDto {
    authorizedCapital: number | undefined;
    currencyCode: string | undefined;
    currencyKey: string | undefined;
    noParValueShares: string | undefined;
    parValue: number | undefined;
    totalNumberOfShares: number | undefined;
    typesOfSharesAllowed: LookupDataDto | undefined;
    id: string | undefined;

    constructor(data?: ICapitalAndShareTransferDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authorizedCapital = data["authorizedCapital"];
            this.currencyCode = data["currencyCode"];
            this.currencyKey = data["currencyKey"];
            this.noParValueShares = data["noParValueShares"];
            this.parValue = data["parValue"];
            this.totalNumberOfShares = data["totalNumberOfShares"];
            this.typesOfSharesAllowed = data["typesOfSharesAllowed"] ? LookupDataDto.fromJS(data["typesOfSharesAllowed"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CapitalAndShareTransferDto {
        data = typeof data === 'object' ? data : {};
        let result = new CapitalAndShareTransferDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizedCapital"] = this.authorizedCapital;
        data["currencyCode"] = this.currencyCode;
        data["currencyKey"] = this.currencyKey;
        data["noParValueShares"] = this.noParValueShares;
        data["parValue"] = this.parValue;
        data["totalNumberOfShares"] = this.totalNumberOfShares;
        data["typesOfSharesAllowed"] = this.typesOfSharesAllowed ? this.typesOfSharesAllowed.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CapitalAndShareTransferDto {
        const json = this.toJSON();
        let result = new CapitalAndShareTransferDto();
        result.init(json);
        return result;
    }
}

export interface ICapitalAndShareTransferDto {
    authorizedCapital: number | undefined;
    currencyCode: string | undefined;
    currencyKey: string | undefined;
    noParValueShares: string | undefined;
    parValue: number | undefined;
    totalNumberOfShares: number | undefined;
    typesOfSharesAllowed: LookupDataDto | undefined;
    id: string | undefined;
}

export class EntityDetailDto implements IEntityDetailDto {
    readonly commentThreadId: string | undefined;
    entityName: EntityNameDto | undefined;
    incorporationDetail: IncorporationDetailDto | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;

    constructor(data?: IEntityDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).commentThreadId = data["commentThreadId"];
            this.entityName = data["entityName"] ? EntityNameDto.fromJS(data["entityName"]) : <any>undefined;
            this.incorporationDetail = data["incorporationDetail"] ? IncorporationDetailDto.fromJS(data["incorporationDetail"]) : <any>undefined;
            this.insuranceManager = data["insuranceManager"];
            this.notes = data["notes"];
            this.registeredAgentResignedAt = data["registeredAgentResignedAt"] ? new Date(data["registeredAgentResignedAt"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentThreadId"] = this.commentThreadId;
        data["entityName"] = this.entityName ? this.entityName.toJSON() : <any>undefined;
        data["incorporationDetail"] = this.incorporationDetail ? this.incorporationDetail.toJSON() : <any>undefined;
        data["insuranceManager"] = this.insuranceManager;
        data["notes"] = this.notes;
        data["registeredAgentResignedAt"] = this.registeredAgentResignedAt ? this.registeredAgentResignedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityDetailDto {
        const json = this.toJSON();
        let result = new EntityDetailDto();
        result.init(json);
        return result;
    }
}

export interface IEntityDetailDto {
    commentThreadId: string | undefined;
    entityName: EntityNameDto | undefined;
    incorporationDetail: IncorporationDetailDto | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;
}

export class IbcInsuranceClassCollectionDto implements IIbcInsuranceClassCollectionDto {
    ibcInsuranceClasses: IbcInsuranceClassDto[] | undefined;
    notes: string | undefined;
    id: string | undefined;

    constructor(data?: IIbcInsuranceClassCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ibcInsuranceClasses"] && data["ibcInsuranceClasses"].constructor === Array) {
                this.ibcInsuranceClasses = [] as any;
                for (let item of data["ibcInsuranceClasses"])
                    this.ibcInsuranceClasses.push(IbcInsuranceClassDto.fromJS(item));
            }
            this.notes = data["notes"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IbcInsuranceClassCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IbcInsuranceClassCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ibcInsuranceClasses && this.ibcInsuranceClasses.constructor === Array) {
            data["ibcInsuranceClasses"] = [];
            for (let item of this.ibcInsuranceClasses)
                data["ibcInsuranceClasses"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data; 
    }

    clone(): IbcInsuranceClassCollectionDto {
        const json = this.toJSON();
        let result = new IbcInsuranceClassCollectionDto();
        result.init(json);
        return result;
    }
}

export interface IIbcInsuranceClassCollectionDto {
    ibcInsuranceClasses: IbcInsuranceClassDto[] | undefined;
    notes: string | undefined;
    id: string | undefined;
}

export class ManagementAndOfficerDto implements IManagementAndOfficerDto {
    dateAppointed: Date | undefined;
    dateOfResignation: Date | undefined;
    identification: IdentificationDto | undefined;
    managerTypeKey: string | undefined;
    managerTypeName: string | undefined;
    nationalityCountryId: string | undefined;
    nationalityCountryName: string | undefined;
    notes: string | undefined;
    originCountryId: string | undefined;
    originCountryName: string | undefined;
    otherOccupation: string | undefined;
    person: ManagementAndOfficerPersonDto | undefined;
    priorName: string;
    registrationDate: Date | undefined;
    titles: string;
    id: string | undefined;

    constructor(data?: IManagementAndOfficerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dateAppointed = data["dateAppointed"] ? new Date(data["dateAppointed"].toString()) : <any>undefined;
            this.dateOfResignation = data["dateOfResignation"] ? new Date(data["dateOfResignation"].toString()) : <any>undefined;
            this.identification = data["identification"] ? IdentificationDto.fromJS(data["identification"]) : <any>undefined;
            this.managerTypeKey = data["managerTypeKey"];
            this.managerTypeName = data["managerTypeName"];
            this.nationalityCountryId = data["nationalityCountryId"];
            this.nationalityCountryName = data["nationalityCountryName"];
            this.notes = data["notes"];
            this.originCountryId = data["originCountryId"];
            this.originCountryName = data["originCountryName"];
            this.otherOccupation = data["otherOccupation"];
            this.person = data["person"] ? ManagementAndOfficerPersonDto.fromJS(data["person"]) : <any>undefined;
            this.priorName = data["priorName"];
            this.registrationDate = data["registrationDate"] ? new Date(data["registrationDate"].toString()) : <any>undefined;
            this.titles = data["titles"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ManagementAndOfficerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementAndOfficerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateAppointed"] = this.dateAppointed ? this.dateAppointed.toISOString() : <any>undefined;
        data["dateOfResignation"] = this.dateOfResignation ? this.dateOfResignation.toISOString() : <any>undefined;
        data["identification"] = this.identification ? this.identification.toJSON() : <any>undefined;
        data["managerTypeKey"] = this.managerTypeKey;
        data["managerTypeName"] = this.managerTypeName;
        data["nationalityCountryId"] = this.nationalityCountryId;
        data["nationalityCountryName"] = this.nationalityCountryName;
        data["notes"] = this.notes;
        data["originCountryId"] = this.originCountryId;
        data["originCountryName"] = this.originCountryName;
        data["otherOccupation"] = this.otherOccupation;
        data["person"] = this.person ? this.person.toJSON() : <any>undefined;
        data["priorName"] = this.priorName;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["titles"] = this.titles;
        data["id"] = this.id;
        return data; 
    }

    clone(): ManagementAndOfficerDto {
        const json = this.toJSON();
        let result = new ManagementAndOfficerDto();
        result.init(json);
        return result;
    }
}

export interface IManagementAndOfficerDto {
    dateAppointed: Date | undefined;
    dateOfResignation: Date | undefined;
    identification: IdentificationDto | undefined;
    managerTypeKey: string | undefined;
    managerTypeName: string | undefined;
    nationalityCountryId: string | undefined;
    nationalityCountryName: string | undefined;
    notes: string | undefined;
    originCountryId: string | undefined;
    originCountryName: string | undefined;
    otherOccupation: string | undefined;
    person: ManagementAndOfficerPersonDto | undefined;
    priorName: string;
    registrationDate: Date | undefined;
    titles: string;
    id: string | undefined;
}

export class ParticularAndNoteDto implements IParticularAndNoteDto {
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    note: string | undefined;
    id: string | undefined;

    constructor(data?: IParticularAndNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModifierUserName = data["lastModifierUserName"];
            this.note = data["note"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ParticularAndNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticularAndNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserName"] = this.lastModifierUserName;
        data["note"] = this.note;
        data["id"] = this.id;
        return data; 
    }

    clone(): ParticularAndNoteDto {
        const json = this.toJSON();
        let result = new ParticularAndNoteDto();
        result.init(json);
        return result;
    }
}

export interface IParticularAndNoteDto {
    lastModificationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModifierUserName: string | undefined;
    note: string | undefined;
    id: string | undefined;
}

export class RegisterOfEntityActivityDto implements IRegisterOfEntityActivityDto {
    activityDate: Date | undefined;
    activityDescription: string | undefined;
    activityKey: string | undefined;
    feeAmount: number | undefined;
    licenseYear: number | undefined;
    notes: string | undefined;
    id: string | undefined;

    constructor(data?: IRegisterOfEntityActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityDate = data["activityDate"] ? new Date(data["activityDate"].toString()) : <any>undefined;
            this.activityDescription = data["activityDescription"];
            this.activityKey = data["activityKey"];
            this.feeAmount = data["feeAmount"];
            this.licenseYear = data["licenseYear"];
            this.notes = data["notes"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegisterOfEntityActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOfEntityActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["activityDescription"] = this.activityDescription;
        data["activityKey"] = this.activityKey;
        data["feeAmount"] = this.feeAmount;
        data["licenseYear"] = this.licenseYear;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegisterOfEntityActivityDto {
        const json = this.toJSON();
        let result = new RegisterOfEntityActivityDto();
        result.init(json);
        return result;
    }
}

export interface IRegisterOfEntityActivityDto {
    activityDate: Date | undefined;
    activityDescription: string | undefined;
    activityKey: string | undefined;
    feeAmount: number | undefined;
    licenseYear: number | undefined;
    notes: string | undefined;
    id: string | undefined;
}

export class RegistrationOfChargeDto implements IRegistrationOfChargeDto {
    chargee: RegistrationOfChargeContactDto | undefined;
    chargeeId: string | undefined;
    charger: RegistrationOfChargeContactDto | undefined;
    chargerId: string | undefined;
    dateOfCreationOfCharge: Date | undefined;
    descriptionOfCharge: string | undefined;
    governingLawOfTheCharge: string | undefined;
    mortgageAndDebenture: MortgageAndDebentureDto | undefined;
    registrationDate: Date | undefined;
    statusOfTheCharge: LookupDataDto | undefined;
    statusOfTheChargeKey: string | undefined;
    statusOfTheChargeName: string | undefined;
    id: string | undefined;

    constructor(data?: IRegistrationOfChargeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.chargee = data["chargee"] ? RegistrationOfChargeContactDto.fromJS(data["chargee"]) : <any>undefined;
            this.chargeeId = data["chargeeId"];
            this.charger = data["charger"] ? RegistrationOfChargeContactDto.fromJS(data["charger"]) : <any>undefined;
            this.chargerId = data["chargerId"];
            this.dateOfCreationOfCharge = data["dateOfCreationOfCharge"] ? new Date(data["dateOfCreationOfCharge"].toString()) : <any>undefined;
            this.descriptionOfCharge = data["descriptionOfCharge"];
            this.governingLawOfTheCharge = data["governingLawOfTheCharge"];
            this.mortgageAndDebenture = data["mortgageAndDebenture"] ? MortgageAndDebentureDto.fromJS(data["mortgageAndDebenture"]) : <any>undefined;
            this.registrationDate = data["registrationDate"] ? new Date(data["registrationDate"].toString()) : <any>undefined;
            this.statusOfTheCharge = data["statusOfTheCharge"] ? LookupDataDto.fromJS(data["statusOfTheCharge"]) : <any>undefined;
            this.statusOfTheChargeKey = data["statusOfTheChargeKey"];
            this.statusOfTheChargeName = data["statusOfTheChargeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationOfChargeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationOfChargeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chargee"] = this.chargee ? this.chargee.toJSON() : <any>undefined;
        data["chargeeId"] = this.chargeeId;
        data["charger"] = this.charger ? this.charger.toJSON() : <any>undefined;
        data["chargerId"] = this.chargerId;
        data["dateOfCreationOfCharge"] = this.dateOfCreationOfCharge ? this.dateOfCreationOfCharge.toISOString() : <any>undefined;
        data["descriptionOfCharge"] = this.descriptionOfCharge;
        data["governingLawOfTheCharge"] = this.governingLawOfTheCharge;
        data["mortgageAndDebenture"] = this.mortgageAndDebenture ? this.mortgageAndDebenture.toJSON() : <any>undefined;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : <any>undefined;
        data["statusOfTheCharge"] = this.statusOfTheCharge ? this.statusOfTheCharge.toJSON() : <any>undefined;
        data["statusOfTheChargeKey"] = this.statusOfTheChargeKey;
        data["statusOfTheChargeName"] = this.statusOfTheChargeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): RegistrationOfChargeDto {
        const json = this.toJSON();
        let result = new RegistrationOfChargeDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationOfChargeDto {
    chargee: RegistrationOfChargeContactDto | undefined;
    chargeeId: string | undefined;
    charger: RegistrationOfChargeContactDto | undefined;
    chargerId: string | undefined;
    dateOfCreationOfCharge: Date | undefined;
    descriptionOfCharge: string | undefined;
    governingLawOfTheCharge: string | undefined;
    mortgageAndDebenture: MortgageAndDebentureDto | undefined;
    registrationDate: Date | undefined;
    statusOfTheCharge: LookupDataDto | undefined;
    statusOfTheChargeKey: string | undefined;
    statusOfTheChargeName: string | undefined;
    id: string | undefined;
}

export class CompanyRegistrationRequestDto implements ICompanyRegistrationRequestDto {
    requestedBy: PersonDto | undefined;
    requestFees: RequestFeeDto[] | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKeys: string[] | undefined;
    serviceTypeName: string | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    readonly registeredAgentNumber: string | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceTypeKey: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;

    constructor(data?: ICompanyRegistrationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestedBy = data["requestedBy"] ? PersonDto.fromJS(data["requestedBy"]) : <any>undefined;
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.serviceCategoryName = data["serviceCategoryName"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
            this.serviceTypeName = data["serviceTypeName"];
            this.totalAmount = data["totalAmount"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedByUserName = data["assignedByUserName"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            if (data["documents"] && data["documents"].constructor === Array) {
                this.documents = [] as any;
                for (let item of data["documents"])
                    this.documents.push(DocumentDto.fromJS(item));
            }
            this.extensionData = data["extensionData"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
            this.registeredAgentName = data["registeredAgentName"];
            (<any>this).registeredAgentNumber = data["registeredAgentNumber"];
            this.requestedByName = data["requestedByName"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.serviceCategoryKey = data["serviceCategoryKey"];
            this.serviceTypeKey = data["serviceTypeKey"];
            this.terminatedAt = data["terminatedAt"] ? new Date(data["terminatedAt"].toString()) : <any>undefined;
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyRegistrationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRegistrationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["serviceCategoryName"] = this.serviceCategoryName;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        data["serviceTypeName"] = this.serviceTypeName;
        data["totalAmount"] = this.totalAmount;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedByUserName"] = this.assignedByUserName;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        if (this.documents && this.documents.constructor === Array) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["extensionData"] = this.extensionData;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        data["registeredAgentName"] = this.registeredAgentName;
        data["registeredAgentNumber"] = this.registeredAgentNumber;
        data["requestedByName"] = this.requestedByName;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["serviceCategoryKey"] = this.serviceCategoryKey;
        data["serviceTypeKey"] = this.serviceTypeKey;
        data["terminatedAt"] = this.terminatedAt ? this.terminatedAt.toISOString() : <any>undefined;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        return data; 
    }

    clone(): CompanyRegistrationRequestDto {
        const json = this.toJSON();
        let result = new CompanyRegistrationRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRegistrationRequestDto {
    requestedBy: PersonDto | undefined;
    requestFees: RequestFeeDto[] | undefined;
    serviceCategoryName: string | undefined;
    serviceTypeKeys: string[] | undefined;
    serviceTypeName: string | undefined;
    totalAmount: number | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    documents: DocumentDto[] | undefined;
    extensionData: string | undefined;
    lastModificationTime: Date | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgentNumber: string | undefined;
    requestedByName: string | undefined;
    requestExternalStatusKey: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusKey: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceCategoryKey: string | undefined;
    serviceTypeKey: string | undefined;
    terminatedAt: Date | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
}

export class CompanyRegistrationBusinessActivitySubBusinessActivityDto implements ICompanyRegistrationBusinessActivitySubBusinessActivityDto {
    subBusinessActivity: BusinessActivityDto | undefined;
    subBusinessActivityId: string | undefined;
    id: string | undefined;

    constructor(data?: ICompanyRegistrationBusinessActivitySubBusinessActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.subBusinessActivity = data["subBusinessActivity"] ? BusinessActivityDto.fromJS(data["subBusinessActivity"]) : <any>undefined;
            this.subBusinessActivityId = data["subBusinessActivityId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CompanyRegistrationBusinessActivitySubBusinessActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRegistrationBusinessActivitySubBusinessActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subBusinessActivity"] = this.subBusinessActivity ? this.subBusinessActivity.toJSON() : <any>undefined;
        data["subBusinessActivityId"] = this.subBusinessActivityId;
        data["id"] = this.id;
        return data; 
    }

    clone(): CompanyRegistrationBusinessActivitySubBusinessActivityDto {
        const json = this.toJSON();
        let result = new CompanyRegistrationBusinessActivitySubBusinessActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICompanyRegistrationBusinessActivitySubBusinessActivityDto {
    subBusinessActivity: BusinessActivityDto | undefined;
    subBusinessActivityId: string | undefined;
    id: string | undefined;
}

export class LookupDataDto implements ILookupDataDto {
    extensionData: string | undefined;
    key: string | undefined;
    lookupDataType: LookupDataTypeDto | undefined;
    name: string | undefined;
    parents: LookupDataDto[] | undefined;
    sortIndex: number | undefined;
    id: string | undefined;

    constructor(data?: ILookupDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.key = data["key"];
            this.lookupDataType = data["lookupDataType"] ? LookupDataTypeDto.fromJS(data["lookupDataType"]) : <any>undefined;
            this.name = data["name"];
            if (data["parents"] && data["parents"].constructor === Array) {
                this.parents = [] as any;
                for (let item of data["parents"])
                    this.parents.push(LookupDataDto.fromJS(item));
            }
            this.sortIndex = data["sortIndex"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LookupDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["key"] = this.key;
        data["lookupDataType"] = this.lookupDataType ? this.lookupDataType.toJSON() : <any>undefined;
        data["name"] = this.name;
        if (this.parents && this.parents.constructor === Array) {
            data["parents"] = [];
            for (let item of this.parents)
                data["parents"].push(item.toJSON());
        }
        data["sortIndex"] = this.sortIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): LookupDataDto {
        const json = this.toJSON();
        let result = new LookupDataDto();
        result.init(json);
        return result;
    }
}

export interface ILookupDataDto {
    extensionData: string | undefined;
    key: string | undefined;
    lookupDataType: LookupDataTypeDto | undefined;
    name: string | undefined;
    parents: LookupDataDto[] | undefined;
    sortIndex: number | undefined;
    id: string | undefined;
}

export class EntityNameDto implements IEntityNameDto {
    alternativeCompanyName: string | undefined;
    companyType: LookupDataDto | undefined;
    companyTypeKey: string | undefined;
    extensionData: string | undefined;
    nameReservation: NameReservationDto | undefined;
    nameReservationId: string | undefined;
    suffix: LookupDataDto | undefined;
    suffixKey: string | undefined;
    id: string | undefined;

    constructor(data?: IEntityNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.companyType = data["companyType"] ? LookupDataDto.fromJS(data["companyType"]) : <any>undefined;
            this.companyTypeKey = data["companyTypeKey"];
            this.extensionData = data["extensionData"];
            this.nameReservation = data["nameReservation"] ? NameReservationDto.fromJS(data["nameReservation"]) : <any>undefined;
            this.nameReservationId = data["nameReservationId"];
            this.suffix = data["suffix"] ? LookupDataDto.fromJS(data["suffix"]) : <any>undefined;
            this.suffixKey = data["suffixKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["companyType"] = this.companyType ? this.companyType.toJSON() : <any>undefined;
        data["companyTypeKey"] = this.companyTypeKey;
        data["extensionData"] = this.extensionData;
        data["nameReservation"] = this.nameReservation ? this.nameReservation.toJSON() : <any>undefined;
        data["nameReservationId"] = this.nameReservationId;
        data["suffix"] = this.suffix ? this.suffix.toJSON() : <any>undefined;
        data["suffixKey"] = this.suffixKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityNameDto {
        const json = this.toJSON();
        let result = new EntityNameDto();
        result.init(json);
        return result;
    }
}

export interface IEntityNameDto {
    alternativeCompanyName: string | undefined;
    companyType: LookupDataDto | undefined;
    companyTypeKey: string | undefined;
    extensionData: string | undefined;
    nameReservation: NameReservationDto | undefined;
    nameReservationId: string | undefined;
    suffix: LookupDataDto | undefined;
    suffixKey: string | undefined;
    id: string | undefined;
}

export class IncorporationDetailDto implements IIncorporationDetailDto {
    address: AddressDto | undefined;
    addressId: string | undefined;
    annualRenewalDate: Date | undefined;
    entityStatus: LookupDataDto | undefined;
    incorporationDate: Date | undefined;
    incorporationNumber: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IIncorporationDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : <any>undefined;
            this.addressId = data["addressId"];
            this.annualRenewalDate = data["annualRenewalDate"] ? new Date(data["annualRenewalDate"].toString()) : <any>undefined;
            this.entityStatus = data["entityStatus"] ? LookupDataDto.fromJS(data["entityStatus"]) : <any>undefined;
            this.incorporationDate = data["incorporationDate"] ? new Date(data["incorporationDate"].toString()) : <any>undefined;
            this.incorporationNumber = data["incorporationNumber"];
            this.statusDate = data["statusDate"] ? new Date(data["statusDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IncorporationDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncorporationDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["addressId"] = this.addressId;
        data["annualRenewalDate"] = this.annualRenewalDate ? this.annualRenewalDate.toISOString() : <any>undefined;
        data["entityStatus"] = this.entityStatus ? this.entityStatus.toJSON() : <any>undefined;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["incorporationNumber"] = this.incorporationNumber;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): IncorporationDetailDto {
        const json = this.toJSON();
        let result = new IncorporationDetailDto();
        result.init(json);
        return result;
    }
}

export interface IIncorporationDetailDto {
    address: AddressDto | undefined;
    addressId: string | undefined;
    annualRenewalDate: Date | undefined;
    entityStatus: LookupDataDto | undefined;
    incorporationDate: Date | undefined;
    incorporationNumber: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;
}

export class IbcInsuranceClassDto implements IIbcInsuranceClassDto {
    applicationFeePaidAt: Date | undefined;
    ibcInsuranceClassKey: string | undefined;
    ibcInsuranceClassName: string | undefined;
    isSelected: boolean | undefined;
    registrationFeePaidAt: Date | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    id: string | undefined;

    constructor(data?: IIbcInsuranceClassDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.applicationFeePaidAt = data["applicationFeePaidAt"] ? new Date(data["applicationFeePaidAt"].toString()) : <any>undefined;
            this.ibcInsuranceClassKey = data["ibcInsuranceClassKey"];
            this.ibcInsuranceClassName = data["ibcInsuranceClassName"];
            this.isSelected = data["isSelected"];
            this.registrationFeePaidAt = data["registrationFeePaidAt"] ? new Date(data["registrationFeePaidAt"].toString()) : <any>undefined;
            this.statusKey = data["statusKey"];
            this.statusName = data["statusName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IbcInsuranceClassDto {
        data = typeof data === 'object' ? data : {};
        let result = new IbcInsuranceClassDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationFeePaidAt"] = this.applicationFeePaidAt ? this.applicationFeePaidAt.toISOString() : <any>undefined;
        data["ibcInsuranceClassKey"] = this.ibcInsuranceClassKey;
        data["ibcInsuranceClassName"] = this.ibcInsuranceClassName;
        data["isSelected"] = this.isSelected;
        data["registrationFeePaidAt"] = this.registrationFeePaidAt ? this.registrationFeePaidAt.toISOString() : <any>undefined;
        data["statusKey"] = this.statusKey;
        data["statusName"] = this.statusName;
        data["id"] = this.id;
        return data; 
    }

    clone(): IbcInsuranceClassDto {
        const json = this.toJSON();
        let result = new IbcInsuranceClassDto();
        result.init(json);
        return result;
    }
}

export interface IIbcInsuranceClassDto {
    applicationFeePaidAt: Date | undefined;
    ibcInsuranceClassKey: string | undefined;
    ibcInsuranceClassName: string | undefined;
    isSelected: boolean | undefined;
    registrationFeePaidAt: Date | undefined;
    statusKey: string | undefined;
    statusName: string | undefined;
    id: string | undefined;
}

export class IdentificationDto implements IIdentificationDto {
    expirationDate: Date | undefined;
    identificationTypeKey: string;
    identificationTypeName: string;
    issuanceDate: Date | undefined;
    issuingCountryId: string;
    issuingCountryName: string | undefined;
    number: string;
    id: string | undefined;

    constructor(data?: IIdentificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : <any>undefined;
            this.identificationTypeKey = data["identificationTypeKey"];
            this.identificationTypeName = data["identificationTypeName"];
            this.issuanceDate = data["issuanceDate"] ? new Date(data["issuanceDate"].toString()) : <any>undefined;
            this.issuingCountryId = data["issuingCountryId"];
            this.issuingCountryName = data["issuingCountryName"];
            this.number = data["number"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): IdentificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["identificationTypeKey"] = this.identificationTypeKey;
        data["identificationTypeName"] = this.identificationTypeName;
        data["issuanceDate"] = this.issuanceDate ? this.issuanceDate.toISOString() : <any>undefined;
        data["issuingCountryId"] = this.issuingCountryId;
        data["issuingCountryName"] = this.issuingCountryName;
        data["number"] = this.number;
        data["id"] = this.id;
        return data; 
    }

    clone(): IdentificationDto {
        const json = this.toJSON();
        let result = new IdentificationDto();
        result.init(json);
        return result;
    }
}

export interface IIdentificationDto {
    expirationDate: Date | undefined;
    identificationTypeKey: string;
    identificationTypeName: string;
    issuanceDate: Date | undefined;
    issuingCountryId: string;
    issuingCountryName: string | undefined;
    number: string;
    id: string | undefined;
}

export class ManagementAndOfficerPersonDto implements IManagementAndOfficerPersonDto {
    addresses: AddressDto[] | undefined;
    contactType: ManagementAndOfficerPersonDtoContactType | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;

    constructor(data?: IManagementAndOfficerPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(AddressDto.fromJS(item));
            }
            this.contactType = data["contactType"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.companyName = data["companyName"];
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ManagementAndOfficerPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementAndOfficerPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["contactType"] = this.contactType;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ManagementAndOfficerPersonDto {
        const json = this.toJSON();
        let result = new ManagementAndOfficerPersonDto();
        result.init(json);
        return result;
    }
}

export interface IManagementAndOfficerPersonDto {
    addresses: AddressDto[] | undefined;
    contactType: ManagementAndOfficerPersonDtoContactType | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;
}

export class RegistrationOfChargeContactDto implements IRegistrationOfChargeContactDto {
    addresses: AddressDto[] | undefined;
    contactType: RegistrationOfChargeContactDtoContactType | undefined;
    firstName: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;

    constructor(data?: IRegistrationOfChargeContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["addresses"] && data["addresses"].constructor === Array) {
                this.addresses = [] as any;
                for (let item of data["addresses"])
                    this.addresses.push(AddressDto.fromJS(item));
            }
            this.contactType = data["contactType"];
            this.firstName = data["firstName"];
            this.isActive = data["isActive"];
            this.isDeleted = data["isDeleted"];
            this.lastName = data["lastName"];
            this.companyName = data["companyName"];
            if (data["emailAddresses"] && data["emailAddresses"].constructor === Array) {
                this.emailAddresses = [] as any;
                for (let item of data["emailAddresses"])
                    this.emailAddresses.push(EmailAddressDto.fromJS(item));
            }
            if (data["phoneNumbers"] && data["phoneNumbers"].constructor === Array) {
                this.phoneNumbers = [] as any;
                for (let item of data["phoneNumbers"])
                    this.phoneNumbers.push(PhoneNumberDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RegistrationOfChargeContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationOfChargeContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.addresses && this.addresses.constructor === Array) {
            data["addresses"] = [];
            for (let item of this.addresses)
                data["addresses"].push(item.toJSON());
        }
        data["contactType"] = this.contactType;
        data["firstName"] = this.firstName;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        if (this.emailAddresses && this.emailAddresses.constructor === Array) {
            data["emailAddresses"] = [];
            for (let item of this.emailAddresses)
                data["emailAddresses"].push(item.toJSON());
        }
        if (this.phoneNumbers && this.phoneNumbers.constructor === Array) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RegistrationOfChargeContactDto {
        const json = this.toJSON();
        let result = new RegistrationOfChargeContactDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationOfChargeContactDto {
    addresses: AddressDto[] | undefined;
    contactType: RegistrationOfChargeContactDtoContactType | undefined;
    firstName: string | undefined;
    isActive: boolean | undefined;
    isDeleted: boolean | undefined;
    lastName: string | undefined;
    companyName: string | undefined;
    emailAddresses: EmailAddressDto[] | undefined;
    phoneNumbers: PhoneNumberDto[] | undefined;
    id: string | undefined;
}

export class MortgageAndDebentureDto implements IMortgageAndDebentureDto {
    amountSecuredByCharge: string | undefined;
    currencyKey: string | undefined;
    currencyName: string | undefined;
    dateOfRegistration: Date | undefined;
    dateOfSatisfaction: Date | undefined;
    dateOfVariation: Date | undefined;
    natureOfRestrictions: string | undefined;
    natureOfTheCharge: string;
    particularsNotesOfVariation: string | undefined;
    serialNumberOfDocumentOnFile: string | undefined;
    shortParticularsOfThePropertyCharged: string;
    id: string | undefined;

    constructor(data?: IMortgageAndDebentureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amountSecuredByCharge = data["amountSecuredByCharge"];
            this.currencyKey = data["currencyKey"];
            this.currencyName = data["currencyName"];
            this.dateOfRegistration = data["dateOfRegistration"] ? new Date(data["dateOfRegistration"].toString()) : <any>undefined;
            this.dateOfSatisfaction = data["dateOfSatisfaction"] ? new Date(data["dateOfSatisfaction"].toString()) : <any>undefined;
            this.dateOfVariation = data["dateOfVariation"] ? new Date(data["dateOfVariation"].toString()) : <any>undefined;
            this.natureOfRestrictions = data["natureOfRestrictions"];
            this.natureOfTheCharge = data["natureOfTheCharge"];
            this.particularsNotesOfVariation = data["particularsNotesOfVariation"];
            this.serialNumberOfDocumentOnFile = data["serialNumberOfDocumentOnFile"];
            this.shortParticularsOfThePropertyCharged = data["shortParticularsOfThePropertyCharged"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MortgageAndDebentureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MortgageAndDebentureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountSecuredByCharge"] = this.amountSecuredByCharge;
        data["currencyKey"] = this.currencyKey;
        data["currencyName"] = this.currencyName;
        data["dateOfRegistration"] = this.dateOfRegistration ? this.dateOfRegistration.toISOString() : <any>undefined;
        data["dateOfSatisfaction"] = this.dateOfSatisfaction ? this.dateOfSatisfaction.toISOString() : <any>undefined;
        data["dateOfVariation"] = this.dateOfVariation ? this.dateOfVariation.toISOString() : <any>undefined;
        data["natureOfRestrictions"] = this.natureOfRestrictions;
        data["natureOfTheCharge"] = this.natureOfTheCharge;
        data["particularsNotesOfVariation"] = this.particularsNotesOfVariation;
        data["serialNumberOfDocumentOnFile"] = this.serialNumberOfDocumentOnFile;
        data["shortParticularsOfThePropertyCharged"] = this.shortParticularsOfThePropertyCharged;
        data["id"] = this.id;
        return data; 
    }

    clone(): MortgageAndDebentureDto {
        const json = this.toJSON();
        let result = new MortgageAndDebentureDto();
        result.init(json);
        return result;
    }
}

export interface IMortgageAndDebentureDto {
    amountSecuredByCharge: string | undefined;
    currencyKey: string | undefined;
    currencyName: string | undefined;
    dateOfRegistration: Date | undefined;
    dateOfSatisfaction: Date | undefined;
    dateOfVariation: Date | undefined;
    natureOfRestrictions: string | undefined;
    natureOfTheCharge: string;
    particularsNotesOfVariation: string | undefined;
    serialNumberOfDocumentOnFile: string | undefined;
    shortParticularsOfThePropertyCharged: string;
    id: string | undefined;
}

export class LookupDataTypeDto implements ILookupDataTypeDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    id: string | undefined;

    constructor(data?: ILookupDataTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.key = data["key"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): LookupDataTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDataTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["key"] = this.key;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): LookupDataTypeDto {
        const json = this.toJSON();
        let result = new LookupDataTypeDto();
        result.init(json);
        return result;
    }
}

export interface ILookupDataTypeDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    id: string | undefined;
}

export class NameReservationDto implements INameReservationDto {
    alternativeCompanyName: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    batchNumber: string | undefined;
    readonly companyFullName: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    expirationDate: Date | undefined;
    extensionData: string | undefined;
    externalStatusKey: string | undefined;
    externalStatusName: string | undefined;
    internalStatusKey: string | undefined;
    internalStatusName: string | undefined;
    isPaid: boolean | undefined;
    lastModificationTime: Date | undefined;
    nameHasWarning: boolean | undefined;
    notes: string | undefined;
    paymentDate: Date | undefined;
    readonly receiptNumbers: string[] | undefined;
    referenceNumber: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    requestID: string | undefined;
    requestNumber: string | undefined;
    requestServiceFees: RequestFeeDto[] | undefined;
    reservationDate: Date | undefined;
    reservationDurationDays: number | undefined;
    reservationDurationKey: string | undefined;
    reservationStatus: LookupDataDto | undefined;
    reservationStatusKey: string | undefined;
    rowVersion: string | undefined;
    suffix: string | undefined;
    suffixKey: string | undefined;
    terminatedAt: Date | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    workflowItemID: string | undefined;
    id: string | undefined;

    constructor(data?: INameReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedByUserName = data["assignedByUserName"];
            this.assignedTo = data["assignedTo"];
            this.batchNumber = data["batchNumber"];
            (<any>this).companyFullName = data["companyFullName"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.completedAt = data["completedAt"] ? new Date(data["completedAt"].toString()) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : <any>undefined;
            this.extensionData = data["extensionData"];
            this.externalStatusKey = data["externalStatusKey"];
            this.externalStatusName = data["externalStatusName"];
            this.internalStatusKey = data["internalStatusKey"];
            this.internalStatusName = data["internalStatusName"];
            this.isPaid = data["isPaid"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.nameHasWarning = data["nameHasWarning"];
            this.notes = data["notes"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            if (data["receiptNumbers"] && data["receiptNumbers"].constructor === Array) {
                (<any>this).receiptNumbers = [] as any;
                for (let item of data["receiptNumbers"])
                    (<any>this).receiptNumbers.push(item);
            }
            this.referenceNumber = data["referenceNumber"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentID = data["registeredAgentID"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestID = data["requestID"];
            this.requestNumber = data["requestNumber"];
            if (data["requestServiceFees"] && data["requestServiceFees"].constructor === Array) {
                this.requestServiceFees = [] as any;
                for (let item of data["requestServiceFees"])
                    this.requestServiceFees.push(RequestFeeDto.fromJS(item));
            }
            this.reservationDate = data["reservationDate"] ? new Date(data["reservationDate"].toString()) : <any>undefined;
            this.reservationDurationDays = data["reservationDurationDays"];
            this.reservationDurationKey = data["reservationDurationKey"];
            this.reservationStatus = data["reservationStatus"] ? LookupDataDto.fromJS(data["reservationStatus"]) : <any>undefined;
            this.reservationStatusKey = data["reservationStatusKey"];
            this.rowVersion = data["rowVersion"];
            this.suffix = data["suffix"];
            this.suffixKey = data["suffixKey"];
            this.terminatedAt = data["terminatedAt"] ? new Date(data["terminatedAt"].toString()) : <any>undefined;
            this.warningOverridden = data["warningOverridden"];
            this.warningOverriddenById = data["warningOverriddenById"];
            this.workflowItemID = data["workflowItemID"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NameReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedByUserName"] = this.assignedByUserName;
        data["assignedTo"] = this.assignedTo;
        data["batchNumber"] = this.batchNumber;
        data["companyFullName"] = this.companyFullName;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["completedAt"] = this.completedAt ? this.completedAt.toISOString() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["extensionData"] = this.extensionData;
        data["externalStatusKey"] = this.externalStatusKey;
        data["externalStatusName"] = this.externalStatusName;
        data["internalStatusKey"] = this.internalStatusKey;
        data["internalStatusName"] = this.internalStatusName;
        data["isPaid"] = this.isPaid;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["nameHasWarning"] = this.nameHasWarning;
        data["notes"] = this.notes;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        if (this.receiptNumbers && this.receiptNumbers.constructor === Array) {
            data["receiptNumbers"] = [];
            for (let item of this.receiptNumbers)
                data["receiptNumbers"].push(item);
        }
        data["referenceNumber"] = this.referenceNumber;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentID"] = this.registeredAgentID;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestID"] = this.requestID;
        data["requestNumber"] = this.requestNumber;
        if (this.requestServiceFees && this.requestServiceFees.constructor === Array) {
            data["requestServiceFees"] = [];
            for (let item of this.requestServiceFees)
                data["requestServiceFees"].push(item.toJSON());
        }
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toISOString() : <any>undefined;
        data["reservationDurationDays"] = this.reservationDurationDays;
        data["reservationDurationKey"] = this.reservationDurationKey;
        data["reservationStatus"] = this.reservationStatus ? this.reservationStatus.toJSON() : <any>undefined;
        data["reservationStatusKey"] = this.reservationStatusKey;
        data["rowVersion"] = this.rowVersion;
        data["suffix"] = this.suffix;
        data["suffixKey"] = this.suffixKey;
        data["terminatedAt"] = this.terminatedAt ? this.terminatedAt.toISOString() : <any>undefined;
        data["warningOverridden"] = this.warningOverridden;
        data["warningOverriddenById"] = this.warningOverriddenById;
        data["workflowItemID"] = this.workflowItemID;
        data["id"] = this.id;
        return data; 
    }

    clone(): NameReservationDto {
        const json = this.toJSON();
        let result = new NameReservationDto();
        result.init(json);
        return result;
    }
}

export interface INameReservationDto {
    alternativeCompanyName: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedByUserName: string | undefined;
    assignedTo: string | undefined;
    batchNumber: string | undefined;
    companyFullName: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    completedAt: Date | undefined;
    creationTime: Date | undefined;
    expirationDate: Date | undefined;
    extensionData: string | undefined;
    externalStatusKey: string | undefined;
    externalStatusName: string | undefined;
    internalStatusKey: string | undefined;
    internalStatusName: string | undefined;
    isPaid: boolean | undefined;
    lastModificationTime: Date | undefined;
    nameHasWarning: boolean | undefined;
    notes: string | undefined;
    paymentDate: Date | undefined;
    receiptNumbers: string[] | undefined;
    referenceNumber: string | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    requestID: string | undefined;
    requestNumber: string | undefined;
    requestServiceFees: RequestFeeDto[] | undefined;
    reservationDate: Date | undefined;
    reservationDurationDays: number | undefined;
    reservationDurationKey: string | undefined;
    reservationStatus: LookupDataDto | undefined;
    reservationStatusKey: string | undefined;
    rowVersion: string | undefined;
    suffix: string | undefined;
    suffixKey: string | undefined;
    terminatedAt: Date | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    workflowItemID: string | undefined;
    id: string | undefined;
}

export class AjaxResponseOfCompanyRegistrationDto implements IAjaxResponseOfCompanyRegistrationDto {
    result: CompanyRegistrationDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfCompanyRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"] ? CompanyRegistrationDto.fromJS(data["result"]) : <any>undefined;
            this.targetUrl = data["targetUrl"];
            this.success = data["success"];
            this.error = data["error"] ? ErrorInfo.fromJS(data["error"]) : <any>undefined;
            this.unAuthorizedRequest = data["unAuthorizedRequest"];
            (<any>this).__abp = data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfCompanyRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfCompanyRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data; 
    }

    clone(): AjaxResponseOfCompanyRegistrationDto {
        const json = this.toJSON();
        let result = new AjaxResponseOfCompanyRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfCompanyRegistrationDto {
    result: CompanyRegistrationDto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class ErrorInfo implements IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;

    constructor(data?: IErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.message = data["message"];
            this.details = data["details"];
            if (data["validationErrors"] && data["validationErrors"].constructor === Array) {
                this.validationErrors = [] as any;
                for (let item of data["validationErrors"])
                    this.validationErrors.push(ValidationErrorInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["details"] = this.details;
        if (this.validationErrors && this.validationErrors.constructor === Array) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ErrorInfo {
        const json = this.toJSON();
        let result = new ErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IErrorInfo {
    code: number | undefined;
    message: string | undefined;
    details: string | undefined;
    validationErrors: ValidationErrorInfo[] | undefined;
}

export class ValidationErrorInfo implements IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;

    constructor(data?: IValidationErrorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.message = data["message"];
            if (data["members"] && data["members"].constructor === Array) {
                this.members = [] as any;
                for (let item of data["members"])
                    this.members.push(item);
            }
        }
    }

    static fromJS(data: any): ValidationErrorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        if (this.members && this.members.constructor === Array) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item);
        }
        return data; 
    }

    clone(): ValidationErrorInfo {
        const json = this.toJSON();
        let result = new ValidationErrorInfo();
        result.init(json);
        return result;
    }
}

export interface IValidationErrorInfo {
    message: string | undefined;
    members: string[] | undefined;
}

export class AjaxResponseOfRequestV2Dto implements IAjaxResponseOfRequestV2Dto {
    result: RequestV2Dto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponseOfRequestV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"] ? RequestV2Dto.fromJS(data["result"]) : <any>undefined;
            this.targetUrl = data["targetUrl"];
            this.success = data["success"];
            this.error = data["error"] ? ErrorInfo.fromJS(data["error"]) : <any>undefined;
            this.unAuthorizedRequest = data["unAuthorizedRequest"];
            (<any>this).__abp = data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponseOfRequestV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponseOfRequestV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data; 
    }

    clone(): AjaxResponseOfRequestV2Dto {
        const json = this.toJSON();
        let result = new AjaxResponseOfRequestV2Dto();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponseOfRequestV2Dto {
    result: RequestV2Dto | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class PagedResultDtoOfCompanyRegistrationDto implements IPagedResultDtoOfCompanyRegistrationDto {
    totalCount: number | undefined;
    items: CompanyRegistrationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCompanyRegistrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CompanyRegistrationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCompanyRegistrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCompanyRegistrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCompanyRegistrationDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCompanyRegistrationDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCompanyRegistrationDto {
    totalCount: number | undefined;
    items: CompanyRegistrationDto[] | undefined;
}

export class GetAllCompanyRegistrationInput implements IGetAllCompanyRegistrationInput {
    companyName: string | undefined;
    companyTypeKeys: string[] | undefined;
    entitiesPassedAnnualRenewalDate: boolean | undefined;
    entitiesWithCertificatesNotIssuedWithRequestCompletion: boolean | undefined;
    entitiesWithExpiredManagerId: boolean | undefined;
    entitiesWithoutRegisteredAgent: EntitiesWithoutRegisteredAgent2[] | undefined;
    entityActivityKey: string | undefined;
    entityStatusKeys: string[] | undefined;
    ibcInsuranceClasses: string[] | undefined;
    ids: string[] | undefined;
    includeChildren: boolean | undefined;
    incorporationDateFrom: Date | undefined;
    incorporationDateTo: Date | undefined;
    incorporationNumber: string | undefined;
    lastRenewedYear: GetAllCompanyRegistrationInputLastRenewedYear | undefined;
    nameReservationReferenceNumber: string | undefined;
    nextAnnualRenewalDateFrom: Date | undefined;
    nextAnnualRenewalDateTo: Date | undefined;
    registeredAgentIds: string[] | undefined;
    requestCreationDateFrom: Date | undefined;
    requestCreationDateTo: Date | undefined;
    requestExternalStatusKeys: string[] | undefined;
    requestInternalStatusKeys: string[] | undefined;
    requestOrBatchNumber: string | undefined;
    typesOfSharesAllowedKey: string | undefined;
    entityStatusDateFrom: Date | undefined;
    entityStatusDateTo: Date | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IGetAllCompanyRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            if (data["companyTypeKeys"] && data["companyTypeKeys"].constructor === Array) {
                this.companyTypeKeys = [] as any;
                for (let item of data["companyTypeKeys"])
                    this.companyTypeKeys.push(item);
            }
            this.entitiesPassedAnnualRenewalDate = data["entitiesPassedAnnualRenewalDate"];
            this.entitiesWithCertificatesNotIssuedWithRequestCompletion = data["entitiesWithCertificatesNotIssuedWithRequestCompletion"];
            this.entitiesWithExpiredManagerId = data["entitiesWithExpiredManagerId"];
            if (data["entitiesWithoutRegisteredAgent"] && data["entitiesWithoutRegisteredAgent"].constructor === Array) {
                this.entitiesWithoutRegisteredAgent = [] as any;
                for (let item of data["entitiesWithoutRegisteredAgent"])
                    this.entitiesWithoutRegisteredAgent.push(item);
            }
            this.entityActivityKey = data["entityActivityKey"];
            if (data["entityStatusKeys"] && data["entityStatusKeys"].constructor === Array) {
                this.entityStatusKeys = [] as any;
                for (let item of data["entityStatusKeys"])
                    this.entityStatusKeys.push(item);
            }
            if (data["ibcInsuranceClasses"] && data["ibcInsuranceClasses"].constructor === Array) {
                this.ibcInsuranceClasses = [] as any;
                for (let item of data["ibcInsuranceClasses"])
                    this.ibcInsuranceClasses.push(item);
            }
            if (data["ids"] && data["ids"].constructor === Array) {
                this.ids = [] as any;
                for (let item of data["ids"])
                    this.ids.push(item);
            }
            this.includeChildren = data["includeChildren"];
            this.incorporationDateFrom = data["incorporationDateFrom"] ? new Date(data["incorporationDateFrom"].toString()) : <any>undefined;
            this.incorporationDateTo = data["incorporationDateTo"] ? new Date(data["incorporationDateTo"].toString()) : <any>undefined;
            this.incorporationNumber = data["incorporationNumber"];
            this.lastRenewedYear = data["lastRenewedYear"];
            this.nameReservationReferenceNumber = data["nameReservationReferenceNumber"];
            this.nextAnnualRenewalDateFrom = data["nextAnnualRenewalDateFrom"] ? new Date(data["nextAnnualRenewalDateFrom"].toString()) : <any>undefined;
            this.nextAnnualRenewalDateTo = data["nextAnnualRenewalDateTo"] ? new Date(data["nextAnnualRenewalDateTo"].toString()) : <any>undefined;
            if (data["registeredAgentIds"] && data["registeredAgentIds"].constructor === Array) {
                this.registeredAgentIds = [] as any;
                for (let item of data["registeredAgentIds"])
                    this.registeredAgentIds.push(item);
            }
            this.requestCreationDateFrom = data["requestCreationDateFrom"] ? new Date(data["requestCreationDateFrom"].toString()) : <any>undefined;
            this.requestCreationDateTo = data["requestCreationDateTo"] ? new Date(data["requestCreationDateTo"].toString()) : <any>undefined;
            if (data["requestExternalStatusKeys"] && data["requestExternalStatusKeys"].constructor === Array) {
                this.requestExternalStatusKeys = [] as any;
                for (let item of data["requestExternalStatusKeys"])
                    this.requestExternalStatusKeys.push(item);
            }
            if (data["requestInternalStatusKeys"] && data["requestInternalStatusKeys"].constructor === Array) {
                this.requestInternalStatusKeys = [] as any;
                for (let item of data["requestInternalStatusKeys"])
                    this.requestInternalStatusKeys.push(item);
            }
            this.requestOrBatchNumber = data["requestOrBatchNumber"];
            this.typesOfSharesAllowedKey = data["typesOfSharesAllowedKey"];
            this.entityStatusDateFrom = data["entityStatusDateFrom"] ? new Date(data["entityStatusDateFrom"].toString()) : <any>undefined;
            this.entityStatusDateTo = data["entityStatusDateTo"] ? new Date(data["entityStatusDateTo"].toString()) : <any>undefined;
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllCompanyRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllCompanyRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        if (this.companyTypeKeys && this.companyTypeKeys.constructor === Array) {
            data["companyTypeKeys"] = [];
            for (let item of this.companyTypeKeys)
                data["companyTypeKeys"].push(item);
        }
        data["entitiesPassedAnnualRenewalDate"] = this.entitiesPassedAnnualRenewalDate;
        data["entitiesWithCertificatesNotIssuedWithRequestCompletion"] = this.entitiesWithCertificatesNotIssuedWithRequestCompletion;
        data["entitiesWithExpiredManagerId"] = this.entitiesWithExpiredManagerId;
        if (this.entitiesWithoutRegisteredAgent && this.entitiesWithoutRegisteredAgent.constructor === Array) {
            data["entitiesWithoutRegisteredAgent"] = [];
            for (let item of this.entitiesWithoutRegisteredAgent)
                data["entitiesWithoutRegisteredAgent"].push(item);
        }
        data["entityActivityKey"] = this.entityActivityKey;
        if (this.entityStatusKeys && this.entityStatusKeys.constructor === Array) {
            data["entityStatusKeys"] = [];
            for (let item of this.entityStatusKeys)
                data["entityStatusKeys"].push(item);
        }
        if (this.ibcInsuranceClasses && this.ibcInsuranceClasses.constructor === Array) {
            data["ibcInsuranceClasses"] = [];
            for (let item of this.ibcInsuranceClasses)
                data["ibcInsuranceClasses"].push(item);
        }
        if (this.ids && this.ids.constructor === Array) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["includeChildren"] = this.includeChildren;
        data["incorporationDateFrom"] = this.incorporationDateFrom ? this.incorporationDateFrom.toISOString() : <any>undefined;
        data["incorporationDateTo"] = this.incorporationDateTo ? this.incorporationDateTo.toISOString() : <any>undefined;
        data["incorporationNumber"] = this.incorporationNumber;
        data["lastRenewedYear"] = this.lastRenewedYear;
        data["nameReservationReferenceNumber"] = this.nameReservationReferenceNumber;
        data["nextAnnualRenewalDateFrom"] = this.nextAnnualRenewalDateFrom ? this.nextAnnualRenewalDateFrom.toISOString() : <any>undefined;
        data["nextAnnualRenewalDateTo"] = this.nextAnnualRenewalDateTo ? this.nextAnnualRenewalDateTo.toISOString() : <any>undefined;
        if (this.registeredAgentIds && this.registeredAgentIds.constructor === Array) {
            data["registeredAgentIds"] = [];
            for (let item of this.registeredAgentIds)
                data["registeredAgentIds"].push(item);
        }
        data["requestCreationDateFrom"] = this.requestCreationDateFrom ? this.requestCreationDateFrom.toISOString() : <any>undefined;
        data["requestCreationDateTo"] = this.requestCreationDateTo ? this.requestCreationDateTo.toISOString() : <any>undefined;
        if (this.requestExternalStatusKeys && this.requestExternalStatusKeys.constructor === Array) {
            data["requestExternalStatusKeys"] = [];
            for (let item of this.requestExternalStatusKeys)
                data["requestExternalStatusKeys"].push(item);
        }
        if (this.requestInternalStatusKeys && this.requestInternalStatusKeys.constructor === Array) {
            data["requestInternalStatusKeys"] = [];
            for (let item of this.requestInternalStatusKeys)
                data["requestInternalStatusKeys"].push(item);
        }
        data["requestOrBatchNumber"] = this.requestOrBatchNumber;
        data["typesOfSharesAllowedKey"] = this.typesOfSharesAllowedKey;
        data["entityStatusDateFrom"] = this.entityStatusDateFrom ? this.entityStatusDateFrom.toISOString() : <any>undefined;
        data["entityStatusDateTo"] = this.entityStatusDateTo ? this.entityStatusDateTo.toISOString() : <any>undefined;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetAllCompanyRegistrationInput {
        const json = this.toJSON();
        let result = new GetAllCompanyRegistrationInput();
        result.init(json);
        return result;
    }
}

export interface IGetAllCompanyRegistrationInput {
    companyName: string | undefined;
    companyTypeKeys: string[] | undefined;
    entitiesPassedAnnualRenewalDate: boolean | undefined;
    entitiesWithCertificatesNotIssuedWithRequestCompletion: boolean | undefined;
    entitiesWithExpiredManagerId: boolean | undefined;
    entitiesWithoutRegisteredAgent: EntitiesWithoutRegisteredAgent2[] | undefined;
    entityActivityKey: string | undefined;
    entityStatusKeys: string[] | undefined;
    ibcInsuranceClasses: string[] | undefined;
    ids: string[] | undefined;
    includeChildren: boolean | undefined;
    incorporationDateFrom: Date | undefined;
    incorporationDateTo: Date | undefined;
    incorporationNumber: string | undefined;
    lastRenewedYear: GetAllCompanyRegistrationInputLastRenewedYear | undefined;
    nameReservationReferenceNumber: string | undefined;
    nextAnnualRenewalDateFrom: Date | undefined;
    nextAnnualRenewalDateTo: Date | undefined;
    registeredAgentIds: string[] | undefined;
    requestCreationDateFrom: Date | undefined;
    requestCreationDateTo: Date | undefined;
    requestExternalStatusKeys: string[] | undefined;
    requestInternalStatusKeys: string[] | undefined;
    requestOrBatchNumber: string | undefined;
    typesOfSharesAllowedKey: string | undefined;
    entityStatusDateFrom: Date | undefined;
    entityStatusDateTo: Date | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetAllSearchCompanyRegistrationOutput implements IPagedResultDtoOfGetAllSearchCompanyRegistrationOutput {
    totalCount: number | undefined;
    items: GetAllSearchCompanyRegistrationOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSearchCompanyRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllSearchCompanyRegistrationOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSearchCompanyRegistrationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSearchCompanyRegistrationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllSearchCompanyRegistrationOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllSearchCompanyRegistrationOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllSearchCompanyRegistrationOutput {
    totalCount: number | undefined;
    items: GetAllSearchCompanyRegistrationOutput[] | undefined;
}

export class GetAllSearchCompanyRegistrationOutput implements IGetAllSearchCompanyRegistrationOutput {
    annualRenewalDate: Date | undefined;
    batchNumber: string | undefined;
    companyName: string | undefined;
    companyNameAndSuffix: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    entityStatusKey: string | undefined;
    entityStatusName: string | undefined;
    incorporationDate: Date | undefined;
    incorporationNumber: string | undefined;
    minYearsToRenew: number | undefined;
    passedAnnualRenewalDate: boolean | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    suffixKey: string | undefined;
    id: string | undefined;

    constructor(data?: IGetAllSearchCompanyRegistrationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.annualRenewalDate = data["annualRenewalDate"] ? new Date(data["annualRenewalDate"].toString()) : <any>undefined;
            this.batchNumber = data["batchNumber"];
            this.companyName = data["companyName"];
            this.companyNameAndSuffix = data["companyNameAndSuffix"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.entityStatusKey = data["entityStatusKey"];
            this.entityStatusName = data["entityStatusName"];
            this.incorporationDate = data["incorporationDate"] ? new Date(data["incorporationDate"].toString()) : <any>undefined;
            this.incorporationNumber = data["incorporationNumber"];
            this.minYearsToRenew = data["minYearsToRenew"];
            this.passedAnnualRenewalDate = data["passedAnnualRenewalDate"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestNumber = data["requestNumber"];
            this.suffixKey = data["suffixKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllSearchCompanyRegistrationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSearchCompanyRegistrationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["annualRenewalDate"] = this.annualRenewalDate ? this.annualRenewalDate.toISOString() : <any>undefined;
        data["batchNumber"] = this.batchNumber;
        data["companyName"] = this.companyName;
        data["companyNameAndSuffix"] = this.companyNameAndSuffix;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["entityStatusKey"] = this.entityStatusKey;
        data["entityStatusName"] = this.entityStatusName;
        data["incorporationDate"] = this.incorporationDate ? this.incorporationDate.toISOString() : <any>undefined;
        data["incorporationNumber"] = this.incorporationNumber;
        data["minYearsToRenew"] = this.minYearsToRenew;
        data["passedAnnualRenewalDate"] = this.passedAnnualRenewalDate;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestNumber"] = this.requestNumber;
        data["suffixKey"] = this.suffixKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllSearchCompanyRegistrationOutput {
        const json = this.toJSON();
        let result = new GetAllSearchCompanyRegistrationOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllSearchCompanyRegistrationOutput {
    annualRenewalDate: Date | undefined;
    batchNumber: string | undefined;
    companyName: string | undefined;
    companyNameAndSuffix: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    entityStatusKey: string | undefined;
    entityStatusName: string | undefined;
    incorporationDate: Date | undefined;
    incorporationNumber: string | undefined;
    minYearsToRenew: number | undefined;
    passedAnnualRenewalDate: boolean | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    suffixKey: string | undefined;
    id: string | undefined;
}

export class UpdateCompanyRegistrationInput implements IUpdateCompanyRegistrationInput {
    businessActivities: BaseCompanyRegistrationBusinessActivityInput[] | undefined;
    capitalAndShareTransfer: BaseCapitalAndShareTransferInput | undefined;
    entityDetail: UpdateEntityDetailInput;
    extensionData: string | undefined;
    ibcInsuranceClasses: UpdateIbcInsuranceClassCollectionInput | undefined;
    managementAndOfficers: BaseManagementAndOfficerInput[] | undefined;
    particularAndNote: BaseParticularAndNoteInput | undefined;
    registerOfEntityActivities: BaseRegisterOfEntityActivityInput[] | undefined;
    registrationOfCharges: BaseRegistrationOfChargeInput[] | undefined;
    request: UpdateCompanyRegistrationRequestInput;
    id: string | undefined;

    constructor(data?: IUpdateCompanyRegistrationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entityDetail = new UpdateEntityDetailInput();
            this.request = new UpdateCompanyRegistrationRequestInput();
        }
    }

    init(data?: any) {
        if (data) {
            if (data["businessActivities"] && data["businessActivities"].constructor === Array) {
                this.businessActivities = [] as any;
                for (let item of data["businessActivities"])
                    this.businessActivities.push(BaseCompanyRegistrationBusinessActivityInput.fromJS(item));
            }
            this.capitalAndShareTransfer = data["capitalAndShareTransfer"] ? BaseCapitalAndShareTransferInput.fromJS(data["capitalAndShareTransfer"]) : <any>undefined;
            this.entityDetail = data["entityDetail"] ? UpdateEntityDetailInput.fromJS(data["entityDetail"]) : new UpdateEntityDetailInput();
            this.extensionData = data["extensionData"];
            this.ibcInsuranceClasses = data["ibcInsuranceClasses"] ? UpdateIbcInsuranceClassCollectionInput.fromJS(data["ibcInsuranceClasses"]) : <any>undefined;
            if (data["managementAndOfficers"] && data["managementAndOfficers"].constructor === Array) {
                this.managementAndOfficers = [] as any;
                for (let item of data["managementAndOfficers"])
                    this.managementAndOfficers.push(BaseManagementAndOfficerInput.fromJS(item));
            }
            this.particularAndNote = data["particularAndNote"] ? BaseParticularAndNoteInput.fromJS(data["particularAndNote"]) : <any>undefined;
            if (data["registerOfEntityActivities"] && data["registerOfEntityActivities"].constructor === Array) {
                this.registerOfEntityActivities = [] as any;
                for (let item of data["registerOfEntityActivities"])
                    this.registerOfEntityActivities.push(BaseRegisterOfEntityActivityInput.fromJS(item));
            }
            if (data["registrationOfCharges"] && data["registrationOfCharges"].constructor === Array) {
                this.registrationOfCharges = [] as any;
                for (let item of data["registrationOfCharges"])
                    this.registrationOfCharges.push(BaseRegistrationOfChargeInput.fromJS(item));
            }
            this.request = data["request"] ? UpdateCompanyRegistrationRequestInput.fromJS(data["request"]) : new UpdateCompanyRegistrationRequestInput();
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateCompanyRegistrationInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyRegistrationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.businessActivities && this.businessActivities.constructor === Array) {
            data["businessActivities"] = [];
            for (let item of this.businessActivities)
                data["businessActivities"].push(item.toJSON());
        }
        data["capitalAndShareTransfer"] = this.capitalAndShareTransfer ? this.capitalAndShareTransfer.toJSON() : <any>undefined;
        data["entityDetail"] = this.entityDetail ? this.entityDetail.toJSON() : <any>undefined;
        data["extensionData"] = this.extensionData;
        data["ibcInsuranceClasses"] = this.ibcInsuranceClasses ? this.ibcInsuranceClasses.toJSON() : <any>undefined;
        if (this.managementAndOfficers && this.managementAndOfficers.constructor === Array) {
            data["managementAndOfficers"] = [];
            for (let item of this.managementAndOfficers)
                data["managementAndOfficers"].push(item.toJSON());
        }
        data["particularAndNote"] = this.particularAndNote ? this.particularAndNote.toJSON() : <any>undefined;
        if (this.registerOfEntityActivities && this.registerOfEntityActivities.constructor === Array) {
            data["registerOfEntityActivities"] = [];
            for (let item of this.registerOfEntityActivities)
                data["registerOfEntityActivities"].push(item.toJSON());
        }
        if (this.registrationOfCharges && this.registrationOfCharges.constructor === Array) {
            data["registrationOfCharges"] = [];
            for (let item of this.registrationOfCharges)
                data["registrationOfCharges"].push(item.toJSON());
        }
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateCompanyRegistrationInput {
        const json = this.toJSON();
        let result = new UpdateCompanyRegistrationInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyRegistrationInput {
    businessActivities: BaseCompanyRegistrationBusinessActivityInput[] | undefined;
    capitalAndShareTransfer: BaseCapitalAndShareTransferInput | undefined;
    entityDetail: UpdateEntityDetailInput;
    extensionData: string | undefined;
    ibcInsuranceClasses: UpdateIbcInsuranceClassCollectionInput | undefined;
    managementAndOfficers: BaseManagementAndOfficerInput[] | undefined;
    particularAndNote: BaseParticularAndNoteInput | undefined;
    registerOfEntityActivities: BaseRegisterOfEntityActivityInput[] | undefined;
    registrationOfCharges: BaseRegistrationOfChargeInput[] | undefined;
    request: UpdateCompanyRegistrationRequestInput;
    id: string | undefined;
}

export class UpdateEntityDetailInput implements IUpdateEntityDetailInput {
    entityName: UpdateEntityNameInput;
    incorporationDetail: UpdateIncorporationDetailInput | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;

    constructor(data?: IUpdateEntityDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entityName = new UpdateEntityNameInput();
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"] ? UpdateEntityNameInput.fromJS(data["entityName"]) : new UpdateEntityNameInput();
            this.incorporationDetail = data["incorporationDetail"] ? UpdateIncorporationDetailInput.fromJS(data["incorporationDetail"]) : <any>undefined;
            this.insuranceManager = data["insuranceManager"];
            this.notes = data["notes"];
            this.registeredAgentResignedAt = data["registeredAgentResignedAt"] ? new Date(data["registeredAgentResignedAt"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateEntityDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntityDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName ? this.entityName.toJSON() : <any>undefined;
        data["incorporationDetail"] = this.incorporationDetail ? this.incorporationDetail.toJSON() : <any>undefined;
        data["insuranceManager"] = this.insuranceManager;
        data["notes"] = this.notes;
        data["registeredAgentResignedAt"] = this.registeredAgentResignedAt ? this.registeredAgentResignedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateEntityDetailInput {
        const json = this.toJSON();
        let result = new UpdateEntityDetailInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateEntityDetailInput {
    entityName: UpdateEntityNameInput;
    incorporationDetail: UpdateIncorporationDetailInput | undefined;
    insuranceManager: string | undefined;
    notes: string | undefined;
    registeredAgentResignedAt: Date | undefined;
    id: string | undefined;
}

export class UpdateIbcInsuranceClassCollectionInput implements IUpdateIbcInsuranceClassCollectionInput {
    ibcInsuranceClasses: UpdateIbcInsuranceClassInput[] | undefined;
    notes: string | undefined;

    constructor(data?: IUpdateIbcInsuranceClassCollectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["ibcInsuranceClasses"] && data["ibcInsuranceClasses"].constructor === Array) {
                this.ibcInsuranceClasses = [] as any;
                for (let item of data["ibcInsuranceClasses"])
                    this.ibcInsuranceClasses.push(UpdateIbcInsuranceClassInput.fromJS(item));
            }
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): UpdateIbcInsuranceClassCollectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIbcInsuranceClassCollectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.ibcInsuranceClasses && this.ibcInsuranceClasses.constructor === Array) {
            data["ibcInsuranceClasses"] = [];
            for (let item of this.ibcInsuranceClasses)
                data["ibcInsuranceClasses"].push(item.toJSON());
        }
        data["notes"] = this.notes;
        return data; 
    }

    clone(): UpdateIbcInsuranceClassCollectionInput {
        const json = this.toJSON();
        let result = new UpdateIbcInsuranceClassCollectionInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateIbcInsuranceClassCollectionInput {
    ibcInsuranceClasses: UpdateIbcInsuranceClassInput[] | undefined;
    notes: string | undefined;
}

export class UpdateCompanyRegistrationRequestInput implements IUpdateCompanyRegistrationRequestInput {
    companyTypeKey: string;
    documentIds: string[] | undefined;
    rowVersion: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IUpdateCompanyRegistrationRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyTypeKey = data["companyTypeKey"];
            if (data["documentIds"] && data["documentIds"].constructor === Array) {
                this.documentIds = [] as any;
                for (let item of data["documentIds"])
                    this.documentIds.push(item);
            }
            this.rowVersion = data["rowVersion"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.id = data["id"];
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateCompanyRegistrationRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCompanyRegistrationRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyTypeKey"] = this.companyTypeKey;
        if (this.documentIds && this.documentIds.constructor === Array) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["rowVersion"] = this.rowVersion;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): UpdateCompanyRegistrationRequestInput {
        const json = this.toJSON();
        let result = new UpdateCompanyRegistrationRequestInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCompanyRegistrationRequestInput {
    companyTypeKey: string;
    documentIds: string[] | undefined;
    rowVersion: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class UpdateEntityNameInput implements IUpdateEntityNameInput {
    alternativeCompanyName: string | undefined;
    companyTypeKey: string;
    nameReservationId: string;
    oldName: string | undefined;
    suffixKey: string;
    id: string | undefined;

    constructor(data?: IUpdateEntityNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.nameReservationId = data["nameReservationId"];
            this.oldName = data["oldName"];
            this.suffixKey = data["suffixKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateEntityNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEntityNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["nameReservationId"] = this.nameReservationId;
        data["oldName"] = this.oldName;
        data["suffixKey"] = this.suffixKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateEntityNameInput {
        const json = this.toJSON();
        let result = new UpdateEntityNameInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateEntityNameInput {
    alternativeCompanyName: string | undefined;
    companyTypeKey: string;
    nameReservationId: string;
    oldName: string | undefined;
    suffixKey: string;
    id: string | undefined;
}

export class UpdateIncorporationDetailInput implements IUpdateIncorporationDetailInput {
    address: CreateAddressInput | undefined;
    annualRenewalDate: Date | undefined;
    entityStatusKey: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;

    constructor(data?: IUpdateIncorporationDetailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.address = data["address"] ? CreateAddressInput.fromJS(data["address"]) : <any>undefined;
            this.annualRenewalDate = data["annualRenewalDate"] ? new Date(data["annualRenewalDate"].toString()) : <any>undefined;
            this.entityStatusKey = data["entityStatusKey"];
            this.statusDate = data["statusDate"] ? new Date(data["statusDate"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateIncorporationDetailInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncorporationDetailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["annualRenewalDate"] = this.annualRenewalDate ? this.annualRenewalDate.toISOString() : <any>undefined;
        data["entityStatusKey"] = this.entityStatusKey;
        data["statusDate"] = this.statusDate ? this.statusDate.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateIncorporationDetailInput {
        const json = this.toJSON();
        let result = new UpdateIncorporationDetailInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncorporationDetailInput {
    address: CreateAddressInput | undefined;
    annualRenewalDate: Date | undefined;
    entityStatusKey: string | undefined;
    statusDate: Date | undefined;
    id: string | undefined;
}

export class UpdateIbcInsuranceClassInput implements IUpdateIbcInsuranceClassInput {
    ibcInsuranceClassKey: string | undefined;
    id: string | undefined;
    isSelected: boolean | undefined;
    statusKey: string | undefined;

    constructor(data?: IUpdateIbcInsuranceClassInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.ibcInsuranceClassKey = data["ibcInsuranceClassKey"];
            this.id = data["id"];
            this.isSelected = data["isSelected"];
            this.statusKey = data["statusKey"];
        }
    }

    static fromJS(data: any): UpdateIbcInsuranceClassInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIbcInsuranceClassInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ibcInsuranceClassKey"] = this.ibcInsuranceClassKey;
        data["id"] = this.id;
        data["isSelected"] = this.isSelected;
        data["statusKey"] = this.statusKey;
        return data; 
    }

    clone(): UpdateIbcInsuranceClassInput {
        const json = this.toJSON();
        let result = new UpdateIbcInsuranceClassInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateIbcInsuranceClassInput {
    ibcInsuranceClassKey: string | undefined;
    id: string | undefined;
    isSelected: boolean | undefined;
    statusKey: string | undefined;
}

export class UpdateRequestFeesInput implements IUpdateRequestFeesInput {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;

    constructor(data?: IUpdateRequestFeesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedTo = data["assignedTo"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(BaseRequestFeeInput.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateRequestFeesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestFeesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedTo"] = this.assignedTo;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateRequestFeesInput {
        const json = this.toJSON();
        let result = new UpdateRequestFeesInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateRequestFeesInput {
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfLookupDataDto implements IPagedResultDtoOfLookupDataDto {
    totalCount: number | undefined;
    items: LookupDataDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLookupDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(LookupDataDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLookupDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLookupDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfLookupDataDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfLookupDataDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfLookupDataDto {
    totalCount: number | undefined;
    items: LookupDataDto[] | undefined;
}

export class ChangeSecurityConfigurationsInput implements IChangeSecurityConfigurationsInput {
    durationInSeconds: number | undefined;
    maxNumberOfDaysBetweenPasswordChanges: number | undefined;
    numberOfAttempts: number | undefined;
    temporaryPasswordExpiryHours: number | undefined;

    constructor(data?: IChangeSecurityConfigurationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.durationInSeconds = data["durationInSeconds"];
            this.maxNumberOfDaysBetweenPasswordChanges = data["maxNumberOfDaysBetweenPasswordChanges"];
            this.numberOfAttempts = data["numberOfAttempts"];
            this.temporaryPasswordExpiryHours = data["temporaryPasswordExpiryHours"];
        }
    }

    static fromJS(data: any): ChangeSecurityConfigurationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeSecurityConfigurationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["durationInSeconds"] = this.durationInSeconds;
        data["maxNumberOfDaysBetweenPasswordChanges"] = this.maxNumberOfDaysBetweenPasswordChanges;
        data["numberOfAttempts"] = this.numberOfAttempts;
        data["temporaryPasswordExpiryHours"] = this.temporaryPasswordExpiryHours;
        return data; 
    }

    clone(): ChangeSecurityConfigurationsInput {
        const json = this.toJSON();
        let result = new ChangeSecurityConfigurationsInput();
        result.init(json);
        return result;
    }
}

export interface IChangeSecurityConfigurationsInput {
    durationInSeconds: number | undefined;
    maxNumberOfDaysBetweenPasswordChanges: number | undefined;
    numberOfAttempts: number | undefined;
    temporaryPasswordExpiryHours: number | undefined;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.theme = data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data; 
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class PagedResultDtoOfCountryDto implements IPagedResultDtoOfCountryDto {
    totalCount: number | undefined;
    items: CountryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(CountryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfCountryDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfCountryDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfCountryDto {
    totalCount: number | undefined;
    items: CountryDto[] | undefined;
}

export class AnalysisResultDto implements IAnalysisResultDto {
    name: string | undefined;
    value: number | undefined;

    constructor(data?: IAnalysisResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    }

    static fromJS(data: any): AnalysisResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data; 
    }

    clone(): AnalysisResultDto {
        const json = this.toJSON();
        let result = new AnalysisResultDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisResultDto {
    name: string | undefined;
    value: number | undefined;
}

export class AnalysisResultByStatusDto implements IAnalysisResultByStatusDto {
    closedCount: number | undefined;
    name: string | undefined;
    openCount: number | undefined;
    total: number | undefined;

    constructor(data?: IAnalysisResultByStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.closedCount = data["closedCount"];
            this.name = data["name"];
            this.openCount = data["openCount"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): AnalysisResultByStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisResultByStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["closedCount"] = this.closedCount;
        data["name"] = this.name;
        data["openCount"] = this.openCount;
        data["total"] = this.total;
        return data; 
    }

    clone(): AnalysisResultByStatusDto {
        const json = this.toJSON();
        let result = new AnalysisResultByStatusDto();
        result.init(json);
        return result;
    }
}

export interface IAnalysisResultByStatusDto {
    closedCount: number | undefined;
    name: string | undefined;
    openCount: number | undefined;
    total: number | undefined;
}

export class PagedResultDtoOfRequestV2Dto implements IPagedResultDtoOfRequestV2Dto {
    totalCount: number | undefined;
    items: RequestV2Dto[] | undefined;

    constructor(data?: IPagedResultDtoOfRequestV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RequestV2Dto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRequestV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRequestV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRequestV2Dto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRequestV2Dto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRequestV2Dto {
    totalCount: number | undefined;
    items: RequestV2Dto[] | undefined;
}

export class GetColumnDefinitionsOutput implements IGetColumnDefinitionsOutput {
    whfldb: string | undefined;
    whfldd: string | undefined;
    whfldi: string | undefined;
    whfldp: string | undefined;
    whftxt: string | undefined;

    constructor(data?: IGetColumnDefinitionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.whfldb = data["whfldb"];
            this.whfldd = data["whfldd"];
            this.whfldi = data["whfldi"];
            this.whfldp = data["whfldp"];
            this.whftxt = data["whftxt"];
        }
    }

    static fromJS(data: any): GetColumnDefinitionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetColumnDefinitionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["whfldb"] = this.whfldb;
        data["whfldd"] = this.whfldd;
        data["whfldi"] = this.whfldi;
        data["whfldp"] = this.whfldp;
        data["whftxt"] = this.whftxt;
        return data; 
    }

    clone(): GetColumnDefinitionsOutput {
        const json = this.toJSON();
        let result = new GetColumnDefinitionsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetColumnDefinitionsOutput {
    whfldb: string | undefined;
    whfldd: string | undefined;
    whfldi: string | undefined;
    whfldp: string | undefined;
    whftxt: string | undefined;
}

export class GetDataOutput implements IGetDataOutput {
    items: any | undefined;
    totalCount: number | undefined;

    constructor(data?: IGetDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.items = data["items"];
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): GetDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["items"] = this.items;
        data["totalCount"] = this.totalCount;
        return data; 
    }

    clone(): GetDataOutput {
        const json = this.toJSON();
        let result = new GetDataOutput();
        result.init(json);
        return result;
    }
}

export interface IGetDataOutput {
    items: any | undefined;
    totalCount: number | undefined;
}

export class GetTableDefinitionsOutput implements IGetTableDefinitionsOutput {
    tableDescription: string | undefined;
    tableName: string | undefined;
    whfile: string | undefined;

    constructor(data?: IGetTableDefinitionsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tableDescription = data["tableDescription"];
            this.tableName = data["tableName"];
            this.whfile = data["whfile"];
        }
    }

    static fromJS(data: any): GetTableDefinitionsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTableDefinitionsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableDescription"] = this.tableDescription;
        data["tableName"] = this.tableName;
        data["whfile"] = this.whfile;
        return data; 
    }

    clone(): GetTableDefinitionsOutput {
        const json = this.toJSON();
        let result = new GetTableDefinitionsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetTableDefinitionsOutput {
    tableDescription: string | undefined;
    tableName: string | undefined;
    whfile: string | undefined;
}

export class CreateDocumentInput implements ICreateDocumentInput {
    confidentialityKey: string | undefined;
    extensionData: string | undefined;
    fileName: string;
    filingDate: Date | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    statusKey: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.confidentialityKey = data["confidentialityKey"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.filingDate = data["filingDate"] ? new Date(data["filingDate"].toString()) : <any>undefined;
            this.requestId = data["requestId"];
            this.stampKey = data["stampKey"];
            this.statusKey = data["statusKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidentialityKey"] = this.confidentialityKey;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["filingDate"] = this.filingDate ? this.filingDate.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["stampKey"] = this.stampKey;
        data["statusKey"] = this.statusKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateDocumentInput {
        const json = this.toJSON();
        let result = new CreateDocumentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateDocumentInput {
    confidentialityKey: string | undefined;
    extensionData: string | undefined;
    fileName: string;
    filingDate: Date | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    statusKey: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfDocumentDto implements IPagedResultDtoOfDocumentDto {
    totalCount: number | undefined;
    items: DocumentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(DocumentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfDocumentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfDocumentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfDocumentDto {
    totalCount: number | undefined;
    items: DocumentDto[] | undefined;
}

export class UpdateDocumentInput implements IUpdateDocumentInput {
    confidentialityKey: string | undefined;
    extensionData: string | undefined;
    fileName: string;
    filingDate: Date | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    statusKey: string | undefined;
    id: string | undefined;

    constructor(data?: IUpdateDocumentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.confidentialityKey = data["confidentialityKey"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.filingDate = data["filingDate"] ? new Date(data["filingDate"].toString()) : <any>undefined;
            this.requestId = data["requestId"];
            this.stampKey = data["stampKey"];
            this.statusKey = data["statusKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateDocumentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDocumentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confidentialityKey"] = this.confidentialityKey;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["filingDate"] = this.filingDate ? this.filingDate.toISOString() : <any>undefined;
        data["requestId"] = this.requestId;
        data["stampKey"] = this.stampKey;
        data["statusKey"] = this.statusKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateDocumentInput {
        const json = this.toJSON();
        let result = new UpdateDocumentInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateDocumentInput {
    confidentialityKey: string | undefined;
    extensionData: string | undefined;
    fileName: string;
    filingDate: Date | undefined;
    requestId: string | undefined;
    stampKey: string | undefined;
    statusKey: string | undefined;
    id: string | undefined;
}

export class VerifyCertificateInput implements IVerifyCertificateInput {
    certificateCode: string | undefined;

    constructor(data?: IVerifyCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.certificateCode = data["certificateCode"];
        }
    }

    static fromJS(data: any): VerifyCertificateInput {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateCode"] = this.certificateCode;
        return data; 
    }

    clone(): VerifyCertificateInput {
        const json = this.toJSON();
        let result = new VerifyCertificateInput();
        result.init(json);
        return result;
    }
}

export interface IVerifyCertificateInput {
    certificateCode: string | undefined;
}

export class CertificateAuthenticityDto implements ICertificateAuthenticityDto {
    companyTypeName: string | undefined;
    incorporationNumber: string | undefined;
    certificateName: string | undefined;
    creationTime: Date | undefined;
    isRequestFeeCertificateDeleted: boolean | undefined;
    requestFeeCertificateLastUpdated: Date | undefined;

    constructor(data?: ICertificateAuthenticityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyTypeName = data["companyTypeName"];
            this.incorporationNumber = data["incorporationNumber"];
            this.certificateName = data["certificateName"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.isRequestFeeCertificateDeleted = data["isRequestFeeCertificateDeleted"];
            this.requestFeeCertificateLastUpdated = data["requestFeeCertificateLastUpdated"] ? new Date(data["requestFeeCertificateLastUpdated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CertificateAuthenticityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateAuthenticityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyTypeName"] = this.companyTypeName;
        data["incorporationNumber"] = this.incorporationNumber;
        data["certificateName"] = this.certificateName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["isRequestFeeCertificateDeleted"] = this.isRequestFeeCertificateDeleted;
        data["requestFeeCertificateLastUpdated"] = this.requestFeeCertificateLastUpdated ? this.requestFeeCertificateLastUpdated.toISOString() : <any>undefined;
        return data; 
    }

    clone(): CertificateAuthenticityDto {
        const json = this.toJSON();
        let result = new CertificateAuthenticityDto();
        result.init(json);
        return result;
    }
}

export interface ICertificateAuthenticityDto {
    companyTypeName: string | undefined;
    incorporationNumber: string | undefined;
    certificateName: string | undefined;
    creationTime: Date | undefined;
    isRequestFeeCertificateDeleted: boolean | undefined;
    requestFeeCertificateLastUpdated: Date | undefined;
}

export class MailMessageDto implements IMailMessageDto {
    body: string | undefined;
    from: string | undefined;
    subject: string | undefined;
    to: string | undefined;

    constructor(data?: IMailMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.body = data["body"];
            this.from = data["from"];
            this.subject = data["subject"];
            this.to = data["to"];
        }
    }

    static fromJS(data: any): MailMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MailMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["from"] = this.from;
        data["subject"] = this.subject;
        data["to"] = this.to;
        return data; 
    }

    clone(): MailMessageDto {
        const json = this.toJSON();
        let result = new MailMessageDto();
        result.init(json);
        return result;
    }
}

export interface IMailMessageDto {
    body: string | undefined;
    from: string | undefined;
    subject: string | undefined;
    to: string | undefined;
}

export class EntityActivityCreateDto implements IEntityActivityCreateDto {
    entityID: string | undefined;
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;

    constructor(data?: IEntityActivityCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityID = data["entityID"];
            this.activityName = data["activityName"];
            this.activityDate = data["activityDate"] ? new Date(data["activityDate"].toString()) : <any>undefined;
            this.feeDescription = data["feeDescription"];
            this.feeCode = data["feeCode"];
            this.feeAmountEC = data["feeAmountEC"];
            this.feeAmountUSD = data["feeAmountUSD"];
            this.licenseYear = data["licenseYear"];
        }
    }

    static fromJS(data: any): EntityActivityCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityActivityCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityID"] = this.entityID;
        data["activityName"] = this.activityName;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["feeDescription"] = this.feeDescription;
        data["feeCode"] = this.feeCode;
        data["feeAmountEC"] = this.feeAmountEC;
        data["feeAmountUSD"] = this.feeAmountUSD;
        data["licenseYear"] = this.licenseYear;
        return data; 
    }

    clone(): EntityActivityCreateDto {
        const json = this.toJSON();
        let result = new EntityActivityCreateDto();
        result.init(json);
        return result;
    }
}

export interface IEntityActivityCreateDto {
    entityID: string | undefined;
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;
}

export class EntityActivityDto implements IEntityActivityDto {
    entityTypeID: string | undefined;
    entityTypeName: string | undefined;
    entityID: string | undefined;
    entityName: string | undefined;
    entityIncoperationNumber: string | undefined;
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;
    id: string | undefined;

    constructor(data?: IEntityActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityTypeID = data["entityTypeID"];
            this.entityTypeName = data["entityTypeName"];
            this.entityID = data["entityID"];
            this.entityName = data["entityName"];
            this.entityIncoperationNumber = data["entityIncoperationNumber"];
            this.activityName = data["activityName"];
            this.activityDate = data["activityDate"] ? new Date(data["activityDate"].toString()) : <any>undefined;
            this.feeDescription = data["feeDescription"];
            this.feeCode = data["feeCode"];
            this.feeAmountEC = data["feeAmountEC"];
            this.feeAmountUSD = data["feeAmountUSD"];
            this.licenseYear = data["licenseYear"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityTypeID"] = this.entityTypeID;
        data["entityTypeName"] = this.entityTypeName;
        data["entityID"] = this.entityID;
        data["entityName"] = this.entityName;
        data["entityIncoperationNumber"] = this.entityIncoperationNumber;
        data["activityName"] = this.activityName;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["feeDescription"] = this.feeDescription;
        data["feeCode"] = this.feeCode;
        data["feeAmountEC"] = this.feeAmountEC;
        data["feeAmountUSD"] = this.feeAmountUSD;
        data["licenseYear"] = this.licenseYear;
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityActivityDto {
        const json = this.toJSON();
        let result = new EntityActivityDto();
        result.init(json);
        return result;
    }
}

export interface IEntityActivityDto {
    entityTypeID: string | undefined;
    entityTypeName: string | undefined;
    entityID: string | undefined;
    entityName: string | undefined;
    entityIncoperationNumber: string | undefined;
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfEntityActivityDto implements IPagedResultDtoOfEntityActivityDto {
    totalCount: number | undefined;
    items: EntityActivityDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(EntityActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfEntityActivityDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEntityActivityDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEntityActivityDto {
    totalCount: number | undefined;
    items: EntityActivityDto[] | undefined;
}

export class EntityActivityUpdateDto implements IEntityActivityUpdateDto {
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;
    id: string | undefined;

    constructor(data?: IEntityActivityUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityName = data["activityName"];
            this.activityDate = data["activityDate"] ? new Date(data["activityDate"].toString()) : <any>undefined;
            this.feeDescription = data["feeDescription"];
            this.feeCode = data["feeCode"];
            this.feeAmountEC = data["feeAmountEC"];
            this.feeAmountUSD = data["feeAmountUSD"];
            this.licenseYear = data["licenseYear"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityActivityUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityActivityUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityName"] = this.activityName;
        data["activityDate"] = this.activityDate ? this.activityDate.toISOString() : <any>undefined;
        data["feeDescription"] = this.feeDescription;
        data["feeCode"] = this.feeCode;
        data["feeAmountEC"] = this.feeAmountEC;
        data["feeAmountUSD"] = this.feeAmountUSD;
        data["licenseYear"] = this.licenseYear;
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityActivityUpdateDto {
        const json = this.toJSON();
        let result = new EntityActivityUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IEntityActivityUpdateDto {
    activityName: string | undefined;
    activityDate: Date | undefined;
    feeDescription: string | undefined;
    feeCode: number | undefined;
    feeAmountEC: number | undefined;
    feeAmountUSD: number | undefined;
    licenseYear: number | undefined;
    id: string | undefined;
}

export class GetAllEntityPropertyChangeInput implements IGetAllEntityPropertyChangeInput {
    changeTimeFrom: Date | undefined;
    changeTimeTo: Date | undefined;
    entityId: string[];
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IGetAllEntityPropertyChangeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.entityId = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.changeTimeFrom = data["changeTimeFrom"] ? new Date(data["changeTimeFrom"].toString()) : <any>undefined;
            this.changeTimeTo = data["changeTimeTo"] ? new Date(data["changeTimeTo"].toString()) : <any>undefined;
            if (data["entityId"] && data["entityId"].constructor === Array) {
                this.entityId = [] as any;
                for (let item of data["entityId"])
                    this.entityId.push(item);
            }
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetAllEntityPropertyChangeInput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntityPropertyChangeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeTimeFrom"] = this.changeTimeFrom ? this.changeTimeFrom.toISOString() : <any>undefined;
        data["changeTimeTo"] = this.changeTimeTo ? this.changeTimeTo.toISOString() : <any>undefined;
        if (this.entityId && this.entityId.constructor === Array) {
            data["entityId"] = [];
            for (let item of this.entityId)
                data["entityId"].push(item);
        }
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): GetAllEntityPropertyChangeInput {
        const json = this.toJSON();
        let result = new GetAllEntityPropertyChangeInput();
        result.init(json);
        return result;
    }
}

export interface IGetAllEntityPropertyChangeInput {
    changeTimeFrom: Date | undefined;
    changeTimeTo: Date | undefined;
    entityId: string[];
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfGetAllEntityPropertyChangeOutput implements IPagedResultDtoOfGetAllEntityPropertyChangeOutput {
    totalCount: number | undefined;
    items: GetAllEntityPropertyChangeOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllEntityPropertyChangeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllEntityPropertyChangeOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllEntityPropertyChangeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllEntityPropertyChangeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllEntityPropertyChangeOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllEntityPropertyChangeOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllEntityPropertyChangeOutput {
    totalCount: number | undefined;
    items: GetAllEntityPropertyChangeOutput[] | undefined;
}

export class GetAllEntityPropertyChangeOutput implements IGetAllEntityPropertyChangeOutput {
    changeTime: Date | undefined;
    newValue: string | undefined;
    originalValue: string | undefined;
    portalName: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    userName: string | undefined;
    id: number | undefined;

    constructor(data?: IGetAllEntityPropertyChangeOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.changeTime = data["changeTime"] ? new Date(data["changeTime"].toString()) : <any>undefined;
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.portalName = data["portalName"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.userName = data["userName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllEntityPropertyChangeOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllEntityPropertyChangeOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : <any>undefined;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["portalName"] = this.portalName;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["userName"] = this.userName;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllEntityPropertyChangeOutput {
        const json = this.toJSON();
        let result = new GetAllEntityPropertyChangeOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllEntityPropertyChangeOutput {
    changeTime: Date | undefined;
    newValue: string | undefined;
    originalValue: string | undefined;
    portalName: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    userName: string | undefined;
    id: number | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    id: number | undefined;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityPropertyChangeDto {
        const json = this.toJSON();
        let result = new EntityPropertyChangeDto();
        result.init(json);
        return result;
    }
}

export interface IEntityPropertyChangeDto {
    id: number | undefined;
}

export class PagedResultDtoOfEntityPropertyChangeDto implements IPagedResultDtoOfEntityPropertyChangeDto {
    totalCount: number | undefined;
    items: EntityPropertyChangeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(EntityPropertyChangeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfEntityPropertyChangeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfEntityPropertyChangeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfEntityPropertyChangeDto {
    totalCount: number | undefined;
    items: EntityPropertyChangeDto[] | undefined;
}

export class FeeGatewayCreateDto implements IFeeGatewayCreateDto {
    activityCodeKey: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    extensionData: string | undefined;
    feeDescription: string;
    financialAccountId: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IFeeGatewayCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityCodeKey = data["activityCodeKey"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.companyTypeKey = data["companyTypeKey"];
            this.extensionData = data["extensionData"];
            this.feeDescription = data["feeDescription"];
            this.financialAccountId = data["financialAccountId"];
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.isOptional = data["isOptional"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): FeeGatewayCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeGatewayCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityCodeKey"] = this.activityCodeKey;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["companyTypeKey"] = this.companyTypeKey;
        data["extensionData"] = this.extensionData;
        data["feeDescription"] = this.feeDescription;
        data["financialAccountId"] = this.financialAccountId;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isOptional"] = this.isOptional;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): FeeGatewayCreateDto {
        const json = this.toJSON();
        let result = new FeeGatewayCreateDto();
        result.init(json);
        return result;
    }
}

export interface IFeeGatewayCreateDto {
    activityCodeKey: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    extensionData: string | undefined;
    feeDescription: string;
    financialAccountId: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class FeeGatewayDto implements IFeeGatewayDto {
    activityCodeKey: string | undefined;
    activityDescription: string | undefined;
    allowMultiple: boolean | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    companyTypeName: string;
    extensionData: string | undefined;
    feeCode: number | undefined;
    feeDescription: string;
    financialAccount: FinancialAccountDto | undefined;
    readonly financialAccountDescription: string | undefined;
    financialAccountId: string | undefined;
    readonly financialAccountNumber: string | undefined;
    readonly financialAccountNumberWithDescription: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    readonly serviceTypeName: string | undefined;
    serviceTypes: ServiceTypeGatewayDto[] | undefined;
    tags: TagDto[] | undefined;

    constructor(data?: IFeeGatewayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityCodeKey = data["activityCodeKey"];
            this.activityDescription = data["activityDescription"];
            this.allowMultiple = data["allowMultiple"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.extensionData = data["extensionData"];
            this.feeCode = data["feeCode"];
            this.feeDescription = data["feeDescription"];
            this.financialAccount = data["financialAccount"] ? FinancialAccountDto.fromJS(data["financialAccount"]) : <any>undefined;
            (<any>this).financialAccountDescription = data["financialAccountDescription"];
            this.financialAccountId = data["financialAccountId"];
            (<any>this).financialAccountNumber = data["financialAccountNumber"];
            (<any>this).financialAccountNumberWithDescription = data["financialAccountNumberWithDescription"];
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.isOptional = data["isOptional"];
            (<any>this).serviceTypeName = data["serviceTypeName"];
            if (data["serviceTypes"] && data["serviceTypes"].constructor === Array) {
                this.serviceTypes = [] as any;
                for (let item of data["serviceTypes"])
                    this.serviceTypes.push(ServiceTypeGatewayDto.fromJS(item));
            }
            if (data["tags"] && data["tags"].constructor === Array) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags.push(TagDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeeGatewayDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeGatewayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityCodeKey"] = this.activityCodeKey;
        data["activityDescription"] = this.activityDescription;
        data["allowMultiple"] = this.allowMultiple;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["extensionData"] = this.extensionData;
        data["feeCode"] = this.feeCode;
        data["feeDescription"] = this.feeDescription;
        data["financialAccount"] = this.financialAccount ? this.financialAccount.toJSON() : <any>undefined;
        data["financialAccountDescription"] = this.financialAccountDescription;
        data["financialAccountId"] = this.financialAccountId;
        data["financialAccountNumber"] = this.financialAccountNumber;
        data["financialAccountNumberWithDescription"] = this.financialAccountNumberWithDescription;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isOptional"] = this.isOptional;
        data["serviceTypeName"] = this.serviceTypeName;
        if (this.serviceTypes && this.serviceTypes.constructor === Array) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item.toJSON());
        }
        if (this.tags && this.tags.constructor === Array) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FeeGatewayDto {
        const json = this.toJSON();
        let result = new FeeGatewayDto();
        result.init(json);
        return result;
    }
}

export interface IFeeGatewayDto {
    activityCodeKey: string | undefined;
    activityDescription: string | undefined;
    allowMultiple: boolean | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    companyTypeName: string;
    extensionData: string | undefined;
    feeCode: number | undefined;
    feeDescription: string;
    financialAccount: FinancialAccountDto | undefined;
    financialAccountDescription: string | undefined;
    financialAccountId: string | undefined;
    financialAccountNumber: string | undefined;
    financialAccountNumberWithDescription: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    serviceTypeName: string | undefined;
    serviceTypes: ServiceTypeGatewayDto[] | undefined;
    tags: TagDto[] | undefined;
}

export class ServiceTypeGatewayDto implements IServiceTypeGatewayDto {
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;

    constructor(data?: IServiceTypeGatewayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.serviceTypeKey = data["serviceTypeKey"];
            this.serviceTypeName = data["serviceTypeName"];
        }
    }

    static fromJS(data: any): ServiceTypeGatewayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeGatewayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceTypeKey"] = this.serviceTypeKey;
        data["serviceTypeName"] = this.serviceTypeName;
        return data; 
    }

    clone(): ServiceTypeGatewayDto {
        const json = this.toJSON();
        let result = new ServiceTypeGatewayDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTypeGatewayDto {
    serviceTypeKey: string | undefined;
    serviceTypeName: string | undefined;
}

export class PagedResultDtoOfFeeGatewayDto implements IPagedResultDtoOfFeeGatewayDto {
    totalCount: number | undefined;
    items: FeeGatewayDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFeeGatewayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FeeGatewayDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFeeGatewayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFeeGatewayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFeeGatewayDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFeeGatewayDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFeeGatewayDto {
    totalCount: number | undefined;
    items: FeeGatewayDto[] | undefined;
}

export class FeeGatewayUpdateDto implements IFeeGatewayUpdateDto {
    activityCodeKey: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    extensionData: string | undefined;
    feeDescription: string;
    financialAccountId: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IFeeGatewayUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.activityCodeKey = data["activityCodeKey"];
            this.alternativeAmount = data["alternativeAmount"];
            this.amount = data["amount"];
            this.companyTypeKey = data["companyTypeKey"];
            this.extensionData = data["extensionData"];
            this.feeDescription = data["feeDescription"];
            this.financialAccountId = data["financialAccountId"];
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.isOptional = data["isOptional"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): FeeGatewayUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeeGatewayUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityCodeKey"] = this.activityCodeKey;
        data["alternativeAmount"] = this.alternativeAmount;
        data["amount"] = this.amount;
        data["companyTypeKey"] = this.companyTypeKey;
        data["extensionData"] = this.extensionData;
        data["feeDescription"] = this.feeDescription;
        data["financialAccountId"] = this.financialAccountId;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["isOptional"] = this.isOptional;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): FeeGatewayUpdateDto {
        const json = this.toJSON();
        let result = new FeeGatewayUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IFeeGatewayUpdateDto {
    activityCodeKey: string | undefined;
    alternativeAmount: number | undefined;
    amount: number | undefined;
    companyTypeKey: string;
    extensionData: string | undefined;
    feeDescription: string;
    financialAccountId: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    isOptional: boolean | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id: string | undefined;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }

    clone(): EntityDtoOfGuid {
        const json = this.toJSON();
        let result = new EntityDtoOfGuid();
        result.init(json);
        return result;
    }
}

export interface IEntityDtoOfGuid {
    id: string | undefined;
}

export class FileRecordDto implements IFileRecordDto {
    contentType: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    lastModificationTime: Date | undefined;
    length: number | undefined;
    id: string | undefined;

    constructor(data?: IFileRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = data["creatorUserId"];
            this.creatorUserName = data["creatorUserName"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.length = data["length"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): FileRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserName"] = this.creatorUserName;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["length"] = this.length;
        data["id"] = this.id;
        return data; 
    }

    clone(): FileRecordDto {
        const json = this.toJSON();
        let result = new FileRecordDto();
        result.init(json);
        return result;
    }
}

export interface IFileRecordDto {
    contentType: string | undefined;
    creationTime: Date | undefined;
    creatorUserId: number | undefined;
    creatorUserName: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    lastModificationTime: Date | undefined;
    length: number | undefined;
    id: string | undefined;
}

export class CreateFileRecordInput implements ICreateFileRecordInput {
    contentType: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    length: number | undefined;
    id: string | undefined;

    constructor(data?: ICreateFileRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.length = data["length"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateFileRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["length"] = this.length;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateFileRecordInput {
        const json = this.toJSON();
        let result = new CreateFileRecordInput();
        result.init(json);
        return result;
    }
}

export interface ICreateFileRecordInput {
    contentType: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    length: number | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfFileRecordDto implements IPagedResultDtoOfFileRecordDto {
    totalCount: number | undefined;
    items: FileRecordDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFileRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FileRecordDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFileRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFileRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFileRecordDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFileRecordDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFileRecordDto {
    totalCount: number | undefined;
    items: FileRecordDto[] | undefined;
}

export class UpdateFileRecordInput implements IUpdateFileRecordInput {
    contentType: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    length: number | undefined;
    id: string | undefined;

    constructor(data?: IUpdateFileRecordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.contentType = data["contentType"];
            this.extensionData = data["extensionData"];
            this.fileName = data["fileName"];
            this.length = data["length"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateFileRecordInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileRecordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentType"] = this.contentType;
        data["extensionData"] = this.extensionData;
        data["fileName"] = this.fileName;
        data["length"] = this.length;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateFileRecordInput {
        const json = this.toJSON();
        let result = new UpdateFileRecordInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateFileRecordInput {
    contentType: string | undefined;
    extensionData: string | undefined;
    fileName: string | undefined;
    length: number | undefined;
    id: string | undefined;
}

export class AddFundsInput implements IAddFundsInput {
    bank: string | undefined;
    chequeNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    paymentTypeName: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    transactionCurrencyKey: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionTypeKey: string | undefined;
    transactionTypeName: string | undefined;

    constructor(data?: IAddFundsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"];
            this.chequeNumber = data["chequeNumber"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeKey = data["paymentTypeKey"];
            this.paymentTypeName = data["paymentTypeName"];
            this.registeredAgentAccountNumber = data["registeredAgentAccountNumber"];
            this.registeredAgentID = data["registeredAgentID"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestedFromCR = data["requestedFromCR"];
            this.transactionCurrencyKey = data["transactionCurrencyKey"];
            this.transactionCurrencyName = data["transactionCurrencyName"];
            this.transactionTypeKey = data["transactionTypeKey"];
            this.transactionTypeName = data["transactionTypeName"];
        }
    }

    static fromJS(data: any): AddFundsInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddFundsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["chequeNumber"] = this.chequeNumber;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeKey"] = this.paymentTypeKey;
        data["paymentTypeName"] = this.paymentTypeName;
        data["registeredAgentAccountNumber"] = this.registeredAgentAccountNumber;
        data["registeredAgentID"] = this.registeredAgentID;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestedFromCR"] = this.requestedFromCR;
        data["transactionCurrencyKey"] = this.transactionCurrencyKey;
        data["transactionCurrencyName"] = this.transactionCurrencyName;
        data["transactionTypeKey"] = this.transactionTypeKey;
        data["transactionTypeName"] = this.transactionTypeName;
        return data; 
    }

    clone(): AddFundsInput {
        const json = this.toJSON();
        let result = new AddFundsInput();
        result.init(json);
        return result;
    }
}

export interface IAddFundsInput {
    bank: string | undefined;
    chequeNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    paymentTypeName: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    transactionCurrencyKey: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionTypeKey: string | undefined;
    transactionTypeName: string | undefined;
}

export class PagedResultDtoOfFinancialAccountDto implements IPagedResultDtoOfFinancialAccountDto {
    totalCount: number | undefined;
    items: FinancialAccountDto[] | undefined;

    constructor(data?: IPagedResultDtoOfFinancialAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FinancialAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFinancialAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFinancialAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFinancialAccountDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFinancialAccountDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFinancialAccountDto {
    totalCount: number | undefined;
    items: FinancialAccountDto[] | undefined;
}

export class RegisteredAgentAlarmDto implements IRegisteredAgentAlarmDto {
    registeredAgentID: string | undefined;
    minAmount: number | undefined;
    currentBalance: number | undefined;

    constructor(data?: IRegisteredAgentAlarmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registeredAgentID = data["registeredAgentID"];
            this.minAmount = data["minAmount"];
            this.currentBalance = data["currentBalance"];
        }
    }

    static fromJS(data: any): RegisteredAgentAlarmDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredAgentAlarmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredAgentID"] = this.registeredAgentID;
        data["minAmount"] = this.minAmount;
        data["currentBalance"] = this.currentBalance;
        return data; 
    }

    clone(): RegisteredAgentAlarmDto {
        const json = this.toJSON();
        let result = new RegisteredAgentAlarmDto();
        result.init(json);
        return result;
    }
}

export interface IRegisteredAgentAlarmDto {
    registeredAgentID: string | undefined;
    minAmount: number | undefined;
    currentBalance: number | undefined;
}

export class PagedResultDtoOfGetAllRAAccountBalanceDto implements IPagedResultDtoOfGetAllRAAccountBalanceDto {
    totalCount: number | undefined;
    items: GetAllRAAccountBalanceDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllRAAccountBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllRAAccountBalanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllRAAccountBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllRAAccountBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllRAAccountBalanceDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllRAAccountBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllRAAccountBalanceDto {
    totalCount: number | undefined;
    items: GetAllRAAccountBalanceDto[] | undefined;
}

export class GetAllRAAccountBalanceDto implements IGetAllRAAccountBalanceDto {
    registeredAgentID: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentName: string | undefined;
    balanceEC: number | undefined;
    isRegisteredAgentActive: boolean | undefined;

    constructor(data?: IGetAllRAAccountBalanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registeredAgentID = data["registeredAgentID"];
            this.registeredAgentAccountNumber = data["registeredAgentAccountNumber"];
            this.registeredAgentName = data["registeredAgentName"];
            this.balanceEC = data["balanceEC"];
            this.isRegisteredAgentActive = data["isRegisteredAgentActive"];
        }
    }

    static fromJS(data: any): GetAllRAAccountBalanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRAAccountBalanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredAgentID"] = this.registeredAgentID;
        data["registeredAgentAccountNumber"] = this.registeredAgentAccountNumber;
        data["registeredAgentName"] = this.registeredAgentName;
        data["balanceEC"] = this.balanceEC;
        data["isRegisteredAgentActive"] = this.isRegisteredAgentActive;
        return data; 
    }

    clone(): GetAllRAAccountBalanceDto {
        const json = this.toJSON();
        let result = new GetAllRAAccountBalanceDto();
        result.init(json);
        return result;
    }
}

export interface IGetAllRAAccountBalanceDto {
    registeredAgentID: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentName: string | undefined;
    balanceEC: number | undefined;
    isRegisteredAgentActive: boolean | undefined;
}

export class RegisteredAgentAlarmInput implements IRegisteredAgentAlarmInput {
    registeredAgentID: string | undefined;
    minAmount: number | undefined;

    constructor(data?: IRegisteredAgentAlarmInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.registeredAgentID = data["registeredAgentID"];
            this.minAmount = data["minAmount"];
        }
    }

    static fromJS(data: any): RegisteredAgentAlarmInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredAgentAlarmInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registeredAgentID"] = this.registeredAgentID;
        data["minAmount"] = this.minAmount;
        return data; 
    }

    clone(): RegisteredAgentAlarmInput {
        const json = this.toJSON();
        let result = new RegisteredAgentAlarmInput();
        result.init(json);
        return result;
    }
}

export interface IRegisteredAgentAlarmInput {
    registeredAgentID: string | undefined;
    minAmount: number | undefined;
}

export class UpdateFinancialAccountInput implements IUpdateFinancialAccountInput {
    overrideDescription: boolean | undefined;
    accountNumber: string;
    description: string | undefined;
    extensionData: string | undefined;
    financialAccountTypeKey: string;
    financialAccountTypeName: string | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    id: string | undefined;

    constructor(data?: IUpdateFinancialAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.overrideDescription = data["overrideDescription"];
            this.accountNumber = data["accountNumber"];
            this.description = data["description"];
            this.extensionData = data["extensionData"];
            this.financialAccountTypeKey = data["financialAccountTypeKey"];
            this.financialAccountTypeName = data["financialAccountTypeName"];
            this.isActive = data["isActive"];
            this.isEditable = data["isEditable"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateFinancialAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overrideDescription"] = this.overrideDescription;
        data["accountNumber"] = this.accountNumber;
        data["description"] = this.description;
        data["extensionData"] = this.extensionData;
        data["financialAccountTypeKey"] = this.financialAccountTypeKey;
        data["financialAccountTypeName"] = this.financialAccountTypeName;
        data["isActive"] = this.isActive;
        data["isEditable"] = this.isEditable;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateFinancialAccountInput {
        const json = this.toJSON();
        let result = new UpdateFinancialAccountInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateFinancialAccountInput {
    overrideDescription: boolean | undefined;
    accountNumber: string;
    description: string | undefined;
    extensionData: string | undefined;
    financialAccountTypeKey: string;
    financialAccountTypeName: string | undefined;
    isActive: boolean | undefined;
    isEditable: boolean | undefined;
    id: string | undefined;
}

export class CreateLookupDataInputWrapper implements ICreateLookupDataInputWrapper {
    key: string | undefined;
    lookupDataTypeKey: string | undefined;
    name: string | undefined;
    sortIndex: number | undefined;
    id: string | undefined;

    constructor(data?: ICreateLookupDataInputWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.key = data["key"];
            this.lookupDataTypeKey = data["lookupDataTypeKey"];
            this.name = data["name"];
            this.sortIndex = data["sortIndex"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateLookupDataInputWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLookupDataInputWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["lookupDataTypeKey"] = this.lookupDataTypeKey;
        data["name"] = this.name;
        data["sortIndex"] = this.sortIndex;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateLookupDataInputWrapper {
        const json = this.toJSON();
        let result = new CreateLookupDataInputWrapper();
        result.init(json);
        return result;
    }
}

export interface ICreateLookupDataInputWrapper {
    key: string | undefined;
    lookupDataTypeKey: string | undefined;
    name: string | undefined;
    sortIndex: number | undefined;
    id: string | undefined;
}

export class CheckNameDtoInput implements ICheckNameDtoInput {
    companyName: string | undefined;
    currentNameReservationRequestId: string | undefined;
    id: string | undefined;
    includePendingNameReservation: boolean | undefined;
    includeWarnings: boolean | undefined;
    registeredAgentId: string | undefined;
    companyTypeKey: string | undefined;

    constructor(data?: ICheckNameDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyName = data["companyName"];
            this.currentNameReservationRequestId = data["currentNameReservationRequestId"];
            this.id = data["id"];
            this.includePendingNameReservation = data["includePendingNameReservation"];
            this.includeWarnings = data["includeWarnings"];
            this.registeredAgentId = data["registeredAgentId"];
            this.companyTypeKey = data["companyTypeKey"];

        }
    }

    static fromJS(data: any): CheckNameDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNameDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["currentNameReservationRequestId"] = this.currentNameReservationRequestId;
        data["id"] = this.id;
        data["includePendingNameReservation"] = this.includePendingNameReservation;
        data["includeWarnings"] = this.includeWarnings;
        data["registeredAgentId"] = this.registeredAgentId;
        data["companyTypeKey"] = this.companyTypeKey;

        return data; 
    }

    clone(): CheckNameDtoInput {
        const json = this.toJSON();
        let result = new CheckNameDtoInput();
        result.init(json);
        return result;
    }
}

export interface ICheckNameDtoInput {
    companyName: string | undefined;
    currentNameReservationRequestId: string | undefined;
    id: string | undefined;
    includePendingNameReservation: boolean | undefined;
    includeWarnings: boolean | undefined;
    registeredAgentId: string | undefined;
    companyTypeKey: string | undefined;

}

export class CheckNameDtoOutput implements ICheckNameDtoOutput {
    fuzzyMatchNames: string[] | undefined;
    hasProhibitedWords: boolean | undefined;
    hasRestrictedWords: boolean | undefined;
    restrictedWordFeeRequired: boolean | undefined;
    spcialCharacterFeeRequired: boolean | undefined;
    hasSpecialCharacters: boolean | undefined;
    readonly isValid: boolean | undefined;
    nameAlreadyInUse: boolean | undefined;
    nameBeingReserveredForSameRA: boolean | undefined;
    prohibitedWords: string[] | undefined;
    restrictedWords: string[] | undefined;
    similarNames: string[] | undefined;

    constructor(data?: ICheckNameDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["fuzzyMatchNames"] && data["fuzzyMatchNames"].constructor === Array) {
                this.fuzzyMatchNames = [] as any;
                for (let item of data["fuzzyMatchNames"])
                    this.fuzzyMatchNames.push(item);
            }
            this.hasProhibitedWords = data["hasProhibitedWords"];
            this.hasRestrictedWords = data["hasRestrictedWords"];
            this.restrictedWordFeeRequired = data["restrictedWordFeeRequired"];
            this.spcialCharacterFeeRequired = data["spcialCharacterFeeRequired"];
            this.hasSpecialCharacters = data["hasSpecialCharacters"];
            (<any>this).isValid = data["isValid"];
            this.nameAlreadyInUse = data["nameAlreadyInUse"];
            this.nameBeingReserveredForSameRA = data["nameBeingReserveredForSameRA"];
            if (data["prohibitedWords"] && data["prohibitedWords"].constructor === Array) {
                this.prohibitedWords = [] as any;
                for (let item of data["prohibitedWords"])
                    this.prohibitedWords.push(item);
            }
            if (data["restrictedWords"] && data["restrictedWords"].constructor === Array) {
                this.restrictedWords = [] as any;
                for (let item of data["restrictedWords"])
                    this.restrictedWords.push(item);
            }
            if (data["similarNames"] && data["similarNames"].constructor === Array) {
                this.similarNames = [] as any;
                for (let item of data["similarNames"])
                    this.similarNames.push(item);
            }
        }
    }

    static fromJS(data: any): CheckNameDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckNameDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.fuzzyMatchNames && this.fuzzyMatchNames.constructor === Array) {
            data["fuzzyMatchNames"] = [];
            for (let item of this.fuzzyMatchNames)
                data["fuzzyMatchNames"].push(item);
        }
        data["hasProhibitedWords"] = this.hasProhibitedWords;
        data["hasRestrictedWords"] = this.hasRestrictedWords;
        data["restrictedWordFeeRequired"] = this.restrictedWordFeeRequired;
        data["spcialCharacterFeeRequired"] = this.spcialCharacterFeeRequired;
        data["hasSpecialCharacters"] = this.hasSpecialCharacters;
        data["isValid"] = this.isValid;
        data["nameAlreadyInUse"] = this.nameAlreadyInUse;
        data["nameBeingReserveredForSameRA"] = this.nameBeingReserveredForSameRA;
        if (this.prohibitedWords && this.prohibitedWords.constructor === Array) {
            data["prohibitedWords"] = [];
            for (let item of this.prohibitedWords)
                data["prohibitedWords"].push(item);
        }
        if (this.restrictedWords && this.restrictedWords.constructor === Array) {
            data["restrictedWords"] = [];
            for (let item of this.restrictedWords)
                data["restrictedWords"].push(item);
        }
        if (this.similarNames && this.similarNames.constructor === Array) {
            data["similarNames"] = [];
            for (let item of this.similarNames)
                data["similarNames"].push(item);
        }
        return data; 
    }

    clone(): CheckNameDtoOutput {
        const json = this.toJSON();
        let result = new CheckNameDtoOutput();
        result.init(json);
        return result;
    }
}

export interface ICheckNameDtoOutput {
    fuzzyMatchNames: string[] | undefined;
    hasProhibitedWords: boolean | undefined;
    hasRestrictedWords: boolean | undefined;
    restrictedWordFeeRequired: boolean | undefined;
    spcialCharacterFeeRequired: boolean | undefined;
    hasSpecialCharacters: boolean | undefined;
    isValid: boolean | undefined;
    nameAlreadyInUse: boolean | undefined;
    nameBeingReserveredForSameRA: boolean | undefined;
    prohibitedWords: string[] | undefined;
    restrictedWords: string[] | undefined;
    similarNames: string[] | undefined;
}

export class NameReservationCreateDto implements INameReservationCreateDto {
    alternativeCompanyName: string | undefined;
    comments: string | undefined;
    companyTypeName: string;
    notes: string | undefined;
    registeredAgentName: string;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    autoComplete: boolean | undefined;
    companyName: string;
    companyTypeKey: string;
    internalStatusKey: string | undefined;
    isRenewal: boolean | undefined;
    nameHasWarning: boolean | undefined;
    registeredAgentID: string;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestServiceFees: BaseRequestFeeInput[];
    reservationDurationDays: number;
    reservationDurationKey: string;
    reservationStatusKey: string | undefined;
    suffix: string;
    suffixKey: string;
    updateReservationStatus: boolean | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    warningOverriddenByUser: boolean | undefined;
    id: string | undefined;

    constructor(data?: INameReservationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestServiceFees = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.comments = data["comments"];
            this.companyTypeName = data["companyTypeName"];
            this.notes = data["notes"];
            this.registeredAgentName = data["registeredAgentName"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedTo = data["assignedTo"];
            this.autoComplete = data["autoComplete"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.internalStatusKey = data["internalStatusKey"];
            this.isRenewal = data["isRenewal"];
            this.nameHasWarning = data["nameHasWarning"];
            this.registeredAgentID = data["registeredAgentID"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestServiceFees"] && data["requestServiceFees"].constructor === Array) {
                this.requestServiceFees = [] as any;
                for (let item of data["requestServiceFees"])
                    this.requestServiceFees.push(BaseRequestFeeInput.fromJS(item));
            }
            this.reservationDurationDays = data["reservationDurationDays"];
            this.reservationDurationKey = data["reservationDurationKey"];
            this.reservationStatusKey = data["reservationStatusKey"];
            this.suffix = data["suffix"];
            this.suffixKey = data["suffixKey"];
            this.updateReservationStatus = data["updateReservationStatus"];
            this.warningOverridden = data["warningOverridden"];
            this.warningOverriddenById = data["warningOverriddenById"];
            this.warningOverriddenByUser = data["warningOverriddenByUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NameReservationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameReservationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["comments"] = this.comments;
        data["companyTypeName"] = this.companyTypeName;
        data["notes"] = this.notes;
        data["registeredAgentName"] = this.registeredAgentName;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedTo"] = this.assignedTo;
        data["autoComplete"] = this.autoComplete;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["internalStatusKey"] = this.internalStatusKey;
        data["isRenewal"] = this.isRenewal;
        data["nameHasWarning"] = this.nameHasWarning;
        data["registeredAgentID"] = this.registeredAgentID;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestServiceFees && this.requestServiceFees.constructor === Array) {
            data["requestServiceFees"] = [];
            for (let item of this.requestServiceFees)
                data["requestServiceFees"].push(item.toJSON());
        }
        data["reservationDurationDays"] = this.reservationDurationDays;
        data["reservationDurationKey"] = this.reservationDurationKey;
        data["reservationStatusKey"] = this.reservationStatusKey;
        data["suffix"] = this.suffix;
        data["suffixKey"] = this.suffixKey;
        data["updateReservationStatus"] = this.updateReservationStatus;
        data["warningOverridden"] = this.warningOverridden;
        data["warningOverriddenById"] = this.warningOverriddenById;
        data["warningOverriddenByUser"] = this.warningOverriddenByUser;
        data["id"] = this.id;
        return data; 
    }

    clone(): NameReservationCreateDto {
        const json = this.toJSON();
        let result = new NameReservationCreateDto();
        result.init(json);
        return result;
    }
}

export interface INameReservationCreateDto {
    alternativeCompanyName: string | undefined;
    comments: string | undefined;
    companyTypeName: string;
    notes: string | undefined;
    registeredAgentName: string;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    autoComplete: boolean | undefined;
    companyName: string;
    companyTypeKey: string;
    internalStatusKey: string | undefined;
    isRenewal: boolean | undefined;
    nameHasWarning: boolean | undefined;
    registeredAgentID: string;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestServiceFees: BaseRequestFeeInput[];
    reservationDurationDays: number;
    reservationDurationKey: string;
    reservationStatusKey: string | undefined;
    suffix: string;
    suffixKey: string;
    updateReservationStatus: boolean | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    warningOverriddenByUser: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfNameReservationDto implements IPagedResultDtoOfNameReservationDto {
    totalCount: number | undefined;
    items: NameReservationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameReservationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(NameReservationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameReservationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameReservationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNameReservationDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNameReservationDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNameReservationDto {
    totalCount: number | undefined;
    items: NameReservationDto[] | undefined;
}

export class PagedResultDtoOfNameReservationGetAllDto implements IPagedResultDtoOfNameReservationGetAllDto {
    totalCount: number | undefined;
    items: NameReservationGetAllDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameReservationGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(NameReservationGetAllDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameReservationGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameReservationGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfNameReservationGetAllDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfNameReservationGetAllDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfNameReservationGetAllDto {
    totalCount: number | undefined;
    items: NameReservationGetAllDto[] | undefined;
}

export class NameReservationGetAllDto implements INameReservationGetAllDto {
    alternativeCompanyName: string | undefined;
    batchNumber: string | undefined;
    readonly companyFullName: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    expirationDate: Date | undefined;
    externalStatusKey: string | undefined;
    externalStatusName: string | undefined;
    internalStatusKey: string | undefined;
    internalStatusName: string | undefined;
    referenceNumber: string | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    requestStatusKey: string | undefined;
    reservationDate: Date | undefined;
    reservationDurationDays: number | undefined;
    reservationStatusKey: string | undefined;
    reservationStatusName: string | undefined;
    suffix: string | undefined;
    suffixKey: string | undefined;
    id: string | undefined;

    constructor(data?: INameReservationGetAllDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.batchNumber = data["batchNumber"];
            (<any>this).companyFullName = data["companyFullName"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.companyTypeName = data["companyTypeName"];
            this.expirationDate = data["expirationDate"] ? new Date(data["expirationDate"].toString()) : <any>undefined;
            this.externalStatusKey = data["externalStatusKey"];
            this.externalStatusName = data["externalStatusName"];
            this.internalStatusKey = data["internalStatusKey"];
            this.internalStatusName = data["internalStatusName"];
            this.referenceNumber = data["referenceNumber"];
            this.registeredAgentID = data["registeredAgentID"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestNumber = data["requestNumber"];
            this.requestStatusKey = data["requestStatusKey"];
            this.reservationDate = data["reservationDate"] ? new Date(data["reservationDate"].toString()) : <any>undefined;
            this.reservationDurationDays = data["reservationDurationDays"];
            this.reservationStatusKey = data["reservationStatusKey"];
            this.reservationStatusName = data["reservationStatusName"];
            this.suffix = data["suffix"];
            this.suffixKey = data["suffixKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NameReservationGetAllDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameReservationGetAllDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["batchNumber"] = this.batchNumber;
        data["companyFullName"] = this.companyFullName;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["companyTypeName"] = this.companyTypeName;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["externalStatusKey"] = this.externalStatusKey;
        data["externalStatusName"] = this.externalStatusName;
        data["internalStatusKey"] = this.internalStatusKey;
        data["internalStatusName"] = this.internalStatusName;
        data["referenceNumber"] = this.referenceNumber;
        data["registeredAgentID"] = this.registeredAgentID;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestNumber"] = this.requestNumber;
        data["requestStatusKey"] = this.requestStatusKey;
        data["reservationDate"] = this.reservationDate ? this.reservationDate.toISOString() : <any>undefined;
        data["reservationDurationDays"] = this.reservationDurationDays;
        data["reservationStatusKey"] = this.reservationStatusKey;
        data["reservationStatusName"] = this.reservationStatusName;
        data["suffix"] = this.suffix;
        data["suffixKey"] = this.suffixKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): NameReservationGetAllDto {
        const json = this.toJSON();
        let result = new NameReservationGetAllDto();
        result.init(json);
        return result;
    }
}

export interface INameReservationGetAllDto {
    alternativeCompanyName: string | undefined;
    batchNumber: string | undefined;
    companyFullName: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    companyTypeName: string | undefined;
    expirationDate: Date | undefined;
    externalStatusKey: string | undefined;
    externalStatusName: string | undefined;
    internalStatusKey: string | undefined;
    internalStatusName: string | undefined;
    referenceNumber: string | undefined;
    registeredAgentID: string | undefined;
    registeredAgentName: string | undefined;
    requestNumber: string | undefined;
    requestStatusKey: string | undefined;
    reservationDate: Date | undefined;
    reservationDurationDays: number | undefined;
    reservationStatusKey: string | undefined;
    reservationStatusName: string | undefined;
    suffix: string | undefined;
    suffixKey: string | undefined;
    id: string | undefined;
}

export class NameReservationDurationDto implements INameReservationDurationDto {
    duration: number | undefined;
    id: string | undefined;
    key: string | undefined;
    type: string | undefined;

    constructor(data?: INameReservationDurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.duration = data["duration"];
            this.id = data["id"];
            this.key = data["key"];
            this.type = data["type"];
        }
    }

    static fromJS(data: any): NameReservationDurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameReservationDurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["id"] = this.id;
        data["key"] = this.key;
        data["type"] = this.type;
        return data; 
    }

    clone(): NameReservationDurationDto {
        const json = this.toJSON();
        let result = new NameReservationDurationDto();
        result.init(json);
        return result;
    }
}

export interface INameReservationDurationDto {
    duration: number | undefined;
    id: string | undefined;
    key: string | undefined;
    type: string | undefined;
}

export class RenewNameReservationInput implements IRenewNameReservationInput {
    reservationDurationKey: string | undefined;
    bank: string | undefined;
    chequeNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    transactionCurrencyKey: string | undefined;
    transactionTypeKey: string | undefined;
    id: string | undefined;

    constructor(data?: IRenewNameReservationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.reservationDurationKey = data["reservationDurationKey"];
            this.bank = data["bank"];
            this.chequeNumber = data["chequeNumber"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeKey = data["paymentTypeKey"];
            this.portalKey = data["portalKey"];
            this.transactionCurrencyKey = data["transactionCurrencyKey"];
            this.transactionTypeKey = data["transactionTypeKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RenewNameReservationInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenewNameReservationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationDurationKey"] = this.reservationDurationKey;
        data["bank"] = this.bank;
        data["chequeNumber"] = this.chequeNumber;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeKey"] = this.paymentTypeKey;
        data["portalKey"] = this.portalKey;
        data["transactionCurrencyKey"] = this.transactionCurrencyKey;
        data["transactionTypeKey"] = this.transactionTypeKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): RenewNameReservationInput {
        const json = this.toJSON();
        let result = new RenewNameReservationInput();
        result.init(json);
        return result;
    }
}

export interface IRenewNameReservationInput {
    reservationDurationKey: string | undefined;
    bank: string | undefined;
    chequeNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    transactionCurrencyKey: string | undefined;
    transactionTypeKey: string | undefined;
    id: string | undefined;
}

export class RenewOutput implements IRenewOutput {
    requestFee: RequestFeeDto | undefined;

    constructor(data?: IRenewOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.requestFee = data["requestFee"] ? RequestFeeDto.fromJS(data["requestFee"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RenewOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RenewOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestFee"] = this.requestFee ? this.requestFee.toJSON() : <any>undefined;
        return data; 
    }

    clone(): RenewOutput {
        const json = this.toJSON();
        let result = new RenewOutput();
        result.init(json);
        return result;
    }
}

export interface IRenewOutput {
    requestFee: RequestFeeDto | undefined;
}

export class NameReservationUpdateDto implements INameReservationUpdateDto {
    alternativeCompanyName: string | undefined;
    comments: string | undefined;
    companyTypeName: string;
    ignoreChanges: boolean | undefined;
    notes: string | undefined;
    registeredAgentName: string;
    rowVersion: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    autoComplete: boolean | undefined;
    companyName: string;
    companyTypeKey: string;
    internalStatusKey: string | undefined;
    isRenewal: boolean | undefined;
    nameHasWarning: boolean | undefined;
    registeredAgentID: string;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestServiceFees: BaseRequestFeeInput[];
    reservationDurationDays: number;
    reservationDurationKey: string;
    reservationStatusKey: string | undefined;
    suffix: string;
    suffixKey: string;
    updateReservationStatus: boolean | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    warningOverriddenByUser: boolean | undefined;
    id: string | undefined;

    constructor(data?: INameReservationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestServiceFees = [];
        }
    }

    init(data?: any) {
        if (data) {
            this.alternativeCompanyName = data["alternativeCompanyName"];
            this.comments = data["comments"];
            this.companyTypeName = data["companyTypeName"];
            this.ignoreChanges = data["ignoreChanges"];
            this.notes = data["notes"];
            this.registeredAgentName = data["registeredAgentName"];
            this.rowVersion = data["rowVersion"];
            this.assignedAt = data["assignedAt"] ? new Date(data["assignedAt"].toString()) : <any>undefined;
            this.assignedByUserID = data["assignedByUserID"];
            this.assignedTo = data["assignedTo"];
            this.autoComplete = data["autoComplete"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.internalStatusKey = data["internalStatusKey"];
            this.isRenewal = data["isRenewal"];
            this.nameHasWarning = data["nameHasWarning"];
            this.registeredAgentID = data["registeredAgentID"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestServiceFees"] && data["requestServiceFees"].constructor === Array) {
                this.requestServiceFees = [] as any;
                for (let item of data["requestServiceFees"])
                    this.requestServiceFees.push(BaseRequestFeeInput.fromJS(item));
            }
            this.reservationDurationDays = data["reservationDurationDays"];
            this.reservationDurationKey = data["reservationDurationKey"];
            this.reservationStatusKey = data["reservationStatusKey"];
            this.suffix = data["suffix"];
            this.suffixKey = data["suffixKey"];
            this.updateReservationStatus = data["updateReservationStatus"];
            this.warningOverridden = data["warningOverridden"];
            this.warningOverriddenById = data["warningOverriddenById"];
            this.warningOverriddenByUser = data["warningOverriddenByUser"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): NameReservationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameReservationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alternativeCompanyName"] = this.alternativeCompanyName;
        data["comments"] = this.comments;
        data["companyTypeName"] = this.companyTypeName;
        data["ignoreChanges"] = this.ignoreChanges;
        data["notes"] = this.notes;
        data["registeredAgentName"] = this.registeredAgentName;
        data["rowVersion"] = this.rowVersion;
        data["assignedAt"] = this.assignedAt ? this.assignedAt.toISOString() : <any>undefined;
        data["assignedByUserID"] = this.assignedByUserID;
        data["assignedTo"] = this.assignedTo;
        data["autoComplete"] = this.autoComplete;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["internalStatusKey"] = this.internalStatusKey;
        data["isRenewal"] = this.isRenewal;
        data["nameHasWarning"] = this.nameHasWarning;
        data["registeredAgentID"] = this.registeredAgentID;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestServiceFees && this.requestServiceFees.constructor === Array) {
            data["requestServiceFees"] = [];
            for (let item of this.requestServiceFees)
                data["requestServiceFees"].push(item.toJSON());
        }
        data["reservationDurationDays"] = this.reservationDurationDays;
        data["reservationDurationKey"] = this.reservationDurationKey;
        data["reservationStatusKey"] = this.reservationStatusKey;
        data["suffix"] = this.suffix;
        data["suffixKey"] = this.suffixKey;
        data["updateReservationStatus"] = this.updateReservationStatus;
        data["warningOverridden"] = this.warningOverridden;
        data["warningOverriddenById"] = this.warningOverriddenById;
        data["warningOverriddenByUser"] = this.warningOverriddenByUser;
        data["id"] = this.id;
        return data; 
    }

    clone(): NameReservationUpdateDto {
        const json = this.toJSON();
        let result = new NameReservationUpdateDto();
        result.init(json);
        return result;
    }
}

export interface INameReservationUpdateDto {
    alternativeCompanyName: string | undefined;
    comments: string | undefined;
    companyTypeName: string;
    ignoreChanges: boolean | undefined;
    notes: string | undefined;
    registeredAgentName: string;
    rowVersion: string | undefined;
    assignedAt: Date | undefined;
    assignedByUserID: number | undefined;
    assignedTo: string | undefined;
    autoComplete: boolean | undefined;
    companyName: string;
    companyTypeKey: string;
    internalStatusKey: string | undefined;
    isRenewal: boolean | undefined;
    nameHasWarning: boolean | undefined;
    registeredAgentID: string;
    requestedFromCR: boolean | undefined;
    requestExternalStatusKey: string | undefined;
    requestServiceFees: BaseRequestFeeInput[];
    reservationDurationDays: number;
    reservationDurationKey: string;
    reservationStatusKey: string | undefined;
    suffix: string;
    suffixKey: string;
    updateReservationStatus: boolean | undefined;
    warningOverridden: boolean | undefined;
    warningOverriddenById: number | undefined;
    warningOverriddenByUser: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfPersonDto implements IPagedResultDtoOfPersonDto {
    totalCount: number | undefined;
    items: PersonDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPersonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(PersonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPersonDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPersonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfPersonDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfPersonDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfPersonDto {
    totalCount: number | undefined;
    items: PersonDto[] | undefined;
}

export class ReceiptDto implements IReceiptDto {
    bank: string | undefined;
    batchNumber: string | undefined;
    chequeNumber: string | undefined;
    entityFees: EntityFeeDto[] | undefined;
    isRefundRequest: boolean | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    receiptNumber: string | undefined;
    receivedFromName: string | undefined;
    receivedFromPhoneNumber: string | undefined;
    receivedFromAddress: string | undefined;
    requestNumber: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountECInText: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionNumber: string | undefined;
    transactionTypeName: string | undefined;
    notes: string | undefined;
    id: string | undefined;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.bank = data["bank"];
            this.batchNumber = data["batchNumber"];
            this.chequeNumber = data["chequeNumber"];
            if (data["entityFees"] && data["entityFees"].constructor === Array) {
                this.entityFees = [] as any;
                for (let item of data["entityFees"])
                    this.entityFees.push(EntityFeeDto.fromJS(item));
            }
            this.isRefundRequest = data["isRefundRequest"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeName = data["paymentTypeName"];
            this.receiptNumber = data["receiptNumber"];
            this.receivedFromName = data["receivedFromName"];
            this.receivedFromPhoneNumber = data["receivedFromPhoneNumber"];
            this.receivedFromAddress = data["receivedFromAddress"];
            this.requestNumber = data["requestNumber"];
            this.transactionAmountEC = data["transactionAmountEC"];
            this.transactionAmountECInText = data["transactionAmountECInText"];
            this.transactionCurrencyName = data["transactionCurrencyName"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionTypeName = data["transactionTypeName"];
            this.notes = data["notes"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank;
        data["batchNumber"] = this.batchNumber;
        data["chequeNumber"] = this.chequeNumber;
        if (this.entityFees && this.entityFees.constructor === Array) {
            data["entityFees"] = [];
            for (let item of this.entityFees)
                data["entityFees"].push(item.toJSON());
        }
        data["isRefundRequest"] = this.isRefundRequest;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeName"] = this.paymentTypeName;
        data["receiptNumber"] = this.receiptNumber;
        data["receivedFromName"] = this.receivedFromName;
        data["receivedFromPhoneNumber"] = this.receivedFromPhoneNumber;
        data["receivedFromAddress"] = this.receivedFromAddress;
        data["requestNumber"] = this.requestNumber;
        data["transactionAmountEC"] = this.transactionAmountEC;
        data["transactionAmountECInText"] = this.transactionAmountECInText;
        data["transactionCurrencyName"] = this.transactionCurrencyName;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionTypeName"] = this.transactionTypeName;
        data["notes"] = this.notes;
        data["id"] = this.id;
        return data; 
    }

    clone(): ReceiptDto {
        const json = this.toJSON();
        let result = new ReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptDto {
    bank: string | undefined;
    batchNumber: string | undefined;
    chequeNumber: string | undefined;
    entityFees: EntityFeeDto[] | undefined;
    isRefundRequest: boolean | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    receiptNumber: string | undefined;
    receivedFromName: string | undefined;
    receivedFromPhoneNumber: string | undefined;
    receivedFromAddress: string | undefined;
    requestNumber: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountECInText: string | undefined;
    transactionCurrencyName: string | undefined;
    transactionNumber: string | undefined;
    transactionTypeName: string | undefined;
    notes: string | undefined;
    id: string | undefined;
}

export class EntityFeeDto implements IEntityFeeDto {
    entityName: string | undefined;
    fees: ReceiptFeeDto[] | undefined;
    gainLossFees: ReceiptFeeDto[] | undefined;
    totalEC: number | undefined;
    extensionData: string | undefined;

    constructor(data?: IEntityFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityName = data["entityName"];
            if (data["fees"] && data["fees"].constructor === Array) {
                this.fees = [] as any;
                for (let item of data["fees"])
                    this.fees.push(ReceiptFeeDto.fromJS(item));
            }
            if (data["gainLossFees"] && data["gainLossFees"].constructor === Array) {
                this.gainLossFees = [] as any;
                for (let item of data["gainLossFees"])
                    this.gainLossFees.push(ReceiptFeeDto.fromJS(item));
            }
            this.totalEC = data["totalEC"];
            this.extensionData = data["extensionData"];
        }
    }

    static fromJS(data: any): EntityFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityName"] = this.entityName;
        if (this.fees && this.fees.constructor === Array) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        if (this.gainLossFees && this.gainLossFees.constructor === Array) {
            data["gainLossFees"] = [];
            for (let item of this.gainLossFees)
                data["gainLossFees"].push(item.toJSON());
        }
        data["totalEC"] = this.totalEC;
        data["extensionData"] = this.extensionData;
        return data; 
    }

    clone(): EntityFeeDto {
        const json = this.toJSON();
        let result = new EntityFeeDto();
        result.init(json);
        return result;
    }
}

export interface IEntityFeeDto {
    entityName: string | undefined;
    fees: ReceiptFeeDto[] | undefined;
    gainLossFees: ReceiptFeeDto[] | undefined;
    totalEC: number | undefined;
    extensionData: string | undefined;
}

export class ReceiptFeeDto implements IReceiptFeeDto {
    amountEC: number | undefined;
    amountUSD: number | undefined;
    feeDescription: string | undefined;
    quantity: number | undefined;
    subTotalEC: number | undefined;

    constructor(data?: IReceiptFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.amountEC = data["amountEC"];
            this.amountUSD = data["amountUSD"];
            this.feeDescription = data["feeDescription"];
            this.quantity = data["quantity"];
            this.subTotalEC = data["subTotalEC"];
        }
    }

    static fromJS(data: any): ReceiptFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountEC"] = this.amountEC;
        data["amountUSD"] = this.amountUSD;
        data["feeDescription"] = this.feeDescription;
        data["quantity"] = this.quantity;
        data["subTotalEC"] = this.subTotalEC;
        return data; 
    }

    clone(): ReceiptFeeDto {
        const json = this.toJSON();
        let result = new ReceiptFeeDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptFeeDto {
    amountEC: number | undefined;
    amountUSD: number | undefined;
    feeDescription: string | undefined;
    quantity: number | undefined;
    subTotalEC: number | undefined;
}

export class PagedResultDtoOfReceiptDto implements IPagedResultDtoOfReceiptDto {
    totalCount: number | undefined;
    items: ReceiptDto[] | undefined;

    constructor(data?: IPagedResultDtoOfReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ReceiptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfReceiptDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfReceiptDto {
    totalCount: number | undefined;
    items: ReceiptDto[] | undefined;
}

export class RefundRequestCreateCRDto implements IRefundRequestCreateCRDto {
    assignedTo: string | undefined;
    comments: string | undefined;
    initialStatus: string | undefined;
    portalKey: string | undefined;
    refundReason: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;

    constructor(data?: IRefundRequestCreateCRDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedTo = data["assignedTo"];
            this.comments = data["comments"];
            this.initialStatus = data["initialStatus"];
            this.portalKey = data["portalKey"];
            this.refundReason = data["refundReason"];
            this.registryComment = data["registryComment"];
            if (data["requestFeeIDs"] && data["requestFeeIDs"].constructor === Array) {
                this.requestFeeIDs = [] as any;
                for (let item of data["requestFeeIDs"])
                    this.requestFeeIDs.push(item);
            }
            this.transactionID = data["transactionID"];
        }
    }

    static fromJS(data: any): RefundRequestCreateCRDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefundRequestCreateCRDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedTo"] = this.assignedTo;
        data["comments"] = this.comments;
        data["initialStatus"] = this.initialStatus;
        data["portalKey"] = this.portalKey;
        data["refundReason"] = this.refundReason;
        data["registryComment"] = this.registryComment;
        if (this.requestFeeIDs && this.requestFeeIDs.constructor === Array) {
            data["requestFeeIDs"] = [];
            for (let item of this.requestFeeIDs)
                data["requestFeeIDs"].push(item);
        }
        data["transactionID"] = this.transactionID;
        return data; 
    }

    clone(): RefundRequestCreateCRDto {
        const json = this.toJSON();
        let result = new RefundRequestCreateCRDto();
        result.init(json);
        return result;
    }
}

export interface IRefundRequestCreateCRDto {
    assignedTo: string | undefined;
    comments: string | undefined;
    initialStatus: string | undefined;
    portalKey: string | undefined;
    refundReason: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;
}

export class GetRefundRequestDto implements IGetRefundRequestDto {
    id: string | undefined;
    originalTransactionDetails: TransactionHeaderDto | undefined;
    refundRequest: RequestV2Dto | undefined;
    refundTransactionDetails: TransactionHeaderDto | undefined;
    originalTransactionId: string | undefined;
    refundReason: string | undefined;
    refundTransactionId: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    rowVersion: string | undefined;

    constructor(data?: IGetRefundRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.originalTransactionDetails = data["originalTransactionDetails"] ? TransactionHeaderDto.fromJS(data["originalTransactionDetails"]) : <any>undefined;
            this.refundRequest = data["refundRequest"] ? RequestV2Dto.fromJS(data["refundRequest"]) : <any>undefined;
            this.refundTransactionDetails = data["refundTransactionDetails"] ? TransactionHeaderDto.fromJS(data["refundTransactionDetails"]) : <any>undefined;
            this.originalTransactionId = data["originalTransactionId"];
            this.refundReason = data["refundReason"];
            this.refundTransactionId = data["refundTransactionId"];
            this.registryComment = data["registryComment"];
            if (data["requestFeeIDs"] && data["requestFeeIDs"].constructor === Array) {
                this.requestFeeIDs = [] as any;
                for (let item of data["requestFeeIDs"])
                    this.requestFeeIDs.push(item);
            }
            this.rowVersion = data["rowVersion"];
        }
    }

    static fromJS(data: any): GetRefundRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetRefundRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["originalTransactionDetails"] = this.originalTransactionDetails ? this.originalTransactionDetails.toJSON() : <any>undefined;
        data["refundRequest"] = this.refundRequest ? this.refundRequest.toJSON() : <any>undefined;
        data["refundTransactionDetails"] = this.refundTransactionDetails ? this.refundTransactionDetails.toJSON() : <any>undefined;
        data["originalTransactionId"] = this.originalTransactionId;
        data["refundReason"] = this.refundReason;
        data["refundTransactionId"] = this.refundTransactionId;
        data["registryComment"] = this.registryComment;
        if (this.requestFeeIDs && this.requestFeeIDs.constructor === Array) {
            data["requestFeeIDs"] = [];
            for (let item of this.requestFeeIDs)
                data["requestFeeIDs"].push(item);
        }
        data["rowVersion"] = this.rowVersion;
        return data; 
    }

    clone(): GetRefundRequestDto {
        const json = this.toJSON();
        let result = new GetRefundRequestDto();
        result.init(json);
        return result;
    }
}

export interface IGetRefundRequestDto {
    id: string | undefined;
    originalTransactionDetails: TransactionHeaderDto | undefined;
    refundRequest: RequestV2Dto | undefined;
    refundTransactionDetails: TransactionHeaderDto | undefined;
    originalTransactionId: string | undefined;
    refundReason: string | undefined;
    refundTransactionId: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    rowVersion: string | undefined;
}

export class RefundRequestCreateDto implements IRefundRequestCreateDto {
    portalKey: string | undefined;
    refundReason: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;

    constructor(data?: IRefundRequestCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.portalKey = data["portalKey"];
            this.refundReason = data["refundReason"];
            this.registryComment = data["registryComment"];
            if (data["requestFeeIDs"] && data["requestFeeIDs"].constructor === Array) {
                this.requestFeeIDs = [] as any;
                for (let item of data["requestFeeIDs"])
                    this.requestFeeIDs.push(item);
            }
            this.transactionID = data["transactionID"];
        }
    }

    static fromJS(data: any): RefundRequestCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefundRequestCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalKey"] = this.portalKey;
        data["refundReason"] = this.refundReason;
        data["registryComment"] = this.registryComment;
        if (this.requestFeeIDs && this.requestFeeIDs.constructor === Array) {
            data["requestFeeIDs"] = [];
            for (let item of this.requestFeeIDs)
                data["requestFeeIDs"].push(item);
        }
        data["transactionID"] = this.transactionID;
        return data; 
    }

    clone(): RefundRequestCreateDto {
        const json = this.toJSON();
        let result = new RefundRequestCreateDto();
        result.init(json);
        return result;
    }
}

export interface IRefundRequestCreateDto {
    portalKey: string | undefined;
    refundReason: string | undefined;
    registryComment: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;
}

export class RefundRequestUpdateDto implements IRefundRequestUpdateDto {
    assignedTo: string | undefined;
    comments: string | undefined;
    registryComment: string | undefined;
    status: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
    refundReason: string | undefined;

    constructor(data?: IRefundRequestUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedTo = data["assignedTo"];
            this.comments = data["comments"];
            this.registryComment = data["registryComment"];
            this.status = data["status"];
            this.rowVersion = data["rowVersion"];
            this.id = data["id"];
            this.refundReason = data["refundReason"];
        }
    }

    static fromJS(data: any): RefundRequestUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RefundRequestUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedTo"] = this.assignedTo;
        data["comments"] = this.comments;
        data["registryComment"] = this.registryComment;
        data["status"] = this.status;
        data["rowVersion"] = this.rowVersion;
        data["id"] = this.id;
        data["refundReason"] = this.refundReason;
        return data; 
    }

    clone(): RefundRequestUpdateDto {
        const json = this.toJSON();
        let result = new RefundRequestUpdateDto();
        result.init(json);
        return result;
    }
}

export interface IRefundRequestUpdateDto {
    assignedTo: string | undefined;
    comments: string | undefined;
    registryComment: string | undefined;
    status: string | undefined;
    rowVersion: string | undefined;
    id: string | undefined;
    refundReason: string | undefined;
}

export class CreateRegisteredAgentInput implements ICreateRegisteredAgentInput {
    accountNumber: string | undefined;
    addressStreetLine1: string;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: string | undefined;
    cellNumber: string | undefined;
    country: string;
    email: string | undefined;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string;
    resignedAt: Date | undefined;
    id: string | undefined;

    constructor(data?: ICreateRegisteredAgentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.addressStreetLine1 = data["addressStreetLine1"];
            this.addressStreetLine2 = data["addressStreetLine2"];
            this.businessPhoneNumber = data["businessPhoneNumber"];
            this.cellNumber = data["cellNumber"];
            this.country = data["country"];
            this.email = data["email"];
            this.faxNumber = data["faxNumber"];
            this.isActive = data["isActive"];
            if (data["licensesNewRenewalDates"]) {
                this.licensesNewRenewalDates = {} as any;
                for (let key in data["licensesNewRenewalDates"]) {
                    if (data["licensesNewRenewalDates"].hasOwnProperty(key))
                        this.licensesNewRenewalDates[key] = data["licensesNewRenewalDates"][key] ? new Date(data["licensesNewRenewalDates"][key].toString()) : <any>undefined;
                }
            }
            this.name = data["name"];
            this.resignedAt = data["resignedAt"] ? new Date(data["resignedAt"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateRegisteredAgentInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRegisteredAgentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["addressStreetLine1"] = this.addressStreetLine1;
        data["addressStreetLine2"] = this.addressStreetLine2;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["cellNumber"] = this.cellNumber;
        data["country"] = this.country;
        data["email"] = this.email;
        data["faxNumber"] = this.faxNumber;
        data["isActive"] = this.isActive;
        if (this.licensesNewRenewalDates) {
            data["licensesNewRenewalDates"] = {};
            for (let key in this.licensesNewRenewalDates) {
                if (this.licensesNewRenewalDates.hasOwnProperty(key))
                    data["licensesNewRenewalDates"][key] = this.licensesNewRenewalDates[key] ? this.licensesNewRenewalDates[key].toISOString() : <any>undefined;
            }
        }
        data["name"] = this.name;
        data["resignedAt"] = this.resignedAt ? this.resignedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateRegisteredAgentInput {
        const json = this.toJSON();
        let result = new CreateRegisteredAgentInput();
        result.init(json);
        return result;
    }
}

export interface ICreateRegisteredAgentInput {
    accountNumber: string | undefined;
    addressStreetLine1: string;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: string | undefined;
    cellNumber: string | undefined;
    country: string;
    email: string | undefined;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string;
    resignedAt: Date | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfRegisteredAgentDto implements IPagedResultDtoOfRegisteredAgentDto {
    totalCount: number | undefined;
    items: RegisteredAgentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRegisteredAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RegisteredAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRegisteredAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRegisteredAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRegisteredAgentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRegisteredAgentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRegisteredAgentDto {
    totalCount: number | undefined;
    items: RegisteredAgentDto[] | undefined;
}

export class PagedResultDtoOfGetAllRegisteredAgentOutput implements IPagedResultDtoOfGetAllRegisteredAgentOutput {
    totalCount: number | undefined;
    items: GetAllRegisteredAgentOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllRegisteredAgentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllRegisteredAgentOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllRegisteredAgentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllRegisteredAgentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllRegisteredAgentOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllRegisteredAgentOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllRegisteredAgentOutput {
    totalCount: number | undefined;
    items: GetAllRegisteredAgentOutput[] | undefined;
}

export class GetAllRegisteredAgentOutput implements IGetAllRegisteredAgentOutput {
    accountNumber: string | undefined;
    businessPhoneNumber: string | undefined;
    email: string | undefined;
    faxNumber: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    name: string | undefined;

    constructor(data?: IGetAllRegisteredAgentOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.businessPhoneNumber = data["businessPhoneNumber"];
            this.email = data["email"];
            this.faxNumber = data["faxNumber"];
            this.id = data["id"];
            this.isActive = data["isActive"];
            this.name = data["name"];
        }
    }

    static fromJS(data: any): GetAllRegisteredAgentOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllRegisteredAgentOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["email"] = this.email;
        data["faxNumber"] = this.faxNumber;
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["name"] = this.name;
        return data; 
    }

    clone(): GetAllRegisteredAgentOutput {
        const json = this.toJSON();
        let result = new GetAllRegisteredAgentOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllRegisteredAgentOutput {
    accountNumber: string | undefined;
    businessPhoneNumber: string | undefined;
    email: string | undefined;
    faxNumber: string | undefined;
    id: string | undefined;
    isActive: boolean | undefined;
    name: string | undefined;
}

export class UpdateRegisteredAgentInput implements IUpdateRegisteredAgentInput {
    accountNumber: string;
    addressStreetLine1: string;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: string | undefined;
    cellNumber: string | undefined;
    country: string;
    email: string | undefined;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string;
    resignedAt: Date | undefined;
    id: string | undefined;

    constructor(data?: IUpdateRegisteredAgentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.addressStreetLine1 = data["addressStreetLine1"];
            this.addressStreetLine2 = data["addressStreetLine2"];
            this.businessPhoneNumber = data["businessPhoneNumber"];
            this.cellNumber = data["cellNumber"];
            this.country = data["country"];
            this.email = data["email"];
            this.faxNumber = data["faxNumber"];
            this.isActive = data["isActive"];
            if (data["licensesNewRenewalDates"]) {
                this.licensesNewRenewalDates = {} as any;
                for (let key in data["licensesNewRenewalDates"]) {
                    if (data["licensesNewRenewalDates"].hasOwnProperty(key))
                        this.licensesNewRenewalDates[key] = data["licensesNewRenewalDates"][key] ? new Date(data["licensesNewRenewalDates"][key].toString()) : <any>undefined;
                }
            }
            this.name = data["name"];
            this.resignedAt = data["resignedAt"] ? new Date(data["resignedAt"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateRegisteredAgentInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegisteredAgentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["addressStreetLine1"] = this.addressStreetLine1;
        data["addressStreetLine2"] = this.addressStreetLine2;
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["cellNumber"] = this.cellNumber;
        data["country"] = this.country;
        data["email"] = this.email;
        data["faxNumber"] = this.faxNumber;
        data["isActive"] = this.isActive;
        if (this.licensesNewRenewalDates) {
            data["licensesNewRenewalDates"] = {};
            for (let key in this.licensesNewRenewalDates) {
                if (this.licensesNewRenewalDates.hasOwnProperty(key))
                    data["licensesNewRenewalDates"][key] = this.licensesNewRenewalDates[key] ? this.licensesNewRenewalDates[key].toISOString() : <any>undefined;
            }
        }
        data["name"] = this.name;
        data["resignedAt"] = this.resignedAt ? this.resignedAt.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateRegisteredAgentInput {
        const json = this.toJSON();
        let result = new UpdateRegisteredAgentInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateRegisteredAgentInput {
    accountNumber: string;
    addressStreetLine1: string;
    addressStreetLine2: string | undefined;
    businessPhoneNumber: string | undefined;
    cellNumber: string | undefined;
    country: string;
    email: string | undefined;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    licensesNewRenewalDates: { [key: string] : Date; } | undefined;
    name: string;
    resignedAt: Date | undefined;
    id: string | undefined;
}

export class GetEntityStatusReportOutput implements IGetEntityStatusReportOutput {
    items: GetEntityStatusReportOutputItem[] | undefined;

    constructor(data?: IGetEntityStatusReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetEntityStatusReportOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEntityStatusReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityStatusReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetEntityStatusReportOutput {
        const json = this.toJSON();
        let result = new GetEntityStatusReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetEntityStatusReportOutput {
    items: GetEntityStatusReportOutputItem[] | undefined;
}

export class GetEntityStatusReportOutputItem implements IGetEntityStatusReportOutputItem {
    entityStatus: string | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;
    total: number | undefined;

    constructor(data?: IGetEntityStatusReportOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityStatus = data["entityStatus"];
            this.ibcCount = data["ibcCount"];
            this.ibcInsuranceCount = data["ibcInsuranceCount"];
            this.llcCount = data["llcCount"];
            this.foundationCount = data["foundationCount"];
            this.internationalTrustCount = data["internationalTrustCount"];
            this.qualifiedForeignTrustCount = data["qualifiedForeignTrustCount"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetEntityStatusReportOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetEntityStatusReportOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityStatus"] = this.entityStatus;
        data["ibcCount"] = this.ibcCount;
        data["ibcInsuranceCount"] = this.ibcInsuranceCount;
        data["llcCount"] = this.llcCount;
        data["foundationCount"] = this.foundationCount;
        data["internationalTrustCount"] = this.internationalTrustCount;
        data["qualifiedForeignTrustCount"] = this.qualifiedForeignTrustCount;
        data["total"] = this.total;
        return data; 
    }

    clone(): GetEntityStatusReportOutputItem {
        const json = this.toJSON();
        let result = new GetEntityStatusReportOutputItem();
        result.init(json);
        return result;
    }
}

export interface IGetEntityStatusReportOutputItem {
    entityStatus: string | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;
    total: number | undefined;
}

export class GetIncorporationStatisticsReportOutput implements IGetIncorporationStatisticsReportOutput {
    items: GetIncorporationStatisticsReportOutputItem[] | undefined;

    constructor(data?: IGetIncorporationStatisticsReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetIncorporationStatisticsReportOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncorporationStatisticsReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncorporationStatisticsReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetIncorporationStatisticsReportOutput {
        const json = this.toJSON();
        let result = new GetIncorporationStatisticsReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetIncorporationStatisticsReportOutput {
    items: GetIncorporationStatisticsReportOutputItem[] | undefined;
}

export class GetIncorporationStatisticsReportOutputItem implements IGetIncorporationStatisticsReportOutputItem {
    date: Date | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;

    constructor(data?: IGetIncorporationStatisticsReportOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? new Date(data["date"].toString()) : <any>undefined;
            this.ibcCount = data["ibcCount"];
            this.ibcInsuranceCount = data["ibcInsuranceCount"];
            this.llcCount = data["llcCount"];
            this.foundationCount = data["foundationCount"];
            this.internationalTrustCount = data["internationalTrustCount"];
            this.qualifiedForeignTrustCount = data["qualifiedForeignTrustCount"];
        }
    }

    static fromJS(data: any): GetIncorporationStatisticsReportOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncorporationStatisticsReportOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["ibcCount"] = this.ibcCount;
        data["ibcInsuranceCount"] = this.ibcInsuranceCount;
        data["llcCount"] = this.llcCount;
        data["foundationCount"] = this.foundationCount;
        data["internationalTrustCount"] = this.internationalTrustCount;
        data["qualifiedForeignTrustCount"] = this.qualifiedForeignTrustCount;
        return data; 
    }

    clone(): GetIncorporationStatisticsReportOutputItem {
        const json = this.toJSON();
        let result = new GetIncorporationStatisticsReportOutputItem();
        result.init(json);
        return result;
    }
}

export interface IGetIncorporationStatisticsReportOutputItem {
    date: Date | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;
}

export class GetRegistryStatisticsReportOutput implements IGetRegistryStatisticsReportOutput {
    items: GetRegistryStatisticsReportOutputItem[] | undefined;

    constructor(data?: IGetRegistryStatisticsReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetRegistryStatisticsReportOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegistryStatisticsReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistryStatisticsReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetRegistryStatisticsReportOutput {
        const json = this.toJSON();
        let result = new GetRegistryStatisticsReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRegistryStatisticsReportOutput {
    items: GetRegistryStatisticsReportOutputItem[] | undefined;
}

export class GetRegistryStatisticsReportOutputItem implements IGetRegistryStatisticsReportOutputItem {
    measure: string | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;
    total: number | undefined;

    constructor(data?: IGetRegistryStatisticsReportOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.measure = data["measure"];
            this.ibcCount = data["ibcCount"];
            this.ibcInsuranceCount = data["ibcInsuranceCount"];
            this.llcCount = data["llcCount"];
            this.foundationCount = data["foundationCount"];
            this.internationalTrustCount = data["internationalTrustCount"];
            this.qualifiedForeignTrustCount = data["qualifiedForeignTrustCount"];
            this.total = data["total"];
        }
    }

    static fromJS(data: any): GetRegistryStatisticsReportOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegistryStatisticsReportOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["measure"] = this.measure;
        data["ibcCount"] = this.ibcCount;
        data["ibcInsuranceCount"] = this.ibcInsuranceCount;
        data["llcCount"] = this.llcCount;
        data["foundationCount"] = this.foundationCount;
        data["internationalTrustCount"] = this.internationalTrustCount;
        data["qualifiedForeignTrustCount"] = this.qualifiedForeignTrustCount;
        data["total"] = this.total;
        return data; 
    }

    clone(): GetRegistryStatisticsReportOutputItem {
        const json = this.toJSON();
        let result = new GetRegistryStatisticsReportOutputItem();
        result.init(json);
        return result;
    }
}

export interface IGetRegistryStatisticsReportOutputItem {
    measure: string | undefined;
    ibcCount: number | undefined;
    ibcInsuranceCount: number | undefined;
    llcCount: number | undefined;
    foundationCount: number | undefined;
    internationalTrustCount: number | undefined;
    qualifiedForeignTrustCount: number | undefined;
    total: number | undefined;
}

export class GetBusinessActivitiesReportOutput implements IGetBusinessActivitiesReportOutput {
    items: GetBusinessActivitiesReportOutputItem[] | undefined;

    constructor(data?: IGetBusinessActivitiesReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetBusinessActivitiesReportOutputItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetBusinessActivitiesReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessActivitiesReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetBusinessActivitiesReportOutput {
        const json = this.toJSON();
        let result = new GetBusinessActivitiesReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetBusinessActivitiesReportOutput {
    items: GetBusinessActivitiesReportOutputItem[] | undefined;
}

export class GetBusinessActivitiesReportOutputItem implements IGetBusinessActivitiesReportOutputItem {
    entityId: string | undefined;
    entityName: string | undefined;
    activityName: string | undefined;
    subActivities: string[] | undefined;
    specificActivities: string[] | undefined;
    notes: string | undefined;

    constructor(data?: IGetBusinessActivitiesReportOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.entityId = data["entityId"];
            this.entityName = data["entityName"];
            this.activityName = data["activityName"];
            if (data["subActivities"] && data["subActivities"].constructor === Array) {
                this.subActivities = [] as any;
                for (let item of data["subActivities"])
                    this.subActivities.push(item);
            }
            if (data["specificActivities"] && data["specificActivities"].constructor === Array) {
                this.specificActivities = [] as any;
                for (let item of data["specificActivities"])
                    this.specificActivities.push(item);
            }
            this.notes = data["notes"];
        }
    }

    static fromJS(data: any): GetBusinessActivitiesReportOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetBusinessActivitiesReportOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityName"] = this.entityName;
        data["activityName"] = this.activityName;
        if (this.subActivities && this.subActivities.constructor === Array) {
            data["subActivities"] = [];
            for (let item of this.subActivities)
                data["subActivities"].push(item);
        }
        if (this.specificActivities && this.specificActivities.constructor === Array) {
            data["specificActivities"] = [];
            for (let item of this.specificActivities)
                data["specificActivities"].push(item);
        }
        data["notes"] = this.notes;
        return data; 
    }

    clone(): GetBusinessActivitiesReportOutputItem {
        const json = this.toJSON();
        let result = new GetBusinessActivitiesReportOutputItem();
        result.init(json);
        return result;
    }
}

export interface IGetBusinessActivitiesReportOutputItem {
    entityId: string | undefined;
    entityName: string | undefined;
    activityName: string | undefined;
    subActivities: string[] | undefined;
    specificActivities: string[] | undefined;
    notes: string | undefined;
}

export class GetRevenueReportOutput implements IGetRevenueReportOutput {
    summary: GetRevenueReportOutputSummaryItem[] | undefined;
    details: GetRevenueReportOutputDetail[] | undefined;

    constructor(data?: IGetRevenueReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["summary"] && data["summary"].constructor === Array) {
                this.summary = [] as any;
                for (let item of data["summary"])
                    this.summary.push(GetRevenueReportOutputSummaryItem.fromJS(item));
            }
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [] as any;
                for (let item of data["details"])
                    this.details.push(GetRevenueReportOutputDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRevenueReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.summary && this.summary.constructor === Array) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item.toJSON());
        }
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetRevenueReportOutput {
        const json = this.toJSON();
        let result = new GetRevenueReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRevenueReportOutput {
    summary: GetRevenueReportOutputSummaryItem[] | undefined;
    details: GetRevenueReportOutputDetail[] | undefined;
}

export class GetRevenueReportOutputSummaryItem implements IGetRevenueReportOutputSummaryItem {
    financialAccountNumber: string | undefined;
    financialAccountName: string | undefined;
    amount: number | undefined;

    constructor(data?: IGetRevenueReportOutputSummaryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialAccountNumber = data["financialAccountNumber"];
            this.financialAccountName = data["financialAccountName"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetRevenueReportOutputSummaryItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueReportOutputSummaryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialAccountNumber"] = this.financialAccountNumber;
        data["financialAccountName"] = this.financialAccountName;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): GetRevenueReportOutputSummaryItem {
        const json = this.toJSON();
        let result = new GetRevenueReportOutputSummaryItem();
        result.init(json);
        return result;
    }
}

export interface IGetRevenueReportOutputSummaryItem {
    financialAccountNumber: string | undefined;
    financialAccountName: string | undefined;
    amount: number | undefined;
}

export class GetRevenueReportOutputDetail implements IGetRevenueReportOutputDetail {
    financialAccountNumber: string | undefined;
    financialAccountName: string | undefined;
    transactions: GetRevenueReportOutputDetailItem[] | undefined;

    constructor(data?: IGetRevenueReportOutputDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.financialAccountNumber = data["financialAccountNumber"];
            this.financialAccountName = data["financialAccountName"];
            if (data["transactions"] && data["transactions"].constructor === Array) {
                this.transactions = [] as any;
                for (let item of data["transactions"])
                    this.transactions.push(GetRevenueReportOutputDetailItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRevenueReportOutputDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueReportOutputDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialAccountNumber"] = this.financialAccountNumber;
        data["financialAccountName"] = this.financialAccountName;
        if (this.transactions && this.transactions.constructor === Array) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetRevenueReportOutputDetail {
        const json = this.toJSON();
        let result = new GetRevenueReportOutputDetail();
        result.init(json);
        return result;
    }
}

export interface IGetRevenueReportOutputDetail {
    financialAccountNumber: string | undefined;
    financialAccountName: string | undefined;
    transactions: GetRevenueReportOutputDetailItem[] | undefined;
}

export class GetRevenueReportOutputDetailItem implements IGetRevenueReportOutputDetailItem {
    receiptNumber: string | undefined;
    receiptDate: Date | undefined;
    accountName: string | undefined;
    amount: number | undefined;

    constructor(data?: IGetRevenueReportOutputDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptNumber = data["receiptNumber"];
            this.receiptDate = data["receiptDate"] ? new Date(data["receiptDate"].toString()) : <any>undefined;
            this.accountName = data["accountName"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetRevenueReportOutputDetailItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetRevenueReportOutputDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        data["receiptDate"] = this.receiptDate ? this.receiptDate.toISOString() : <any>undefined;
        data["accountName"] = this.accountName;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): GetRevenueReportOutputDetailItem {
        const json = this.toJSON();
        let result = new GetRevenueReportOutputDetailItem();
        result.init(json);
        return result;
    }
}

export interface IGetRevenueReportOutputDetailItem {
    receiptNumber: string | undefined;
    receiptDate: Date | undefined;
    accountName: string | undefined;
    amount: number | undefined;
}

export class GetDepositReportOutput implements IGetDepositReportOutput {
    summary: GetDepositReportOutputSummaryItem[] | undefined;
    details: GetDepositReportOutputDetailItem[] | undefined;

    constructor(data?: IGetDepositReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["summary"] && data["summary"].constructor === Array) {
                this.summary = [] as any;
                for (let item of data["summary"])
                    this.summary.push(GetDepositReportOutputSummaryItem.fromJS(item));
            }
            if (data["details"] && data["details"].constructor === Array) {
                this.details = [] as any;
                for (let item of data["details"])
                    this.details.push(GetDepositReportOutputDetailItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDepositReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.summary && this.summary.constructor === Array) {
            data["summary"] = [];
            for (let item of this.summary)
                data["summary"].push(item.toJSON());
        }
        if (this.details && this.details.constructor === Array) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }

    clone(): GetDepositReportOutput {
        const json = this.toJSON();
        let result = new GetDepositReportOutput();
        result.init(json);
        return result;
    }
}

export interface IGetDepositReportOutput {
    summary: GetDepositReportOutputSummaryItem[] | undefined;
    details: GetDepositReportOutputDetailItem[] | undefined;
}

export class GetDepositReportOutputSummaryItem implements IGetDepositReportOutputSummaryItem {
    paymentMethod: string | undefined;
    numberOfTransactions: number | undefined;
    amount: number | undefined;

    constructor(data?: IGetDepositReportOutputSummaryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.paymentMethod = data["paymentMethod"];
            this.numberOfTransactions = data["numberOfTransactions"];
            this.amount = data["amount"];
        }
    }

    static fromJS(data: any): GetDepositReportOutputSummaryItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositReportOutputSummaryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod;
        data["numberOfTransactions"] = this.numberOfTransactions;
        data["amount"] = this.amount;
        return data; 
    }

    clone(): GetDepositReportOutputSummaryItem {
        const json = this.toJSON();
        let result = new GetDepositReportOutputSummaryItem();
        result.init(json);
        return result;
    }
}

export interface IGetDepositReportOutputSummaryItem {
    paymentMethod: string | undefined;
    numberOfTransactions: number | undefined;
    amount: number | undefined;
}

export class GetDepositReportOutputDetailItem implements IGetDepositReportOutputDetailItem {
    receiptNumber: string | undefined;
    receivedFrom: string | undefined;
    amount: number | undefined;
    paymentMethod: string | undefined;
    documentNumber: string | undefined;
    bank: string | undefined;
    fees: string[] | undefined;

    constructor(data?: IGetDepositReportOutputDetailItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.receiptNumber = data["receiptNumber"];
            this.receivedFrom = data["receivedFrom"];
            this.amount = data["amount"];
            this.paymentMethod = data["paymentMethod"];
            this.documentNumber = data["documentNumber"];
            this.bank = data["bank"];
            if (data["fees"] && data["fees"].constructor === Array) {
                this.fees = [] as any;
                for (let item of data["fees"])
                    this.fees.push(item);
            }
        }
    }

    static fromJS(data: any): GetDepositReportOutputDetailItem {
        data = typeof data === 'object' ? data : {};
        let result = new GetDepositReportOutputDetailItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptNumber"] = this.receiptNumber;
        data["receivedFrom"] = this.receivedFrom;
        data["amount"] = this.amount;
        data["paymentMethod"] = this.paymentMethod;
        data["documentNumber"] = this.documentNumber;
        data["bank"] = this.bank;
        if (this.fees && this.fees.constructor === Array) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item);
        }
        return data; 
    }

    clone(): GetDepositReportOutputDetailItem {
        const json = this.toJSON();
        let result = new GetDepositReportOutputDetailItem();
        result.init(json);
        return result;
    }
}

export interface IGetDepositReportOutputDetailItem {
    receiptNumber: string | undefined;
    receivedFrom: string | undefined;
    amount: number | undefined;
    paymentMethod: string | undefined;
    documentNumber: string | undefined;
    bank: string | undefined;
    fees: string[] | undefined;
}

export class UpdateRequestFeeCertificateInput implements IUpdateRequestFeeCertificateInput {
    certificateFieldValues: UpdateCertificateFieldValueInput[] | undefined;
    isRequestCompleted: boolean | undefined;
    sealKey: string | undefined;
    signatoryKey: string | undefined;
    signatureKey: string | undefined;
    statusKey: string | undefined;
    isDeleted: boolean | undefined;
    lastModificationTime: Date | undefined;
    id: string | undefined;

    constructor(data?: IUpdateRequestFeeCertificateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["certificateFieldValues"] && data["certificateFieldValues"].constructor === Array) {
                this.certificateFieldValues = [] as any;
                for (let item of data["certificateFieldValues"])
                    this.certificateFieldValues.push(UpdateCertificateFieldValueInput.fromJS(item));
            }
            this.isRequestCompleted = data["isRequestCompleted"];
            this.sealKey = data["sealKey"];
            this.signatoryKey = data["signatoryKey"];
            this.signatureKey = data["signatureKey"];
            this.statusKey = data["statusKey"];
            this.isDeleted = data["isDeleted"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateRequestFeeCertificateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestFeeCertificateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.certificateFieldValues && this.certificateFieldValues.constructor === Array) {
            data["certificateFieldValues"] = [];
            for (let item of this.certificateFieldValues)
                data["certificateFieldValues"].push(item.toJSON());
        }
        data["isRequestCompleted"] = this.isRequestCompleted;
        data["sealKey"] = this.sealKey;
        data["signatoryKey"] = this.signatoryKey;
        data["signatureKey"] = this.signatureKey;
        data["statusKey"] = this.statusKey;
        data["isDeleted"] = this.isDeleted;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateRequestFeeCertificateInput {
        const json = this.toJSON();
        let result = new UpdateRequestFeeCertificateInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateRequestFeeCertificateInput {
    certificateFieldValues: UpdateCertificateFieldValueInput[] | undefined;
    isRequestCompleted: boolean | undefined;
    sealKey: string | undefined;
    signatoryKey: string | undefined;
    signatureKey: string | undefined;
    statusKey: string | undefined;
    isDeleted: boolean | undefined;
    lastModificationTime: Date | undefined;
    id: string | undefined;
}

export class UpdateCertificateFieldValueInput implements IUpdateCertificateFieldValueInput {
    value: string | undefined;
    id: string | undefined;

    constructor(data?: IUpdateCertificateFieldValueInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.value = data["value"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateCertificateFieldValueInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCertificateFieldValueInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateCertificateFieldValueInput {
        const json = this.toJSON();
        let result = new UpdateCertificateFieldValueInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateCertificateFieldValueInput {
    value: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfRequestFeeCertificateDto implements IPagedResultDtoOfRequestFeeCertificateDto {
    totalCount: number | undefined;
    items: RequestFeeCertificateDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRequestFeeCertificateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RequestFeeCertificateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRequestFeeCertificateDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRequestFeeCertificateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRequestFeeCertificateDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRequestFeeCertificateDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRequestFeeCertificateDto {
    totalCount: number | undefined;
    items: RequestFeeCertificateDto[] | undefined;
}

export class CreateRequestInput implements ICreateRequestInput {
    portalKey: string;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: ICreateRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.portalKey = data["portalKey"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.id = data["id"];
            this.notes = data["notes"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portalKey"] = this.portalKey;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): CreateRequestInput {
        const json = this.toJSON();
        let result = new CreateRequestInput();
        result.init(json);
        return result;
    }
}

export interface ICreateRequestInput {
    portalKey: string;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class MarkRequestAsPaidInput implements IMarkRequestAsPaidInput {
    accountTransactions: MarkRequestAsPaidInputAccountTransaction[] | undefined;
    baseOnTransactionHeaderEventInput: BaseOnTransactionHeaderEventInput | undefined;
    paymentDate: Date | undefined;
    portalKey: string | undefined;
    receiptNumber: string | undefined;
    id: string | undefined;

    constructor(data?: IMarkRequestAsPaidInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["accountTransactions"] && data["accountTransactions"].constructor === Array) {
                this.accountTransactions = [] as any;
                for (let item of data["accountTransactions"])
                    this.accountTransactions.push(MarkRequestAsPaidInputAccountTransaction.fromJS(item));
            }
            this.baseOnTransactionHeaderEventInput = data["baseOnTransactionHeaderEventInput"] ? BaseOnTransactionHeaderEventInput.fromJS(data["baseOnTransactionHeaderEventInput"]) : <any>undefined;
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.portalKey = data["portalKey"];
            this.receiptNumber = data["receiptNumber"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): MarkRequestAsPaidInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRequestAsPaidInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.accountTransactions && this.accountTransactions.constructor === Array) {
            data["accountTransactions"] = [];
            for (let item of this.accountTransactions)
                data["accountTransactions"].push(item.toJSON());
        }
        data["baseOnTransactionHeaderEventInput"] = this.baseOnTransactionHeaderEventInput ? this.baseOnTransactionHeaderEventInput.toJSON() : <any>undefined;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["portalKey"] = this.portalKey;
        data["receiptNumber"] = this.receiptNumber;
        data["id"] = this.id;
        return data; 
    }

    clone(): MarkRequestAsPaidInput {
        const json = this.toJSON();
        let result = new MarkRequestAsPaidInput();
        result.init(json);
        return result;
    }
}

export interface IMarkRequestAsPaidInput {
    accountTransactions: MarkRequestAsPaidInputAccountTransaction[] | undefined;
    baseOnTransactionHeaderEventInput: BaseOnTransactionHeaderEventInput | undefined;
    paymentDate: Date | undefined;
    portalKey: string | undefined;
    receiptNumber: string | undefined;
    id: string | undefined;
}

export class MarkRequestAsPaidInputAccountTransaction implements IMarkRequestAsPaidInputAccountTransaction {
    fee: FeeDto | undefined;
    requestFeeId: string | undefined;

    constructor(data?: IMarkRequestAsPaidInputAccountTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.fee = data["fee"] ? FeeDto.fromJS(data["fee"]) : <any>undefined;
            this.requestFeeId = data["requestFeeId"];
        }
    }

    static fromJS(data: any): MarkRequestAsPaidInputAccountTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRequestAsPaidInputAccountTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["requestFeeId"] = this.requestFeeId;
        return data; 
    }

    clone(): MarkRequestAsPaidInputAccountTransaction {
        const json = this.toJSON();
        let result = new MarkRequestAsPaidInputAccountTransaction();
        result.init(json);
        return result;
    }
}

export interface IMarkRequestAsPaidInputAccountTransaction {
    fee: FeeDto | undefined;
    requestFeeId: string | undefined;
}

export class BaseOnTransactionHeaderEventInput implements IBaseOnTransactionHeaderEventInput {
    accountTransactions: OnTransactionHeaderCreatedInputAccountTransaction[] | undefined;
    extensionData: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    receiptNumber: string | undefined;
    status: string | undefined;

    constructor(data?: IBaseOnTransactionHeaderEventInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["accountTransactions"] && data["accountTransactions"].constructor === Array) {
                this.accountTransactions = [] as any;
                for (let item of data["accountTransactions"])
                    this.accountTransactions.push(OnTransactionHeaderCreatedInputAccountTransaction.fromJS(item));
            }
            this.extensionData = data["extensionData"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeKey = data["paymentTypeKey"];
            this.portalKey = data["portalKey"];
            this.receiptNumber = data["receiptNumber"];
            this.status = data["status"];
        }
    }

    static fromJS(data: any): BaseOnTransactionHeaderEventInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseOnTransactionHeaderEventInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.accountTransactions && this.accountTransactions.constructor === Array) {
            data["accountTransactions"] = [];
            for (let item of this.accountTransactions)
                data["accountTransactions"].push(item.toJSON());
        }
        data["extensionData"] = this.extensionData;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeKey"] = this.paymentTypeKey;
        data["portalKey"] = this.portalKey;
        data["receiptNumber"] = this.receiptNumber;
        data["status"] = this.status;
        return data; 
    }

    clone(): BaseOnTransactionHeaderEventInput {
        const json = this.toJSON();
        let result = new BaseOnTransactionHeaderEventInput();
        result.init(json);
        return result;
    }
}

export interface IBaseOnTransactionHeaderEventInput {
    accountTransactions: OnTransactionHeaderCreatedInputAccountTransaction[] | undefined;
    extensionData: string | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    receiptNumber: string | undefined;
    status: string | undefined;
}

export class OnTransactionHeaderCreatedInputAccountTransaction implements IOnTransactionHeaderCreatedInputAccountTransaction {
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    requestFeeId: string | undefined;

    constructor(data?: IOnTransactionHeaderCreatedInputAccountTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.fee = data["fee"] ? FeeDto.fromJS(data["fee"]) : <any>undefined;
            this.requestFeeId = data["requestFeeId"];
        }
    }

    static fromJS(data: any): OnTransactionHeaderCreatedInputAccountTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new OnTransactionHeaderCreatedInputAccountTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["fee"] = this.fee ? this.fee.toJSON() : <any>undefined;
        data["requestFeeId"] = this.requestFeeId;
        return data; 
    }

    clone(): OnTransactionHeaderCreatedInputAccountTransaction {
        const json = this.toJSON();
        let result = new OnTransactionHeaderCreatedInputAccountTransaction();
        result.init(json);
        return result;
    }
}

export interface IOnTransactionHeaderCreatedInputAccountTransaction {
    extensionData: string | undefined;
    fee: FeeDto | undefined;
    requestFeeId: string | undefined;
}

export class UpdateRequestInput implements IUpdateRequestInput {
    documentIds: string[] | undefined;
    rowVersion: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IUpdateRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["documentIds"] && data["documentIds"].constructor === Array) {
                this.documentIds = [] as any;
                for (let item of data["documentIds"])
                    this.documentIds.push(item);
            }
            this.rowVersion = data["rowVersion"];
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.id = data["id"];
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(RequestFeeDto.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.documentIds && this.documentIds.constructor === Array) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        data["rowVersion"] = this.rowVersion;
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): UpdateRequestInput {
        const json = this.toJSON();
        let result = new UpdateRequestInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateRequestInput {
    documentIds: string[] | undefined;
    rowVersion: string | undefined;
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: RequestFeeDto[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class ValidateRequestForPaymentInput implements IValidateRequestForPaymentInput {
    extensionData: string | undefined;
    id: string | undefined;

    constructor(data?: IValidateRequestForPaymentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ValidateRequestForPaymentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateRequestForPaymentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["id"] = this.id;
        return data; 
    }

    clone(): ValidateRequestForPaymentInput {
        const json = this.toJSON();
        let result = new ValidateRequestForPaymentInput();
        result.init(json);
        return result;
    }
}

export interface IValidateRequestForPaymentInput {
    extensionData: string | undefined;
    id: string | undefined;
}

export class AjaxResponse implements IAjaxResponse {
    result: any | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    readonly __abp: boolean | undefined;

    constructor(data?: IAjaxResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.result = data["result"];
            this.targetUrl = data["targetUrl"];
            this.success = data["success"];
            this.error = data["error"] ? ErrorInfo.fromJS(data["error"]) : <any>undefined;
            this.unAuthorizedRequest = data["unAuthorizedRequest"];
            (<any>this).__abp = data["__abp"];
        }
    }

    static fromJS(data: any): AjaxResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AjaxResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data; 
    }

    clone(): AjaxResponse {
        const json = this.toJSON();
        let result = new AjaxResponse();
        result.init(json);
        return result;
    }
}

export interface IAjaxResponse {
    result: any | undefined;
    targetUrl: string | undefined;
    success: boolean | undefined;
    error: ErrorInfo | undefined;
    unAuthorizedRequest: boolean | undefined;
    __abp: boolean | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    description: string | undefined;
    displayName: string;
    grantedPermissions: string[] | undefined;
    name: string;
    normalizedName: string | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.description = data["description"];
            this.displayName = data["displayName"];
            if (data["grantedPermissions"] && data["grantedPermissions"].constructor === Array) {
                this.grantedPermissions = [] as any;
                for (let item of data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.name = data["name"];
            this.normalizedName = data["normalizedName"];
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        if (this.grantedPermissions && this.grantedPermissions.constructor === Array) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["name"] = this.name;
        data["normalizedName"] = this.normalizedName;
        return data; 
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    description: string | undefined;
    displayName: string;
    grantedPermissions: string[] | undefined;
    name: string;
    normalizedName: string | undefined;
}

export class RoleDto implements IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.normalizedName = data["normalizedName"];
            this.description = data["description"];
            if (data["grantedPermissions"] && data["grantedPermissions"].constructor === Array) {
                this.grantedPermissions = [] as any;
                for (let item of data["grantedPermissions"])
                    this.grantedPermissions.push(item);
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (this.grantedPermissions && this.grantedPermissions.constructor === Array) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    id: number | undefined;
}

export class ListResultDtoOfPermissionDto implements IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;

    constructor(data?: IListResultDtoOfPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfPermissionDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfPermissionDto {
    items: PermissionDto[] | undefined;
}

export class PermissionDto implements IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data; 
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    id: number | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : <any>undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [] as any;
                for (let item of data["permissions"])
                    this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [] as any;
                for (let item of data["grantedPermissionNames"])
                    this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data; 
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean | undefined;
    id: number | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data; 
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleListDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleListDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class RoleListDto implements IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: Date | undefined;
    id: number | undefined;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean | undefined;
    isDefault: boolean | undefined;
    creationTime: Date | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfRoleDto implements IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfRoleDto {
    totalCount: number | undefined;
    items: RoleDto[] | undefined;
}

export class CreateOrUpdate implements ICreateOrUpdate {
    userId: number | undefined;
    questionKey: string | undefined;
    plainAnswerText: string | undefined;
    isActive: boolean | undefined;
    id: string | undefined;

    constructor(data?: ICreateOrUpdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userId = data["userId"];
            this.questionKey = data["questionKey"];
            this.plainAnswerText = data["plainAnswerText"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateOrUpdate {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["questionKey"] = this.questionKey;
        data["plainAnswerText"] = this.plainAnswerText;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateOrUpdate {
        const json = this.toJSON();
        let result = new CreateOrUpdate();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdate {
    userId: number | undefined;
    questionKey: string | undefined;
    plainAnswerText: string | undefined;
    isActive: boolean | undefined;
    id: string | undefined;
}

export class SecurityQuestionDto implements ISecurityQuestionDto {
    isActive: boolean | undefined;
    questionKey: string | undefined;
    questionText: string | undefined;
    userId: number | undefined;
    id: string | undefined;

    constructor(data?: ISecurityQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.isActive = data["isActive"];
            this.questionKey = data["questionKey"];
            this.questionText = data["questionText"];
            this.userId = data["userId"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): SecurityQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["questionKey"] = this.questionKey;
        data["questionText"] = this.questionText;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data; 
    }

    clone(): SecurityQuestionDto {
        const json = this.toJSON();
        let result = new SecurityQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ISecurityQuestionDto {
    isActive: boolean | undefined;
    questionKey: string | undefined;
    questionText: string | undefined;
    userId: number | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfSecurityQuestionDto implements IPagedResultDtoOfSecurityQuestionDto {
    totalCount: number | undefined;
    items: SecurityQuestionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSecurityQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(SecurityQuestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSecurityQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSecurityQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfSecurityQuestionDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfSecurityQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfSecurityQuestionDto {
    totalCount: number | undefined;
    items: SecurityQuestionDto[] | undefined;
}

export class ValidateAnswerForSecurityQuestionDto implements IValidateAnswerForSecurityQuestionDto {
    plainAnswerText: string | undefined;
    plainQuestionText: string | undefined;
    userId: number | undefined;
    userSecurityQuestionId: string | undefined;

    constructor(data?: IValidateAnswerForSecurityQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.plainAnswerText = data["plainAnswerText"];
            this.plainQuestionText = data["plainQuestionText"];
            this.userId = data["userId"];
            this.userSecurityQuestionId = data["userSecurityQuestionId"];
        }
    }

    static fromJS(data: any): ValidateAnswerForSecurityQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAnswerForSecurityQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plainAnswerText"] = this.plainAnswerText;
        data["plainQuestionText"] = this.plainQuestionText;
        data["userId"] = this.userId;
        data["userSecurityQuestionId"] = this.userSecurityQuestionId;
        return data; 
    }

    clone(): ValidateAnswerForSecurityQuestionDto {
        const json = this.toJSON();
        let result = new ValidateAnswerForSecurityQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IValidateAnswerForSecurityQuestionDto {
    plainAnswerText: string | undefined;
    plainQuestionText: string | undefined;
    userId: number | undefined;
    userSecurityQuestionId: string | undefined;
}

export class ServiceFeeDto implements IServiceFeeDto {
    certificates: CertificateDto[] | undefined;
    companyTypeKey: string | undefined;
    serviceTypes: ServiceTypeDto[] | undefined;
    id: string | undefined;

    constructor(data?: IServiceFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["certificates"] && data["certificates"].constructor === Array) {
                this.certificates = [] as any;
                for (let item of data["certificates"])
                    this.certificates.push(CertificateDto.fromJS(item));
            }
            this.companyTypeKey = data["companyTypeKey"];
            if (data["serviceTypes"] && data["serviceTypes"].constructor === Array) {
                this.serviceTypes = [] as any;
                for (let item of data["serviceTypes"])
                    this.serviceTypes.push(ServiceTypeDto.fromJS(item));
            }
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.certificates && this.certificates.constructor === Array) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        data["companyTypeKey"] = this.companyTypeKey;
        if (this.serviceTypes && this.serviceTypes.constructor === Array) {
            data["serviceTypes"] = [];
            for (let item of this.serviceTypes)
                data["serviceTypes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data; 
    }

    clone(): ServiceFeeDto {
        const json = this.toJSON();
        let result = new ServiceFeeDto();
        result.init(json);
        return result;
    }
}

export interface IServiceFeeDto {
    certificates: CertificateDto[] | undefined;
    companyTypeKey: string | undefined;
    serviceTypes: ServiceTypeDto[] | undefined;
    id: string | undefined;
}

export class ServiceTypeDto implements IServiceTypeDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    serviceCategory: ServiceCategoryDto | undefined;
    id: string | undefined;

    constructor(data?: IServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.key = data["key"];
            this.name = data["name"];
            this.serviceCategory = data["serviceCategory"] ? ServiceCategoryDto.fromJS(data["serviceCategory"]) : <any>undefined;
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["key"] = this.key;
        data["name"] = this.name;
        data["serviceCategory"] = this.serviceCategory ? this.serviceCategory.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data; 
    }

    clone(): ServiceTypeDto {
        const json = this.toJSON();
        let result = new ServiceTypeDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTypeDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    serviceCategory: ServiceCategoryDto | undefined;
    id: string | undefined;
}

export class ServiceCategoryDto implements IServiceCategoryDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    id: string | undefined;

    constructor(data?: IServiceCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.key = data["key"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["key"] = this.key;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): ServiceCategoryDto {
        const json = this.toJSON();
        let result = new ServiceCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCategoryDto {
    extensionData: string | undefined;
    key: string | undefined;
    name: string | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfServiceFeeDto implements IPagedResultDtoOfServiceFeeDto {
    totalCount: number | undefined;
    items: ServiceFeeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ServiceFeeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfServiceFeeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfServiceFeeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfServiceFeeDto {
    totalCount: number | undefined;
    items: ServiceFeeDto[] | undefined;
}

export class CreateServiceRequestInput implements ICreateServiceRequestInput {
    companyRegistrationId: string | undefined;
    description: string | undefined;
    markZeroDollarFeesAsPaid: boolean | undefined;
    request: BaseRequestInput | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;

    constructor(data?: ICreateServiceRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyRegistrationId = data["companyRegistrationId"];
            this.description = data["description"];
            this.markZeroDollarFeesAsPaid = data["markZeroDollarFeesAsPaid"];
            this.request = data["request"] ? BaseRequestInput.fromJS(data["request"]) : <any>undefined;
            this.warningOverridden = data["warningOverridden"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateServiceRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegistrationId"] = this.companyRegistrationId;
        data["description"] = this.description;
        data["markZeroDollarFeesAsPaid"] = this.markZeroDollarFeesAsPaid;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["warningOverridden"] = this.warningOverridden;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateServiceRequestInput {
        const json = this.toJSON();
        let result = new CreateServiceRequestInput();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceRequestInput {
    companyRegistrationId: string | undefined;
    description: string | undefined;
    markZeroDollarFeesAsPaid: boolean | undefined;
    request: BaseRequestInput | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;
}

export class BaseRequestInput implements IBaseRequestInput {
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;

    constructor(data?: IBaseRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.assignedTo = data["assignedTo"];
            this.companyName = data["companyName"];
            this.companyTypeKey = data["companyTypeKey"];
            this.id = data["id"];
            this.notes = data["notes"];
            this.portalKey = data["portalKey"];
            this.registeredAgentId = data["registeredAgentId"];
            this.requestedBy = data["requestedBy"] ? CreatePersonInput.fromJS(data["requestedBy"]) : <any>undefined;
            this.requestExternalStatusKey = data["requestExternalStatusKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(BaseRequestFeeInput.fromJS(item));
            }
            this.requestInternalStatusKey = data["requestInternalStatusKey"];
            this.serviceCategoryName = data["serviceCategoryName"];
            this.serviceTypeKey = data["serviceTypeKey"];
            if (data["serviceTypeKeys"] && data["serviceTypeKeys"].constructor === Array) {
                this.serviceTypeKeys = [] as any;
                for (let item of data["serviceTypeKeys"])
                    this.serviceTypeKeys.push(item);
            }
        }
    }

    static fromJS(data: any): BaseRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new BaseRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assignedTo"] = this.assignedTo;
        data["companyName"] = this.companyName;
        data["companyTypeKey"] = this.companyTypeKey;
        data["id"] = this.id;
        data["notes"] = this.notes;
        data["portalKey"] = this.portalKey;
        data["registeredAgentId"] = this.registeredAgentId;
        data["requestedBy"] = this.requestedBy ? this.requestedBy.toJSON() : <any>undefined;
        data["requestExternalStatusKey"] = this.requestExternalStatusKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["requestInternalStatusKey"] = this.requestInternalStatusKey;
        data["serviceCategoryName"] = this.serviceCategoryName;
        data["serviceTypeKey"] = this.serviceTypeKey;
        if (this.serviceTypeKeys && this.serviceTypeKeys.constructor === Array) {
            data["serviceTypeKeys"] = [];
            for (let item of this.serviceTypeKeys)
                data["serviceTypeKeys"].push(item);
        }
        return data; 
    }

    clone(): BaseRequestInput {
        const json = this.toJSON();
        let result = new BaseRequestInput();
        result.init(json);
        return result;
    }
}

export interface IBaseRequestInput {
    assignedTo: string | undefined;
    companyName: string | undefined;
    companyTypeKey: string | undefined;
    id: string | undefined;
    notes: string | undefined;
    portalKey: string | undefined;
    registeredAgentId: string | undefined;
    requestedBy: CreatePersonInput | undefined;
    requestExternalStatusKey: string | undefined;
    requestFees: BaseRequestFeeInput[] | undefined;
    requestInternalStatusKey: string;
    serviceCategoryName: string | undefined;
    serviceTypeKey: string | undefined;
    serviceTypeKeys: string[] | undefined;
}

export class ServiceRequestDto implements IServiceRequestDto {
    readonly companyName: string | undefined;
    companyRegistration: CompanyRegistrationDto | undefined;
    description: string | undefined;
    lastModificationTime: Date | undefined;
    request: RequestV2Dto | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;

    constructor(data?: IServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            (<any>this).companyName = data["companyName"];
            this.companyRegistration = data["companyRegistration"] ? CompanyRegistrationDto.fromJS(data["companyRegistration"]) : <any>undefined;
            this.description = data["description"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.request = data["request"] ? RequestV2Dto.fromJS(data["request"]) : <any>undefined;
            this.warningOverridden = data["warningOverridden"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): ServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["companyRegistration"] = this.companyRegistration ? this.companyRegistration.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["warningOverridden"] = this.warningOverridden;
        data["id"] = this.id;
        return data; 
    }

    clone(): ServiceRequestDto {
        const json = this.toJSON();
        let result = new ServiceRequestDto();
        result.init(json);
        return result;
    }
}

export interface IServiceRequestDto {
    companyName: string | undefined;
    companyRegistration: CompanyRegistrationDto | undefined;
    description: string | undefined;
    lastModificationTime: Date | undefined;
    request: RequestV2Dto | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfServiceRequestDto implements IPagedResultDtoOfServiceRequestDto {
    totalCount: number | undefined;
    items: ServiceRequestDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ServiceRequestDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfServiceRequestDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfServiceRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfServiceRequestDto {
    totalCount: number | undefined;
    items: ServiceRequestDto[] | undefined;
}

export class PagedResultDtoOfGetAllServiceRequestOutput implements IPagedResultDtoOfGetAllServiceRequestOutput {
    totalCount: number | undefined;
    items: GetAllServiceRequestOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllServiceRequestOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllServiceRequestOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllServiceRequestOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllServiceRequestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllServiceRequestOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllServiceRequestOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllServiceRequestOutput {
    totalCount: number | undefined;
    items: GetAllServiceRequestOutput[] | undefined;
}

export class GetAllServiceRequestOutput implements IGetAllServiceRequestOutput {
    companyNameAndSuffix: string | undefined;
    creationTime: Date | undefined;
    registeredAgentName: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    id: string | undefined;

    constructor(data?: IGetAllServiceRequestOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyNameAndSuffix = data["companyNameAndSuffix"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.registeredAgentName = data["registeredAgentName"];
            this.requestExternalStatusName = data["requestExternalStatusName"];
            this.requestInternalStatusName = data["requestInternalStatusName"];
            this.requestNumber = data["requestNumber"];
            this.serviceTypeName = data["serviceTypeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllServiceRequestOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllServiceRequestOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyNameAndSuffix"] = this.companyNameAndSuffix;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestExternalStatusName"] = this.requestExternalStatusName;
        data["requestInternalStatusName"] = this.requestInternalStatusName;
        data["requestNumber"] = this.requestNumber;
        data["serviceTypeName"] = this.serviceTypeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllServiceRequestOutput {
        const json = this.toJSON();
        let result = new GetAllServiceRequestOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllServiceRequestOutput {
    companyNameAndSuffix: string | undefined;
    creationTime: Date | undefined;
    registeredAgentName: string | undefined;
    requestExternalStatusName: string | undefined;
    requestInternalStatusName: string | undefined;
    requestNumber: string | undefined;
    serviceTypeName: string | undefined;
    id: string | undefined;
}

export class UpdateServiceRequestInput implements IUpdateServiceRequestInput {
    companyRegistrationId: string | undefined;
    description: string | undefined;
    markZeroDollarFeesAsPaid: boolean | undefined;
    request: UpdateRequestInput | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;

    constructor(data?: IUpdateServiceRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.companyRegistrationId = data["companyRegistrationId"];
            this.description = data["description"];
            this.markZeroDollarFeesAsPaid = data["markZeroDollarFeesAsPaid"];
            this.request = data["request"] ? UpdateRequestInput.fromJS(data["request"]) : <any>undefined;
            this.warningOverridden = data["warningOverridden"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateServiceRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyRegistrationId"] = this.companyRegistrationId;
        data["description"] = this.description;
        data["markZeroDollarFeesAsPaid"] = this.markZeroDollarFeesAsPaid;
        data["request"] = this.request ? this.request.toJSON() : <any>undefined;
        data["warningOverridden"] = this.warningOverridden;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateServiceRequestInput {
        const json = this.toJSON();
        let result = new UpdateServiceRequestInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceRequestInput {
    companyRegistrationId: string | undefined;
    description: string | undefined;
    markZeroDollarFeesAsPaid: boolean | undefined;
    request: UpdateRequestInput | undefined;
    warningOverridden: boolean | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfServiceTypeDto implements IPagedResultDtoOfServiceTypeDto {
    totalCount: number | undefined;
    items: ServiceTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(ServiceTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfServiceTypeDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfServiceTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfServiceTypeDto {
    totalCount: number | undefined;
    items: ServiceTypeDto[] | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : <any>undefined;
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : <any>undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        return data; 
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto | undefined;
    user: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date | undefined;
    features: { [key: string] : boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? new Date(data["releaseDate"].toString()) : <any>undefined;
            if (data["features"]) {
                this.features = {} as any;
                for (let key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data; 
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: Date | undefined;
    features: { [key: string] : boolean; } | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    id: number | undefined;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    id: number | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data; 
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean | undefined;
}

export class TenantDto implements ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data; 
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    tenancyName: string;
    name: string;
    isActive: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfTenantDto implements IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TenantDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTenantDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTenantDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTenantDto {
    totalCount: number | undefined;
    items: TenantDto[] | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    password: string;
    rememberClient: boolean | undefined;
    userNameOrEmailAddress: string;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.password = data["password"];
            this.rememberClient = data["rememberClient"];
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        return data; 
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    password: string;
    rememberClient: boolean | undefined;
    userNameOrEmailAddress: string;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;
    hasPasswordExpired: boolean | undefined;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.userId = data["userId"];
            this.hasPasswordExpired = data["hasPasswordExpired"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["hasPasswordExpired"] = this.hasPasswordExpired;
        return data; 
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    userId: number | undefined;
    hasPasswordExpired: boolean | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data; 
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data; 
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number | undefined;
    waitingForActivation: boolean | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data; 
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class CreateTransactionHeaderInput implements ICreateTransactionHeaderInput {
    notes: string | undefined;
    notifyRequestService: boolean | undefined;
    paymentTypeKey: string;
    requestFees: TransactionHeaderRequestFeeDto[] | undefined;
    transactionCurrencyKey: string;
    transactionNumber: string | undefined;
    transactionTypeKey: string;
    bank: string | undefined;
    chequeNumber: string | undefined;
    extensionData: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    portalKey: string | undefined;
    id: string | undefined;

    constructor(data?: ICreateTransactionHeaderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notes = data["notes"];
            this.notifyRequestService = data["notifyRequestService"];
            this.paymentTypeKey = data["paymentTypeKey"];
            if (data["requestFees"] && data["requestFees"].constructor === Array) {
                this.requestFees = [] as any;
                for (let item of data["requestFees"])
                    this.requestFees.push(TransactionHeaderRequestFeeDto.fromJS(item));
            }
            this.transactionCurrencyKey = data["transactionCurrencyKey"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionTypeKey = data["transactionTypeKey"];
            this.bank = data["bank"];
            this.chequeNumber = data["chequeNumber"];
            this.extensionData = data["extensionData"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.portalKey = data["portalKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): CreateTransactionHeaderInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionHeaderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notes"] = this.notes;
        data["notifyRequestService"] = this.notifyRequestService;
        data["paymentTypeKey"] = this.paymentTypeKey;
        if (this.requestFees && this.requestFees.constructor === Array) {
            data["requestFees"] = [];
            for (let item of this.requestFees)
                data["requestFees"].push(item.toJSON());
        }
        data["transactionCurrencyKey"] = this.transactionCurrencyKey;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionTypeKey"] = this.transactionTypeKey;
        data["bank"] = this.bank;
        data["chequeNumber"] = this.chequeNumber;
        data["extensionData"] = this.extensionData;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["portalKey"] = this.portalKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): CreateTransactionHeaderInput {
        const json = this.toJSON();
        let result = new CreateTransactionHeaderInput();
        result.init(json);
        return result;
    }
}

export interface ICreateTransactionHeaderInput {
    notes: string | undefined;
    notifyRequestService: boolean | undefined;
    paymentTypeKey: string;
    requestFees: TransactionHeaderRequestFeeDto[] | undefined;
    transactionCurrencyKey: string;
    transactionNumber: string | undefined;
    transactionTypeKey: string;
    bank: string | undefined;
    chequeNumber: string | undefined;
    extensionData: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    portalKey: string | undefined;
    id: string | undefined;
}

export class TransactionHeaderRequestFeeDto implements ITransactionHeaderRequestFeeDto {
    extensionData: string | undefined;
    quantity: number | undefined;
    id: string | undefined;

    constructor(data?: ITransactionHeaderRequestFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.extensionData = data["extensionData"];
            this.quantity = data["quantity"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): TransactionHeaderRequestFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionHeaderRequestFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extensionData"] = this.extensionData;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data; 
    }

    clone(): TransactionHeaderRequestFeeDto {
        const json = this.toJSON();
        let result = new TransactionHeaderRequestFeeDto();
        result.init(json);
        return result;
    }
}

export interface ITransactionHeaderRequestFeeDto {
    extensionData: string | undefined;
    quantity: number | undefined;
    id: string | undefined;
}

export class PagedResultDtoOfTransactionHeaderDto implements IPagedResultDtoOfTransactionHeaderDto {
    totalCount: number | undefined;
    items: TransactionHeaderDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTransactionHeaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(TransactionHeaderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTransactionHeaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTransactionHeaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfTransactionHeaderDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfTransactionHeaderDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfTransactionHeaderDto {
    totalCount: number | undefined;
    items: TransactionHeaderDto[] | undefined;
}

export class PagedResultDtoOfGetAllSearchOutput implements IPagedResultDtoOfGetAllSearchOutput {
    totalCount: number | undefined;
    items: GetAllSearchOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfGetAllSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(GetAllSearchOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetAllSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetAllSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfGetAllSearchOutput {
        const json = this.toJSON();
        let result = new PagedResultDtoOfGetAllSearchOutput();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfGetAllSearchOutput {
    totalCount: number | undefined;
    items: GetAllSearchOutput[] | undefined;
}

export class GetAllSearchOutput implements IGetAllSearchOutput {
    batchNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    postedAt: Date | undefined;
    receiptNumber: string | undefined;
    receivedFromName: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    requestNumber: string | undefined;
    status: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountUSD: number | undefined;
    transactionNumber: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;

    constructor(data?: IGetAllSearchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.batchNumber = data["batchNumber"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeName = data["paymentTypeName"];
            this.postedAt = data["postedAt"] ? new Date(data["postedAt"].toString()) : <any>undefined;
            this.receiptNumber = data["receiptNumber"];
            this.receivedFromName = data["receivedFromName"];
            this.registeredAgentAccountNumber = data["registeredAgentAccountNumber"];
            this.registeredAgentName = data["registeredAgentName"];
            this.requestedFromCR = data["requestedFromCR"];
            this.requestNumber = data["requestNumber"];
            this.status = data["status"];
            this.transactionAmountEC = data["transactionAmountEC"];
            this.transactionAmountUSD = data["transactionAmountUSD"];
            this.transactionNumber = data["transactionNumber"];
            this.transactionTypeName = data["transactionTypeName"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): GetAllSearchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllSearchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchNumber"] = this.batchNumber;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeName"] = this.paymentTypeName;
        data["postedAt"] = this.postedAt ? this.postedAt.toISOString() : <any>undefined;
        data["receiptNumber"] = this.receiptNumber;
        data["receivedFromName"] = this.receivedFromName;
        data["registeredAgentAccountNumber"] = this.registeredAgentAccountNumber;
        data["registeredAgentName"] = this.registeredAgentName;
        data["requestedFromCR"] = this.requestedFromCR;
        data["requestNumber"] = this.requestNumber;
        data["status"] = this.status;
        data["transactionAmountEC"] = this.transactionAmountEC;
        data["transactionAmountUSD"] = this.transactionAmountUSD;
        data["transactionNumber"] = this.transactionNumber;
        data["transactionTypeName"] = this.transactionTypeName;
        data["id"] = this.id;
        return data; 
    }

    clone(): GetAllSearchOutput {
        const json = this.toJSON();
        let result = new GetAllSearchOutput();
        result.init(json);
        return result;
    }
}

export interface IGetAllSearchOutput {
    batchNumber: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeName: string | undefined;
    postedAt: Date | undefined;
    receiptNumber: string | undefined;
    receivedFromName: string | undefined;
    registeredAgentAccountNumber: string | undefined;
    registeredAgentName: string | undefined;
    requestedFromCR: boolean | undefined;
    requestNumber: string | undefined;
    status: string | undefined;
    transactionAmountEC: number | undefined;
    transactionAmountUSD: number | undefined;
    transactionNumber: string | undefined;
    transactionTypeName: string | undefined;
    id: string | undefined;
}

export class MakeRefundInput implements IMakeRefundInput {
    notifyRefundRequestService: boolean | undefined;
    refundRequestId: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;

    constructor(data?: IMakeRefundInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.notifyRefundRequestService = data["notifyRefundRequestService"];
            this.refundRequestId = data["refundRequestId"];
            if (data["requestFeeIDs"] && data["requestFeeIDs"].constructor === Array) {
                this.requestFeeIDs = [] as any;
                for (let item of data["requestFeeIDs"])
                    this.requestFeeIDs.push(item);
            }
            this.transactionID = data["transactionID"];
        }
    }

    static fromJS(data: any): MakeRefundInput {
        data = typeof data === 'object' ? data : {};
        let result = new MakeRefundInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notifyRefundRequestService"] = this.notifyRefundRequestService;
        data["refundRequestId"] = this.refundRequestId;
        if (this.requestFeeIDs && this.requestFeeIDs.constructor === Array) {
            data["requestFeeIDs"] = [];
            for (let item of this.requestFeeIDs)
                data["requestFeeIDs"].push(item);
        }
        data["transactionID"] = this.transactionID;
        return data; 
    }

    clone(): MakeRefundInput {
        const json = this.toJSON();
        let result = new MakeRefundInput();
        result.init(json);
        return result;
    }
}

export interface IMakeRefundInput {
    notifyRefundRequestService: boolean | undefined;
    refundRequestId: string | undefined;
    requestFeeIDs: string[] | undefined;
    transactionID: string | undefined;
}

export class UpdateTransactionHeaderInput implements IUpdateTransactionHeaderInput {
    status: string | undefined;
    rowVersion: string | undefined;
    bank: string | undefined;
    chequeNumber: string | undefined;
    extensionData: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    transactionCurrencyKey: string | undefined;
    transactionTypeKey: string | undefined;
    id: string | undefined;

    constructor(data?: IUpdateTransactionHeaderInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.status = data["status"];
            this.rowVersion = data["rowVersion"];
            this.bank = data["bank"];
            this.chequeNumber = data["chequeNumber"];
            this.extensionData = data["extensionData"];
            this.paymentAmount = data["paymentAmount"];
            this.paymentDate = data["paymentDate"] ? new Date(data["paymentDate"].toString()) : <any>undefined;
            this.paymentTypeKey = data["paymentTypeKey"];
            this.portalKey = data["portalKey"];
            this.transactionCurrencyKey = data["transactionCurrencyKey"];
            this.transactionTypeKey = data["transactionTypeKey"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateTransactionHeaderInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionHeaderInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["rowVersion"] = this.rowVersion;
        data["bank"] = this.bank;
        data["chequeNumber"] = this.chequeNumber;
        data["extensionData"] = this.extensionData;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
        data["paymentTypeKey"] = this.paymentTypeKey;
        data["portalKey"] = this.portalKey;
        data["transactionCurrencyKey"] = this.transactionCurrencyKey;
        data["transactionTypeKey"] = this.transactionTypeKey;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateTransactionHeaderInput {
        const json = this.toJSON();
        let result = new UpdateTransactionHeaderInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateTransactionHeaderInput {
    status: string | undefined;
    rowVersion: string | undefined;
    bank: string | undefined;
    chequeNumber: string | undefined;
    extensionData: string | undefined;
    paymentAmount: number | undefined;
    paymentDate: Date | undefined;
    paymentTypeKey: string | undefined;
    portalKey: string | undefined;
    transactionCurrencyKey: string | undefined;
    transactionTypeKey: string | undefined;
    id: string | undefined;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.languageName = data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data; 
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword: string;
    userNameorEmail: string | undefined;
    isExpiredPassword: boolean | undefined;
    newPassword: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.userNameorEmail = data["userNameorEmail"];
            this.isExpiredPassword = data["isExpiredPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["userNameorEmail"] = this.userNameorEmail;
        data["isExpiredPassword"] = this.isExpiredPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    userNameorEmail: string | undefined;
    isExpiredPassword: boolean | undefined;
    newPassword: string;
}

export class ChangePasswordWithoutCurrentInput implements IChangePasswordWithoutCurrentInput {
    userNameorEmail: string | undefined;
    isExpiredPassword: boolean | undefined;
    newPassword: string;

    constructor(data?: IChangePasswordWithoutCurrentInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameorEmail = data["userNameorEmail"];
            this.isExpiredPassword = data["isExpiredPassword"];
            this.newPassword = data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordWithoutCurrentInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordWithoutCurrentInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameorEmail"] = this.userNameorEmail;
        data["isExpiredPassword"] = this.isExpiredPassword;
        data["newPassword"] = this.newPassword;
        return data; 
    }

    clone(): ChangePasswordWithoutCurrentInput {
        const json = this.toJSON();
        let result = new ChangePasswordWithoutCurrentInput();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordWithoutCurrentInput {
    userNameorEmail: string | undefined;
    isExpiredPassword: boolean | undefined;
    newPassword: string;
}

export class CreateUserDto implements ICreateUserDto {
    businessPhoneNumber: string;
    cellNumber: string | undefined;
    emailAddress: string;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isTemporarilyLocked: boolean | undefined;
    name: string;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userName: string;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.businessPhoneNumber = data["businessPhoneNumber"];
            this.cellNumber = data["cellNumber"];
            this.emailAddress = data["emailAddress"];
            this.faxNumber = data["faxNumber"];
            this.isActive = data["isActive"];
            this.isLocked = data["isLocked"];
            this.isTemporarilyLocked = data["isTemporarilyLocked"];
            this.name = data["name"];
            if (data["registeredAgents"] && data["registeredAgents"].constructor === Array) {
                this.registeredAgents = [] as any;
                for (let item of data["registeredAgents"])
                    this.registeredAgents.push(UserRegisteredAgentDto.fromJS(item));
            }
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.surname = data["surname"];
            this.userName = data["userName"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["businessPhoneNumber"] = this.businessPhoneNumber;
        data["cellNumber"] = this.cellNumber;
        data["emailAddress"] = this.emailAddress;
        data["faxNumber"] = this.faxNumber;
        data["isActive"] = this.isActive;
        data["isLocked"] = this.isLocked;
        data["isTemporarilyLocked"] = this.isTemporarilyLocked;
        data["name"] = this.name;
        if (this.registeredAgents && this.registeredAgents.constructor === Array) {
            data["registeredAgents"] = [];
            for (let item of this.registeredAgents)
                data["registeredAgents"].push(item.toJSON());
        }
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        return data; 
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    businessPhoneNumber: string;
    cellNumber: string | undefined;
    emailAddress: string;
    faxNumber: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isTemporarilyLocked: boolean | undefined;
    name: string;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userName: string;
}

export class UserRegisteredAgentDto implements IUserRegisteredAgentDto {
    id: string | undefined;
    isAdministrator: boolean | undefined;
    isDefaultRegisteredAgent: boolean | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;

    constructor(data?: IUserRegisteredAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.isAdministrator = data["isAdministrator"];
            this.isDefaultRegisteredAgent = data["isDefaultRegisteredAgent"];
            this.registeredAgent = data["registeredAgent"] ? RegisteredAgentDto.fromJS(data["registeredAgent"]) : <any>undefined;
            this.registeredAgentId = data["registeredAgentId"];
        }
    }

    static fromJS(data: any): UserRegisteredAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRegisteredAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAdministrator"] = this.isAdministrator;
        data["isDefaultRegisteredAgent"] = this.isDefaultRegisteredAgent;
        data["registeredAgent"] = this.registeredAgent ? this.registeredAgent.toJSON() : <any>undefined;
        data["registeredAgentId"] = this.registeredAgentId;
        return data; 
    }

    clone(): UserRegisteredAgentDto {
        const json = this.toJSON();
        let result = new UserRegisteredAgentDto();
        result.init(json);
        return result;
    }
}

export interface IUserRegisteredAgentDto {
    id: string | undefined;
    isAdministrator: boolean | undefined;
    isDefaultRegisteredAgent: boolean | undefined;
    registeredAgent: RegisteredAgentDto | undefined;
    registeredAgentId: string | undefined;
}

export class UserDto implements IUserDto {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.businessPhoneNumber = data["businessPhoneNumber"] ? PhoneNumberDto.fromJS(data["businessPhoneNumber"]) : <any>undefined;
            this.cellNumber = data["cellNumber"] ? PhoneNumberDto.fromJS(data["cellNumber"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.emailAddress = data["emailAddress"];
            this.faxNumber = data["faxNumber"] ? PhoneNumberDto.fromJS(data["faxNumber"]) : <any>undefined;
            this.fullName = data["fullName"];
            this.isActive = data["isActive"];
            this.isLocked = data["isLocked"];
            this.isSecurityQuestionsAnswered = data["isSecurityQuestionsAnswered"];
            this.isUsingTemporaryPassword = data["isUsingTemporaryPassword"];
            this.lastChangedPasswordDateUtc = data["lastChangedPasswordDateUtc"] ? new Date(data["lastChangedPasswordDateUtc"].toString()) : <any>undefined;
            this.lastLoginTime = data["lastLoginTime"] ? new Date(data["lastLoginTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.personId = data["personId"];
            this.registeredAgentName = data["registeredAgentName"];
            if (data["registeredAgents"] && data["registeredAgents"].constructor === Array) {
                this.registeredAgents = [] as any;
                for (let item of data["registeredAgents"])
                    this.registeredAgents.push(UserRegisteredAgentDto.fromJS(item));
            }
            if (data["roleDisplayNames"] && data["roleDisplayNames"].constructor === Array) {
                this.roleDisplayNames = [] as any;
                for (let item of data["roleDisplayNames"])
                    this.roleDisplayNames.push(item);
            }
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.surname = data["surname"];
            this.userMustChangePasswordOnNextLogin = data["userMustChangePasswordOnNextLogin"];
            this.userName = data["userName"];
            this.isTemporarilyLocked = data["isTemporarilyLocked"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["businessPhoneNumber"] = this.businessPhoneNumber ? this.businessPhoneNumber.toJSON() : <any>undefined;
        data["cellNumber"] = this.cellNumber ? this.cellNumber.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["faxNumber"] = this.faxNumber ? this.faxNumber.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["isActive"] = this.isActive;
        data["isLocked"] = this.isLocked;
        data["isSecurityQuestionsAnswered"] = this.isSecurityQuestionsAnswered;
        data["isUsingTemporaryPassword"] = this.isUsingTemporaryPassword;
        data["lastChangedPasswordDateUtc"] = this.lastChangedPasswordDateUtc ? this.lastChangedPasswordDateUtc.toISOString() : <any>undefined;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["personId"] = this.personId;
        data["registeredAgentName"] = this.registeredAgentName;
        if (this.registeredAgents && this.registeredAgents.constructor === Array) {
            data["registeredAgents"] = [];
            for (let item of this.registeredAgents)
                data["registeredAgents"].push(item.toJSON());
        }
        if (this.roleDisplayNames && this.roleDisplayNames.constructor === Array) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["surname"] = this.surname;
        data["userMustChangePasswordOnNextLogin"] = this.userMustChangePasswordOnNextLogin;
        data["userName"] = this.userName;
        data["isTemporarilyLocked"] = this.isTemporarilyLocked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserDto implements IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserDto {
    totalCount: number | undefined;
    items: UserDto[] | undefined;
}

export class ListResultDtoOfRoleDto implements IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ListResultDtoOfRoleDto {
        const json = this.toJSON();
        let result = new ListResultDtoOfRoleDto();
        result.init(json);
        return result;
    }
}

export interface IListResultDtoOfRoleDto {
    items: RoleDto[] | undefined;
}

export class ResetPasswordDto implements IResetPasswordDto {
    userNameOrEmailAddress: string;

    constructor(data?: IResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
        }
    }

    static fromJS(data: any): ResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        return data; 
    }

    clone(): ResetPasswordDto {
        const json = this.toJSON();
        let result = new ResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordDto {
    userNameOrEmailAddress: string;
}

export class UpdateUserInput implements IUpdateUserInput {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.businessPhoneNumber = data["businessPhoneNumber"] ? PhoneNumberDto.fromJS(data["businessPhoneNumber"]) : <any>undefined;
            this.cellNumber = data["cellNumber"] ? PhoneNumberDto.fromJS(data["cellNumber"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.emailAddress = data["emailAddress"];
            this.faxNumber = data["faxNumber"] ? PhoneNumberDto.fromJS(data["faxNumber"]) : <any>undefined;
            this.fullName = data["fullName"];
            this.isActive = data["isActive"];
            this.isLocked = data["isLocked"];
            this.isSecurityQuestionsAnswered = data["isSecurityQuestionsAnswered"];
            this.isUsingTemporaryPassword = data["isUsingTemporaryPassword"];
            this.lastChangedPasswordDateUtc = data["lastChangedPasswordDateUtc"] ? new Date(data["lastChangedPasswordDateUtc"].toString()) : <any>undefined;
            this.lastLoginTime = data["lastLoginTime"] ? new Date(data["lastLoginTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.personId = data["personId"];
            this.registeredAgentName = data["registeredAgentName"];
            if (data["registeredAgents"] && data["registeredAgents"].constructor === Array) {
                this.registeredAgents = [] as any;
                for (let item of data["registeredAgents"])
                    this.registeredAgents.push(UserRegisteredAgentDto.fromJS(item));
            }
            if (data["roleDisplayNames"] && data["roleDisplayNames"].constructor === Array) {
                this.roleDisplayNames = [] as any;
                for (let item of data["roleDisplayNames"])
                    this.roleDisplayNames.push(item);
            }
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.surname = data["surname"];
            this.userMustChangePasswordOnNextLogin = data["userMustChangePasswordOnNextLogin"];
            this.userName = data["userName"];
            this.isTemporarilyLocked = data["isTemporarilyLocked"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["businessPhoneNumber"] = this.businessPhoneNumber ? this.businessPhoneNumber.toJSON() : <any>undefined;
        data["cellNumber"] = this.cellNumber ? this.cellNumber.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["faxNumber"] = this.faxNumber ? this.faxNumber.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["isActive"] = this.isActive;
        data["isLocked"] = this.isLocked;
        data["isSecurityQuestionsAnswered"] = this.isSecurityQuestionsAnswered;
        data["isUsingTemporaryPassword"] = this.isUsingTemporaryPassword;
        data["lastChangedPasswordDateUtc"] = this.lastChangedPasswordDateUtc ? this.lastChangedPasswordDateUtc.toISOString() : <any>undefined;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["personId"] = this.personId;
        data["registeredAgentName"] = this.registeredAgentName;
        if (this.registeredAgents && this.registeredAgents.constructor === Array) {
            data["registeredAgents"] = [];
            for (let item of this.registeredAgents)
                data["registeredAgents"].push(item.toJSON());
        }
        if (this.roleDisplayNames && this.roleDisplayNames.constructor === Array) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["surname"] = this.surname;
        data["userMustChangePasswordOnNextLogin"] = this.userMustChangePasswordOnNextLogin;
        data["userName"] = this.userName;
        data["isTemporarilyLocked"] = this.isTemporarilyLocked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateUserInput {
        const json = this.toJSON();
        let result = new UpdateUserInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserInput {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;
}

export class UpdateMyProfileInput implements IUpdateMyProfileInput {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;

    constructor(data?: IUpdateMyProfileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.businessPhoneNumber = data["businessPhoneNumber"] ? PhoneNumberDto.fromJS(data["businessPhoneNumber"]) : <any>undefined;
            this.cellNumber = data["cellNumber"] ? PhoneNumberDto.fromJS(data["cellNumber"]) : <any>undefined;
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.emailAddress = data["emailAddress"];
            this.faxNumber = data["faxNumber"] ? PhoneNumberDto.fromJS(data["faxNumber"]) : <any>undefined;
            this.fullName = data["fullName"];
            this.isActive = data["isActive"];
            this.isLocked = data["isLocked"];
            this.isSecurityQuestionsAnswered = data["isSecurityQuestionsAnswered"];
            this.isUsingTemporaryPassword = data["isUsingTemporaryPassword"];
            this.lastChangedPasswordDateUtc = data["lastChangedPasswordDateUtc"] ? new Date(data["lastChangedPasswordDateUtc"].toString()) : <any>undefined;
            this.lastLoginTime = data["lastLoginTime"] ? new Date(data["lastLoginTime"].toString()) : <any>undefined;
            this.name = data["name"];
            this.personId = data["personId"];
            this.registeredAgentName = data["registeredAgentName"];
            if (data["registeredAgents"] && data["registeredAgents"].constructor === Array) {
                this.registeredAgents = [] as any;
                for (let item of data["registeredAgents"])
                    this.registeredAgents.push(UserRegisteredAgentDto.fromJS(item));
            }
            if (data["roleDisplayNames"] && data["roleDisplayNames"].constructor === Array) {
                this.roleDisplayNames = [] as any;
                for (let item of data["roleDisplayNames"])
                    this.roleDisplayNames.push(item);
            }
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [] as any;
                for (let item of data["roleNames"])
                    this.roleNames.push(item);
            }
            this.surname = data["surname"];
            this.userMustChangePasswordOnNextLogin = data["userMustChangePasswordOnNextLogin"];
            this.userName = data["userName"];
            this.isTemporarilyLocked = data["isTemporarilyLocked"];
            this.id = data["id"];
        }
    }

    static fromJS(data: any): UpdateMyProfileInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMyProfileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["businessPhoneNumber"] = this.businessPhoneNumber ? this.businessPhoneNumber.toJSON() : <any>undefined;
        data["cellNumber"] = this.cellNumber ? this.cellNumber.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["faxNumber"] = this.faxNumber ? this.faxNumber.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["isActive"] = this.isActive;
        data["isLocked"] = this.isLocked;
        data["isSecurityQuestionsAnswered"] = this.isSecurityQuestionsAnswered;
        data["isUsingTemporaryPassword"] = this.isUsingTemporaryPassword;
        data["lastChangedPasswordDateUtc"] = this.lastChangedPasswordDateUtc ? this.lastChangedPasswordDateUtc.toISOString() : <any>undefined;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["personId"] = this.personId;
        data["registeredAgentName"] = this.registeredAgentName;
        if (this.registeredAgents && this.registeredAgents.constructor === Array) {
            data["registeredAgents"] = [];
            for (let item of this.registeredAgents)
                data["registeredAgents"].push(item.toJSON());
        }
        if (this.roleDisplayNames && this.roleDisplayNames.constructor === Array) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["surname"] = this.surname;
        data["userMustChangePasswordOnNextLogin"] = this.userMustChangePasswordOnNextLogin;
        data["userName"] = this.userName;
        data["isTemporarilyLocked"] = this.isTemporarilyLocked;
        data["id"] = this.id;
        return data; 
    }

    clone(): UpdateMyProfileInput {
        const json = this.toJSON();
        let result = new UpdateMyProfileInput();
        result.init(json);
        return result;
    }
}

export interface IUpdateMyProfileInput {
    accountNumber: string | undefined;
    businessPhoneNumber: PhoneNumberDto | undefined;
    cellNumber: PhoneNumberDto | undefined;
    creationTime: Date | undefined;
    emailAddress: string;
    faxNumber: PhoneNumberDto | undefined;
    fullName: string | undefined;
    isActive: boolean | undefined;
    isLocked: boolean | undefined;
    isSecurityQuestionsAnswered: boolean | undefined;
    isUsingTemporaryPassword: boolean | undefined;
    lastChangedPasswordDateUtc: Date | undefined;
    lastLoginTime: Date | undefined;
    name: string;
    personId: string | undefined;
    registeredAgentName: string | undefined;
    registeredAgents: UserRegisteredAgentDto[] | undefined;
    roleDisplayNames: string[] | undefined;
    roleNames: string[] | undefined;
    surname: string;
    userMustChangePasswordOnNextLogin: boolean | undefined;
    userName: string;
    isTemporarilyLocked: boolean | undefined;
    id: number | undefined;
}

export class PagedResultDtoOfUserRegisteredAgentDto implements IPagedResultDtoOfUserRegisteredAgentDto {
    totalCount: number | undefined;
    items: UserRegisteredAgentDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserRegisteredAgentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(UserRegisteredAgentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserRegisteredAgentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserRegisteredAgentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfUserRegisteredAgentDto {
        const json = this.toJSON();
        let result = new PagedResultDtoOfUserRegisteredAgentDto();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfUserRegisteredAgentDto {
    totalCount: number | undefined;
    items: UserRegisteredAgentDto[] | undefined;
}

export enum EntitiesWithoutRegisteredAgent {
    Undefined = <any>"Undefined", 
    LessThan30Days = <any>"LessThan30Days", 
    Between30And60Days = <any>"Between30And60Days", 
    MoreThan60Days = <any>"MoreThan60Days", 
    All = <any>"All", 
}

export enum LastRenewedYear {
    Undefined = <any>"Undefined", 
    CurrentYear = <any>"CurrentYear", 
    Last2Years = <any>"Last2Years", 
    Next10Years = <any>"Next10Years", 
}

export enum IsTenantAvailableOutputState {
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
}

export enum RegisteredAgentDtoContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum PersonDtoContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum CompanyPersonDtoContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum BaseContactInputContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum ManagementAndOfficerPersonDtoContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum RegistrationOfChargeContactDtoContactType {
    Undefined = <any>"Undefined", 
    Company = <any>"Company", 
    Person = <any>"Person", 
}

export enum EntitiesWithoutRegisteredAgent2 {
    Undefined = <any>"Undefined", 
    LessThan30Days = <any>"LessThan30Days", 
    Between30And60Days = <any>"Between30And60Days", 
    MoreThan60Days = <any>"MoreThan60Days", 
    All = <any>"All", 
}

export enum GetAllCompanyRegistrationInputLastRenewedYear {
    Undefined = <any>"Undefined", 
    CurrentYear = <any>"CurrentYear", 
    Last2Years = <any>"Last2Years", 
    Next10Years = <any>"Next10Years", 
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}